webpackJsonp([0],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_element_ui_lib_theme_chalk_slider_css__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_element_ui_lib_theme_chalk_slider_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_element_ui_lib_theme_chalk_slider_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_base_css__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_slider__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_slider___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_slider__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__App__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__router__ = __webpack_require__(166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__store__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_notification__ = __webpack_require__(308);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_notification___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_notification__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vee_validate__ = __webpack_require__(309);



// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.









//import './assets/css/styles.min.css'

__WEBPACK_IMPORTED_MODULE_3_vue__["default"].config.productionTip = false;
__WEBPACK_IMPORTED_MODULE_3_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_8_vee_validate__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_3_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_7_vue_notification___default.a);
__WEBPACK_IMPORTED_MODULE_3_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_slider___default.a);

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_3_vue__["default"]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_5__router__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */],
  render: function render(h) {
    return h(__WEBPACK_IMPORTED_MODULE_4__App__["a" /* default */]);
  },
  created: function created() {
    //check if the cart is not empty see the content of localstorage
    this.$store.dispatch('loadCart');
  }
});

/***/ }),
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_navbar__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_navigation__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_mhdfooter__ = __webpack_require__(161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue2_animate_dist_vue2_animate_min_css__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue2_animate_dist_vue2_animate_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue2_animate_dist_vue2_animate_min_css__);
//
//
//
//
//
//
//
//
//
//

//navbar and footer





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'App',
  components: {
    navigation: __WEBPACK_IMPORTED_MODULE_1__components_navigation__["a" /* default */],
    mhdfooter: __WEBPACK_IMPORTED_MODULE_2__components_mhdfooter__["a" /* default */]
  },
  mounted: function mounted() {
    document.dispatchEvent(new Event('render-event'));
  }
});

/***/ }),
/* 25 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(1);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  computed: {
    products: function products() {
      return this.$store.getters.cartProducts;
    },
    itemsInCart: function itemsInCart() {
      var cart = this.$store.getters.cartProducts;
      return cart.reduce(function (accum, item) {
        return accum + item.quantity;
      }, 0);
    },
    total: function total() {
      return this.products.reduce(function (total, p) {
        return total + p.price * p.quantity;
      }, 0);
    }
  },
  methods: Object(__WEBPACK_IMPORTED_MODULE_0_vuex__["b" /* mapActions */])(['removeItem'])
});

/***/ }),
/* 26 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex_map_fields__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      isActive: false,
      isAccount: false,
      isCart: false
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    products: function products() {
      return this.$store.getters.cartProducts;
    },
    itemsInCart: function itemsInCart() {
      var cart = this.$store.getters.cartProducts;
      return cart.reduce(function (accum, item) {
        return accum + item.quantity;
      }, 0);
    },
    total: function total() {
      return this.products.reduce(function (total, p) {
        return total + p.price * p.quantity;
      }, 0);
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])({ isAuthenticated: 'isAuthenticated' }), Object(__WEBPACK_IMPORTED_MODULE_2_vuex_map_fields__["b" /* mapFields */])(['loginInfo.email', 'loginInfo.password', 'loginInfo.phonenumber', 'registreInfo.emailregister', 'registreInfo.prenomregister', 'registreInfo.nomregister', 'registreInfo.phonenumberregister', 'registreInfo.passwordregister'])),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    cancelCart: function cancelCart() {
      var _this = this;

      this.isActive = true;
      this.$nextTick(function () {
        return _this.isActive = false;
      });
      this.isCart = false;
    },
    cancelAccount: function cancelAccount() {
      var _this2 = this;

      this.isActive = true;
      this.$nextTick(function () {
        return _this2.isActive = false;
      });
      this.isAccount = false;
    },
    openFbLoginDialog: function openFbLoginDialog() {
      FB.login(this.checkLoginState, { scope: 'email' });
    },

    checkLoginState: function checkLoginState(response) {
      if (response.status === 'connected') {
        console.log(response.authResponse.accessToken);
        this.$store.dispatch('fblogin', response.authResponse.accessToken);
        this.cancelAccount();
        /*FB.api('/me', { fields: 'name,email' }, function(profile) {
          console.log('Good to see you, ' + profile.name + '.');
        });
        } else if (response.status === 'not_authorized') {
        // the user is logged in to Facebook,
        // but has not authenticated your app
        } else {
        // the user isn't logged in to Facebook.
        }*/
      }
    },
    login: function login() {
      this.$store.dispatch('login');
      this.cancelAccount();
    },
    register: function register() {
      this.$store.dispatch('register');
      this.cancelAccount();
    },
    logout: function logout() {
      this.$store.dispatch('logout');
      this.cancelAccount();
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])(['removeItem']))
});

/***/ }),
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({});

/***/ }),
/* 41 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_owl_carousel_dist_assets_owl_carousel_css__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_owl_carousel_dist_assets_owl_carousel_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_owl_carousel_dist_assets_owl_carousel_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_owl_carousel__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_owl_carousel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_owl_carousel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_jquery__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__main_js__ = __webpack_require__(15);



var _data$computed$watch$;

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

//for carousel in home page







/* harmony default export */ __webpack_exports__["a"] = (_data$computed$watch$ = {
  data: function data() {
    return {
      show: true
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({
    fetchComplete: function fetchComplete() {
      return this.$store.state.fetchedData;
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_5_vuex__["c" /* mapGetters */])({

    products: 'lastProducts',
    products2: 'lastProducts2'
  })),
  watch: {
    fetchComplete: function fetchComplete() {
      if (this.fetchComplete) {
        //create the owl carousel until i fetch the data fechedData=true in the store
        this.$nextTick(function () {
          var _$$owlCarousel, _$$owlCarousel2;

          __WEBPACK_IMPORTED_MODULE_4_jquery___default()('#top-category').owlCarousel((_$$owlCarousel = {
            nav: false,
            dots: true,
            margin: 30,
            responsiveClass: true,
            autoplay: true,
            autoplayTimeout: 7000,
            loop: true
          }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_$$owlCarousel, 'dots', true), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_$$owlCarousel, 'responsive', {
            0: { items: 1 },
            576: { items: 2 },
            768: { items: 3 },
            991: { items: 4 },
            1200: { items: 4 }
          }), _$$owlCarousel));
          __WEBPACK_IMPORTED_MODULE_4_jquery___default()('#top-categoryH').owlCarousel((_$$owlCarousel2 = {
            nav: false,
            dots: true,
            margin: 30,
            responsiveClass: true,
            autoplay: true,
            autoplayTimeout: 7000,
            loop: true
          }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_$$owlCarousel2, 'dots', true), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_$$owlCarousel2, 'responsive', {
            0: { items: 1 },
            576: { items: 2 },
            768: { items: 3 },
            991: { items: 4 },
            1200: { items: 4 }
          }), _$$owlCarousel2));
        });
      }
    }
  },
  //need this for redirection from another page like from all back to home
  mounted: function mounted() {
    if (this.fetchComplete) {
      this.$nextTick(function () {
        var _$$owlCarousel3, _$$owlCarousel4;

        __WEBPACK_IMPORTED_MODULE_4_jquery___default()('#top-category').owlCarousel((_$$owlCarousel3 = {
          nav: false,
          dots: true,
          margin: 30,
          responsiveClass: true,
          autoplay: true,
          autoplayTimeout: 7000,
          loop: true
        }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_$$owlCarousel3, 'dots', true), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_$$owlCarousel3, 'responsive', {
          0: { items: 1 },
          576: { items: 2 },
          768: { items: 3 },
          991: { items: 4 },
          1200: { items: 4 }
        }), _$$owlCarousel3));
        __WEBPACK_IMPORTED_MODULE_4_jquery___default()('#top-categoryH').owlCarousel((_$$owlCarousel4 = {
          nav: false,
          dots: true,
          margin: 30,
          responsiveClass: true,
          autoplay: true,
          autoplayTimeout: 7000,
          loop: true
        }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_$$owlCarousel4, 'dots', true), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_$$owlCarousel4, 'responsive', {
          0: { items: 1 },
          576: { items: 2 },
          768: { items: 3 },
          991: { items: 4 },
          1200: { items: 4 }
        }), _$$owlCarousel4));
      });
    }
  },
  created: function created() {
    this.$store.dispatch('lastProduct', { limit: 18 });

    this.$nextTick(function () {
      __WEBPACK_IMPORTED_MODULE_4_jquery___default()('#mhdfeature').owlCarousel({
        nav: false,
        dots: true,
        margin: 30,
        responsive: {
          0: { items: 1 },
          576: { items: 2 },
          768: { items: 3 },
          991: { items: 3 },
          1200: { items: 3 }
        }
      });
      __WEBPACK_IMPORTED_MODULE_4_jquery___default()('#slide').owlCarousel({
        items: 1,
        loop: true,
        autoplay: true,
        autoplayTimeout: 8000
      });
      __WEBPACK_IMPORTED_MODULE_4_jquery___default()('#brands').owlCarousel({
        nav: false,
        dots: false,
        loop: true,
        autoplay: true,
        autoplayTimeout: 4000,
        responsive: {
          0: { items: 2 },
          470: { items: 3 },
          630: { items: 4 },
          991: { items: 5 },
          1200: { items: 6 }
        }
      });
    });
  }
}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_data$computed$watch$, 'data', function data() {
  return {
    sales: false,
    discount: 0
  };
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_data$computed$watch$, 'methods', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({
  addToCart: function addToCart(item) {
    var _this = this;

    this.$store.dispatch('addToCart', item).then(function () {
      _this.$notify({
        group: 'cart',
        title: 'Product',
        type: 'success',
        text: 'vous avez ajouter un produit au panier'
      });
    }).catch(function (error) {
      return console.log(error);
    });
  }
}, Object(__WEBPACK_IMPORTED_MODULE_5_vuex__["b" /* mapActions */])(['ProductDetail', 'ProductDetail2']))), _data$computed$watch$);

/***/ }),
/* 42 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 43 */,
/* 44 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(1);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])({
    products: 'cartProducts'
  }), {
    total: function total() {
      return this.products.reduce(function (total, p) {
        return total + p.price * p.quantity;
      }, 0);
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    checkout: function checkout() {
      alert('Pay us $' + this.total);
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])(['clearCart', 'removeItem']))
});

/***/ }),
/* 45 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_zoom__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_zoom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_zoom__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

//vuex mapgetters and mapactions

//vue zoom


/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    vZoom: __WEBPACK_IMPORTED_MODULE_1_vue_zoom___default.a
  },
  computed: Object(__WEBPACK_IMPORTED_MODULE_0_vuex__["c" /* mapGetters */])({
    product: 'detailProduct', //<=>this.$store.getters.detailProducts
    images: 'allImages'

  }),
  methods: Object(__WEBPACK_IMPORTED_MODULE_0_vuex__["b" /* mapActions */])(['addToCart'])
});

/***/ }),
/* 46 */,
/* 47 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex_map_fields__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(1);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    isComplete: function isComplete() {
      return this.phoneNumber;
    },
    total: function total() {
      return this.products.reduce(function (total, p) {
        return total + p.price * p.quantity;
      }, 0);
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapGetters */])({ products: 'cartProducts', isAuthenticated: 'isAuthenticated' }), Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])(['user_info']), Object(__WEBPACK_IMPORTED_MODULE_1_vuex_map_fields__["b" /* mapFields */])(['commandeInfo.phoneNumber']))
});

/***/ }),
/* 48 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(1);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    total: function total() {
      return this.products.reduce(function (total, p) {
        return total + p.price * p.quantity;
      }, 0);
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])({
    products: 'cartProducts'
  }))
});

/***/ }),
/* 49 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex_map_fields__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(1);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    isComplete: function isComplete() {
      return this.firstName && this.address && this.lastName && this.deliveryAddress && this.phoneNumber && this.deliveryWilaya;
    },
    total: function total() {
      return this.products.reduce(function (total, p) {
        return total + p.price * p.quantity;
      }, 0);
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapGetters */])({ products: 'cartProducts', isAuthenticated: 'isAuthenticated', user: 'user' }), Object(__WEBPACK_IMPORTED_MODULE_1_vuex_map_fields__["b" /* mapFields */])(['user.firstName', 'user.lastName', 'user.address', 'user.phoneNumber', 'user.email', 'user.deliveryAddress', 'user.billingAdress', 'user.deliveryPostalCode', 'user.deliveryFirstName', 'user.deliveryLastName', 'user.deliveryPhoneNumber', 'user.deliveryWilaya', 'user.wilaya']))
});

/***/ }),
/* 50 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex_map_fields__ = __webpack_require__(11);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    status: function status() {
      return this.$store.state.statusCode;
    },
    total: function total() {
      return this.products.reduce(function (total, p) {
        return total + p.price * p.quantity;
      }, 0);
    },
    commande: function commande() {
      //let current = this.$store.getters.getCommandeInfo;
      if (this.firstName === '' || this.phoneNumber === '' || this.lastName === '' || this.deliveryAddress === '' || this.deliveryFirstName === '' || this.deliveryLastName === '') return false;
      return true;
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])({ products: 'cartProducts' }), Object(__WEBPACK_IMPORTED_MODULE_2_vuex_map_fields__["b" /* mapFields */])(['user.firstName', 'user.lastName', 'user.address', 'user.phoneNumber', 'user.email', 'user.deliveryAddress', 'user.billingAdress', 'user.deliveryFirstName', 'user.deliveryLastName', 'user.deliveryPhoneNumber', 'user.deliveryWilaya', 'user.wilaya'])),
  watch: {
    status: function status() {
      if (this.status === 201) {
        /*this.$notify({
          group: 'cart',
          title: 'Commande',
          type: 'success',
          text: 'successfuly send commande to luxuryshop!'
        });*/
        this.$router.push('/complete');
      }
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    doCommande: function doCommande() {
      this.$store.dispatch('doCommande');
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])(['ProductDettail']))
});

/***/ }),
/* 51 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(1);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])({ order: 'orderId' }))
});

/***/ }),
/* 52 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_pagination_bootstrap__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_range_slider_dist_vue_range_slider_css__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_range_slider_dist_vue_range_slider_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_range_slider_dist_vue_range_slider_css__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




// you probably need to import built-in style

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    pagination: __WEBPACK_IMPORTED_MODULE_2_vue_pagination_bootstrap__["a" /* default */]
  },
  data: function data() {
    var _paginationOptions;

    return {
      sidebarOpen: false,
      priceValue: [15000, 85000],
      sliderValue: 50,
      filter: '',
      currentPage: 1,
      brands: [],
      pageSize: 48,
      paginationOptions: (_paginationOptions = {
        offset: 4,
        previousText: 'Prev'
      }, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_paginationOptions, 'previousText', 'Préc'), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_paginationOptions, 'nextText', 'Suivant'), _paginationOptions)
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapGetters */])({
    products: 'allProducts',
    total: 'totalProduct'
  }), {
    filterProduct: function filterProduct() {
      var filter = new RegExp(this.filter, 'i');
      if (this.brands.length > 0) {
        return this.products.filter(function (el) {
          return el.name.match(filter);
        });
      } else return this.products.filter(function (el) {
        return el.id.match(filter);
      });
    }
  }),
  created: function created() {

    var pagestore = sessionStorage.getItem("page");
    if (pagestore) this.$store.dispatch('fetchData', { page: pagestore, filter: '', gender: '' });else this.$store.dispatch('fetchData', { page: 1, filter: '', gender: '' });
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    pageChanged: function pageChanged(page) {
      this.currentPage = page;
      sessionStorage.setItem("page", page);
      if (this.brands.length > 0 || this.filter == '') {
        var filter = 'price:' + this.priceValue;
        this.$store.dispatch('fetchData', { page: page, filter: this.brands, gender: '' });
      } else {
        var filter2 = 'price:' + this.priceValue;
        this.$store.dispatch('fetchData', { page: page, filter: filter2, gender: '' });
      }
    },
    ordreby: function ordreby(filter) {
      var filter2 = 'ordre:' + filter;
      console.log(filter);
      this.$store.dispatch('fetchData', { page: this.currentPage, filter: filter2, gender: '' });
    },
    submit: function submit() {
      var filter = 'price:' + this.priceValue;
      console.log(filter);
      this.$store.dispatch('fetchData', { page: this.currentPage, filter: filter, gender: '' });
    },

    search: function search(event) {
      var _this = this;

      var debounce = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.debounce(function () {
        if (_this.brands.length === 0) _this.$store.dispatch('fetchData', {
          page: _this.currentPage,
          filter: event.target.value,
          gender: ''
        });
      }, 500);
      debounce();
    },
    brandChecked: function brandChecked(event) {
      var _this2 = this;

      var debounce = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.debounce(function () {
        return _this2.$store.dispatch('fetchData', {
          page: _this2.currentPage,
          filter: _this2.brands,
          gender: ''
        });
      }, 500);
      debounce();
    },
    addToCart: function addToCart(item) {
      var _this3 = this;

      this.$store.dispatch('addToCart', item).then(function () {
        _this3.$notify({
          group: 'cart',
          title: 'Product',
          type: 'success',
          text: 'successfuly added to cart!'
        });
      }).catch(function (error) {
        return console.log(error);
      });
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapActions */])(['ProductDetail']))
});

/***/ }),
/* 53 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_pagination_bootstrap__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_range_slider_dist_vue_range_slider_css__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_range_slider_dist_vue_range_slider_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_range_slider_dist_vue_range_slider_css__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




// you probably need to import built-in style

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    pagination: __WEBPACK_IMPORTED_MODULE_2_vue_pagination_bootstrap__["a" /* default */]
  },
  data: function data() {
    var _paginationOptions;

    return {
      sidebarOpen: false,
      priceValue: [15000, 85000],
      sliderValue: 50,
      filter: '',
      currentPage: 1,
      brands: [],
      pageSize: 48,
      paginationOptions: (_paginationOptions = {
        offset: 4,
        previousText: 'Prev'
      }, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_paginationOptions, 'previousText', 'Préc'), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_paginationOptions, 'nextText', 'Suivant'), _paginationOptions)
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapGetters */])({
    products: 'allProducts',
    total: 'totalProduct'
  }), {
    filterProduct: function filterProduct() {
      var filter = new RegExp(this.filter, 'i');
      if (this.brands.length > 0) {
        return this.products.filter(function (el) {
          return el.name.match(filter);
        });
      } else return this.products.filter(function (el) {
        return el.id.match(filter);
      });
    }
  }),
  created: function created() {

    var pagestore = sessionStorage.getItem("page");
    if (pagestore) this.$store.dispatch('fetchData', { page: pagestore, filter: '', gender: '' });else this.$store.dispatch('fetchData', { page: 1, filter: '', gender: '' });
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    pageChanged: function pageChanged(page) {
      this.currentPage = page;
      sessionStorage.setItem("page", page);
      if (this.brands.length > 0 || this.filter == '') {
        var filter = 'price:' + this.priceValue;
        this.$store.dispatch('fetchData', { page: page, filter: this.brands, gender: '' });
      } else {
        var filter2 = 'price:' + this.priceValue;
        this.$store.dispatch('fetchData', { page: page, filter: filter2, gender: '' });
      }
    },
    ordreby: function ordreby(filter) {
      var filter2 = 'ordre:' + filter;
      console.log(filter);
      this.$store.dispatch('fetchData', { page: this.currentPage, filter: filter2, gender: '' });
    },
    submit: function submit() {
      var filter = 'price:' + this.priceValue;
      console.log(filter);
      this.$store.dispatch('fetchData', { page: this.currentPage, filter: filter, gender: '' });
    },

    search: function search(event) {
      var _this = this;

      var debounce = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.debounce(function () {
        if (_this.brands.length === 0) _this.$store.dispatch('fetchData', {
          page: _this.currentPage,
          filter: event.target.value,
          gender: ''
        });
      }, 500);
      debounce();
    },
    brandChecked: function brandChecked(event) {
      var _this2 = this;

      var debounce = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.debounce(function () {
        return _this2.$store.dispatch('fetchData', {
          page: _this2.currentPage,
          filter: _this2.brands,
          gender: ''
        });
      }, 500);
      debounce();
    },
    addToCart: function addToCart(item) {
      var _this3 = this;

      this.$store.dispatch('addToCart', item).then(function () {
        _this3.$notify({
          group: 'cart',
          title: 'Product',
          type: 'success',
          text: 'successfuly added to cart!'
        });
      }).catch(function (error) {
        return console.log(error);
      });
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapActions */])(['ProductDetail']))
});

/***/ }),
/* 54 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({});

/***/ }),
/* 55 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_pagination_bootstrap__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_range_slider_dist_vue_range_slider_css__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_range_slider_dist_vue_range_slider_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_range_slider_dist_vue_range_slider_css__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




// you probably need to import built-in style

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    pagination: __WEBPACK_IMPORTED_MODULE_2_vue_pagination_bootstrap__["a" /* default */]
  },
  data: function data() {
    var _paginationOptions;

    return {
      sidebarOpen: false,
      priceValue: [15000, 85000],
      sliderValue: 50,
      filter: '',
      currentPage: 1,
      brands: [],
      pageSize: 48,
      paginationOptions: (_paginationOptions = {
        offset: 4,
        previousText: 'Prev'
      }, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_paginationOptions, 'previousText', 'Préc'), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_paginationOptions, 'nextText', 'Suivant'), _paginationOptions)
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapGetters */])({ products: 'menProducts', total: 'menCount' }), {
    filterProduct: function filterProduct() {
      var filter = new RegExp(this.filter, 'i');
      if (this.brands.length > 0) {
        return this.products.filter(function (el) {
          return el.name.match(filter);
        });
      } else return this.products.filter(function (el) {
        return el.id.match(filter);
      });
    }
  }),
  created: function created() {
    this.$store.dispatch('fetchData', { page: this.currentPage, filter: '', gender: 'H' });
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    pageChanged: function pageChanged(page) {
      this.currentPage = page;
      if (this.brands.length > 0) {
        var filter = 'price:' + this.priceValue;
        this.$store.dispatch('fetchData', { page: page, filter: this.brands, gender: 'H' });
      } else {
        var filter2 = 'price:' + this.priceValue;
        this.$store.dispatch('fetchData', { page: page, filter: '', gender: 'H' });
      }
    },
    submit: function submit() {
      var filter = 'price:' + this.priceValue;
      this.$store.dispatch('fetchData', { page: this.currentPage, filter: filter, gender: 'H' });
    },


    search: function search(event) {
      var _this = this;

      var debounce = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.debounce(function () {
        if (_this.brands.length === 0) _this.$store.dispatch('fetchData', {
          page: _this.currentPage,
          filter: event.target.value,
          gender: 'H'
        });
      }, 500);
      debounce();
    },
    ordreby: function ordreby(filter) {
      var filter2 = 'ordre:' + filter;
      console.log(filter);
      this.$store.dispatch('fetchData', { page: this.currentPage, filter: filter2, gender: '' });
    },

    brandChecked: function brandChecked(event) {
      var _this2 = this;

      var debounce = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.debounce(function () {
        return _this2.$store.dispatch('fetchData', {
          page: _this2.currentPage,
          filter: _this2.brands,
          gender: 'H'
        });
      }, 500);
      debounce();
    },
    addToCart: function addToCart(item) {
      var _this3 = this;

      this.$store.dispatch('addToCart', item).then(function () {
        _this3.$notify({
          group: 'cart',
          title: 'Product',
          type: 'success',
          text: 'successfuly added to cart!'
        });
      });
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapActions */])(['ProductDetail']))
});

/***/ }),
/* 56 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_pagination_bootstrap__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_range_slider_dist_vue_range_slider_css__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_range_slider_dist_vue_range_slider_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_range_slider_dist_vue_range_slider_css__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




// you probably need to import built-in style

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    pagination: __WEBPACK_IMPORTED_MODULE_2_vue_pagination_bootstrap__["a" /* default */]
  },
  data: function data() {
    var _paginationOptions;

    return {
      sidebarOpen: false,
      priceValue: [15000, 85000],
      sliderValue: 50,
      filter: '',
      currentPage: 1,
      brands: [],
      pageSize: 48,
      paginationOptions: (_paginationOptions = {
        offset: 4,
        previousText: 'Prev'
      }, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_paginationOptions, 'previousText', 'Préc'), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_paginationOptions, 'nextText', 'Suivant'), _paginationOptions)
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapGetters */])({

    products: 'productsfestina',
    total: 'totalProductfestina'
  }), {
    //products(){
    //  if (this.$store.state.lastEntriesfestina.length > 0)
    // return this.$store.state.productsfestina
    // else
    //  return this.$store.state.allProducts

    // },

    filterProduct: function filterProduct() {
      var filter = new RegExp(this.filter, 'i');
      if (this.brands.length > 0) {
        return this.products.filter(function (el) {
          return el.name.match(filter);
        });
      } else return this.products.filter(function (el) {
        return el.id.match(filter);
      });
    }
  }),
  created: function created() {
    this.$store.dispatch('fetchDatafestina', { page: 1, filter: '', gender: '' });
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    pageChanged: function pageChanged(page) {
      // this.currentPage = page;
      // if (this.brands.length > 0  ||this.filter =='' ) {
      //  if (this.filter ='')
      //  {
      //    let filter = ``;
      //   this.$store.dispatch('fetchDatafestina', { page: page, filter: filter, gender:this.brands });
      // }

      //  else
      //  {
      //  let filter = `price:${this.priceValue}`;
      //  this.$store.dispatch('fetchDatafestina', { page: page, filter: filter, gender:this.brands });
      // }


      //  } else {
      //    let filter = `price:${this.priceValue}`;
      //   this.$store.dispatch('fetchDatafestina', { page: page, filter: this.filter, gender: '' });
      // }
      // },

      this.currentPage = page;
      if (this.brands.length > 0) {
        var filter = 'price:' + this.priceValue;
        this.$store.dispatch('fetchDatafestina', { page: page, filter: this.brands, gender: '' });
      } else {
        var _filter = 'price:' + this.priceValue;
        this.$store.dispatch('fetchDatafestina', { page: page, filter: this.filter, gender: '' });
      }
    },
    ordreby: function ordreby(filter) {
      var filter2 = 'ordre:' + filter;
      console.log(filter);
      this.$store.dispatch('fetchDatafestina', { page: this.currentPage, filter: filter2, gender: '' });
    },
    submit: function submit() {
      var filter = 'price:' + this.priceValue;
      console.log(filter);
      if (this.brands.length > 0) {
        this.$store.dispatch('fetchDatafestina', { page: this.currentPage, filter: filter, gender: this.brands });
      } else {

        this.$store.dispatch('fetchDatafestina', { page: this.currentPage, filter: filter, gender: '' });
      }
    },

    search: function search(event) {
      var _this = this;

      var debounce = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.debounce(function () {
        if (_this.brands.length === 0) _this.$store.dispatch('fetchData', {
          page: _this.currentPage,
          filter: event.target.value,
          gender: ''
        });
      }, 500);
      debounce();
    },
    brandChecked: function brandChecked(event) {
      var _this2 = this;

      var debounce = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.debounce(function () {
        return _this2.$store.dispatch('fetchDatafestina', {
          page: _this2.currentPage,
          filter: _this2.brands,
          gender: ''
        });
      }, 500);
      debounce();
    },
    addToCart: function addToCart(item) {
      var _this3 = this;

      this.$store.dispatch('addToCart', item).then(function () {
        _this3.$notify({
          group: 'cart',
          title: 'Product',
          type: 'success',
          text: 'successfuly added to cart!'
        });
      }).catch(function (error) {
        return console.log(error);
      });
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapActions */])(['lastProductfestina', 'ProductDetail']))
});

/***/ }),
/* 57 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_pagination_bootstrap__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_range_slider_dist_vue_range_slider_css__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_range_slider_dist_vue_range_slider_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_range_slider_dist_vue_range_slider_css__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




// you probably need to import built-in style

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    pagination: __WEBPACK_IMPORTED_MODULE_2_vue_pagination_bootstrap__["a" /* default */]
  },
  data: function data() {
    var _paginationOptions;

    return {
      sidebarOpen: false,
      priceValue: [15000, 85000],
      sliderValue: 50,
      filter: '',
      currentPage: 1,
      brands: [],
      pageSize: 48,
      paginationOptions: (_paginationOptions = {
        offset: 4,
        previousText: 'Prev'
      }, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_paginationOptions, 'previousText', 'Préc'), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_paginationOptions, 'nextText', 'Suivant'), _paginationOptions)
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapGetters */])({

    products: 'productsfestinadepot',
    total: 'totalProductfestinadepot'
  }), {
    //products(){
    //  if (this.$store.state.lastEntriesfestina.length > 0)
    // return this.$store.state.productsfestina
    // else
    //  return this.$store.state.allProducts

    // },

    filterProduct: function filterProduct() {
      var filter = new RegExp(this.filter, 'i');
      if (this.brands.length > 0) {
        return this.products.filter(function (el) {
          return el.name.match(filter);
        });
      } else return this.products.filter(function (el) {
        return el.id.match(filter);
      });
    }
  }),
  created: function created() {
    this.$store.dispatch('fetchDatafestinadepot', { page: 1, filter: '', gender: '' });
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    pageChanged: function pageChanged(page) {
      this.currentPage = page;
      sessionStorage.setItem("page", page);
      if (this.filter2 !== '') {
        var filter = 'price:' + this.priceValue;
        this.$store.dispatch('fetchDatafestinadepot', { page: page, filter: this.filter, gender: '' });
      } else {
        this.$store.dispatch('fetchDatafestinadepot', { page: page, filter: this.filter2, gender: '' });
      }
    },
    ordreby: function ordreby(filter) {
      var filter2 = 'ordre:' + filter;
      sessionStorage.setItem("filter2", filter2);
      console.log(filter);
      this.$store.dispatch('fetchDatafestinadepot', { page: this.currentPage, filter: filter2, gender: '' });
    },
    submit: function submit() {
      var filter = 'price:' + this.priceValue;
      console.log(filter);
      if (this.brands.length > 0) {
        this.$store.dispatch('fetchDatafestinadepot', { page: this.currentPage, filter: filter, gender: this.brands });
      } else {

        this.$store.dispatch('fetchDatafestinadepot', { page: this.currentPage, filter: filter, gender: '' });
      }
    },

    search: function search(event) {
      var _this = this;

      var debounce = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.debounce(function () {
        if (_this.brands.length === 0) _this.$store.dispatch('fetchData', {
          page: _this.currentPage,
          filter: event.target.value,
          gender: ''
        });
      }, 500);
      debounce();
    },
    brandChecked: function brandChecked(event) {
      var _this2 = this;

      var debounce = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.debounce(function () {
        return _this2.$store.dispatch('fetchDatafestinadepot', {
          page: _this2.currentPage,
          filter: _this2.brands,
          gender: ''
        });
      }, 500);
      debounce();
    },
    addToCart: function addToCart(item) {
      var _this3 = this;

      this.$store.dispatch('addToCart', item).then(function () {
        _this3.$notify({
          group: 'cart',
          title: 'Product',
          type: 'success',
          text: 'successfuly added to cart!'
        });
      }).catch(function (error) {
        return console.log(error);
      });
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapActions */])(['lastProductfestinadepot', 'ProductDetail']))
});

/***/ }),
/* 58 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_pagination_bootstrap__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_range_slider_dist_vue_range_slider_css__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_range_slider_dist_vue_range_slider_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_range_slider_dist_vue_range_slider_css__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




// you probably need to import built-in style

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    pagination: __WEBPACK_IMPORTED_MODULE_2_vue_pagination_bootstrap__["a" /* default */]
  },
  data: function data() {
    var _paginationOptions;

    return {
      sidebarOpen: false,
      priceValue: [15000, 85000],
      sliderValue: 50,
      filter: '',
      currentPage: 1,
      brands: [],
      pageSize: 24,
      paginationOptions: (_paginationOptions = {
        offset: 4,
        previousText: 'Prev'
      }, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_paginationOptions, 'previousText', 'Préc'), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_paginationOptions, 'nextText', 'Suivant'), _paginationOptions)
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapGetters */])({

    products: 'productsfestinabourdima',
    total: 'totalProductfestina'
  }), {
    //products(){
    //  if (this.$store.state.lastEntriesfestina.length > 0)
    // return this.$store.state.productsfestina
    // else
    //  return this.$store.state.allProducts

    // },

    filterProduct: function filterProduct() {
      var filter = new RegExp(this.filter, 'i');
      if (this.brands.length > 0) {
        return this.products.filter(function (el) {
          return el.name.match(filter);
        });
      } else return this.products.filter(function (el) {
        return el.id.match(filter);
      });
    }
  }),
  created: function created() {
    this.$store.dispatch('fetchDatafestina', { page: 1, filter: '', gender: '' });
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    pageChanged: function pageChanged(page) {
      // this.currentPage = page;
      // if (this.brands.length > 0  ||this.filter =='' ) {
      //  if (this.filter ='')
      //  {
      //    let filter = ``;
      //   this.$store.dispatch('fetchDatafestina', { page: page, filter: filter, gender:this.brands });
      // }

      //  else
      //  {
      //  let filter = `price:${this.priceValue}`;
      //  this.$store.dispatch('fetchDatafestina', { page: page, filter: filter, gender:this.brands });
      // }


      //  } else {
      //    let filter = `price:${this.priceValue}`;
      //   this.$store.dispatch('fetchDatafestina', { page: page, filter: this.filter, gender: '' });
      // }
      // },

      this.currentPage = page;
      if (this.brands.length > 0) {
        var filter = 'price:' + this.priceValue;
        this.$store.dispatch('fetchDatafestina', { page: page, filter: filter, gender: this.brands });
      } else {
        var _filter = 'price:' + this.priceValue;
        this.$store.dispatch('fetchDatafestina', { page: page, filter: this.filter, gender: '' });
      }
    },
    ordreby: function ordreby(filter) {
      var filter2 = 'ordre:' + filter;
      console.log(filter);
      this.$store.dispatch('fetchDatafestina', { page: this.currentPage, filter: filter2, gender: '' });
    },
    submit: function submit() {
      var filter = 'price:' + this.priceValue;
      console.log(filter);
      if (this.brands.length > 0) {
        this.$store.dispatch('fetchDatafestina', { page: this.currentPage, filter: filter, gender: this.brands });
      } else {

        this.$store.dispatch('fetchDatafestina', { page: this.currentPage, filter: filter, gender: '' });
      }
    },

    search: function search(event) {
      var _this = this;

      var debounce = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.debounce(function () {
        if (_this.brands.length === 0) _this.$store.dispatch('fetchData', {
          page: _this.currentPage,
          filter: event.target.value,
          gender: ''
        });
      }, 500);
      debounce();
    },
    brandChecked: function brandChecked(event) {
      var _this2 = this;

      var debounce = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.debounce(function () {
        return _this2.$store.dispatch('fetchDatafestina', {
          page: _this2.currentPage,
          filter: _this2.brands,
          gender: ''
        });
      }, 500);
      debounce();
    },
    addToCart: function addToCart(item) {
      var _this3 = this;

      this.$store.dispatch('addToCart', item).then(function () {
        _this3.$notify({
          group: 'cart',
          title: 'Product',
          type: 'success',
          text: 'successfuly added to cart!'
        });
      }).catch(function (error) {
        return console.log(error);
      });
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapActions */])(['lastProductfestina', 'ProductDetail']))
});

/***/ }),
/* 59 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_pagination_bootstrap__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_range_slider_dist_vue_range_slider_css__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_range_slider_dist_vue_range_slider_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_range_slider_dist_vue_range_slider_css__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




// you probably need to import built-in style

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    pagination: __WEBPACK_IMPORTED_MODULE_2_vue_pagination_bootstrap__["a" /* default */]
  },
  data: function data() {
    var _paginationOptions;

    return {
      sidebarOpen: false,
      priceValue: [15000, 85000],
      sliderValue: 50,
      filter: '',
      currentPage: 1,
      brands: [],
      pageSize: 24,
      paginationOptions: (_paginationOptions = {
        offset: 4,
        previousText: 'Prev'
      }, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_paginationOptions, 'previousText', 'Préc'), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_paginationOptions, 'nextText', 'Suivant'), _paginationOptions)
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapGetters */])({

    products: 'productsfossil',
    total: 'totalProductfossil'
  }), {
    //products(){
    //  if (this.$store.state.lastEntriesfossil.length > 0)
    // return this.$store.state.productsfossil
    // else
    //  return this.$store.state.allProducts

    // },
    filterProduct: function filterProduct() {
      var filter = new RegExp(this.filter, 'i');
      if (this.brands.length > 0) {
        return this.products.filter(function (el) {
          return el.name.match(filter);
        });
      } else return this.products.filter(function (el) {
        return el.id.match(filter);
      });
    }
  }),
  created: function created() {
    this.$store.dispatch('fetchDatafossil', { page: 1, filter: '', gender: '' });
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    // pageChanged(page) {
    // this.currentPage = page;
    //if (this.brands.length > 0 ) {
    //  this.$store.dispatch('fetchDatafossil', { page: page, filter: filter, gender:this.brands });
    //} else {
    //   let filter = `price:${this.priceValue}`;
    //  this.$store.dispatch('fetchDatafossil', { page: page, filter: this.filter, gender: '' });
    // }
    //},


    pageChanged: function pageChanged(page) {

      this.currentPage = page;
      if (this.brands.length > 0) {
        var filter = 'price:' + this.priceValue;
        this.$store.dispatch('fetchDatafossil', { page: page, filter: filter, gender: this.brands });
      } else {
        var _filter = 'price:' + this.priceValue;
        this.$store.dispatch('fetchDatafossil', { page: page, filter: this.filter, gender: '' });
      }
    },
    ordreby: function ordreby(filter) {
      var filter2 = 'ordre:' + filter;
      console.log(filter);
      this.$store.dispatch('fetchDatafossil', { page: this.currentPage, filter: filter2, gender: '' });
    },
    submit: function submit() {
      var filter = 'price:' + this.priceValue;
      console.log(filter);
      if (this.brands.length > 0) {
        this.$store.dispatch('fetchDatafossil', { page: this.currentPage, filter: filter, gender: this.brands });
      } else {

        this.$store.dispatch('fetchDatafossil', { page: this.currentPage, filter: filter, gender: '' });
      }
    },

    search: function search(event) {
      var _this = this;

      var debounce = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.debounce(function () {
        if (_this.brands.length === 0) _this.$store.dispatch('fetchDatafossil', {
          page: _this.currentPage,
          filter: event.target.value,
          gender: ''
        });
      }, 500);
      debounce();
    },
    brandChecked: function brandChecked(event) {
      var _this2 = this;

      var debounce = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.debounce(function () {
        return _this2.$store.dispatch('fetchDatafossil', {
          page: _this2.currentPage,
          filter: _this2.brands,
          gender: ''
        });
      }, 500);
      debounce();
    },
    addToCart: function addToCart(item) {
      var _this3 = this;

      this.$store.dispatch('addToCart', item).then(function () {
        _this3.$notify({
          group: 'cart',
          title: 'Product',
          type: 'success',
          text: 'successfuly added to cart!'
        });
      }).catch(function (error) {
        return console.log(error);
      });
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapActions */])(['lastProductfossil', 'ProductDetail']))
});

/***/ }),
/* 60 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_pagination_bootstrap__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_range_slider_dist_vue_range_slider_css__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_range_slider_dist_vue_range_slider_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_range_slider_dist_vue_range_slider_css__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




// you probably need to import built-in style

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    pagination: __WEBPACK_IMPORTED_MODULE_2_vue_pagination_bootstrap__["a" /* default */]
  },
  data: function data() {
    var _paginationOptions;

    return {
      sidebarOpen: false,
      priceValue: [15000, 85000],
      sliderValue: 50,
      filter: '',
      currentPage: 1,
      brands: [],
      pageSize: 24,
      paginationOptions: (_paginationOptions = {
        offset: 4,
        previousText: 'Prev'
      }, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_paginationOptions, 'previousText', 'Préc'), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_paginationOptions, 'nextText', 'Suivant'), _paginationOptions)
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapGetters */])({

    products: 'productsarmani',
    total: 'totalProductarmani'
  }), {
    //products(){
    //  if (this.$store.state.lastEntriesarmani.length > 0)
    // return this.$store.state.productsarmani
    // else
    //  return this.$store.state.allProducts

    // },
    filterProduct: function filterProduct() {
      var filter = new RegExp(this.filter, 'i');
      if (this.brands.length > 0) {
        return this.products.filter(function (el) {
          return el.name.match(filter);
        });
      } else return this.products.filter(function (el) {
        return el.id.match(filter);
      });
    }
  }),
  created: function created() {
    this.$store.dispatch('fetchDataarmani', { page: 1, filter: '', gender: '' });
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    pageChanged: function pageChanged(page) {
      this.currentPage = page;
      if (this.brands.length > 0) {
        var filter = 'price:' + this.priceValue;
        this.$store.dispatch('fetchDataarmani', { page: page, filter: filter, gender: this.brands });
      } else {
        var _filter = 'price:' + this.priceValue;
        this.$store.dispatch('fetchDataarmani', { page: page, filter: this.filter, gender: '' });
      }
    },
    ordreby: function ordreby(filter) {
      var filter2 = 'ordre:' + filter;
      console.log(filter);
      this.$store.dispatch('fetchDataarmani', { page: this.currentPage, filter: filter2, gender: '' });
    },
    submit: function submit() {
      var filter = 'price:' + this.priceValue;
      console.log(filter);
      if (this.brands.length > 0) {
        this.$store.dispatch('fetchDataarmani', { page: this.currentPage, filter: filter, gender: this.brands });
      } else {

        this.$store.dispatch('fetchDataarmani', { page: this.currentPage, filter: filter, gender: '' });
      }
    },

    search: function search(event) {
      var _this = this;

      var debounce = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.debounce(function () {
        if (_this.brands.length === 0) _this.$store.dispatch('fetchDataarmani', {
          page: _this.currentPage,
          filter: event.target.value,
          gender: ''
        });
      }, 500);
      debounce();
    },
    brandChecked: function brandChecked(event) {
      var _this2 = this;

      var debounce = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.debounce(function () {
        return _this2.$store.dispatch('fetchDataarmani', {
          page: _this2.currentPage,
          filter: _this2.brands,
          gender: ''
        });
      }, 500);
      debounce();
    },
    addToCart: function addToCart(item) {
      var _this3 = this;

      this.$store.dispatch('addToCart', item).then(function () {
        _this3.$notify({
          group: 'cart',
          title: 'Product',
          type: 'success',
          text: 'successfuly added to cart!'
        });
      }).catch(function (error) {
        return console.log(error);
      });
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapActions */])(['lastProductarmani', 'ProductDetail']))
});

/***/ }),
/* 61 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_pagination_bootstrap__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_range_slider_dist_vue_range_slider_css__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_range_slider_dist_vue_range_slider_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_range_slider_dist_vue_range_slider_css__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




// you probably need to import built-in style

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    pagination: __WEBPACK_IMPORTED_MODULE_2_vue_pagination_bootstrap__["a" /* default */]
  },
  data: function data() {
    var _paginationOptions;

    return {
      sidebarOpen: false,
      priceValue: [15000, 85000],
      sliderValue: 50,
      filter: '',
      currentPage: 1,
      brands: [],
      pageSize: 24,
      paginationOptions: (_paginationOptions = {
        offset: 4,
        previousText: 'Prev'
      }, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_paginationOptions, 'previousText', 'Préc'), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_paginationOptions, 'nextText', 'Suivant'), _paginationOptions)
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapGetters */])({

    products: 'productsdiesel',
    total: 'totalProductdiesel'
  }), {
    //products(){
    //  if (this.$store.state.lastEntriesdiesel.length > 0)
    // return this.$store.state.productsdiesel
    // else
    //  return this.$store.state.allProducts

    // },
    filterProduct: function filterProduct() {
      var filter = new RegExp(this.filter, 'i');
      if (this.brands.length > 0) {
        return this.products.filter(function (el) {
          return el.name.match(filter);
        });
      } else return this.products.filter(function (el) {
        return el.id.match(filter);
      });
    }
  }),
  created: function created() {
    this.$store.dispatch('fetchDatadiesel', { page: 1, filter: '', gender: '' });
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    pageChanged: function pageChanged(page) {
      this.currentPage = page;
      if (this.brands.length > 0) {
        var filter = 'price:' + this.priceValue;
        this.$store.dispatch('fetchDatadiesel', { page: page, filter: filter, gender: this.brands });
      } else {
        var _filter = 'price:' + this.priceValue;
        this.$store.dispatch('fetchDatadiesel', { page: page, filter: this.filter, gender: '' });
      }
    },
    ordreby: function ordreby(filter) {
      var filter2 = 'ordre:' + filter;
      console.log(filter);
      this.$store.dispatch('fetchDatadiesel', { page: this.currentPage, filter: filter2, gender: '' });
    },
    submit: function submit() {
      var filter = 'price:' + this.priceValue;
      console.log(filter);
      if (this.brands.length > 0) {
        this.$store.dispatch('fetchDatadiesel', { page: this.currentPage, filter: filter, gender: this.brands });
      } else {

        this.$store.dispatch('fetchDatadiesel', { page: this.currentPage, filter: filter, gender: '' });
      }
    },

    search: function search(event) {
      var _this = this;

      var debounce = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.debounce(function () {
        if (_this.brands.length === 0) _this.$store.dispatch('fetchDatadiesel', {
          page: _this.currentPage,
          filter: event.target.value,
          gender: ''
        });
      }, 500);
      debounce();
    },
    brandChecked: function brandChecked(event) {
      var _this2 = this;

      var debounce = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.debounce(function () {
        return _this2.$store.dispatch('fetchDatadiesel', {
          page: _this2.currentPage,
          filter: _this2.brands,
          gender: ''
        });
      }, 500);
      debounce();
    },
    addToCart: function addToCart(item) {
      var _this3 = this;

      this.$store.dispatch('addToCart', item).then(function () {
        _this3.$notify({
          group: 'cart',
          title: 'Product',
          type: 'success',
          text: 'successfuly added to cart!'
        });
      }).catch(function (error) {
        return console.log(error);
      });
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapActions */])(['lastProductdiesel', 'ProductDetail']))
});

/***/ }),
/* 62 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_owl_carousel_dist_assets_owl_carousel_css__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_owl_carousel_dist_assets_owl_carousel_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_owl_carousel_dist_assets_owl_carousel_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_owl_carousel__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_owl_carousel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_owl_carousel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_jquery__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_zoom__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_zoom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_zoom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__main_js__ = __webpack_require__(15);



var _components$data$comp;

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

//for carousel in home page








/* harmony default export */ __webpack_exports__["a"] = (_components$data$comp = {
  components: {
    vZoom: __WEBPACK_IMPORTED_MODULE_5_vue_zoom___default.a
  },
  data: function data() {
    return {
      show: true
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({
    fetchComplete: function fetchComplete() {
      return this.$store.state.fetchDatapromo;
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_6_vuex__["c" /* mapGetters */])({
    products2: 'lastProductspromos',
    product: 'detailProduct', //<=>this.$store.getters.detailProducts
    images: 'allImages'
  })),

  watch: {
    fetchComplete: function fetchComplete() {
      if (this.fetchComplete) {
        //create the owl carousel until i fetch the data fechedData=true in the store
        this.$nextTick(function () {
          var _$$owlCarousel, _$$owlCarousel2;

          __WEBPACK_IMPORTED_MODULE_4_jquery___default()('#top-category').owlCarousel((_$$owlCarousel = {
            nav: false,
            dots: true,
            margin: 30,
            responsiveClass: true,
            autoplay: true,
            autoplayTimeout: 7000,
            loop: true
          }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_$$owlCarousel, 'dots', true), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_$$owlCarousel, 'responsive', {
            0: { items: 1 },
            576: { items: 2 },
            768: { items: 3 },
            991: { items: 4 },
            1200: { items: 4 }
          }), _$$owlCarousel));
          __WEBPACK_IMPORTED_MODULE_4_jquery___default()('#top-categoryH').owlCarousel((_$$owlCarousel2 = {
            nav: false,
            dots: true,
            margin: 30,
            responsiveClass: true,
            autoplay: true,
            autoplayTimeout: 7000,
            loop: true
          }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_$$owlCarousel2, 'dots', true), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_$$owlCarousel2, 'responsive', {
            0: { items: 1 },
            576: { items: 2 },
            768: { items: 3 },
            991: { items: 4 },
            1200: { items: 4 }
          }), _$$owlCarousel2));
        });
      }
    }
  },
  //need this for redirection from another page like from all back to home
  mounted: function mounted() {
    if (this.fetchComplete) {
      this.$nextTick(function () {
        var _$$owlCarousel3, _$$owlCarousel4;

        __WEBPACK_IMPORTED_MODULE_4_jquery___default()('#top-category').owlCarousel((_$$owlCarousel3 = {
          nav: false,
          dots: true,
          margin: 30,
          responsiveClass: true,
          autoplay: true,
          autoplayTimeout: 7000,
          loop: true
        }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_$$owlCarousel3, 'dots', true), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_$$owlCarousel3, 'responsive', {
          0: { items: 1 },
          576: { items: 2 },
          768: { items: 3 },
          991: { items: 4 },
          1200: { items: 4 }
        }), _$$owlCarousel3));
        __WEBPACK_IMPORTED_MODULE_4_jquery___default()('#top-categoryH').owlCarousel((_$$owlCarousel4 = {
          nav: false,
          dots: true,
          margin: 30,
          responsiveClass: true,
          autoplay: true,
          autoplayTimeout: 7000,
          loop: true
        }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_$$owlCarousel4, 'dots', true), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_$$owlCarousel4, 'responsive', {
          0: { items: 1 },
          576: { items: 2 },
          768: { items: 3 },
          991: { items: 4 },
          1200: { items: 4 }
        }), _$$owlCarousel4));
      });
    }
  },
  created: function created() {
    var refe = this.$route.params.ref;
    this.$store.dispatch('fetchDataref', { refe: refe });

    this.$nextTick(function () {
      __WEBPACK_IMPORTED_MODULE_4_jquery___default()('#mhdfeature').owlCarousel({
        nav: false,
        dots: true,
        margin: 30,
        responsive: {
          0: { items: 1 },
          576: { items: 2 },
          768: { items: 3 },
          991: { items: 3 },
          1200: { items: 3 }
        }
      });
      __WEBPACK_IMPORTED_MODULE_4_jquery___default()('#slide').owlCarousel({
        items: 1,
        loop: true,
        autoplay: true,
        autoplayTimeout: 8000
      });
      __WEBPACK_IMPORTED_MODULE_4_jquery___default()('#brands').owlCarousel({
        nav: false,
        dots: false,
        loop: true,
        autoplay: true,
        autoplayTimeout: 4000,
        responsive: {
          0: { items: 2 },
          470: { items: 3 },
          630: { items: 4 },
          991: { items: 5 },
          1200: { items: 6 }
        }
      });
    });
  }
}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components$data$comp, 'data', function data() {
  return {
    sales: false,
    discount: 0
  };
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components$data$comp, 'methods', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({
  addToCart: function addToCart(item) {
    var _this = this;

    this.$store.dispatch('addToCart', item).then(function () {
      _this.$notify({
        group: 'cart',
        title: 'Product',
        type: 'success',
        text: 'vous avez ajouter un produit au panier'
      });
    }).catch(function (error) {
      return console.log(error);
    });
  }

}, Object(__WEBPACK_IMPORTED_MODULE_6_vuex__["b" /* mapActions */])(['addToCart']))), _components$data$comp);

/***/ }),
/* 63 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_pagination_bootstrap__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_range_slider_dist_vue_range_slider_css__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_range_slider_dist_vue_range_slider_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_range_slider_dist_vue_range_slider_css__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




// you probably need to import built-in style

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    pagination: __WEBPACK_IMPORTED_MODULE_2_vue_pagination_bootstrap__["a" /* default */]
  },
  data: function data() {
    var _paginationOptions;

    return {
      sidebarOpen: false,
      priceValue: [15000, 85000],
      sliderValue: 50,
      filter: '',
      currentPage: 1,
      brands: [],
      pageSize: 24,
      paginationOptions: (_paginationOptions = {
        offset: 4,
        previousText: 'Prev'
      }, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_paginationOptions, 'previousText', 'Préc'), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_paginationOptions, 'nextText', 'Suivant'), _paginationOptions)
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapGetters */])({

    products: 'productsMichaelkors',
    total: 'totalProductMichaelkors'
  }), {
    //products(){
    //  if (this.$store.state.lastEntriesMichaelkors.length > 0)
    // return this.$store.state.productsMichaelkors
    // else
    //  return this.$store.state.allProducts

    // },
    filterProduct: function filterProduct() {
      var filter = new RegExp(this.filter, 'i');
      if (this.brands.length > 0) {
        return this.products.filter(function (el) {
          return el.name.match(filter);
        });
      } else return this.products.filter(function (el) {
        return el.id.match(filter);
      });
    }
  }),
  created: function created() {
    this.$store.dispatch('fetchDataMichaelkors', { page: 1, filter: '', gender: '' });
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    // pageChanged(page) {
    // this.currentPage = page;
    //if (this.brands.length > 0 ) {
    //  this.$store.dispatch('fetchDataMichaelkors', { page: page, filter: filter, gender:this.brands });
    //} else {
    //   let filter = `price:${this.priceValue}`;
    //  this.$store.dispatch('fetchDataMichaelkors', { page: page, filter: this.filter, gender: '' });
    // }
    //},


    pageChanged: function pageChanged(page) {

      this.currentPage = page;
      if (this.brands.length > 0) {
        var filter = 'price:' + this.priceValue;
        this.$store.dispatch('fetchDataMichaelkors', { page: page, filter: filter, gender: this.brands });
      } else {
        var _filter = 'price:' + this.priceValue;
        this.$store.dispatch('fetchDataMichaelkors', { page: page, filter: this.filter, gender: '' });
      }
    },
    ordreby: function ordreby(filter) {
      var filter2 = 'ordre:' + filter;
      console.log(filter);
      this.$store.dispatch('fetchDataMichaelkors', { page: this.currentPage, filter: filter2, gender: '' });
    },
    submit: function submit() {
      var filter = 'price:' + this.priceValue;
      console.log(filter);
      if (this.brands.length > 0) {
        this.$store.dispatch('fetchDataMichaelkors', { page: this.currentPage, filter: filter, gender: this.brands });
      } else {

        this.$store.dispatch('fetchDataMichaelkors', { page: this.currentPage, filter: filter, gender: '' });
      }
    },

    search: function search(event) {
      var _this = this;

      var debounce = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.debounce(function () {
        if (_this.brands.length === 0) _this.$store.dispatch('fetchDataMichaelkors', {
          page: _this.currentPage,
          filter: event.target.value,
          gender: ''
        });
      }, 500);
      debounce();
    },
    brandChecked: function brandChecked(event) {
      var _this2 = this;

      var debounce = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.debounce(function () {
        return _this2.$store.dispatch('fetchDataMichaelkors', {
          page: _this2.currentPage,
          filter: _this2.brands,
          gender: ''
        });
      }, 500);
      debounce();
    },
    addToCart: function addToCart(item) {
      var _this3 = this;

      this.$store.dispatch('addToCart', item).then(function () {
        _this3.$notify({
          group: 'cart',
          title: 'Product',
          type: 'success',
          text: 'successfuly added to cart!'
        });
      }).catch(function (error) {
        return console.log(error);
      });
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapActions */])(['lastProductMichaelkors', 'ProductDetail']))
});

/***/ }),
/* 64 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_pagination_bootstrap__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_range_slider_dist_vue_range_slider_css__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_range_slider_dist_vue_range_slider_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_range_slider_dist_vue_range_slider_css__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




// you probably need to import built-in style

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    pagination: __WEBPACK_IMPORTED_MODULE_2_vue_pagination_bootstrap__["a" /* default */]
  },
  data: function data() {
    var _paginationOptions;

    return {
      sidebarOpen: false,
      priceValue: [15000, 85000],
      sliderValue: 50,
      filter: '',
      currentPage: 1,
      brands: [],
      pageSize: 24,
      paginationOptions: (_paginationOptions = {
        offset: 4,
        previousText: 'Prev'
      }, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_paginationOptions, 'previousText', 'Préc'), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_paginationOptions, 'nextText', 'Suivant'), _paginationOptions)
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapGetters */])({
    products: 'allProductsbourdima',
    total: 'totalProduct'
  }), {
    filterProduct: function filterProduct() {
      var filter = new RegExp(this.filter, 'i');
      if (this.brands.length > 0) {
        return this.products.filter(function (el) {
          return el.name.match(filter);
        });
      } else return this.products.filter(function (el) {
        return el.id.match(filter);
      });
    }
  }),
  created: function created() {

    var pagestore = sessionStorage.getItem("page");
    if (pagestore) this.$store.dispatch('fetchData', { page: pagestore, filter: '', gender: '' });else this.$store.dispatch('fetchData', { page: 1, filter: '', gender: '' });
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    pageChanged: function pageChanged(page) {
      this.currentPage = page;
      sessionStorage.setItem("page", page);
      if (this.brands.length > 0 || this.filter == '') {
        var filter = 'price:' + this.priceValue;
        this.$store.dispatch('fetchData', { page: page, filter: this.brands, gender: '' });
      } else {
        var filter2 = 'price:' + this.priceValue;
        this.$store.dispatch('fetchData', { page: page, filter: filter2, gender: '' });
      }
    },
    ordreby: function ordreby(filter) {
      var filter2 = 'ordre:' + filter;
      console.log(filter);
      this.$store.dispatch('fetchData', { page: this.currentPage, filter: filter2, gender: '' });
    },
    submit: function submit() {
      var filter = 'price:' + this.priceValue;
      console.log(filter);
      this.$store.dispatch('fetchData', { page: this.currentPage, filter: filter, gender: '' });
    },

    search: function search(event) {
      var _this = this;

      var debounce = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.debounce(function () {
        if (_this.brands.length === 0) _this.$store.dispatch('fetchData', {
          page: _this.currentPage,
          filter: event.target.value,
          gender: ''
        });
      }, 500);
      debounce();
    },
    brandChecked: function brandChecked(event) {
      var _this2 = this;

      var debounce = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.debounce(function () {
        return _this2.$store.dispatch('fetchData', {
          page: _this2.currentPage,
          filter: _this2.brands,
          gender: ''
        });
      }, 500);
      debounce();
    },
    addToCart: function addToCart(item) {
      var _this3 = this;

      this.$store.dispatch('addToCart', item).then(function () {
        _this3.$notify({
          group: 'cart',
          title: 'Product',
          type: 'success',
          text: 'successfuly added to cart!'
        });
      }).catch(function (error) {
        return console.log(error);
      });
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapActions */])(['ProductDetail']))
});

/***/ }),
/* 65 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_pagination_bootstrap__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_range_slider_dist_vue_range_slider_css__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_range_slider_dist_vue_range_slider_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_range_slider_dist_vue_range_slider_css__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




// you probably need to import built-in style

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    pagination: __WEBPACK_IMPORTED_MODULE_2_vue_pagination_bootstrap__["a" /* default */]
  },
  data: function data() {
    var _paginationOptions;

    return {
      sidebarOpen: false,
      priceValue: [15000, 85000],
      sliderValue: 50,
      filter: '',
      currentPage: 1,
      brands: [],
      pageSize: 12,
      paginationOptions: (_paginationOptions = {
        offset: 4,
        previousText: 'Prev'
      }, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_paginationOptions, 'previousText', 'Préc'), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_paginationOptions, 'nextText', 'Suivant'), _paginationOptions)
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapGetters */])({

    products: 'productsroyal',
    total: 'totalProductroyal'
  }), {
    //products(){
    //  if (this.$store.state.lastEntriesroyal.length > 0)
    // return this.$store.state.productsroyal
    // else
    //  return this.$store.state.allProducts

    // },

    filterProduct: function filterProduct() {
      var filter = new RegExp(this.filter, 'i');
      if (this.brands.length > 0) {
        return this.products.filter(function (el) {
          return el.name.match(filter);
        });
      } else return this.products.filter(function (el) {
        return el.id.match(filter);
      });
    }
  }),
  created: function created() {
    this.$store.dispatch('fetchDataroyal', { page: 1, filter: '', gender: '' });
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    pageChanged: function pageChanged(page) {
      // this.currentPage = page;
      // if (this.brands.length > 0  ||this.filter =='' ) {
      //  if (this.filter ='')
      //  {
      //    let filter = ``;
      //   this.$store.dispatch('fetchDataroyal', { page: page, filter: filter, gender:this.brands });
      // }

      //  else
      //  {
      //  let filter = `price:${this.priceValue}`;
      //  this.$store.dispatch('fetchDataroyal', { page: page, filter: filter, gender:this.brands });
      // }


      //  } else {
      //    let filter = `price:${this.priceValue}`;
      //   this.$store.dispatch('fetchDataroyal', { page: page, filter: this.filter, gender: '' });
      // }
      // },

      this.currentPage = page;
      if (this.brands.length > 0) {
        var filter = 'price:' + this.priceValue;
        this.$store.dispatch('fetchDataroyal', { page: page, filter: filter, gender: this.brands });
      } else {
        var _filter = 'price:' + this.priceValue;
        this.$store.dispatch('fetchDataroyal', { page: page, filter: this.filter, gender: '' });
      }
    },
    ordreby: function ordreby(filter) {
      var filter2 = 'ordre:' + filter;
      console.log(filter);
      this.$store.dispatch('fetchDataroyal', { page: this.currentPage, filter: filter2, gender: '' });
    },
    submit: function submit() {
      var filter = 'price:' + this.priceValue;
      console.log(filter);
      if (this.brands.length > 0) {
        this.$store.dispatch('fetchDataroyal', { page: this.currentPage, filter: filter, gender: this.brands });
      } else {

        this.$store.dispatch('fetchDataroyal', { page: this.currentPage, filter: filter, gender: '' });
      }
    },

    search: function search(event) {
      var _this = this;

      var debounce = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.debounce(function () {
        if (_this.brands.length === 0) _this.$store.dispatch('fetchData', {
          page: _this.currentPage,
          filter: event.target.value,
          gender: ''
        });
      }, 500);
      debounce();
    },
    brandChecked: function brandChecked(event) {
      var _this2 = this;

      var debounce = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.debounce(function () {
        return _this2.$store.dispatch('fetchDataroyal', {
          page: _this2.currentPage,
          filter: _this2.brands,
          gender: ''
        });
      }, 500);
      debounce();
    },
    addToCart: function addToCart(item) {
      var _this3 = this;

      this.$store.dispatch('addToCart', item).then(function () {
        _this3.$notify({
          group: 'cart',
          title: 'Product',
          type: 'success',
          text: 'successfuly added to cart!'
        });
      }).catch(function (error) {
        return console.log(error);
      });
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapActions */])(['lastProductroyal', 'ProductDetail']))
});

/***/ }),
/* 66 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_pagination_bootstrap__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_range_slider_dist_vue_range_slider_css__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_range_slider_dist_vue_range_slider_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_range_slider_dist_vue_range_slider_css__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




// you probably need to import built-in style

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    pagination: __WEBPACK_IMPORTED_MODULE_2_vue_pagination_bootstrap__["a" /* default */]
  },
  data: function data() {
    var _paginationOptions;

    return {
      sidebarOpen: false,
      priceValue: [15000, 85000],
      sliderValue: 50,
      filter: '',
      currentPage: 1,
      brands: [],
      pageSize: 12,
      paginationOptions: (_paginationOptions = {
        offset: 4,
        previousText: 'Prev'
      }, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_paginationOptions, 'previousText', 'Préc'), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_paginationOptions, 'nextText', 'Suivant'), _paginationOptions)
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapGetters */])({

    products: 'productspolice',
    total: 'totalProductpolice'
  }), {
    //products(){
    //  if (this.$store.state.lastEntriespolice.length > 0)
    // return this.$store.state.productspolice
    // else
    //  return this.$store.state.allProducts

    // },

    filterProduct: function filterProduct() {
      var filter = new RegExp(this.filter, 'i');
      if (this.brands.length > 0) {
        return this.products.filter(function (el) {
          return el.name.match(filter);
        });
      } else return this.products.filter(function (el) {
        return el.id.match(filter);
      });
    }
  }),
  created: function created() {
    this.$store.dispatch('fetchDatapolice', { page: 1, filter: '', gender: '' });
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    pageChanged: function pageChanged(page) {
      this.currentPage = page;
      if (this.brands.length > 0 || this.filter == '') {
        if (this.filter = '') {
          var filter = '';
          this.$store.dispatch('fetchDatapolice', { page: page, filter: filter, gender: this.brands });
        } else {
          var _filter = 'price:' + this.priceValue;
          this.$store.dispatch('fetchDatapolice', { page: page, filter: _filter, gender: this.brands });
        }
      } else {
        var _filter2 = 'price:' + this.priceValue;
        this.$store.dispatch('fetchDatapolice', { page: page, filter: this.filter, gender: '' });
      }
    },
    ordreby: function ordreby(filter) {
      var filter2 = 'ordre:' + filter;
      console.log(filter);
      this.$store.dispatch('fetchDatapolice', { page: this.currentPage, filter: filter2, gender: '' });
    },
    submit: function submit() {
      var filter = 'price:' + this.priceValue;
      console.log(filter);
      if (this.brands.length > 0) {
        this.$store.dispatch('fetchDatapolice', { page: this.currentPage, filter: filter, gender: this.brands });
      } else {

        this.$store.dispatch('fetchDatapolice', { page: this.currentPage, filter: filter, gender: '' });
      }
    },

    search: function search(event) {
      var _this = this;

      var debounce = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.debounce(function () {
        if (_this.brands.length === 0) _this.$store.dispatch('fetchDatapolice', {
          page: _this.currentPage,
          filter: event.target.value,
          gender: ''
        });
      }, 500);
      debounce();
    },
    brandChecked: function brandChecked(event) {
      var _this2 = this;

      var debounce = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.debounce(function () {
        return _this2.$store.dispatch('fetchDatapolice', {
          page: _this2.currentPage,
          filter: _this2.brands,
          gender: ''
        });
      }, 500);
      debounce();
    },
    addToCart: function addToCart(item) {
      var _this3 = this;

      this.$store.dispatch('addToCart', item).then(function () {
        _this3.$notify({
          group: 'cart',
          title: 'Product',
          type: 'success',
          text: 'successfuly added to cart!'
        });
      }).catch(function (error) {
        return console.log(error);
      });
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapActions */])(['lastProductpolice', 'ProductDetail']))
});

/***/ }),
/* 67 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_pagination_bootstrap__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_range_slider_dist_vue_range_slider_css__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_range_slider_dist_vue_range_slider_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_range_slider_dist_vue_range_slider_css__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




// you probably need to import built-in style

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    pagination: __WEBPACK_IMPORTED_MODULE_2_vue_pagination_bootstrap__["a" /* default */]
  },
  data: function data() {
    var _paginationOptions;

    return {
      sidebarOpen: false,
      priceValue: [15000, 85000],
      sliderValue: 50,
      filter: '',
      currentPage: 1,
      brands: [],
      pageSize: 24,
      paginationOptions: (_paginationOptions = {
        offset: 4,
        previousText: 'Prev'
      }, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_paginationOptions, 'previousText', 'Préc'), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_paginationOptions, 'nextText', 'Suivant'), _paginationOptions)
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapGetters */])({

    products: 'productscerruti',
    total: 'totalProductcerruti'
  }), {
    //products(){
    //  if (this.$store.state.lastEntriescerruti.length > 0)
    // return this.$store.state.productscerruti
    // else
    //  return this.$store.state.allProducts

    // },
    filterProduct: function filterProduct() {
      var filter = new RegExp(this.filter, 'i');
      if (this.brands.length > 0) {
        return this.products.filter(function (el) {
          return el.name.match(filter);
        });
      } else return this.products.filter(function (el) {
        return el.id.match(filter);
      });
    }
  }),
  created: function created() {
    this.$store.dispatch('fetchDatacerruti', { page: 1, filter: '', gender: '' });
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    pageChanged: function pageChanged(page) {
      this.currentPage = page;
      if (this.brands.length > 0) {
        var filter = 'price:' + this.priceValue;
        this.$store.dispatch('fetchDatacerruti', { page: page, filter: filter, gender: this.brands });
      } else {
        var _filter = 'price:' + this.priceValue;
        this.$store.dispatch('fetchDatacerruti', { page: page, filter: this.filter, gender: '' });
      }
    },
    ordreby: function ordreby(filter) {
      var filter2 = 'ordre:' + filter;
      console.log(filter);
      this.$store.dispatch('fetchDatacerruti', { page: this.currentPage, filter: filter2, gender: '' });
    },
    submit: function submit() {
      var filter = 'price:' + this.priceValue;
      console.log(filter);
      if (this.brands.length > 0) {
        this.$store.dispatch('fetchDatacerruti', { page: this.currentPage, filter: filter, gender: this.brands });
      } else {

        this.$store.dispatch('fetchDatacerruti', { page: this.currentPage, filter: filter, gender: '' });
      }
    },

    search: function search(event) {
      var _this = this;

      var debounce = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.debounce(function () {
        if (_this.brands.length === 0) _this.$store.dispatch('fetchDatacerruti', {
          page: _this.currentPage,
          filter: event.target.value,
          gender: ''
        });
      }, 500);
      debounce();
    },
    brandChecked: function brandChecked(event) {
      var _this2 = this;

      var debounce = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.debounce(function () {
        return _this2.$store.dispatch('fetchDatacerruti', {
          page: _this2.currentPage,
          filter: _this2.brands,
          gender: ''
        });
      }, 500);
      debounce();
    },
    addToCart: function addToCart(item) {
      var _this3 = this;

      this.$store.dispatch('addToCart', item).then(function () {
        _this3.$notify({
          group: 'cart',
          title: 'Product',
          type: 'success',
          text: 'successfuly added to cart!'
        });
      }).catch(function (error) {
        return console.log(error);
      });
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapActions */])(['lastProductcerruti', 'ProductDetail']))
});

/***/ }),
/* 68 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_pagination_bootstrap__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_range_slider_dist_vue_range_slider_css__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_range_slider_dist_vue_range_slider_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_range_slider_dist_vue_range_slider_css__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





// you probably need to import built-in style

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    pagination: __WEBPACK_IMPORTED_MODULE_2_vue_pagination_bootstrap__["a" /* default */]
  },
  data: function data() {
    var _paginationOptions;

    return {
      sidebarOpen: false,
      priceValue: [15000, 85000],
      sliderValue: 50,
      filter: '',
      currentPage: 1,
      brands: [],
      pageSize: 48,
      paginationOptions: (_paginationOptions = {
        offset: 4,
        previousText: 'Prev'
      }, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_paginationOptions, 'previousText', 'Préc'), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_paginationOptions, 'nextText', 'Suivant'), _paginationOptions)
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapGetters */])({

    products: 'productspromo',
    total: 'totalProductpromo'
  }), {
    //products(){
    //  if (this.$store.state.lastEntriespromo.length > 0)
    // return this.$store.state.productspromo
    // else
    //  return this.$store.state.allProducts

    // },
    filterProduct: function filterProduct() {
      var filter = new RegExp(this.filter, 'i');
      if (this.brands.length > 0) {
        return this.products.filter(function (el) {
          return el.name.match(filter);
        });
      } else return this.products.filter(function (el) {
        return el.id.match(filter);
      });
    }
  }),
  created: function created() {
    this.$store.dispatch('fetchDatapromo', { page: 1, filter: '', gender: '' });
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    pageChanged: function pageChanged(page) {
      this.currentPage = page;
      if (this.brands.length > 0) {
        var filter = 'price:' + this.priceValue;
        this.$store.dispatch('fetchDatapromo', { page: page, filter: filter, gender: this.brands });
      } else {
        var _filter = 'price:' + this.priceValue;
        this.$store.dispatch('fetchDatapromo', { page: page, filter: this.filter, gender: '' });
      }
    },
    ordreby: function ordreby(filter) {
      var filter2 = 'ordre:' + filter;
      console.log(filter);
      this.$store.dispatch('fetchDatapromo', { page: this.currentPage, filter: filter2, gender: '' });
    },
    submit: function submit() {
      var filter = 'price:' + this.priceValue;
      console.log(filter);
      if (this.brands.length > 0) {
        this.$store.dispatch('fetchDatapromo', { page: this.currentPage, filter: filter, gender: this.brands });
      } else {

        this.$store.dispatch('fetchDatapromo', { page: this.currentPage, filter: filter, gender: '' });
      }
    },

    search: function search(event) {
      var _this = this;

      var debounce = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.debounce(function () {
        if (_this.brands.length === 0) _this.$store.dispatch('fetchDatapromo', {
          page: _this.currentPage,
          filter: event.target.value,
          gender: ''
        });
      }, 500);
      debounce();
    },
    brandChecked: function brandChecked(event) {
      var _this2 = this;

      var debounce = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.debounce(function () {
        return _this2.$store.dispatch('fetchDatapromo', {
          page: _this2.currentPage,
          filter: _this2.brands,
          gender: ''
        });
      }, 500);
      debounce();
    },
    addToCart: function addToCart(item) {
      var _this3 = this;

      this.$store.dispatch('addToCart', item).then(function () {
        _this3.$notify({
          group: 'cart',
          title: 'Product',
          type: 'success',
          text: 'successfuly added to cart!'
        });
      }).catch(function (error) {
        return console.log(error);
      });
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapActions */])(['lastProductpromo', 'ProductDetail']))
});

/***/ }),
/* 69 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_pagination_bootstrap__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_range_slider_dist_vue_range_slider_css__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_range_slider_dist_vue_range_slider_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_range_slider_dist_vue_range_slider_css__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




// you probably need to import built-in style

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    pagination: __WEBPACK_IMPORTED_MODULE_2_vue_pagination_bootstrap__["a" /* default */]
  },
  data: function data() {
    var _paginationOptions;

    return {
      sidebarOpen: false,
      priceValue: [15000, 85000],
      sliderValue: 50,
      filter: '',
      currentPage: 1,
      brands: [],
      pageSize: 48,
      paginationOptions: (_paginationOptions = {
        offset: 4,
        previousText: 'Prev'
      }, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_paginationOptions, 'previousText', 'Préc'), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_paginationOptions, 'nextText', 'Suivant'), _paginationOptions)
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapGetters */])({

    products: 'productslotus',
    total: 'totalProductlotus'
  }), {
    //products(){
    //  if (this.$store.state.lastEntrieslotus.length > 0)
    // return this.$store.state.productslotus
    // else
    //  return this.$store.state.allProducts

    // },
    filterProduct: function filterProduct() {
      var filter = new RegExp(this.filter, 'i');
      if (this.brands.length > 0) {
        return this.products.filter(function (el) {
          return el.name.match(filter);
        });
      } else return this.products.filter(function (el) {
        return el.id.match(filter);
      });
    }
  }),
  created: function created() {
    this.$store.dispatch('fetchDatalotus', { page: 1, filter: '', gender: '' });
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    pageChanged: function pageChanged(page) {
      this.currentPage = page;
      if (this.brands.length > 0) {
        var filter = 'price:' + this.priceValue;
        this.$store.dispatch('fetchDatalotus', { page: page, filter: filter, gender: this.brands });
      } else {
        var _filter = 'price:' + this.priceValue;
        this.$store.dispatch('fetchDatalotus', { page: page, filter: this.filter, gender: '' });
      }
    },
    ordreby: function ordreby(filter) {
      var filter2 = 'ordre:' + filter;
      console.log(filter);
      this.$store.dispatch('fetchDatalotus', { page: this.currentPage, filter: filter2, gender: '' });
    },
    submit: function submit() {
      var filter = 'price:' + this.priceValue;
      console.log(filter);
      if (this.brands.length > 0) {
        this.$store.dispatch('fetchDatalotus', { page: this.currentPage, filter: filter, gender: this.brands });
      } else {

        this.$store.dispatch('fetchDatalotus', { page: this.currentPage, filter: filter, gender: '' });
      }
    },

    search: function search(event) {
      var _this = this;

      var debounce = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.debounce(function () {
        if (_this.brands.length === 0) _this.$store.dispatch('fetchDatalotus', {
          page: _this.currentPage,
          filter: event.target.value,
          gender: ''
        });
      }, 500);
      debounce();
    },
    brandChecked: function brandChecked(event) {
      var _this2 = this;

      var debounce = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.debounce(function () {
        return _this2.$store.dispatch('fetchDatalotus', {
          page: _this2.currentPage,
          filter: _this2.brands,
          gender: ''
        });
      }, 500);
      debounce();
    },
    addToCart: function addToCart(item) {
      var _this3 = this;

      this.$store.dispatch('addToCart', item).then(function () {
        _this3.$notify({
          group: 'cart',
          title: 'Product',
          type: 'success',
          text: 'successfuly added to cart!'
        });
      }).catch(function (error) {
        return console.log(error);
      });
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapActions */])(['lastProductlotus', 'ProductDetail']))
});

/***/ }),
/* 70 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_pagination_bootstrap__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_range_slider_dist_vue_range_slider_css__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_range_slider_dist_vue_range_slider_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_range_slider_dist_vue_range_slider_css__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




// you probably need to import built-in style

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    pagination: __WEBPACK_IMPORTED_MODULE_2_vue_pagination_bootstrap__["a" /* default */]
  },
  data: function data() {
    var _paginationOptions;

    return {
      sidebarOpen: false,
      priceValue: [15000, 85000],
      sliderValue: 50,
      filter: '',
      currentPage: 1,
      brands: [],
      pageSize: 48,
      paginationOptions: (_paginationOptions = {
        offset: 4,
        previousText: 'Prev'
      }, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_paginationOptions, 'previousText', 'Préc'), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_paginationOptions, 'nextText', 'Suivant'), _paginationOptions)
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapGetters */])({

    products: 'productsversus',
    total: 'totalProductversus'
  }), {
    //products(){
    //  if (this.$store.state.lastEntriesversus.length > 0)
    // return this.$store.state.productsversus
    // else
    //  return this.$store.state.allProducts

    // },
    filterProduct: function filterProduct() {
      var filter = new RegExp(this.filter, 'i');
      if (this.brands.length > 0) {
        return this.products.filter(function (el) {
          return el.name.match(filter);
        });
      } else return this.products.filter(function (el) {
        return el.id.match(filter);
      });
    }
  }),
  created: function created() {
    this.$store.dispatch('fetchDataversus', { page: 1, filter: '', gender: '' });
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    pageChanged: function pageChanged(page) {
      this.currentPage = page;
      if (this.brands.length > 0) {
        var filter = 'price:' + this.priceValue;
        this.$store.dispatch('fetchDataversus', { page: page, filter: filter, gender: this.brands });
      } else {
        var _filter = 'price:' + this.priceValue;
        this.$store.dispatch('fetchDataversus', { page: page, filter: this.filter, gender: '' });
      }
    },
    ordreby: function ordreby(filter) {
      var filter2 = 'ordre:' + filter;
      console.log(filter);
      this.$store.dispatch('fetchDataversus', { page: this.currentPage, filter: filter2, gender: '' });
    },
    submit: function submit() {
      var filter = 'price:' + this.priceValue;
      console.log(filter);
      if (this.brands.length > 0) {
        this.$store.dispatch('fetchDataversus', { page: this.currentPage, filter: filter, gender: this.brands });
      } else {

        this.$store.dispatch('fetchDataversus', { page: this.currentPage, filter: filter, gender: '' });
      }
    },

    search: function search(event) {
      var _this = this;

      var debounce = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.debounce(function () {
        if (_this.brands.length === 0) _this.$store.dispatch('fetchDataversus', {
          page: _this.currentPage,
          filter: event.target.value,
          gender: ''
        });
      }, 500);
      debounce();
    },
    brandChecked: function brandChecked(event) {
      var _this2 = this;

      var debounce = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.debounce(function () {
        return _this2.$store.dispatch('fetchDataversus', {
          page: _this2.currentPage,
          filter: _this2.brands,
          gender: ''
        });
      }, 500);
      debounce();
    },
    addToCart: function addToCart(item) {
      var _this3 = this;

      this.$store.dispatch('addToCart', item).then(function () {
        _this3.$notify({
          group: 'cart',
          title: 'Product',
          type: 'success',
          text: 'successfuly added to cart!'
        });
      }).catch(function (error) {
        return console.log(error);
      });
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapActions */])(['lastProductversus', 'ProductDetail']))
});

/***/ }),
/* 71 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_pagination_bootstrap__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_range_slider_dist_vue_range_slider_css__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_range_slider_dist_vue_range_slider_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_range_slider_dist_vue_range_slider_css__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




// you probably need to import built-in style

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    pagination: __WEBPACK_IMPORTED_MODULE_2_vue_pagination_bootstrap__["a" /* default */]
  },
  data: function data() {
    var _paginationOptions;

    return {
      sidebarOpen: false,
      priceValue: [15000, 85000],
      sliderValue: 50,
      filter: '',
      currentPage: 1,
      brands: [],
      pageSize: 48,
      paginationOptions: (_paginationOptions = {
        offset: 4,
        previousText: 'Prev'
      }, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_paginationOptions, 'previousText', 'Préc'), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_paginationOptions, 'nextText', 'Suivant'), _paginationOptions)
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapGetters */])({

    products: 'productsTRUSSARDI',
    total: 'totalProductTRUSSARDI'
  }), {
    //products(){
    //  if (this.$store.state.lastEntriesTRUSSARDI.length > 0)
    // return this.$store.state.productsTRUSSARDI
    // else
    //  return this.$store.state.allProducts

    // },
    filterProduct: function filterProduct() {
      var filter = new RegExp(this.filter, 'i');
      if (this.brands.length > 0) {
        return this.products.filter(function (el) {
          return el.name.match(filter);
        });
      } else return this.products.filter(function (el) {
        return el.id.match(filter);
      });
    }
  }),
  created: function created() {
    this.$store.dispatch('fetchDataTRUSSARDI', { page: 1, filter: '', gender: '' });
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    pageChanged: function pageChanged(page) {
      this.currentPage = page;
      if (this.brands.length > 0) {
        var filter = 'price:' + this.priceValue;
        this.$store.dispatch('fetchDataTRUSSARDI', { page: page, filter: filter, gender: this.brands });
      } else {
        var _filter = 'price:' + this.priceValue;
        this.$store.dispatch('fetchDataTRUSSARDI', { page: page, filter: this.filter, gender: '' });
      }
    },
    ordreby: function ordreby(filter) {
      var filter2 = 'ordre:' + filter;
      console.log(filter);
      this.$store.dispatch('fetchDataTRUSSARDI', { page: this.currentPage, filter: filter2, gender: '' });
    },
    submit: function submit() {
      var filter = 'price:' + this.priceValue;
      console.log(filter);
      if (this.brands.length > 0) {
        this.$store.dispatch('fetchDataTRUSSARDI', { page: this.currentPage, filter: filter, gender: this.brands });
      } else {

        this.$store.dispatch('fetchDataTRUSSARDI', { page: this.currentPage, filter: filter, gender: '' });
      }
    },

    search: function search(event) {
      var _this = this;

      var debounce = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.debounce(function () {
        if (_this.brands.length === 0) _this.$store.dispatch('fetchDataTRUSSARDI', {
          page: _this.currentPage,
          filter: event.target.value,
          gender: ''
        });
      }, 500);
      debounce();
    },
    brandChecked: function brandChecked(event) {
      var _this2 = this;

      var debounce = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.debounce(function () {
        return _this2.$store.dispatch('fetchDataTRUSSARDI', {
          page: _this2.currentPage,
          filter: _this2.brands,
          gender: ''
        });
      }, 500);
      debounce();
    },
    addToCart: function addToCart(item) {
      var _this3 = this;

      this.$store.dispatch('addToCart', item).then(function () {
        _this3.$notify({
          group: 'cart',
          title: 'Product',
          type: 'success',
          text: 'successfuly added to cart!'
        });
      }).catch(function (error) {
        return console.log(error);
      });
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapActions */])(['lastProductTRUSSARDI', 'ProductDetail']))
});

/***/ }),
/* 72 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_pagination_bootstrap__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_range_slider_dist_vue_range_slider_css__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_range_slider_dist_vue_range_slider_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_range_slider_dist_vue_range_slider_css__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




// you probably need to import built-in style

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    pagination: __WEBPACK_IMPORTED_MODULE_2_vue_pagination_bootstrap__["a" /* default */]
  },
  data: function data() {
    var _paginationOptions;

    return {
      sidebarOpen: false,
      priceValue: [15000, 85000],
      sliderValue: 50,
      filter: '',
      currentPage: 1,
      brands: [],
      pageSize: 48,
      paginationOptions: (_paginationOptions = {
        offset: 4,
        previousText: 'Prev'
      }, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_paginationOptions, 'previousText', 'Préc'), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_paginationOptions, 'nextText', 'Suivant'), _paginationOptions)
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapGetters */])({

    products: 'productsMONTIGNAC',
    total: 'totalProductMONTIGNAC'
  }), {
    //products(){
    //  if (this.$store.state.lastEntriesMONTIGNAC.length > 0)
    // return this.$store.state.productsMONTIGNAC
    // else
    //  return this.$store.state.allProducts

    // },
    filterProduct: function filterProduct() {
      var filter = new RegExp(this.filter, 'i');
      if (this.brands.length > 0) {
        return this.products.filter(function (el) {
          return el.name.match(filter);
        });
      } else return this.products.filter(function (el) {
        return el.id.match(filter);
      });
    }
  }),
  created: function created() {
    this.$store.dispatch('fetchDataMONTIGNAC', { page: 1, filter: '', gender: '' });
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    pageChanged: function pageChanged(page) {
      this.currentPage = page;
      if (this.brands.length > 0) {
        var filter = 'price:' + this.priceValue;
        this.$store.dispatch('fetchDataMONTIGNAC', { page: page, filter: filter, gender: this.brands });
      } else {
        var _filter = 'price:' + this.priceValue;
        this.$store.dispatch('fetchDataMONTIGNAC', { page: page, filter: this.filter, gender: '' });
      }
    },
    ordreby: function ordreby(filter) {
      var filter2 = 'ordre:' + filter;
      console.log(filter);
      this.$store.dispatch('fetchDataMONTIGNAC', { page: this.currentPage, filter: filter2, gender: '' });
    },
    submit: function submit() {
      var filter = 'price:' + this.priceValue;
      console.log(filter);
      if (this.brands.length > 0) {
        this.$store.dispatch('fetchDataMONTIGNAC', { page: this.currentPage, filter: filter, gender: this.brands });
      } else {

        this.$store.dispatch('fetchDataMONTIGNAC', { page: this.currentPage, filter: filter, gender: '' });
      }
    },

    search: function search(event) {
      var _this = this;

      var debounce = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.debounce(function () {
        if (_this.brands.length === 0) _this.$store.dispatch('fetchDataMONTIGNAC', {
          page: _this.currentPage,
          filter: event.target.value,
          gender: ''
        });
      }, 500);
      debounce();
    },
    brandChecked: function brandChecked(event) {
      var _this2 = this;

      var debounce = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.debounce(function () {
        return _this2.$store.dispatch('fetchDataMONTIGNAC', {
          page: _this2.currentPage,
          filter: _this2.brands,
          gender: ''
        });
      }, 500);
      debounce();
    },
    addToCart: function addToCart(item) {
      var _this3 = this;

      this.$store.dispatch('addToCart', item).then(function () {
        _this3.$notify({
          group: 'cart',
          title: 'Product',
          type: 'success',
          text: 'successfuly added to cart!'
        });
      }).catch(function (error) {
        return console.log(error);
      });
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapActions */])(['lastProductMONTIGNAC', 'ProductDetail']))
});

/***/ }),
/* 73 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_pagination_bootstrap__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_range_slider_dist_vue_range_slider_css__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_range_slider_dist_vue_range_slider_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_range_slider_dist_vue_range_slider_css__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




// you probably need to import built-in style

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    pagination: __WEBPACK_IMPORTED_MODULE_2_vue_pagination_bootstrap__["a" /* default */]
  },
  data: function data() {
    var _paginationOptions;

    return {
      sidebarOpen: false,
      priceValue: [15000, 85000],
      sliderValue: 50,
      filter: '',
      currentPage: 1,
      brands: [],
      pageSize: 48,
      paginationOptions: (_paginationOptions = {
        offset: 4,
        previousText: 'Prev'
      }, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_paginationOptions, 'previousText', 'Préc'), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_paginationOptions, 'nextText', 'Suivant'), _paginationOptions)
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapGetters */])({

    products: 'productsarmani',
    total: 'totalProductarmani'
  }), {
    //products(){
    //  if (this.$store.state.lastEntriesarmani.length > 0)
    // return this.$store.state.productsarmani
    // else
    //  return this.$store.state.allProducts

    // },
    filterProduct: function filterProduct() {
      var filter = new RegExp(this.filter, 'i');
      if (this.brands.length > 0) {
        return this.products.filter(function (el) {
          return el.name.match(filter);
        });
      } else return this.products.filter(function (el) {
        return el.id.match(filter);
      });
    }
  }),
  created: function created() {
    this.$store.dispatch('fetchDataarmani', { page: 1, filter: '', gender: '' });
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    pageChanged: function pageChanged(page) {
      this.currentPage = page;
      if (this.brands.length > 0) {
        var filter = 'price:' + this.priceValue;
        this.$store.dispatch('fetchDataarmani', { page: page, filter: filter, gender: this.brands });
      } else {
        var _filter = 'price:' + this.priceValue;
        this.$store.dispatch('fetchDataarmani', { page: page, filter: this.filter, gender: '' });
      }
    },
    ordreby: function ordreby(filter) {
      var filter2 = 'ordre:' + filter;
      console.log(filter);
      this.$store.dispatch('fetchDataarmani', { page: this.currentPage, filter: filter2, gender: '' });
    },
    submit: function submit() {
      var filter = 'price:' + this.priceValue;
      console.log(filter);
      if (this.brands.length > 0) {
        this.$store.dispatch('fetchDataarmani', { page: this.currentPage, filter: filter, gender: this.brands });
      } else {

        this.$store.dispatch('fetchDataarmani', { page: this.currentPage, filter: filter, gender: '' });
      }
    },

    search: function search(event) {
      var _this = this;

      var debounce = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.debounce(function () {
        if (_this.brands.length === 0) _this.$store.dispatch('fetchDataarmani', {
          page: _this.currentPage,
          filter: event.target.value,
          gender: ''
        });
      }, 500);
      debounce();
    },
    brandChecked: function brandChecked(event) {
      var _this2 = this;

      var debounce = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.debounce(function () {
        return _this2.$store.dispatch('fetchDataarmani', {
          page: _this2.currentPage,
          filter: _this2.brands,
          gender: ''
        });
      }, 500);
      debounce();
    },
    addToCart: function addToCart(item) {
      var _this3 = this;

      this.$store.dispatch('addToCart', item).then(function () {
        _this3.$notify({
          group: 'cart',
          title: 'Product',
          type: 'success',
          text: 'successfuly added to cart!'
        });
      }).catch(function (error) {
        return console.log(error);
      });
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapActions */])(['lastProductarmani', 'ProductDetail']))
});

/***/ }),
/* 74 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_pagination_bootstrap__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_range_slider_dist_vue_range_slider_css__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_range_slider_dist_vue_range_slider_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_range_slider_dist_vue_range_slider_css__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




// you probably need to import built-in style

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    pagination: __WEBPACK_IMPORTED_MODULE_2_vue_pagination_bootstrap__["a" /* default */]
  },
  data: function data() {
    var _paginationOptions;

    return {
      sidebarOpen: false,
      priceValue: [15000, 85000],
      sliderValue: 50,
      filter: '',
      currentPage: 1,
      brands: [],
      pageSize: 48,
      paginationOptions: (_paginationOptions = {
        offset: 4,
        previousText: 'Prev'
      }, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_paginationOptions, 'previousText', 'Préc'), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_paginationOptions, 'nextText', 'Suivant'), _paginationOptions)
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapGetters */])({

    products: 'productsnautica',
    total: 'totalProductnautica'
  }), {
    //products(){
    //  if (this.$store.state.lastEntriesnautica.length > 0)
    // return this.$store.state.productsnautica
    // else
    //  return this.$store.state.allProducts

    // },
    filterProduct: function filterProduct() {
      var filter = new RegExp(this.filter, 'i');
      if (this.brands.length > 0) {
        return this.products.filter(function (el) {
          return el.name.match(filter);
        });
      } else return this.products.filter(function (el) {
        return el.id.match(filter);
      });
    }
  }),
  created: function created() {
    this.$store.dispatch('fetchDatanautica', { page: 1, filter: '', gender: '' });
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    pageChanged: function pageChanged(page) {
      this.currentPage = page;
      if (this.brands.length > 0) {
        var filter = 'price:' + this.priceValue;
        this.$store.dispatch('fetchDatanautica', { page: page, filter: filter, gender: this.brands });
      } else {
        var _filter = 'price:' + this.priceValue;
        this.$store.dispatch('fetchDatanautica', { page: page, filter: this.filter, gender: '' });
      }
    },
    ordreby: function ordreby(filter) {
      var filter2 = 'ordre:' + filter;
      console.log(filter);
      this.$store.dispatch('fetchDatanautica', { page: this.currentPage, filter: filter2, gender: '' });
    },
    submit: function submit() {
      var filter = 'price:' + this.priceValue;
      console.log(filter);
      if (this.brands.length > 0) {
        this.$store.dispatch('fetchDatanautica', { page: this.currentPage, filter: filter, gender: this.brands });
      } else {

        this.$store.dispatch('fetchDatanautica', { page: this.currentPage, filter: filter, gender: '' });
      }
    },

    search: function search(event) {
      var _this = this;

      var debounce = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.debounce(function () {
        if (_this.brands.length === 0) _this.$store.dispatch('fetchDatanautica', {
          page: _this.currentPage,
          filter: event.target.value,
          gender: ''
        });
      }, 500);
      debounce();
    },
    brandChecked: function brandChecked(event) {
      var _this2 = this;

      var debounce = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.debounce(function () {
        return _this2.$store.dispatch('fetchDatanautica', {
          page: _this2.currentPage,
          filter: _this2.brands,
          gender: ''
        });
      }, 500);
      debounce();
    },
    addToCart: function addToCart(item) {
      var _this3 = this;

      this.$store.dispatch('addToCart', item).then(function () {
        _this3.$notify({
          group: 'cart',
          title: 'Product',
          type: 'success',
          text: 'successfuly added to cart!'
        });
      }).catch(function (error) {
        return console.log(error);
      });
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapActions */])(['lastProductnautica', 'ProductDetail']))
});

/***/ }),
/* 75 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_pagination_bootstrap__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_range_slider_dist_vue_range_slider_css__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_range_slider_dist_vue_range_slider_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_range_slider_dist_vue_range_slider_css__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





// you probably need to import built-in style

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    pagination: __WEBPACK_IMPORTED_MODULE_2_vue_pagination_bootstrap__["a" /* default */]
  },
  data: function data() {
    var _paginationOptions;

    return {
      sidebarOpen: false,
      priceValue: [15000, 85000],
      sliderValue: 50,
      filter: '',
      currentPage: 1,
      brands: [],
      pageSize: 48,
      paginationOptions: (_paginationOptions = {
        offset: 4,
        previousText: 'Prev'
      }, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_paginationOptions, 'previousText', 'Préc'), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_paginationOptions, 'nextText', 'Suivant'), _paginationOptions)
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapGetters */])({

    products: 'productsmaserati',
    total: 'totalProductmaserati'
  }), {
    //products(){
    //  if (this.$store.state.lastEntriesmaserati.length > 0)
    // return this.$store.state.productsmaserati
    // else
    //  return this.$store.state.allProducts

    // },
    filterProduct: function filterProduct() {
      var filter = new RegExp(this.filter, 'i');
      if (this.brands.length > 0) {
        return this.products.filter(function (el) {
          return el.name.match(filter);
        });
      } else return this.products.filter(function (el) {
        return el.id.match(filter);
      });
    }
  }),
  created: function created() {
    this.$store.dispatch('fetchDatamaserati', { page: 1, filter: '', gender: '' });
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    pageChanged: function pageChanged(page) {
      this.currentPage = page;
      if (this.brands.length > 0) {
        var filter = 'price:' + this.priceValue;
        this.$store.dispatch('fetchDatamaserati', { page: page, filter: filter, gender: this.brands });
      } else {
        var _filter = 'price:' + this.priceValue;
        this.$store.dispatch('fetchDatamaserati', { page: page, filter: this.filter, gender: '' });
      }
    },
    ordreby: function ordreby(filter) {
      var filter2 = 'ordre:' + filter;
      console.log(filter);
      this.$store.dispatch('fetchDatamaserati', { page: this.currentPage, filter: filter2, gender: '' });
    },
    submit: function submit() {
      var filter = 'price:' + this.priceValue;
      console.log(filter);
      if (this.brands.length > 0) {
        this.$store.dispatch('fetchDatamaserati', { page: this.currentPage, filter: filter, gender: this.brands });
      } else {

        this.$store.dispatch('fetchDatamaserati', { page: this.currentPage, filter: filter, gender: '' });
      }
    },

    search: function search(event) {
      var _this = this;

      var debounce = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.debounce(function () {
        if (_this.brands.length === 0) _this.$store.dispatch('fetchDatamaserati', {
          page: _this.currentPage,
          filter: event.target.value,
          gender: ''
        });
      }, 500);
      debounce();
    },
    brandChecked: function brandChecked(event) {
      var _this2 = this;

      var debounce = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.debounce(function () {
        return _this2.$store.dispatch('fetchDatamaserati', {
          page: _this2.currentPage,
          filter: _this2.brands,
          gender: ''
        });
      }, 500);
      debounce();
    },
    addToCart: function addToCart(item) {
      var _this3 = this;

      this.$store.dispatch('addToCart', item).then(function () {
        _this3.$notify({
          group: 'cart',
          title: 'Product',
          type: 'success',
          text: 'successfuly added to cart!'
        });
      }).catch(function (error) {
        return console.log(error);
      });
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapActions */])(['lastProductmaserati', 'ProductDetail']))
});

/***/ }),
/* 76 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_pagination_bootstrap__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_range_slider_dist_vue_range_slider_css__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_range_slider_dist_vue_range_slider_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_range_slider_dist_vue_range_slider_css__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




// you probably need to import built-in style

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    pagination: __WEBPACK_IMPORTED_MODULE_2_vue_pagination_bootstrap__["a" /* default */]
  },
  data: function data() {
    var _paginationOptions;

    return {
      sidebarOpen: false,
      priceValue: [15000, 85000],
      sliderValue: 50,
      filter: '',
      currentPage: 1,
      brands: [],
      pageSize: 48,
      paginationOptions: (_paginationOptions = {
        offset: 4,
        previousText: 'Prev'
      }, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_paginationOptions, 'previousText', 'Préc'), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_paginationOptions, 'nextText', 'Suivant'), _paginationOptions)
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapGetters */])({

    products: 'productsmorellato',
    total: 'totalProductmorellato'
  }), {
    //products(){
    //  if (this.$store.state.lastEntriesmorellato.length > 0)
    // return this.$store.state.productsmorellato
    // else
    //  return this.$store.state.allProducts

    // },
    filterProduct: function filterProduct() {
      var filter = new RegExp(this.filter, 'i');
      if (this.brands.length > 0) {
        return this.products.filter(function (el) {
          return el.name.match(filter);
        });
      } else return this.products.filter(function (el) {
        return el.id.match(filter);
      });
    }
  }),
  created: function created() {
    this.$store.dispatch('fetchDatamorellato', { page: 1, filter: '', gender: '' });
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    pageChanged: function pageChanged(page) {
      this.currentPage = page;
      if (this.brands.length > 0) {
        var filter = 'price:' + this.priceValue;
        this.$store.dispatch('fetchDatamorellato', { page: page, filter: filter, gender: this.brands });
      } else {
        var _filter = 'price:' + this.priceValue;
        this.$store.dispatch('fetchDatamorellato', { page: page, filter: this.filter, gender: '' });
      }
    },
    ordreby: function ordreby(filter) {
      var filter2 = 'ordre:' + filter;
      console.log(filter);
      this.$store.dispatch('fetchDatamorellato', { page: this.currentPage, filter: filter2, gender: '' });
    },
    submit: function submit() {
      var filter = 'price:' + this.priceValue;
      console.log(filter);
      if (this.brands.length > 0) {
        this.$store.dispatch('fetchDatamorellato', { page: this.currentPage, filter: filter, gender: this.brands });
      } else {

        this.$store.dispatch('fetchDatamorellato', { page: this.currentPage, filter: filter, gender: '' });
      }
    },

    search: function search(event) {
      var _this = this;

      var debounce = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.debounce(function () {
        if (_this.brands.length === 0) _this.$store.dispatch('fetchDatamorellato', {
          page: _this.currentPage,
          filter: event.target.value,
          gender: ''
        });
      }, 500);
      debounce();
    },
    brandChecked: function brandChecked(event) {
      var _this2 = this;

      var debounce = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.debounce(function () {
        return _this2.$store.dispatch('fetchDatamorellato', {
          page: _this2.currentPage,
          filter: _this2.brands,
          gender: ''
        });
      }, 500);
      debounce();
    },
    addToCart: function addToCart(item) {
      var _this3 = this;

      this.$store.dispatch('addToCart', item).then(function () {
        _this3.$notify({
          group: 'cart',
          title: 'Product',
          type: 'success',
          text: 'successfuly added to cart!'
        });
      }).catch(function (error) {
        return console.log(error);
      });
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapActions */])(['lastProductmorellato', 'ProductDetail']))
});

/***/ }),
/* 77 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_pagination_bootstrap__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_range_slider_dist_vue_range_slider_css__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_range_slider_dist_vue_range_slider_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_range_slider_dist_vue_range_slider_css__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




// you probably need to import built-in style

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    pagination: __WEBPACK_IMPORTED_MODULE_2_vue_pagination_bootstrap__["a" /* default */]
  },
  data: function data() {
    var _paginationOptions;

    return {
      sidebarOpen: false,
      priceValue: [15000, 85000],
      sliderValue: 50,
      filter: '',
      currentPage: 1,
      brands: [],
      pageSize: 48,
      paginationOptions: (_paginationOptions = {
        offset: 4,
        previousText: 'Prev'
      }, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_paginationOptions, 'previousText', 'Préc'), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_paginationOptions, 'nextText', 'Suivant'), _paginationOptions)
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapGetters */])({

    products: 'productstimberland',
    total: 'totalProducttimberland'
  }), {
    //products(){
    //  if (this.$store.state.lastEntriestimberland.length > 0)
    // return this.$store.state.productstimberland
    // else
    //  return this.$store.state.allProducts

    // },
    filterProduct: function filterProduct() {
      var filter = new RegExp(this.filter, 'i');
      if (this.brands.length > 0) {
        return this.products.filter(function (el) {
          return el.name.match(filter);
        });
      } else return this.products.filter(function (el) {
        return el.id.match(filter);
      });
    }
  }),
  created: function created() {
    this.$store.dispatch('fetchDatatimberland', { page: 1, filter: '', gender: '' });
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    pageChanged: function pageChanged(page) {
      this.currentPage = page;
      if (this.brands.length > 0) {
        var filter = 'price:' + this.priceValue;
        this.$store.dispatch('fetchDatatimberland', { page: page, filter: filter, gender: this.brands });
      } else {
        var _filter = 'price:' + this.priceValue;
        this.$store.dispatch('fetchDatatimberland', { page: page, filter: this.filter, gender: '' });
      }
    },
    ordreby: function ordreby(filter) {
      var filter2 = 'ordre:' + filter;
      console.log(filter);
      this.$store.dispatch('fetchDatatimberland', { page: this.currentPage, filter: filter2, gender: '' });
    },
    submit: function submit() {
      var filter = 'price:' + this.priceValue;
      console.log(filter);
      if (this.brands.length > 0) {
        this.$store.dispatch('fetchDatatimberland', { page: this.currentPage, filter: filter, gender: this.brands });
      } else {

        this.$store.dispatch('fetchDatatimberland', { page: this.currentPage, filter: filter, gender: '' });
      }
    },

    search: function search(event) {
      var _this = this;

      var debounce = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.debounce(function () {
        if (_this.brands.length === 0) _this.$store.dispatch('fetchDatatimberland', {
          page: _this.currentPage,
          filter: event.target.value,
          gender: ''
        });
      }, 500);
      debounce();
    },
    brandChecked: function brandChecked(event) {
      var _this2 = this;

      var debounce = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.debounce(function () {
        return _this2.$store.dispatch('fetchDatatimberland', {
          page: _this2.currentPage,
          filter: _this2.brands,
          gender: ''
        });
      }, 500);
      debounce();
    },
    addToCart: function addToCart(item) {
      var _this3 = this;

      this.$store.dispatch('addToCart', item).then(function () {
        _this3.$notify({
          group: 'cart',
          title: 'Product',
          type: 'success',
          text: 'successfuly added to cart!'
        });
      }).catch(function (error) {
        return console.log(error);
      });
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapActions */])(['lastProducttimberland', 'ProductDetail']))
});

/***/ }),
/* 78 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_pagination_bootstrap__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_range_slider_dist_vue_range_slider_css__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_range_slider_dist_vue_range_slider_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_range_slider_dist_vue_range_slider_css__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




// you probably need to import built-in style

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    pagination: __WEBPACK_IMPORTED_MODULE_2_vue_pagination_bootstrap__["a" /* default */]
  },
  data: function data() {
    var _paginationOptions;

    return {
      sidebarOpen: false,
      priceValue: [15000, 85000],
      sliderValue: 50,
      filter: '',
      currentPage: 1,
      brands: [],
      pageSize: 48,
      paginationOptions: (_paginationOptions = {
        offset: 4,
        previousText: 'Prev'
      }, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_paginationOptions, 'previousText', 'Préc'), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_paginationOptions, 'nextText', 'Suivant'), _paginationOptions)
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapGetters */])({

    products: 'productsMichaelkors',
    total: 'totalProductMichaelkors'
  }), {
    //products(){
    //  if (this.$store.state.lastEntriesMichaelkors.length > 0)
    // return this.$store.state.productsMichaelkors
    // else
    //  return this.$store.state.allProducts

    // },
    filterProduct: function filterProduct() {
      var filter = new RegExp(this.filter, 'i');
      if (this.brands.length > 0) {
        return this.products.filter(function (el) {
          return el.name.match(filter);
        });
      } else return this.products.filter(function (el) {
        return el.id.match(filter);
      });
    }
  }),
  created: function created() {
    this.$store.dispatch('fetchDataMichaelkors', { page: 1, filter: '', gender: '' });
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    pageChanged: function pageChanged(page) {
      this.currentPage = page;
      if (this.brands.length > 0) {
        var filter = 'price:' + this.priceValue;
        this.$store.dispatch('fetchDataMichaelkors', { page: page, filter: filter, gender: this.brands });
      } else {
        var _filter = 'price:' + this.priceValue;
        this.$store.dispatch('fetchDataMichaelkors', { page: page, filter: this.filter, gender: '' });
      }
    },
    ordreby: function ordreby(filter) {
      var filter2 = 'ordre:' + filter;
      console.log(filter);
      this.$store.dispatch('fetchDataMichaelkors', { page: this.currentPage, filter: filter2, gender: '' });
    },
    submit: function submit() {
      var filter = 'price:' + this.priceValue;
      console.log(filter);
      if (this.brands.length > 0) {
        this.$store.dispatch('fetchDataMichaelkors', { page: this.currentPage, filter: filter, gender: this.brands });
      } else {

        this.$store.dispatch('fetchDataMichaelkors', { page: this.currentPage, filter: filter, gender: '' });
      }
    },

    search: function search(event) {
      var _this = this;

      var debounce = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.debounce(function () {
        if (_this.brands.length === 0) _this.$store.dispatch('fetchDataMichaelkors', {
          page: _this.currentPage,
          filter: event.target.value,
          gender: ''
        });
      }, 500);
      debounce();
    },
    brandChecked: function brandChecked(event) {
      var _this2 = this;

      var debounce = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.debounce(function () {
        return _this2.$store.dispatch('fetchDataMichaelkors', {
          page: _this2.currentPage,
          filter: _this2.brands,
          gender: ''
        });
      }, 500);
      debounce();
    },
    addToCart: function addToCart(item) {
      var _this3 = this;

      this.$store.dispatch('addToCart', item).then(function () {
        _this3.$notify({
          group: 'cart',
          title: 'Product',
          type: 'success',
          text: 'successfuly added to cart!'
        });
      }).catch(function (error) {
        return console.log(error);
      });
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapActions */])(['lastProductMichaelkors', 'ProductDetail']))
});

/***/ }),
/* 79 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_pagination_bootstrap__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_range_slider_dist_vue_range_slider_css__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_range_slider_dist_vue_range_slider_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_range_slider_dist_vue_range_slider_css__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




// you probably need to import built-in style

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    pagination: __WEBPACK_IMPORTED_MODULE_2_vue_pagination_bootstrap__["a" /* default */]
  },
  data: function data() {
    var _paginationOptions;

    return {
      sidebarOpen: false,
      priceValue: [15000, 85000],
      sliderValue: 50,
      filter: '',
      currentPage: 1,
      brands: [],
      pageSize: 24,
      paginationOptions: (_paginationOptions = {
        offset: 4,
        previousText: 'Prev'
      }, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_paginationOptions, 'previousText', 'Préc'), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_paginationOptions, 'nextText', 'Suivant'), _paginationOptions)
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapGetters */])({

    products: 'productsconnectee',
    total: 'totalProductconnectee'
  }), {
    //products(){
    //  if (this.$store.state.lastEntriesMichaelkors.length > 0)
    // return this.$store.state.productsMichaelkors
    // else
    //  return this.$store.state.allProducts

    // },
    filterProduct: function filterProduct() {
      var filter = new RegExp(this.filter, 'i');
      if (this.brands.length > 0) {
        return this.products.filter(function (el) {
          return el.name.match(filter);
        });
      } else return this.products.filter(function (el) {
        return el.id.match(filter);
      });
    }
  }),
  created: function created() {
    this.$store.dispatch('fetchDataconnectee', { page: 1, filter: '', gender: '' });
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    pageChanged: function pageChanged(page) {
      this.currentPage = page;
      if (this.brands.length > 0) {
        var filter = 'price:' + this.priceValue;
        this.$store.dispatch('fetchDataconnectee', { page: page, filter: filter, gender: this.brands });
      } else {
        var _filter = 'price:' + this.priceValue;
        this.$store.dispatch('fetchDataconnectee', { page: page, filter: this.filter, gender: '' });
      }
    },
    ordreby: function ordreby(filter) {
      var filter2 = 'ordre:' + filter;
      console.log(filter);
      this.$store.dispatch('fetchDataconnectee', { page: this.currentPage, filter: filter2, gender: '' });
    },
    submit: function submit() {
      var filter = 'price:' + this.priceValue;
      console.log(filter);
      if (this.brands.length > 0) {
        this.$store.dispatch('fetchDataconnectee', { page: this.currentPage, filter: filter, gender: this.brands });
      } else {

        this.$store.dispatch('fetchDataconnectee', { page: this.currentPage, filter: filter, gender: '' });
      }
    },

    search: function search(event) {
      var _this = this;

      var debounce = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.debounce(function () {
        if (_this.brands.length === 0) _this.$store.dispatch('fetchDataconnectee', {
          page: _this.currentPage,
          filter: event.target.value,
          gender: ''
        });
      }, 500);
      debounce();
    },
    brandChecked: function brandChecked(event) {
      var _this2 = this;

      var debounce = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.debounce(function () {
        return _this2.$store.dispatch('fetchDataconnectee', {
          page: _this2.currentPage,
          filter: _this2.brands,
          gender: ''
        });
      }, 500);
      debounce();
    },
    addToCart: function addToCart(item) {
      var _this3 = this;

      this.$store.dispatch('addToCart', item).then(function () {
        _this3.$notify({
          group: 'cart',
          title: 'Product',
          type: 'success',
          text: 'successfuly added to cart!'
        });
      }).catch(function (error) {
        return console.log(error);
      });
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapActions */])(['lastProductconnectee', 'ProductDetail']))
});

/***/ }),
/* 80 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_pagination_bootstrap__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_range_slider_dist_vue_range_slider_css__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_range_slider_dist_vue_range_slider_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_range_slider_dist_vue_range_slider_css__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




// you probably need to import built-in style

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    pagination: __WEBPACK_IMPORTED_MODULE_2_vue_pagination_bootstrap__["a" /* default */]
  },
  data: function data() {
    var _paginationOptions;

    return {
      sidebarOpen: false,
      priceValue: [15000, 85000],
      sliderValue: 50,
      filter: '',
      currentPage: 1,
      brands: [],
      pageSize: 48,
      paginationOptions: (_paginationOptions = {
        offset: 4,
        previousText: 'Prev'
      }, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_paginationOptions, 'previousText', 'Préc'), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_paginationOptions, 'nextText', 'Suivant'), _paginationOptions)
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapGetters */])({

    products: 'productsdiesel',
    total: 'totalProductdiesel'
  }), {
    //products(){
    //  if (this.$store.state.lastEntriesdiesel.length > 0)
    // return this.$store.state.productsdiesel
    // else
    //  return this.$store.state.allProducts

    // },
    filterProduct: function filterProduct() {
      var filter = new RegExp(this.filter, 'i');
      if (this.brands.length > 0) {
        return this.products.filter(function (el) {
          return el.name.match(filter);
        });
      } else return this.products.filter(function (el) {
        return el.id.match(filter);
      });
    }
  }),
  created: function created() {
    this.$store.dispatch('fetchDatadiesel', { page: 1, filter: '', gender: '' });
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    pageChanged: function pageChanged(page) {
      this.currentPage = page;
      if (this.brands.length > 0) {
        var filter = 'price:' + this.priceValue;
        this.$store.dispatch('fetchDatadiesel', { page: page, filter: filter, gender: this.brands });
      } else {
        var _filter = 'price:' + this.priceValue;
        this.$store.dispatch('fetchDatadiesel', { page: page, filter: this.filter, gender: '' });
      }
    },
    ordreby: function ordreby(filter) {
      var filter2 = 'ordre:' + filter;
      console.log(filter);
      this.$store.dispatch('fetchDatadiesel', { page: this.currentPage, filter: filter2, gender: '' });
    },
    submit: function submit() {
      var filter = 'price:' + this.priceValue;
      console.log(filter);
      if (this.brands.length > 0) {
        this.$store.dispatch('fetchDatadiesel', { page: this.currentPage, filter: filter, gender: this.brands });
      } else {

        this.$store.dispatch('fetchDatadiesel', { page: this.currentPage, filter: filter, gender: '' });
      }
    },

    search: function search(event) {
      var _this = this;

      var debounce = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.debounce(function () {
        if (_this.brands.length === 0) _this.$store.dispatch('fetchDatadiesel', {
          page: _this.currentPage,
          filter: event.target.value,
          gender: ''
        });
      }, 500);
      debounce();
    },
    brandChecked: function brandChecked(event) {
      var _this2 = this;

      var debounce = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.debounce(function () {
        return _this2.$store.dispatch('fetchDatadiesel', {
          page: _this2.currentPage,
          filter: _this2.brands,
          gender: ''
        });
      }, 500);
      debounce();
    },
    addToCart: function addToCart(item) {
      var _this3 = this;

      this.$store.dispatch('addToCart', item).then(function () {
        _this3.$notify({
          group: 'cart',
          title: 'Product',
          type: 'success',
          text: 'successfuly added to cart!'
        });
      }).catch(function (error) {
        return console.log(error);
      });
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapActions */])(['lastProductdiesel', 'ProductDetail']))
});

/***/ }),
/* 81 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_pagination_bootstrap__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_range_slider_dist_vue_range_slider_css__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_range_slider_dist_vue_range_slider_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_range_slider_dist_vue_range_slider_css__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




// you probably need to import built-in style

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    pagination: __WEBPACK_IMPORTED_MODULE_2_vue_pagination_bootstrap__["a" /* default */]
  },
  data: function data() {
    var _paginationOptions;

    return {
      sidebarOpen: false,
      priceValue: [15000, 85000],
      sliderValue: 50,
      filter: '',
      currentPage: 1,
      brands: [],
      pageSize: 24,
      paginationOptions: (_paginationOptions = {
        offset: 4,
        previousText: 'Prev'
      }, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_paginationOptions, 'previousText', 'Préc'), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_paginationOptions, 'nextText', 'Suivant'), _paginationOptions)
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapGetters */])({

    products: 'productsvideo',
    total: 'totalProductvideo'
  }), {
    //products(){
    //  if (this.$store.state.lastEntriesvideo.length > 0)
    // return this.$store.state.productsvideo
    // else
    //  return this.$store.state.allProducts

    // },

    filterProduct: function filterProduct() {
      var filter = new RegExp(this.filter, 'i');
      if (this.brands.length > 0) {
        return this.products.filter(function (el) {
          return el.name.match(filter);
        });
      } else return this.products.filter(function (el) {
        return el.id.match(filter);
      });
    }
  }),
  created: function created() {
    this.$store.dispatch('fetchDatavideo', { page: 1, filter: '', gender: '' });
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    pageChanged: function pageChanged(page) {
      // this.currentPage = page;
      // if (this.brands.length > 0  ||this.filter =='' ) {
      //  if (this.filter ='')
      //  {
      //    let filter = ``;
      //   this.$store.dispatch('fetchDatavideo', { page: page, filter: filter, gender:this.brands });
      // }

      //  else
      //  {
      //  let filter = `price:${this.priceValue}`;
      //  this.$store.dispatch('fetchDatavideo', { page: page, filter: filter, gender:this.brands });
      // }


      //  } else {
      //    let filter = `price:${this.priceValue}`;
      //   this.$store.dispatch('fetchDatavideo', { page: page, filter: this.filter, gender: '' });
      // }
      // },

      this.currentPage = page;
      if (this.brands.length > 0) {
        var filter = 'price:' + this.priceValue;
        this.$store.dispatch('fetchDatavideo', { page: page, filter: filter, gender: this.brands });
      } else {
        var _filter = 'price:' + this.priceValue;
        this.$store.dispatch('fetchDatavideo', { page: page, filter: this.filter, gender: '' });
      }
    },
    ordreby: function ordreby(filter) {
      var filter2 = 'ordre:' + filter;
      console.log(filter);
      this.$store.dispatch('fetchDatavideo', { page: this.currentPage, filter: filter2, gender: '' });
    },
    submit: function submit() {
      var filter = 'price:' + this.priceValue;
      console.log(filter);
      if (this.brands.length > 0) {
        this.$store.dispatch('fetchDatavideo', { page: this.currentPage, filter: filter, gender: this.brands });
      } else {

        this.$store.dispatch('fetchDatavideo', { page: this.currentPage, filter: filter, gender: '' });
      }
    },

    search: function search(event) {
      var _this = this;

      var debounce = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.debounce(function () {
        if (_this.brands.length === 0) _this.$store.dispatch('fetchData', {
          page: _this.currentPage,
          filter: event.target.value,
          gender: ''
        });
      }, 500);
      debounce();
    },
    brandChecked: function brandChecked(event) {
      var _this2 = this;

      var debounce = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.debounce(function () {
        return _this2.$store.dispatch('fetchDatavideo', {
          page: _this2.currentPage,
          filter: _this2.brands,
          gender: ''
        });
      }, 500);
      debounce();
    },
    addToCart: function addToCart(item) {
      var _this3 = this;

      this.$store.dispatch('addToCart', item).then(function () {
        _this3.$notify({
          group: 'cart',
          title: 'Product',
          type: 'success',
          text: 'successfuly added to cart!'
        });
      }).catch(function (error) {
        return console.log(error);
      });
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapActions */])(['lastProductvideo', 'ProductDetail']))
});

/***/ }),
/* 82 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_pagination_bootstrap__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_range_slider_dist_vue_range_slider_css__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_range_slider_dist_vue_range_slider_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_range_slider_dist_vue_range_slider_css__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




// you probably need to import built-in style

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    pagination: __WEBPACK_IMPORTED_MODULE_2_vue_pagination_bootstrap__["a" /* default */]
  },
  data: function data() {
    var _paginationOptions;

    return {
      sidebarOpen: false,
      priceValue: [15000, 85000],
      sliderValue: 50,
      filter: '',
      currentPage: 1,
      brands: [],
      pageSize: 48,
      paginationOptions: (_paginationOptions = {
        offset: 4,
        previousText: 'Prev'
      }, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_paginationOptions, 'previousText', 'Préc'), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_paginationOptions, 'nextText', 'Suivant'), _paginationOptions)
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapGetters */])({

    products: 'productsfossil',
    total: 'totalProductfossil'
  }), {
    //products(){
    //  if (this.$store.state.lastEntriesfossil.length > 0)
    // return this.$store.state.productsfossil
    // else
    //  return this.$store.state.allProducts

    // },
    filterProduct: function filterProduct() {
      var filter = new RegExp(this.filter, 'i');
      if (this.brands.length > 0) {
        return this.products.filter(function (el) {
          return el.name.match(filter);
        });
      } else return this.products.filter(function (el) {
        return el.id.match(filter);
      });
    }
  }),
  created: function created() {
    this.$store.dispatch('fetchDatafossil', { page: 1, filter: '', gender: '' });
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    // pageChanged(page) {
    // this.currentPage = page;
    //if (this.brands.length > 0 ) {
    //  this.$store.dispatch('fetchDatafossil', { page: page, filter: filter, gender:this.brands });
    //} else {
    //   let filter = `price:${this.priceValue}`;
    //  this.$store.dispatch('fetchDatafossil', { page: page, filter: this.filter, gender: '' });
    // }
    //},


    pageChanged: function pageChanged(page) {

      this.currentPage = page;
      if (this.brands.length > 0) {
        var filter = 'price:' + this.priceValue;
        this.$store.dispatch('fetchDatafossil', { page: page, filter: filter, gender: this.brands });
      } else {
        var _filter = 'price:' + this.priceValue;
        this.$store.dispatch('fetchDatafossil', { page: page, filter: this.filter, gender: '' });
      }
    },
    ordreby: function ordreby(filter) {
      var filter2 = 'ordre:' + filter;
      console.log(filter);
      this.$store.dispatch('fetchDatafossil', { page: this.currentPage, filter: filter2, gender: '' });
    },
    submit: function submit() {
      var filter = 'price:' + this.priceValue;
      console.log(filter);
      if (this.brands.length > 0) {
        this.$store.dispatch('fetchDatafossil', { page: this.currentPage, filter: filter, gender: this.brands });
      } else {

        this.$store.dispatch('fetchDatafossil', { page: this.currentPage, filter: filter, gender: '' });
      }
    },

    search: function search(event) {
      var _this = this;

      var debounce = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.debounce(function () {
        if (_this.brands.length === 0) _this.$store.dispatch('fetchDatafossil', {
          page: _this.currentPage,
          filter: event.target.value,
          gender: ''
        });
      }, 500);
      debounce();
    },
    brandChecked: function brandChecked(event) {
      var _this2 = this;

      var debounce = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.debounce(function () {
        return _this2.$store.dispatch('fetchDatafossil', {
          page: _this2.currentPage,
          filter: _this2.brands,
          gender: ''
        });
      }, 500);
      debounce();
    },
    addToCart: function addToCart(item) {
      var _this3 = this;

      this.$store.dispatch('addToCart', item).then(function () {
        _this3.$notify({
          group: 'cart',
          title: 'Product',
          type: 'success',
          text: 'successfuly added to cart!'
        });
      }).catch(function (error) {
        return console.log(error);
      });
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapActions */])(['lastProductfossil', 'ProductDetail']))
});

/***/ }),
/* 83 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_pagination_bootstrap__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_range_slider_dist_vue_range_slider_css__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_range_slider_dist_vue_range_slider_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_range_slider_dist_vue_range_slider_css__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




// you probably need to import built-in style

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    pagination: __WEBPACK_IMPORTED_MODULE_1_vue_pagination_bootstrap__["a" /* default */]
  },
  data: function data() {
    return {
      sidebarOpen: false,
      priceValue: [15000, 85000],
      sliderValue: 50,
      filter: "",
      currentPage: 1,
      brands: [],
      pageSize: 48,
      paginationOptions: {
        offset: 4,
        previousText: "Prev",
        npreviousText: "Préc",
        nextText: "Suivant"
      }
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapGetters */])({ products: "womenProducts", total: "womenCount" }), {
    filterProduct: function filterProduct() {
      var filter = new RegExp(this.filter, "i");
      if (this.brands.length > 0) {
        return this.products.filter(function (el) {
          return el.name.match(filter);
        });
      } else return this.products.filter(function (el) {
        return el.id.match(filter);
      });
    }
  }),
  created: function created() {
    this.$store.dispatch("fetchData", {
      page: this.currentPage,
      filter: "",
      gender: "F"
    });
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    pageChanged: function pageChanged(page) {
      this.currentPage = page;
      if (this.brands.length > 0) {
        var filter = "price:" + this.priceValue;
        this.$store.dispatch("fetchData", {
          page: page,
          filter: this.brands,
          gender: "F"
        });
      } else {
        var filter2 = "price:" + this.priceValue;
        this.$store.dispatch("fetchData", {
          page: page,
          filter: "",
          gender: "F"
        });
      }
    },
    submit: function submit() {
      var filter = "price:" + this.priceValue;
      this.$store.dispatch("fetchData", {
        page: this.currentPage,
        filter: filter,
        gender: "F"
      });
    },

    search: function search(event) {
      var _this = this;

      var debounce = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function () {
        if (_this.brands.length === 0) _this.$store.dispatch("fetchData", {
          page: _this.currentPage,
          filter: event.target.value,
          gender: "F"
        });
      }, 500);
      debounce();
    },
    brandChecked: function brandChecked(event) {
      var _this2 = this;

      var debounce = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function () {
        return _this2.$store.dispatch("fetchData", {
          page: _this2.currentPage,
          filter: _this2.brands,
          gender: "F"
        });
      }, 500);
      debounce();
    },
    ordreby: function ordreby(filter) {
      var filter2 = "ordre:" + filter;
      console.log(filter);
      this.$store.dispatch("fetchData", {
        page: this.currentPage,
        filter: filter2,
        gender: ""
      });
    },

    addToCart: function addToCart(item) {
      var _this3 = this;

      this.$store.dispatch("addToCart", item).then(function () {
        _this3.$notify({
          group: "cart",
          title: "Product",
          type: "success",
          text: "successfuly added to cart!"
        });
      });
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])(["ProductDetail"]))
});

/***/ }),
/* 84 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({});

/***/ }),
/* 85 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({});

/***/ }),
/* 86 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({});

/***/ }),
/* 87 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({});

/***/ }),
/* 88 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(305);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mutation_types__ = __webpack_require__(307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex_map_fields__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_axios__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_lodash__);



var _state, _getters, _mutations;





//import createPersistedState from 'vuex-persistedstate';



__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* default */]);

var debug = "production" !== 'production';
var baseUrl = 'https://luxuryshopdz.com/api';
//const baseUrl = 'http://localhost:5000/api';
//const imageUrl = 'https://luxuryshopdz.com';
var imageUrl = 'https://bilal.luxuryshopdz.com';
//const baseUrl = 'https://luxuryshopdz.com/api';
// initial state
var state = (_state = {
  commandeInfo: {
    firstName: '',
    lastName: '',
    address: '',
    phoneNumber: '',
    billingAdress: '',
    deliveryAddress: '',
    email: '',
    deliveryFirstName: '',
    deliveryLastName: '',
    deliveryPhoneNumber: '',
    deliveryWilaya: '',
    wilaya: ''
  },
  user: {
    firstName: '',
    lastName: '',
    address: '',
    phoneNumber: '',
    billingAdress: '',
    deliveryAddress: '',
    email: '',
    deliveryPostalCode: '',
    deliveryFirstName: '',
    deliveryLastName: '',
    deliveryPhoneNumber: '',
    deliveryWilaya: '',
    wilaya: ''
  },
  loginInfo: {
    email: '',
    password: '',
    phonenumber: ''
  },
  registreInfo: {
    emailregister: '',
    passwordregister: '',
    phonenumberregister: '',
    prenomregister: '',
    nomregister: ''
  },
  product: {},
  added: [],
  all: [],
  festina: [],
  festinadepot: [],
  video: [],
  royal: [],
  men: []
}, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_state, 'user', null), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_state, 'women', []), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_state, 'lastEntries', []), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_state, 'lastEntries2', []), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_state, 'lastEntriesfestina', []), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_state, 'lastEntriesfestinadepot', []), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_state, 'lastEntriesref', []), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_state, 'lastEntriesvideo', []), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_state, 'lastEntriesroyal', []), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_state, 'lastEntriespolice', []), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_state, 'lastEntriescerruti', []), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_state, 'lastEntrieslotus', []), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_state, 'lastEntriesversus', []), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_state, 'lastEntriesTRUSSARDI', []), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_state, 'lastEntriesMONTIGNAC', []), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_state, 'lastEntriesarmani', []), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_state, 'lastEntriesnautica', []), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_state, 'lastEntriesmaserati', []), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_state, 'lastEntriesmorellato', []), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_state, 'lastEntriestimberland', []), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_state, 'lastEntriesMichaelkors', []), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_state, 'lastEntriesconnectee', []), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_state, 'lastEntriespromo', []), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_state, 'lastEntriespromo', []), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_state, 'lastEntriesdiesel', []), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_state, 'lastEntriesfossil', []), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_state, 'totalProduct', 0), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_state, 'totalProductfestina', 0), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_state, 'totalProductfestinadepot', 0), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_state, 'totalProductref', 0), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_state, 'totalProductpromo', 0), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_state, 'totalProductvideo', 0), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_state, 'totalProductroyal', 0), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_state, 'totalProductpolice', 0), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_state, 'totalProductarmani', 0), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_state, 'totalProductnautica', 0), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_state, 'totalProductmaserati', 0), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_state, 'totalProductmorellato', 0), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_state, 'totalProducttimberland', 0), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_state, 'totalProductMichaelkors', 0), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_state, 'totalProductconnectee', 0), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_state, 'totalProductcerruti', 0), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_state, 'totalProductlotus', 0), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_state, 'totalProductversus', 0), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_state, 'totalProductTRUSSARDI', 0), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_state, 'totalProductMONTIGNAC', 0), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_state, 'totalProductdiesel', 0), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_state, 'totalProductfossil', 0), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_state, 'menCount', 0), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_state, 'womenCount', 0), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_state, 'statusCode', 0), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_state, 'fetchedData', false), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_state, 'isAuthenticated', false), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_state, 'orderId', 0), _state);

// getters
var getters = (_getters = {
  getField: __WEBPACK_IMPORTED_MODULE_5_vuex_map_fields__["a" /* getField */],
  orderId: function orderId(state) {
    return state.orderId;
  },
  isAuthenticated: function isAuthenticated(state) {
    return state.isAuthenticated;
  },
  totalProduct: function totalProduct(state) {
    return state.totalProduct;
  },

  totalProductfestina: function totalProductfestina(state) {
    return state.totalProductfestina;
  },
  totalProductfestinadepot: function totalProductfestinadepot(state) {
    return state.totalProductfestinadepot;
  },
  totalProductref: function totalProductref(state) {
    return state.totalProductref;
  },
  totalProductpromo: function totalProductpromo(state) {
    return state.totalProductpromo;
  },
  totalProductvideo: function totalProductvideo(state) {
    return state.totalProductvideo;
  },
  totalProductroyal: function totalProductroyal(state) {
    return state.totalProductroyal;
  },
  totalProductpolice: function totalProductpolice(state) {
    return state.totalProductpolice;
  },
  totalProductcerruti: function totalProductcerruti(state) {
    return state.totalProductcerruti;
  },
  totalProductlotus: function totalProductlotus(state) {
    return state.totalProductlotus;
  },
  totalProductversus: function totalProductversus(state) {
    return state.totalProductversus;
  },
  totalProductTRUSSARDI: function totalProductTRUSSARDI(state) {
    return state.totalProductTRUSSARDI;
  },
  totalProductMONTIGNAC: function totalProductMONTIGNAC(state) {
    return state.totalProductMONTIGNAC;
  },
  totalProductarmani: function totalProductarmani(state) {
    return state.totalProductarmani;
  },
  totalProductnautica: function totalProductnautica(state) {
    return state.totalProductnautica;
  },
  totalProductmaserati: function totalProductmaserati(state) {
    return state.totalProductmaserati;
  },
  totalProductmorellato: function totalProductmorellato(state) {
    return state.totalProductmorellato;
  },
  totalProducttimberland: function totalProducttimberland(state) {
    return state.totalProducttimberland;
  },
  totalProductMichaelkors: function totalProductMichaelkors(state) {
    return state.totalProductMichaelkors;
  },
  totalProductconnectee: function totalProductconnectee(state) {
    return state.totalProductconnectee;
  },
  totalProductdiesel: function totalProductdiesel(state) {
    return state.totalProductdiesel;
  },
  totalProductfossil: function totalProductfossil(state) {
    return state.totalProductfossil;
  },
  menCount: function menCount(state) {
    return state.menCount;
  },
  womenCount: function womenCount(state) {
    return state.womenCount;
  },
  cartNotification: function cartNotification(state) {
    return state.showNotification;
  },
  getCommandeInfo: function getCommandeInfo(state) {
    return state.commandeInfo;
  },
  user: function user(state) {
    return state.user;
  },
  allImages: function allImages(state) {
    return state.all.map(function (product) {
      return imageUrl + '/' + product.imgUrl;
    });
  },
  allProducts: function allProducts(state) {
    return state.all.map(function (article) {
      return {
        id: article.reference,
        description: article.discprition,
        famille: article.famille,
        name: article.marque,
        price: article.prixDetail,
        price2: article.prixAchat,
        gender: article.famille,
        color: article.couleur,
        annee: article.anneeArticle,
        quantite: article.quantite,

        waterResiste: article.waterResiste,
        tailleCadron: article.tailleCadron,
        typeBracelet: article.typeBracelet,
        type: article.type,
        sales: false,
        discount: 0,
        img: imageUrl + '/' + article.imgUrl
      };
    });
  },
  allProductsbourdima: function allProductsbourdima(state) {
    return state.all.filter(function (x) {
      return x.quantite >= 3;
    }).map(function (article) {
      return {
        id: article.reference,
        description: article.discprition,
        famille: article.famille,
        name: article.marque,
        price: article.prixDetail,
        price2: article.prixAchat,
        gender: article.famille,

        color: article.couleur,
        quantite: article.quantite,
        waterResiste: article.waterResiste,
        tailleCadron: article.tailleCadron,
        typeBracelet: article.typeBracelet,
        type: article.type,
        sales: false,
        discount: 0,
        img: imageUrl + '/' + article.imgUrl
      };
    });
  },

  lastProducts: function lastProducts(state) {

    return state.lastEntries.filter(function (x) {
      return x.famille == 'F';
    }).map(function (article) {
      return {
        id: article.reference,
        description: article.discprition,
        famille: article.famille,
        waterResiste: article.waterResiste,
        tailleCadron: article.tailleCadron,
        typeBracelet: article.typeBracelet,
        type: article.type,
        name: article.marque,
        price: article.prixDetail,
        price2: article.prixAchat,
        gender: article.famille,
        color: article.couleur,

        sales: false,
        discount: 0,
        img: imageUrl + '/' + article.imgUrl,
        photo: imageUrl + '/' + article.photo
      };
    });
  },
  lastProductspromos: function lastProductspromos(state) {

    return state.lastEntriespromo.map(function (article) {
      return {
        id: article.reference,
        description: article.discprition,
        famille: article.famille,
        waterResiste: article.waterResiste,
        tailleCadron: article.tailleCadron,
        typeBracelet: article.typeBracelet,
        type: article.type,
        name: article.marque,
        price: article.prixDetail,
        price2: article.prixAchat,
        gender: article.famille,
        color: article.couleur,

        sales: false,
        discount: 0,
        img: imageUrl + '/' + article.imgUrl,
        photo: imageUrl + '/' + article.photo
      };
    });
  },
  lastProductsreference: function lastProductsreference(state) {
    return state.lastEntriesreference.map(function (article) {
      return {
        id: article.reference,
        description: article.discprition,
        famille: article.famille,
        waterResiste: article.waterResiste,
        tailleCadron: article.tailleCadron,
        typeBracelet: article.typeBracelet,
        type: article.type,
        name: article.marque,
        price: article.prixDetail,
        price2: article.prixAchat,
        gender: article.famille,
        color: article.couleur,

        sales: false,
        discount: 0,
        img: imageUrl + '/' + article.imgUrl,
        photo: imageUrl + '/' + article.photo
      };
    });
  },
  lastProducts2: function lastProducts2(state) {

    return state.lastEntries.filter(function (x) {
      return x.famille == 'H';
    }).map(function (article) {
      return {
        id: article.reference,
        description: article.discprition,
        famille: article.famille,
        waterResiste: article.waterResiste,
        tailleCadron: article.tailleCadron,
        typeBracelet: article.typeBracelet,
        type: article.type,
        name: article.marque,
        state: article.status,
        price: article.prixDetail,
        price2: article.prixAchat,
        gender: article.famille,
        color: article.couleur,

        sales: false,
        discount: 0,
        img: imageUrl + '/' + article.imgUrl,
        photo: imageUrl + '/' + article.photo
      };
    });
  }
}, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_getters, 'lastProducts2', function lastProducts2(state) {

  return state.lastEntries.filter(function (x) {
    return x.famille == 'H';
  }).map(function (article) {
    return {
      id: article.reference,
      description: article.discprition,
      famille: article.famille,
      waterResiste: article.waterResiste,
      tailleCadron: article.tailleCadron,
      typeBracelet: article.typeBracelet,
      type: article.type,
      name: article.marque,
      state: article.status,
      price: article.prixDetail,
      price2: article.prixAchat,
      gender: article.famille,
      color: article.couleur,

      sales: false,
      discount: 0,
      img: imageUrl + '/' + article.imgUrl,
      photo: imageUrl + '/' + article.photo
    };
  });
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_getters, 'productsfestina', function productsfestina(state) {
  return state.lastEntriesfestina.map(function (article) {
    return {
      id: article.reference,
      description: article.discprition,
      quantite: article.quantite,
      annee: article.anneeArticle,

      famille: article.famille,
      waterResiste: article.waterResiste,
      tailleCadron: article.tailleCadron,
      typeBracelet: article.typeBracelet,
      type: article.type,
      name: article.marque,
      price: article.prixDetail,
      price2: article.prixAchat,
      gender: article.famille,
      color: article.couleur,
      sales: false,
      discount: 0,
      img: imageUrl + '/' + article.imgUrl
    };
  });
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_getters, 'productsfestinadepot', function productsfestinadepot(state) {
  return state.lastEntriesfestinadepot.map(function (article) {
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()({
      id: article.reference,

      quantite: article.quantite,
      img: imageUrl + '/' + article.imgUrl,
      description: article.discprition,
      waterResiste: article.waterResiste,
      annee: article.anneeArticle,
      typeBracelet: article.typeBracelet,

      famille: article.famille,

      name: article.marque,
      price: article.prixDetail,
      price2: article.prixAchat,

      gender: article.famille,

      sales: false,
      discount: 0
    }, 'img', imageUrl + '/' + article.imgUrl);
  });
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_getters, 'productsref', function productsref(state) {
  return state.lastEntriesref.map(function (article) {
    return {
      id: article.reference,
      description: article.discprition,
      quantite: article.quantite,
      annee: article.anneeArticle,

      famille: article.famille,
      waterResiste: article.waterResiste,
      tailleCadron: article.tailleCadron,
      typeBracelet: article.typeBracelet,
      type: article.type,
      name: article.marque,
      price: article.prixDetail,
      price2: article.prixAchat,
      gender: article.famille,
      color: article.couleur,
      sales: false,
      discount: 0,
      img: imageUrl + '/' + article.imgUrl
    };
  });
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_getters, 'productsfestinabourdima', function productsfestinabourdima(state) {
  return state.lastEntriesfestina.filter(function (x) {
    return x.quantite >= 3;
  }).map(function (article) {
    return {
      id: article.reference,
      description: article.discprition,
      famille: article.famille,
      quantite: article.quantite,
      waterResiste: article.waterResiste,
      tailleCadron: article.tailleCadron,
      typeBracelet: article.typeBracelet,
      type: article.type,
      name: article.marque,
      price: article.prixDetail,
      gender: article.famille,
      color: article.couleur,
      sales: false,
      discount: 0,
      img: imageUrl + '/' + article.imgUrl
    };
  });
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_getters, 'productsvideo', function productsvideo(state) {
  return state.lastEntriesvideo.filter(function (x) {
    return x.quantite > 0;
  }).map(function (article) {
    return {
      id: article.reference,
      description: article.discprition,
      famille: article.famille,
      name: article.marque,
      price: article.prixDetail,
      price2: article.prixAchat,
      gender: article.famille,
      color: article.couleur,
      waterResiste: article.waterResiste,
      tailleCadron: article.tailleCadron,
      typeBracelet: article.typeBracelet,
      type: article.type,
      sales: false,
      discount: 0,
      img: imageUrl + '/' + article.imgUrl
    };
  });
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_getters, 'productsroyal', function productsroyal(state) {
  return state.lastEntriesroyal.map(function (article) {
    return {
      id: article.reference,
      description: article.discprition,
      famille: article.famille,
      waterResiste: article.waterResiste,
      tailleCadron: article.tailleCadron,
      typeBracelet: article.typeBracelet,
      type: article.type,
      name: article.marque,
      price: article.prixDetail,
      price2: article.prixAchat,
      gender: article.famille,
      color: article.couleur,

      sales: false,
      discount: 0,
      img: imageUrl + '/' + article.imgUrl
    };
  });
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_getters, 'productspolice', function productspolice(state) {
  return state.lastEntriespolice.map(function (article) {
    return {
      id: article.reference,
      description: article.discprition,
      famille: article.famille,
      waterResiste: article.waterResiste,
      tailleCadron: article.tailleCadron,
      typeBracelet: article.typeBracelet,
      type: article.type,
      name: article.marque,
      price: article.prixDetail,
      gender: article.famille,
      color: article.couleur,

      sales: false,
      discount: 0,
      img: imageUrl + '/' + article.imgUrl
    };
  });
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_getters, 'productsarmani', function productsarmani(state) {
  return state.lastEntriesarmani.map(function (article) {
    return {
      id: article.reference,
      description: article.discprition,
      famille: article.famille,
      waterResiste: article.waterResiste,
      tailleCadron: article.tailleCadron,
      typeBracelet: article.typeBracelet,
      type: article.type,
      name: article.marque,
      price: article.prixDetail,
      price2: article.prixAchat,
      gender: article.famille,
      color: article.couleur,
      quantite: article.quantite,
      annee: article.anneeArticle,

      sales: false,
      discount: 0,
      img: imageUrl + '/' + article.imgUrl
    };
  });
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_getters, 'productsnautica', function productsnautica(state) {
  return state.lastEntriesnautica.map(function (article) {
    return {
      id: article.reference,
      description: article.discprition,
      famille: article.famille,
      waterResiste: article.waterResiste,
      tailleCadron: article.tailleCadron,
      typeBracelet: article.typeBracelet,
      type: article.type,
      name: article.marque,
      price: article.prixDetail,
      price2: article.prixAchat,
      gender: article.famille,
      color: article.couleur,
      quantite: article.quantite,
      annee: article.anneeArticle,

      sales: false,
      discount: 0,
      img: imageUrl + '/' + article.imgUrl
    };
  });
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_getters, 'productsmaserati', function productsmaserati(state) {
  return state.lastEntriesmaserati.map(function (article) {
    return {
      id: article.reference,
      description: article.discprition,
      famille: article.famille,
      waterResiste: article.waterResiste,
      tailleCadron: article.tailleCadron,
      typeBracelet: article.typeBracelet,
      type: article.type,
      name: article.marque,
      price: article.prixDetail,
      price2: article.prixAchat,
      gender: article.famille,
      color: article.couleur,
      quantite: article.quantite,
      annee: article.anneeArticle,

      sales: false,
      discount: 0,
      img: imageUrl + '/' + article.imgUrl
    };
  });
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_getters, 'productsmorellato', function productsmorellato(state) {
  return state.lastEntriesmorellato.map(function (article) {
    return {
      id: article.reference,
      description: article.discprition,
      famille: article.famille,
      waterResiste: article.waterResiste,
      tailleCadron: article.tailleCadron,
      typeBracelet: article.typeBracelet,
      type: article.type,
      name: article.marque,
      price: article.prixDetail,
      price2: article.prixAchat,
      gender: article.famille,
      color: article.couleur,
      quantite: article.quantite,
      annee: article.anneeArticle,

      sales: false,
      discount: 0,
      img: imageUrl + '/' + article.imgUrl
    };
  });
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_getters, 'productstimberland', function productstimberland(state) {
  return state.lastEntriestimberland.map(function (article) {
    return {
      id: article.reference,
      description: article.discprition,
      famille: article.famille,
      waterResiste: article.waterResiste,
      tailleCadron: article.tailleCadron,
      typeBracelet: article.typeBracelet,
      type: article.type,
      name: article.marque,
      price: article.prixDetail,
      price2: article.prixAchat,
      gender: article.famille,
      color: article.couleur,
      quantite: article.quantite,
      annee: article.anneeArticle,

      sales: false,
      discount: 0,
      img: imageUrl + '/' + article.imgUrl
    };
  });
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_getters, 'productsMichaelkors', function productsMichaelkors(state) {
  return state.lastEntriesMichaelkors.map(function (article) {
    return {
      id: article.reference,
      description: article.discprition,
      famille: article.famille,
      waterResiste: article.waterResiste,
      tailleCadron: article.tailleCadron,
      typeBracelet: article.typeBracelet,
      type: article.type,
      name: article.marque,
      price: article.prixDetail,
      price2: article.prixAchat,
      gender: article.famille,
      color: article.couleur,
      quantite: article.quantite,

      sales: false,
      discount: 0,
      img: imageUrl + '/' + article.imgUrl
    };
  });
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_getters, 'productsconnectee', function productsconnectee(state) {
  return state.lastEntriesconnectee.map(function (article) {
    return {
      id: article.reference,
      description: article.discprition,
      famille: article.famille,
      waterResiste: article.waterResiste,
      tailleCadron: article.tailleCadron,
      typeBracelet: article.typeBracelet,
      type: article.type,
      name: article.marque,
      price: article.prixDetail,
      price2: article.prixAchat,
      gender: article.famille,
      color: article.couleur,
      quantite: article.quantite,

      sales: false,
      discount: 0,
      img: imageUrl + '/' + article.imgUrl
    };
  });
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_getters, 'productscerruti', function productscerruti(state) {
  return state.lastEntriescerruti.map(function (article) {
    return {
      id: article.reference,
      description: article.discprition,
      famille: article.famille,
      waterResiste: article.waterResiste,
      tailleCadron: article.tailleCadron,
      typeBracelet: article.typeBracelet,
      type: article.type,
      name: article.marque,
      price: article.prixDetail,
      price2: article.prixAchat,
      gender: article.famille,
      color: article.couleur,

      sales: false,
      discount: 0,
      img: imageUrl + '/' + article.imgUrl
    };
  });
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_getters, 'productslotus', function productslotus(state) {
  return state.lastEntrieslotus.map(function (article) {
    return {
      id: article.reference,
      description: article.discprition,
      famille: article.famille,
      waterResiste: article.waterResiste,
      tailleCadron: article.tailleCadron,
      typeBracelet: article.typeBracelet,
      type: article.type,
      name: article.marque,
      price: article.prixDetail,
      price2: article.prixAchat,
      gender: article.famille,
      color: article.couleur,

      sales: false,
      discount: 0,
      img: imageUrl + '/' + article.imgUrl
    };
  });
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_getters, 'productsversus', function productsversus(state) {
  return state.lastEntriesversus.map(function (article) {
    return {
      id: article.reference,
      description: article.discprition,
      famille: article.famille,
      waterResiste: article.waterResiste,
      tailleCadron: article.tailleCadron,
      typeBracelet: article.typeBracelet,
      type: article.type,
      name: article.marque,
      price: article.prixDetail,
      price2: article.prixAchat,
      gender: article.famille,
      color: article.couleur,

      sales: false,
      discount: 0,
      img: imageUrl + '/' + article.imgUrl
    };
  });
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_getters, 'productsTRUSSARDI', function productsTRUSSARDI(state) {
  return state.lastEntriesTRUSSARDI.map(function (article) {
    return {
      id: article.reference,
      description: article.discprition,
      famille: article.famille,
      waterResiste: article.waterResiste,
      tailleCadron: article.tailleCadron,
      typeBracelet: article.typeBracelet,
      type: article.type,
      name: article.marque,
      price: article.prixDetail,
      price2: article.prixAchat,
      gender: article.famille,
      color: article.couleur,

      sales: false,
      discount: 0,
      img: imageUrl + '/' + article.imgUrl
    };
  });
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_getters, 'productsMONTIGNAC', function productsMONTIGNAC(state) {
  return state.lastEntriesMONTIGNAC.map(function (article) {
    return {
      id: article.reference,
      description: article.discprition,
      famille: article.famille,
      waterResiste: article.waterResiste,
      tailleCadron: article.tailleCadron,
      typeBracelet: article.typeBracelet,
      type: article.type,
      name: article.marque,
      price: article.prixDetail,
      price2: article.prixAchat,
      gender: article.famille,
      color: article.couleur,

      sales: false,
      discount: 0,
      img: imageUrl + '/' + article.imgUrl
    };
  });
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_getters, 'productsdiesel', function productsdiesel(state) {
  return state.lastEntriesdiesel.map(function (article) {
    return {
      id: article.reference,
      description: article.discprition,
      famille: article.famille,
      waterResiste: article.waterResiste,
      tailleCadron: article.tailleCadron,
      typeBracelet: article.typeBracelet,
      type: article.type,
      name: article.marque,
      price: article.prixDetail,
      price2: article.prixAchat,
      gender: article.famille,
      color: article.couleur,
      quantite: article.quantite,

      sales: false,
      discount: 0,
      img: imageUrl + '/' + article.imgUrl
    };
  });
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_getters, 'productsfossil', function productsfossil(state) {
  return state.lastEntriesfossil.map(function (article) {
    return {
      id: article.reference,
      famille: article.famille,
      description: article.discprition,
      waterResiste: article.waterResiste,
      tailleCadron: article.tailleCadron,
      typeBracelet: article.typeBracelet,
      type: article.type,
      name: article.marque,
      price: article.prixDetail,
      price2: article.prixAchat,
      gender: article.famille,
      color: article.couleur,
      annee: article.anneeArticle,
      quantite: article.quantite,

      sales: false,
      discount: 0,
      img: imageUrl + '/' + article.imgUrl
    };
  });
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_getters, 'productspromo', function productspromo(state) {
  return state.lastEntriespromo.map(function (article) {
    return {
      id: article.reference,
      famille: article.famille,
      description: article.discprition,
      waterResiste: article.waterResiste,
      tailleCadron: article.tailleCadron,
      typeBracelet: article.typeBracelet,
      type: article.type,
      name: article.marque,
      price: article.prixDetail,
      gender: article.famille,
      color: article.couleur,
      annee: article.anneeArticle,
      quantite: article.quantite,
      price2: article.prixAchat,

      sales: false,
      discount: 0,
      img: imageUrl + '/' + article.imgUrl
    };
  });
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_getters, 'menProducts', function menProducts(state) {
  return state.men.map(function (article) {
    return {
      id: article.reference,
      description: article.discprition,
      famille: article.famille,
      name: article.marque,
      price: article.prixDetail,
      price2: article.prixAchat,
      gender: article.famille,
      waterResiste: article.waterResiste,
      tailleCadron: article.tailleCadron,
      typeBracelet: article.typeBracelet,
      type: article.type,
      color: article.couleur,

      sales: false,
      discount: 0,
      img: imageUrl + '/' + article.imgUrl
    };
  });
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_getters, 'womenProducts', function womenProducts(state) {
  return state.women.map(function (article) {
    return {
      id: article.reference,
      description: article.discprition,
      famille: article.famille,
      name: article.marque,
      price: article.prixDetail,
      price2: article.prixAchat,
      gender: article.famille,
      color: article.couleur,
      waterResiste: article.waterResiste,
      tailleCadron: article.tailleCadron,
      typeBracelet: article.typeBracelet,
      type: article.type,

      sales: false,
      discount: 0,
      img: imageUrl + '/' + article.imgUrl
    };
  });
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_getters, 'getNumberOfProducts', function getNumberOfProducts(state) {
  return state.all ? state.all.length : 0;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_getters, 'cartProducts', function cartProducts(state) {
  return state.added;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_getters, 'detailProduct', function detailProduct(state) {

  if (state.product.length > 0) return state.product;
  if (sessionStorage.length > 0) return JSON.parse(sessionStorage.getItem('product'));
}), _getters);

// actions
var actions = {
  fblogin: function fblogin(_ref2, accessToken) {
    var commit = _ref2.commit;

    var url = baseUrl + '/auth/facebooklogin?accessToken=' + accessToken;
    __WEBPACK_IMPORTED_MODULE_6_axios___default.a.get(url, {
      headers: {
        //'Access-Control-Allow-Origin': '*'
      }
    }).then(function (response) {
      if (response.status === 200) {
        localStorage.setItem('auth', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(response.data));
        commit(__WEBPACK_IMPORTED_MODULE_4__mutation_types__["E" /* LOGIN */], {
          isAuth: true
        });
      } else commit(__WEBPACK_IMPORTED_MODULE_4__mutation_types__["E" /* LOGIN */], {
        isAuth: false
      });
    });
  },


  //////////////////////////////////////
  login: function login(_ref3) {
    var commit = _ref3.commit;

    var loginurl = baseUrl + '/auth/login';
    var data = state.loginInfo;
    __WEBPACK_IMPORTED_MODULE_6_axios___default.a.post(loginurl, data, {
      headers: {
        //'Access-Control-Allow-Origin': '*'
      }
    }).then(function (response) {
      if (response.status === 200) {
        localStorage.setItem('auth', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(response.data));
        commit(__WEBPACK_IMPORTED_MODULE_4__mutation_types__["E" /* LOGIN */], {
          isAuth: true
        });
      } else commit(__WEBPACK_IMPORTED_MODULE_4__mutation_types__["E" /* LOGIN */], {
        isAuth: false
      });
    });
  },

  //////////////////////////////////////
  register: function register(_ref4) {
    var commit = _ref4.commit;

    var registernurl = baseUrl + '/auth/Register';
    var data = state.registreInfo;
    __WEBPACK_IMPORTED_MODULE_6_axios___default.a.post(registernurl, data, {
      headers: {
        //'Access-Control-Allow-Origin': '*'
      }
    }).then(function (response) {
      if (response.status === 200) {
        localStorage.setItem('auth', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(response.data));
        commit(__WEBPACK_IMPORTED_MODULE_4__mutation_types__["F" /* REGISTER */], {
          isAuth: true
        });
      } else commit(__WEBPACK_IMPORTED_MODULE_4__mutation_types__["F" /* REGISTER */], {
        isAuth: false
      });
    });
  },


  /////////////////////////////
  logout: function logout(_ref5) {
    var commit = _ref5.commit;

    localStorage.removeItem('auth');
    state.loginInfo.email = "";
    state.loginInfo.password = "";
    commit(__WEBPACK_IMPORTED_MODULE_4__mutation_types__["E" /* LOGIN */], {
      isAuth: false
    });
  },


  ////////////////////////
  loadCart: function loadCart(_ref6) {
    var commit = _ref6.commit;

    commit(__WEBPACK_IMPORTED_MODULE_4__mutation_types__["D" /* LOAD_CART */]);
  },

  ///////////////////////////
  addToCart: function addToCart(_ref7, product) {
    var commit = _ref7.commit;

    commit(__WEBPACK_IMPORTED_MODULE_4__mutation_types__["a" /* ADD_TO_CART */], {
      id: product.id,
      name: product.name,
      color: product.color,
      price: product.price,
      price2: product.price2,
      img: product.img,
      waterResiste: product.waterResiste,
      tailleCadron: product.tailleCadron,
      typeBracelet: product.typeBracelet,
      type: product.type

    });
  },

  ////////////////////
  lastProduct: function lastProduct(_ref8, _ref9) {
    var commit = _ref8.commit;
    var limit = _ref9.limit;

    var url = baseUrl + '/article/lastproducts?_limit=' + limit;
    __WEBPACK_IMPORTED_MODULE_6_axios___default.a.get(url, {
      headers: {
        //'Access-Control-Allow-Origin': '*'
      }
    }).then(function (response) {
      state.fetchedData = true;
      commit(__WEBPACK_IMPORTED_MODULE_4__mutation_types__["f" /* LAST_PRODUCT */], {
        response: response.data
      });
    }).catch(function (error) {
      console.log(error);
      state.fetchedData = false;
    });
  },
  lastProductpromo: function lastProductpromo(_ref10, _ref11) {
    var commit = _ref10.commit;
    var limit = _ref11.limit;

    //let url = `${baseUrl}/article/lastproductspromo?_limit=${limit}`;
    var url = baseUrl + '/article/update/' + reference + '?_limit=' + limit;
    __WEBPACK_IMPORTED_MODULE_6_axios___default.a.get(url, {
      headers: {
        //'Access-Control-Allow-Origin': '*'
      }
    }).then(function (response) {
      state.fetchedData = true;
      commit(__WEBPACK_IMPORTED_MODULE_4__mutation_types__["w" /* LAST_PRODUCTpromo */], {
        response: response.data
      });
    }).catch(function (error) {
      console.log(error);
      state.fetchedData = false;
    });
  },
  lastProducttotal: function lastProducttotal(_ref12, _ref13) {
    var commit = _ref12.commit;
    var limit = _ref13.limit;

    var url = baseUrl + '/article/lastproducts?_limit=' + limit;
    var url2 = baseUrl + '/article/lastproducts2?_limit=' + limit;

    __WEBPACK_IMPORTED_MODULE_6_axios___default.a.get(url, {
      headers: {
        //'Access-Control-Allow-Origin': '*'
      }
    }).then(function (response) {
      state.fetchedData = true;
      commit(__WEBPACK_IMPORTED_MODULE_4__mutation_types__["f" /* LAST_PRODUCT */], {
        response: response.data
      });
    }).catch(function (error) {
      console.log(error);
      state.fetchedData = false;
    });
    __WEBPACK_IMPORTED_MODULE_6_axios___default.a.get(url2, {
      headers: {
        //'Access-Control-Allow-Origin': '*'
      }
    }).then(function (response) {
      state.fetchedData = true;
      commit(__WEBPACK_IMPORTED_MODULE_4__mutation_types__["f" /* LAST_PRODUCT */], {
        response: response.data
      });
    }).catch(function (error) {
      console.log(error);
      state.fetchedData = false;
    });
  },
  //
  ////////////////////
  ////////////////////
  lastProductreference: function lastProductreference(_ref14, _ref15) {
    var commit = _ref14.commit;
    var limit = _ref15.limit;

    var url = baseUrl + '/article/update/' + reference + '?_limit=' + limit;
    __WEBPACK_IMPORTED_MODULE_6_axios___default.a.get(url, {
      headers: {
        //'Access-Control-Allow-Origin': '*'
      }
    }).then(function (response) {
      state.fetchedData = true;
      commit(__WEBPACK_IMPORTED_MODULE_4__mutation_types__["y" /* LAST_PRODUCTreference */], {
        response: response.data
      });
    }).catch(function (error) {
      console.log(error);
      state.fetchedData = false;
    });
  },
  //
  ////////////////////
  lastProduct2: function lastProduct2(_ref16, _ref17) {
    var commit = _ref16.commit;
    var limit = _ref17.limit;

    var url = baseUrl + '/article/lastproducts2?_limit=' + limit;
    __WEBPACK_IMPORTED_MODULE_6_axios___default.a.get(url, {
      headers: {
        //'Access-Control-Allow-Origin': '*'
      }
    }).then(function (response) {
      state.fetchedData = true;
      commit(__WEBPACK_IMPORTED_MODULE_4__mutation_types__["g" /* LAST_PRODUCT2 */], {
        response: response.data
      });
    }).catch(function (error) {
      console.log(error);
      state.fetchedData = false;
    });
  },


  //
  ////////////////////
  lastProductfestina: function lastProductfestina(_ref18, _ref19) {
    var commit = _ref18.commit;
    var limit = _ref19.limit;

    var url = baseUrl + '/article/productsfestina?_limit=' + limit;
    __WEBPACK_IMPORTED_MODULE_6_axios___default.a.get(url, {
      headers: {
        //'Access-Control-Allow-Origin': '*'
      }
    }).then(function (response) {
      state.fetchedData = true;
      commit(__WEBPACK_IMPORTED_MODULE_4__mutation_types__["o" /* LAST_PRODUCTfestina */], {
        response: response.data
      });
    }).catch(function (error) {
      console.log(error);
      state.fetchedData = false;
    });
  },

  ////////////////////
  lastProductfestinadepot: function lastProductfestinadepot(_ref20, _ref21) {
    var commit = _ref20.commit;
    var limit = _ref21.limit;

    var url = baseUrl + '/article/productsdepot?_limit=' + limit;
    __WEBPACK_IMPORTED_MODULE_6_axios___default.a.get(url, {
      headers: {
        //'Access-Control-Allow-Origin': '*'
      }
    }).then(function (response) {
      state.fetchedData = true;
      commit(__WEBPACK_IMPORTED_MODULE_4__mutation_types__["p" /* LAST_PRODUCTfestinadepot */], {
        response: response.data
      });
    }).catch(function (error) {
      console.log(error);
      state.fetchedData = false;
    });
  },

  ////////////////////
  lastProductref: function lastProductref(_ref22, _ref23) {
    var commit = _ref22.commit;
    var limit = _ref23.limit;

    var url = baseUrl + '/article/product/' + "mk5354";
    __WEBPACK_IMPORTED_MODULE_6_axios___default.a.get(url, {
      headers: {
        //'Access-Control-Allow-Origin': '*'
      }
    }).then(function (response) {
      state.fetchedData = true;
      commit(__WEBPACK_IMPORTED_MODULE_4__mutation_types__["x" /* LAST_PRODUCTref */], {
        response: response.data
      });
    }).catch(function (error) {
      console.log(error);
      state.fetchedData = false;
    });
  },


  ////////////////////
  LAST_PRODUCTvideo: function LAST_PRODUCTvideo(_ref24, _ref25) {
    var commit = _ref24.commit;
    var limit = _ref25.limit;

    var url = baseUrl + '/article/productsvideo?_limit=' + limit;
    __WEBPACK_IMPORTED_MODULE_6_axios___default.a.get(url, {
      headers: {
        //'Access-Control-Allow-Origin': '*'
      }
    }).then(function (response) {
      state.fetchedData = true;
      commit(__WEBPACK_IMPORTED_MODULE_4__mutation_types__["C" /* LAST_PRODUCTvideo */], {
        response: response.data
      });
    }).catch(function (error) {
      console.log(error);
      state.fetchedData = false;
    });
  },

  ////////////////////
  lastProductroyal: function lastProductroyal(_ref26, _ref27) {
    var commit = _ref26.commit;
    var limit = _ref27.limit;

    var url = baseUrl + '/article/productsroyal?_limit=' + limit;
    __WEBPACK_IMPORTED_MODULE_6_axios___default.a.get(url, {
      headers: {
        //'Access-Control-Allow-Origin': '*'
      }
    }).then(function (response) {
      state.fetchedData = true;
      commit(__WEBPACK_IMPORTED_MODULE_4__mutation_types__["z" /* LAST_PRODUCTroyal */], {
        response: response.data
      });
    }).catch(function (error) {
      console.log(error);
      state.fetchedData = false;
    });
  },

  ////////////////////
  lastProductpolice: function lastProductpolice(_ref28, _ref29) {
    var commit = _ref28.commit;
    var limit = _ref29.limit;

    var url = baseUrl + '/article/productspolice?_limit=' + limit;
    __WEBPACK_IMPORTED_MODULE_6_axios___default.a.get(url, {
      headers: {
        //'Access-Control-Allow-Origin': '*'
      }
    }).then(function (response) {
      state.fetchedData = true;
      commit(__WEBPACK_IMPORTED_MODULE_4__mutation_types__["v" /* LAST_PRODUCTpolice */], {
        response: response.data
      });
    }).catch(function (error) {
      console.log(error);
      state.fetchedData = false;
    });
  },

  //
  ////////////////////
  lastProductarmani: function lastProductarmani(_ref30, _ref31) {
    var commit = _ref30.commit;
    var limit = _ref31.limit;

    var url = baseUrl + '/article/productsarmani?_limit=' + limit;
    __WEBPACK_IMPORTED_MODULE_6_axios___default.a.get(url, {
      headers: {
        //'Access-Control-Allow-Origin': '*'
      }
    }).then(function (response) {
      state.fetchedData = true;
      commit(__WEBPACK_IMPORTED_MODULE_4__mutation_types__["k" /* LAST_PRODUCTarmani */], {
        response: response.data
      });
    }).catch(function (error) {
      console.log(error);
      state.fetchedData = false;
    });
  },

  ////////////////////
  lastProductnautica: function lastProductnautica(_ref32, _ref33) {
    var commit = _ref32.commit;
    var limit = _ref33.limit;

    var url = baseUrl + '/article/productsnautica?_limit=' + limit;
    __WEBPACK_IMPORTED_MODULE_6_axios___default.a.get(url, {
      headers: {
        //'Access-Control-Allow-Origin': '*'
      }
    }).then(function (response) {
      state.fetchedData = true;
      commit(__WEBPACK_IMPORTED_MODULE_4__mutation_types__["u" /* LAST_PRODUCTnautica */], {
        response: response.data
      });
    }).catch(function (error) {
      console.log(error);
      state.fetchedData = false;
    });
  },

  ////////////////////
  lastProductmaserati: function lastProductmaserati(_ref34, _ref35) {
    var commit = _ref34.commit;
    var limit = _ref35.limit;

    var url = baseUrl + '/article/productsmaserati?_limit=' + limit;
    __WEBPACK_IMPORTED_MODULE_6_axios___default.a.get(url, {
      headers: {
        //'Access-Control-Allow-Origin': '*'
      }
    }).then(function (response) {
      state.fetchedData = true;
      commit(__WEBPACK_IMPORTED_MODULE_4__mutation_types__["s" /* LAST_PRODUCTmaserati */], {
        response: response.data
      });
    }).catch(function (error) {
      console.log(error);
      state.fetchedData = false;
    });
  },

  ////////////////////
  lastProductmorellato: function lastProductmorellato(_ref36, _ref37) {
    var commit = _ref36.commit;
    var limit = _ref37.limit;

    var url = baseUrl + '/article/productsmorellato?_limit=' + limit;
    __WEBPACK_IMPORTED_MODULE_6_axios___default.a.get(url, {
      headers: {
        //'Access-Control-Allow-Origin': '*'
      }
    }).then(function (response) {
      state.fetchedData = true;
      commit(__WEBPACK_IMPORTED_MODULE_4__mutation_types__["t" /* LAST_PRODUCTmorellato */], {
        response: response.data
      });
    }).catch(function (error) {
      console.log(error);
      state.fetchedData = false;
    });
  },

  ////////////////////
  lastProducttimberland: function lastProducttimberland(_ref38, _ref39) {
    var commit = _ref38.commit;
    var limit = _ref39.limit;

    var url = baseUrl + '/article/productstimberland?_limit=' + limit;
    __WEBPACK_IMPORTED_MODULE_6_axios___default.a.get(url, {
      headers: {
        //'Access-Control-Allow-Origin': '*'
      }
    }).then(function (response) {
      state.fetchedData = true;
      commit(__WEBPACK_IMPORTED_MODULE_4__mutation_types__["A" /* LAST_PRODUCTtimberland */], {
        response: response.data
      });
    }).catch(function (error) {
      console.log(error);
      state.fetchedData = false;
    });
  },

  //
  ////////////////////
  lastProductMichaelkors: function lastProductMichaelkors(_ref40, _ref41) {
    var commit = _ref40.commit;
    var limit = _ref41.limit;

    var url = baseUrl + '/article/productsMichaelkors?_limit=' + limit;
    __WEBPACK_IMPORTED_MODULE_6_axios___default.a.get(url, {
      headers: {
        //'Access-Control-Allow-Origin': '*'
      }
    }).then(function (response) {
      state.fetchedData = true;
      commit(__WEBPACK_IMPORTED_MODULE_4__mutation_types__["i" /* LAST_PRODUCTMichaelkors */], {
        response: response.data
      });
    }).catch(function (error) {
      console.log(error);
      state.fetchedData = false;
    });
  },

  //
  ////////////////////
  LAST_PRODUCTconnectee: function LAST_PRODUCTconnectee(_ref42, _ref43) {
    var commit = _ref42.commit;
    var limit = _ref43.limit;

    var url = baseUrl + '/article/productsconnectee?_limit=' + limit;
    __WEBPACK_IMPORTED_MODULE_6_axios___default.a.get(url, {
      headers: {
        //'Access-Control-Allow-Origin': '*'
      }
    }).then(function (response) {
      state.fetchedData = true;
      commit(__WEBPACK_IMPORTED_MODULE_4__mutation_types__["m" /* LAST_PRODUCTconnectee */], {
        response: response.data
      });
    }).catch(function (error) {
      console.log(error);
      state.fetchedData = false;
    });
  },

  ////////////////////
  lastProductcerruti: function lastProductcerruti(_ref44, _ref45) {
    var commit = _ref44.commit;
    var limit = _ref45.limit;

    var url = baseUrl + '/article/productscerruti?_limit=' + limit;
    __WEBPACK_IMPORTED_MODULE_6_axios___default.a.get(url, {
      headers: {
        //'Access-Control-Allow-Origin': '*'
      }
    }).then(function (response) {
      state.fetchedData = true;
      commit(__WEBPACK_IMPORTED_MODULE_4__mutation_types__["l" /* LAST_PRODUCTcerruti */], {
        response: response.data
      });
    }).catch(function (error) {
      console.log(error);
      state.fetchedData = false;
    });
  },

  //
  ////////////////////
  lastProductlotus: function lastProductlotus(_ref46, _ref47) {
    var commit = _ref46.commit;
    var limit = _ref47.limit;

    var url = baseUrl + '/article/productslotus?_limit=' + limit;
    __WEBPACK_IMPORTED_MODULE_6_axios___default.a.get(url, {
      headers: {
        //'Access-Control-Allow-Origin': '*'
      }
    }).then(function (response) {
      state.fetchedData = true;
      commit(__WEBPACK_IMPORTED_MODULE_4__mutation_types__["r" /* LAST_PRODUCTlotus */], {
        response: response.data
      });
    }).catch(function (error) {
      console.log(error);
      state.fetchedData = false;
    });
  },

  //
  ////////////////////
  lastProductversus: function lastProductversus(_ref48, _ref49) {
    var commit = _ref48.commit;
    var limit = _ref49.limit;

    var url = baseUrl + '/article/productsversus?_limit=' + limit;
    __WEBPACK_IMPORTED_MODULE_6_axios___default.a.get(url, {
      headers: {
        //'Access-Control-Allow-Origin': '*'
      }
    }).then(function (response) {
      state.fetchedData = true;
      commit(__WEBPACK_IMPORTED_MODULE_4__mutation_types__["B" /* LAST_PRODUCTversus */], {
        response: response.data
      });
    }).catch(function (error) {
      console.log(error);
      state.fetchedData = false;
    });
  },

  //
  ////////////////////
  lastProductTRUSSARDI: function lastProductTRUSSARDI(_ref50, _ref51) {
    var commit = _ref50.commit;
    var limit = _ref51.limit;

    var url = baseUrl + '/article/productsTRUSSARDI?_limit=' + limit;
    __WEBPACK_IMPORTED_MODULE_6_axios___default.a.get(url, {
      headers: {
        //'Access-Control-Allow-Origin': '*'
      }
    }).then(function (response) {
      state.fetchedData = true;
      commit(__WEBPACK_IMPORTED_MODULE_4__mutation_types__["j" /* LAST_PRODUCTTRUSSARDI */], {
        response: response.data
      });
    }).catch(function (error) {
      console.log(error);
      state.fetchedData = false;
    });
  },

  //
  ////////////////////
  lastProductMONTIGNAC: function lastProductMONTIGNAC(_ref52, _ref53) {
    var commit = _ref52.commit;
    var limit = _ref53.limit;

    var url = baseUrl + '/article/productsMONTIGNAC?_limit=' + limit;
    __WEBPACK_IMPORTED_MODULE_6_axios___default.a.get(url, {
      headers: {
        //'Access-Control-Allow-Origin': '*'
      }
    }).then(function (response) {
      state.fetchedData = true;
      commit(__WEBPACK_IMPORTED_MODULE_4__mutation_types__["h" /* LAST_PRODUCTMONTIGNAC */], {
        response: response.data
      });
    }).catch(function (error) {
      console.log(error);
      state.fetchedData = false;
    });
  },

  //
  lastProductdiesel: function lastProductdiesel(_ref54, _ref55) {
    var commit = _ref54.commit;
    var limit = _ref55.limit;

    var url = baseUrl + '/article/productsdiesel?_limit=' + limit;
    __WEBPACK_IMPORTED_MODULE_6_axios___default.a.get(url, {
      headers: {
        //'Access-Control-Allow-Origin': '*'
      }
    }).then(function (response) {
      state.fetchedData = true;
      commit(__WEBPACK_IMPORTED_MODULE_4__mutation_types__["n" /* LAST_PRODUCTdiesel */], {
        response: response.data
      });
    }).catch(function (error) {
      console.log(error);
      state.fetchedData = false;
    });
  },

  //
  lastProductfossil: function lastProductfossil(_ref56, _ref57) {
    var commit = _ref56.commit;
    var limit = _ref57.limit;

    var url = baseUrl + '/article/productsfossil?_limit=' + limit;
    __WEBPACK_IMPORTED_MODULE_6_axios___default.a.get(url, {
      headers: {
        //'Access-Control-Allow-Origin': '*'
      }
    }).then(function (response) {
      state.fetchedData = true;
      commit(__WEBPACK_IMPORTED_MODULE_4__mutation_types__["q" /* LAST_PRODUCTfossil */], {
        response: response.data
      });
    }).catch(function (error) {
      console.log(error);
      state.fetchedData = false;
    });
  },

  //
  user_info: function user_info(_ref58, _ref59) {
    var commit = _ref58.commit;
    var phoneNumber = _ref59.phoneNumber;

    var url = baseUrl + '/commande/user/' + phoneNumber;
    __WEBPACK_IMPORTED_MODULE_6_axios___default.a.get(url, {
      headers: {
        'Access-Control-Allow-Origin': '*'
      }
    }).then(function (response) {
      state.fetchedData = true;
      commit(__WEBPACK_IMPORTED_MODULE_4__mutation_types__["H" /* USER_INFO */], {
        response: response
      });
    }).catch(function (error) {
      console.log(error);
      state.fetchedData = false;
    });
  },

  //////////////////////////////
  fetchData: function fetchData(_ref60, _ref61) {
    var commit = _ref60.commit;
    var page = _ref61.page,
        filter = _ref61.filter,
        gender = _ref61.gender;

    var url = baseUrl + '/article/products?_page=' + page + '&gender=' + gender + '&filter=' + filter;
    __WEBPACK_IMPORTED_MODULE_6_axios___default.a.get(url, {
      headers: {
        //'Access-Control-Allow-Origin': '*'
      }
    }).then(function (response) {
      commit(__WEBPACK_IMPORTED_MODULE_4__mutation_types__["e" /* FETCH_DATA */], {
        response: response.data,
        gender: gender
      });
    }).catch(function (error) {
      console.log(error);
    });
  },

  //////////////////////////////
  fetchDatafestina: function fetchDatafestina(_ref62, _ref63) {
    var commit = _ref62.commit;
    var page = _ref63.page,
        filter = _ref63.filter,
        gender = _ref63.gender;

    var url = baseUrl + '/article/productsfestina?_page=' + page + '&gender=' + gender + '&filter=' + filter;
    __WEBPACK_IMPORTED_MODULE_6_axios___default.a.get(url, {
      headers: {
        //'Access-Control-Allow-Origin': '*'
      }
    }).then(function (response) {
      commit(__WEBPACK_IMPORTED_MODULE_4__mutation_types__["o" /* LAST_PRODUCTfestina */], {
        response: response.data,
        gender: gender
      });
    }).catch(function (error) {
      console.log(error);
    });
  },

  //////////////////////////////
  fetchDatafestinadepot: function fetchDatafestinadepot(_ref64, _ref65) {
    var commit = _ref64.commit;
    var page = _ref65.page,
        filter = _ref65.filter,
        gender = _ref65.gender;

    var url = baseUrl + '/article/productsdepot?_page=' + page + '&gender=' + gender + '&filter=' + filter;
    __WEBPACK_IMPORTED_MODULE_6_axios___default.a.get(url, {
      headers: {
        //'Access-Control-Allow-Origin': '*'
      }
    }).then(function (response) {
      commit(__WEBPACK_IMPORTED_MODULE_4__mutation_types__["p" /* LAST_PRODUCTfestinadepot */], {
        response: response.data,
        gender: gender
      });
    }).catch(function (error) {
      console.log(error);
    });
  },

  //
  //////////////////////////////
  fetchDataref: function fetchDataref(_ref66, _ref67) {
    var commit = _ref66.commit;
    var refe = _ref67.refe;

    var url = baseUrl + '/article/product/' + refe;
    __WEBPACK_IMPORTED_MODULE_6_axios___default.a.get(url, {
      headers: {
        //'Access-Control-Allow-Origin': '*'
      }
    }).then(function (response) {
      commit(__WEBPACK_IMPORTED_MODULE_4__mutation_types__["c" /* DETAIL_PRODUCT */], {
        product: response.data
      });
    }).catch(function (error) {
      console.log(error);
    });
  },

  //////////////////////////////
  fetchDatapromo: function fetchDatapromo(_ref68, _ref69) {
    var commit = _ref68.commit;
    var page = _ref69.page,
        filter = _ref69.filter,
        gender = _ref69.gender;

    var url = baseUrl + '/article/productspromo?_page=' + page + '&gender=' + gender + '&filter=' + filter;
    __WEBPACK_IMPORTED_MODULE_6_axios___default.a.get(url, {
      headers: {
        //'Access-Control-Allow-Origin': '*'
      }
    }).then(function (response) {
      commit(__WEBPACK_IMPORTED_MODULE_4__mutation_types__["w" /* LAST_PRODUCTpromo */], {
        response: response.data,
        gender: gender
      });
    }).catch(function (error) {
      console.log(error);
    });
  },

  //////////////////////////////
  fetchDatavideo: function fetchDatavideo(_ref70, _ref71) {
    var commit = _ref70.commit;
    var page = _ref71.page,
        filter = _ref71.filter,
        gender = _ref71.gender;

    var url = baseUrl + '/article/productsvideo?_page=' + page + '&gender=' + gender + '&filter=' + filter;
    __WEBPACK_IMPORTED_MODULE_6_axios___default.a.get(url, {
      headers: {
        //'Access-Control-Allow-Origin': '*'
      }
    }).then(function (response) {
      commit(__WEBPACK_IMPORTED_MODULE_4__mutation_types__["C" /* LAST_PRODUCTvideo */], {
        response: response.data,
        gender: gender
      });
    }).catch(function (error) {
      console.log(error);
    });
  },


  //////////////////////////////
  fetchDataroyal: function fetchDataroyal(_ref72, _ref73) {
    var commit = _ref72.commit;
    var page = _ref73.page,
        filter = _ref73.filter,
        gender = _ref73.gender;

    var url = baseUrl + '/article/productsroyal?_page=' + page + '&gender=' + gender + '&filter=' + filter;
    __WEBPACK_IMPORTED_MODULE_6_axios___default.a.get(url, {
      headers: {
        //'Access-Control-Allow-Origin': '*'
      }
    }).then(function (response) {
      commit(__WEBPACK_IMPORTED_MODULE_4__mutation_types__["z" /* LAST_PRODUCTroyal */], {
        response: response.data,
        gender: gender
      });
    }).catch(function (error) {
      console.log(error);
    });
  },

  //////////////////////////////
  fetchDatapolice: function fetchDatapolice(_ref74, _ref75) {
    var commit = _ref74.commit;
    var page = _ref75.page,
        filter = _ref75.filter,
        gender = _ref75.gender;

    var url = baseUrl + '/article/productspolice?_page=' + page + '&gender=' + gender + '&filter=' + filter;
    __WEBPACK_IMPORTED_MODULE_6_axios___default.a.get(url, {
      headers: {
        //'Access-Control-Allow-Origin': '*'
      }
    }).then(function (response) {
      commit(__WEBPACK_IMPORTED_MODULE_4__mutation_types__["v" /* LAST_PRODUCTpolice */], {
        response: response.data,
        gender: gender
      });
    }).catch(function (error) {
      console.log(error);
    });
  },

  //////////////////////////////
  ////////////////////////
  //////////////////////////////
  fetchDataarmani: function fetchDataarmani(_ref76, _ref77) {
    var commit = _ref76.commit;
    var page = _ref77.page,
        filter = _ref77.filter,
        gender = _ref77.gender;

    var url = baseUrl + '/article/productsarmani?_page=' + page + '&gender=' + gender + '&filter=' + filter;
    __WEBPACK_IMPORTED_MODULE_6_axios___default.a.get(url, {
      headers: {
        //'Access-Control-Allow-Origin': '*'
      }
    }).then(function (response) {
      commit(__WEBPACK_IMPORTED_MODULE_4__mutation_types__["k" /* LAST_PRODUCTarmani */], {
        response: response.data,
        gender: gender
      });
    }).catch(function (error) {
      console.log(error);
    });
  },

  //////////////////////////////
  fetchDatanautica: function fetchDatanautica(_ref78, _ref79) {
    var commit = _ref78.commit;
    var page = _ref79.page,
        filter = _ref79.filter,
        gender = _ref79.gender;

    var url = baseUrl + '/article/productsnautica?_page=' + page + '&gender=' + gender + '&filter=' + filter;
    __WEBPACK_IMPORTED_MODULE_6_axios___default.a.get(url, {
      headers: {
        //'Access-Control-Allow-Origin': '*'
      }
    }).then(function (response) {
      commit(__WEBPACK_IMPORTED_MODULE_4__mutation_types__["u" /* LAST_PRODUCTnautica */], {
        response: response.data,
        gender: gender
      });
    }).catch(function (error) {
      console.log(error);
    });
  },

  //////////////////////////////
  fetchDatamaserati: function fetchDatamaserati(_ref80, _ref81) {
    var commit = _ref80.commit;
    var page = _ref81.page,
        filter = _ref81.filter,
        gender = _ref81.gender;

    var url = baseUrl + '/article/productsmaserati?_page=' + page + '&gender=' + gender + '&filter=' + filter;
    __WEBPACK_IMPORTED_MODULE_6_axios___default.a.get(url, {
      headers: {
        //'Access-Control-Allow-Origin': '*'
      }
    }).then(function (response) {
      commit(__WEBPACK_IMPORTED_MODULE_4__mutation_types__["s" /* LAST_PRODUCTmaserati */], {
        response: response.data,
        gender: gender
      });
    }).catch(function (error) {
      console.log(error);
    });
  },

  //////////////////////////////
  fetchDatamorellato: function fetchDatamorellato(_ref82, _ref83) {
    var commit = _ref82.commit;
    var page = _ref83.page,
        filter = _ref83.filter,
        gender = _ref83.gender;

    var url = baseUrl + '/article/productsmorellato?_page=' + page + '&gender=' + gender + '&filter=' + filter;
    __WEBPACK_IMPORTED_MODULE_6_axios___default.a.get(url, {
      headers: {
        //'Access-Control-Allow-Origin': '*'
      }
    }).then(function (response) {
      commit(__WEBPACK_IMPORTED_MODULE_4__mutation_types__["t" /* LAST_PRODUCTmorellato */], {
        response: response.data,
        gender: gender
      });
    }).catch(function (error) {
      console.log(error);
    });
  },

  //////////////////////////////
  fetchDatatimberland: function fetchDatatimberland(_ref84, _ref85) {
    var commit = _ref84.commit;
    var page = _ref85.page,
        filter = _ref85.filter,
        gender = _ref85.gender;

    var url = baseUrl + '/article/productstimberland?_page=' + page + '&gender=' + gender + '&filter=' + filter;
    __WEBPACK_IMPORTED_MODULE_6_axios___default.a.get(url, {
      headers: {
        //'Access-Control-Allow-Origin': '*'
      }
    }).then(function (response) {
      commit(__WEBPACK_IMPORTED_MODULE_4__mutation_types__["A" /* LAST_PRODUCTtimberland */], {
        response: response.data,
        gender: gender
      });
    }).catch(function (error) {
      console.log(error);
    });
  },

  //////////////////////////////
  fetchDataMichaelkors: function fetchDataMichaelkors(_ref86, _ref87) {
    var commit = _ref86.commit;
    var page = _ref87.page,
        filter = _ref87.filter,
        gender = _ref87.gender;

    var url = baseUrl + '/article/productsMichaelkors?_page=' + page + '&gender=' + gender + '&filter=' + filter;
    __WEBPACK_IMPORTED_MODULE_6_axios___default.a.get(url, {
      headers: {
        //'Access-Control-Allow-Origin': '*'
      }
    }).then(function (response) {
      commit(__WEBPACK_IMPORTED_MODULE_4__mutation_types__["i" /* LAST_PRODUCTMichaelkors */], {
        response: response.data,
        gender: gender
      });
    }).catch(function (error) {
      console.log(error);
    });
  },

  //////////////////////////////
  fetchDataconnectee: function fetchDataconnectee(_ref88, _ref89) {
    var commit = _ref88.commit;
    var page = _ref89.page,
        filter = _ref89.filter,
        gender = _ref89.gender;

    var url = baseUrl + '/article/productsconnectee?_page=' + page + '&gender=' + gender + '&filter=' + filter;
    __WEBPACK_IMPORTED_MODULE_6_axios___default.a.get(url, {
      headers: {
        //'Access-Control-Allow-Origin': '*'
      }
    }).then(function (response) {
      commit(__WEBPACK_IMPORTED_MODULE_4__mutation_types__["m" /* LAST_PRODUCTconnectee */], {
        response: response.data,
        gender: gender
      });
    }).catch(function (error) {
      console.log(error);
    });
  },

  //////////////////////////////
  fetchDatacerruti: function fetchDatacerruti(_ref90, _ref91) {
    var commit = _ref90.commit;
    var page = _ref91.page,
        filter = _ref91.filter,
        gender = _ref91.gender;

    var url = baseUrl + '/article/productscerruti?_page=' + page + '&gender=' + gender + '&filter=' + filter;
    __WEBPACK_IMPORTED_MODULE_6_axios___default.a.get(url, {
      headers: {
        //'Access-Control-Allow-Origin': '*'
      }
    }).then(function (response) {
      commit(__WEBPACK_IMPORTED_MODULE_4__mutation_types__["l" /* LAST_PRODUCTcerruti */], {
        response: response.data,
        gender: gender
      });
    }).catch(function (error) {
      console.log(error);
    });
  },

  //////////////////////////////
  fetchDatalotus: function fetchDatalotus(_ref92, _ref93) {
    var commit = _ref92.commit;
    var page = _ref93.page,
        filter = _ref93.filter,
        gender = _ref93.gender;

    var url = baseUrl + '/article/productslotus?_page=' + page + '&gender=' + gender + '&filter=' + filter;
    __WEBPACK_IMPORTED_MODULE_6_axios___default.a.get(url, {
      headers: {
        //'Access-Control-Allow-Origin': '*'
      }
    }).then(function (response) {
      commit(__WEBPACK_IMPORTED_MODULE_4__mutation_types__["r" /* LAST_PRODUCTlotus */], {
        response: response.data,
        gender: gender
      });
    }).catch(function (error) {
      console.log(error);
    });
  },

  //////////////////////////////
  //////////////////////////////
  fetchDataversus: function fetchDataversus(_ref94, _ref95) {
    var commit = _ref94.commit;
    var page = _ref95.page,
        filter = _ref95.filter,
        gender = _ref95.gender;

    var url = baseUrl + '/article/productsversus?_page=' + page + '&gender=' + gender + '&filter=' + filter;
    __WEBPACK_IMPORTED_MODULE_6_axios___default.a.get(url, {
      headers: {
        //'Access-Control-Allow-Origin': '*'
      }
    }).then(function (response) {
      commit(__WEBPACK_IMPORTED_MODULE_4__mutation_types__["B" /* LAST_PRODUCTversus */], {
        response: response.data,
        gender: gender
      });
    }).catch(function (error) {
      console.log(error);
    });
  },

  //////////////////////////////
  fetchDataTRUSSARDI: function fetchDataTRUSSARDI(_ref96, _ref97) {
    var commit = _ref96.commit;
    var page = _ref97.page,
        filter = _ref97.filter,
        gender = _ref97.gender;

    var url = baseUrl + '/article/productsTRUSSARDI?_page=' + page + '&gender=' + gender + '&filter=' + filter;
    __WEBPACK_IMPORTED_MODULE_6_axios___default.a.get(url, {
      headers: {
        //'Access-Control-Allow-Origin': '*'
      }
    }).then(function (response) {
      commit(__WEBPACK_IMPORTED_MODULE_4__mutation_types__["j" /* LAST_PRODUCTTRUSSARDI */], {
        response: response.data,
        gender: gender
      });
    }).catch(function (error) {
      console.log(error);
    });
  },

  //////////////////////////////
  fetchDataMONTIGNAC: function fetchDataMONTIGNAC(_ref98, _ref99) {
    var commit = _ref98.commit;
    var page = _ref99.page,
        filter = _ref99.filter,
        gender = _ref99.gender;

    var url = baseUrl + '/article/productsMONTIGNAC?_page=' + page + '&gender=' + gender + '&filter=' + filter;
    __WEBPACK_IMPORTED_MODULE_6_axios___default.a.get(url, {
      headers: {
        //'Access-Control-Allow-Origin': '*'
      }
    }).then(function (response) {
      commit(__WEBPACK_IMPORTED_MODULE_4__mutation_types__["h" /* LAST_PRODUCTMONTIGNAC */], {
        response: response.data,
        gender: gender
      });
    }).catch(function (error) {
      console.log(error);
    });
  },

  //////////////////////////////
  fetchDatadiesel: function fetchDatadiesel(_ref100, _ref101) {
    var commit = _ref100.commit;
    var page = _ref101.page,
        filter = _ref101.filter,
        gender = _ref101.gender;

    var url = baseUrl + '/article/productsdiesel?_page=' + page + '&gender=' + gender + '&filter=' + filter;
    __WEBPACK_IMPORTED_MODULE_6_axios___default.a.get(url, {
      headers: {
        //'Access-Control-Allow-Origin': '*'
      }
    }).then(function (response) {
      commit(__WEBPACK_IMPORTED_MODULE_4__mutation_types__["n" /* LAST_PRODUCTdiesel */], {
        response: response.data,
        gender: gender
      });
    }).catch(function (error) {
      console.log(error);
    });
  },

  //////////////////////////////
  fetchDatafossil: function fetchDatafossil(_ref102, _ref103) {
    var commit = _ref102.commit;
    var page = _ref103.page,
        filter = _ref103.filter,
        gender = _ref103.gender;

    var url = baseUrl + '/article/productsfossil?_page=' + page + '&gender=' + gender + '&filter=' + filter;
    __WEBPACK_IMPORTED_MODULE_6_axios___default.a.get(url, {
      headers: {
        //'Access-Control-Allow-Origin': '*'
      }
    }).then(function (response) {
      commit(__WEBPACK_IMPORTED_MODULE_4__mutation_types__["q" /* LAST_PRODUCTfossil */], {
        response: response.data,
        gender: gender
      });
    }).catch(function (error) {
      console.log(error);
    });
  },
  doCommande: function doCommande(_ref104) {
    var commit = _ref104.commit;

    var url = baseUrl + '/commande/add/E';
    if (state.commandeInfo) {
      var commandes = [];
      __WEBPACK_IMPORTED_MODULE_7_lodash___default.a.forEach(state.added, function (value, key) {
        commandes.push({
          reference: value.id,
          quantity: value.quantity

        });
      });
      var commande = {
        firstName: state.user.firstName,
        lastName: state.user.lastName,
        phoneNumber: state.user.phoneNumber,
        address: state.user.address,
        email: state.user.email,
        billingAddress: state.user.billingAdress,
        deliveryAddress: state.user.deliveryAddress,
        deliveryFirstName: state.user.deliveryFirstName,
        deliveryLastName: state.user.deliveryLastName,
        deliveryPhoneNumber: state.user.deliveryPhoneNumber,
        deliveryWilaya: state.user.deliveryWilaya,
        commandes: commandes
      };
      __WEBPACK_IMPORTED_MODULE_6_axios___default.a.post(url, commande, {
        headers: {
          //'Access-Control-Allow-Origin': '*'
        }
      }).then(function (response) {
        if (response.status === 201) {
          state.statusCode = 201;
          state.orderId = response.data.idCommande;
          commit(__WEBPACK_IMPORTED_MODULE_4__mutation_types__["d" /* DO_COMMANDE */]);
        } else {
          console.log(response.status);
        }
      }).catch(function (error) {
        return console.log(error);
      });
    }
  },
  ProductDetail: function ProductDetail(_ref105, product) {
    var commit = _ref105.commit;

    commit(__WEBPACK_IMPORTED_MODULE_4__mutation_types__["c" /* DETAIL_PRODUCT */], {
      product: product
    });
  },
  ProductDetail2: function ProductDetail2(_ref106, product) {
    var commit = _ref106.commit;

    commit(__WEBPACK_IMPORTED_MODULE_4__mutation_types__["c" /* DETAIL_PRODUCT */], {
      product: product
    });
  },
  clearCart: function clearCart(_ref107) {
    var commit = _ref107.commit;

    commit(__WEBPACK_IMPORTED_MODULE_4__mutation_types__["b" /* CLEAR_CART */]);
  },
  removeItem: function removeItem(_ref108, product) {
    var commit = _ref108.commit;

    commit(__WEBPACK_IMPORTED_MODULE_4__mutation_types__["G" /* REMOVE_FROM_CART */], {
      product: product
    });
  }
};
// mutations
var mutations = (_mutations = {
  updateField: __WEBPACK_IMPORTED_MODULE_5_vuex_map_fields__["c" /* updateField */]
}, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["D" /* LOAD_CART */], function (state) {

  var authCredit = JSON.parse(localStorage.getItem('auth'));
  if (authCredit) state.isAuthenticated = true;else state.isAuthenticated = false;

  var storedCarts = JSON.parse(localStorage.getItem('carts'));
  if (storedCarts) {
    __WEBPACK_IMPORTED_MODULE_7_lodash___default.a.forEach(storedCarts, function (cart) {
      return state.added.push(cart);
    });
  }
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["a" /* ADD_TO_CART */], function (state, _ref109) {
  var id = _ref109.id,
      name = _ref109.name,
      color = _ref109.color,
      price = _ref109.price,
      img = _ref109.img;


  if (name === 'promo') if (state.added.filter(function (p) {
    return p.name === 'promo';
  }).length != 0) return;
  if (name === 'promo1') if (state.added.filter(function (p) {
    return p.name === 'promo1';
  }).length != 0) return;

  var record = state.added.find(function (p) {
    return p.id === id;
  });
  if (!record) {
    state.added.push({
      id: id,
      name: name,
      color: color,
      price: price,
      img: img,
      quantity: 1
    });
  } else {
    record.quantity++;
  }

  //store the current cart in localStorage
  localStorage.setItem('carts', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(state.added));
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["e" /* FETCH_DATA */], function (state, _ref110) {
  var response = _ref110.response,
      gender = _ref110.gender;

  switch (gender) {
    //men case
    case "H":
      state.men = response.data;
      state.menCount = response.total;
      break;
    case "F":
      state.women = response.data;
      state.womenCount = response.total;
      break;
    default:
      state.all = response.data;
      state.totalProduct = response.total;
      state.totalProductfestina = response.totalfestina;
      state.totalProductfestinadepot = response.totalProductfestinadepot;

      state.totalProductref = response.totalref;
      state.totalProductpromo = response.totalProductpromo;
      state.totalProductvideo = response.totalProductvideo;
      state.totalProductroyal = response.totalroyal;
      state.totalProductpolice = response.totalpolice;
      state.totalProductdiesel = response.totaldiesel;
      state.totalProductarmani = response.totalarmani;
      state.totalProductnautica = response.totalnautica;
      state.totalProductmaserati = response.totalmaserati;
      state.totalProductmorellato = response.totalmorellato;
      state.totalProducttimberland = response.totaltimberland;
      state.totalProductcerruti = response.totalcerruti;
      state.totalProductlotus = response.totallotus;
      state.totalProductversus = response.totalProductversus;
      state.totalProductTRUSSARDI = response.totalProductTRUSSARDI;
      state.totalProductMONTIGNAC = response.totalProductMONTIGNAC;
      state.totalProductfossil = response.totalfossil;

  }
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["c" /* DETAIL_PRODUCT */], function (state, _ref111) {
  var product = _ref111.product;

  var detailProduct = {
    id: product.id,
    img: product.img,
    discount: false,
    description: product.description,
    price: product.price,
    price2: product.price2,
    gender: product.gender,
    name: product.name,
    waterResiste: product.waterResiste,
    tailleCadron: product.tailleCadron,
    typeBracelet: product.typeBracelet,
    type: product.type
  };
  console.log("detailProduct=" + detailProduct);
  state.product = detailProduct;
  sessionStorage.setItem('product', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(detailProduct));
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["b" /* CLEAR_CART */], function (state) {
  state.added = [];
  var item = localStorage.getItem('carts');
  if (item) localStorage.removeItem('carts');
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["G" /* REMOVE_FROM_CART */], function (state, _ref112) {
  var product = _ref112.product;

  state.added.splice(state.added.indexOf(product), 1);
  //update localstorage if exist
  var carts = localStorage.getItem('carts');
  if (carts) {
    localStorage.removeItem('carts');
    localStorage.setItem('carts', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(state.added));
  }
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["d" /* DO_COMMANDE */], function (state) {
  var carts = localStorage.getItem('carts');
  if (carts) localStorage.removeItem('carts');

  state.added = [];
  state.commandeInfo = [];
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["y" /* LAST_PRODUCTreference */], function (state, _ref113) {
  var response = _ref113.response;

  state.lastEntriesreference = response.data;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["f" /* LAST_PRODUCT */], function (state, _ref114) {
  var response = _ref114.response;

  state.lastEntries = response.data;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["g" /* LAST_PRODUCT2 */], function (state, _ref115) {
  var response = _ref115.response;

  state.lastEntries2 = response.data;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["w" /* LAST_PRODUCTpromo */], function (state, _ref116) {
  var response = _ref116.response;

  state.lastEntriespromo = response.data;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["C" /* LAST_PRODUCTvideo */], function (state, _ref117) {
  var response = _ref117.response;

  state.lastEntriesvideo = response.data;
  state.totalProductvideo = response.total;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["z" /* LAST_PRODUCTroyal */], function (state, _ref118) {
  var response = _ref118.response;

  state.lastEntriesroyal = response.data;
  state.totalProductroyal = response.total;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["f" /* LAST_PRODUCT */], function (state, _ref119) {
  var response = _ref119.response;

  state.lastEntries = response.data;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["v" /* LAST_PRODUCTpolice */], function (state, _ref120) {
  var response = _ref120.response;

  state.lastEntriespolice = response.data;
  state.totalProductpolice = response.total;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["f" /* LAST_PRODUCT */], function (state, _ref121) {
  var response = _ref121.response;

  state.lastEntries = response.data;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["k" /* LAST_PRODUCTarmani */], function (state, _ref122) {
  var response = _ref122.response;

  state.lastEntriesarmani = response.data;
  state.totalProductarmani = response.total;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["i" /* LAST_PRODUCTMichaelkors */], function (state, _ref123) {
  var response = _ref123.response;

  state.lastEntriesMichaelkors = response.data;
  state.totalProductMichaelkors = response.total;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["u" /* LAST_PRODUCTnautica */], function (state, _ref124) {
  var response = _ref124.response;

  state.lastEntriesnautica = response.data;
  state.totalProductnautica = response.total;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["s" /* LAST_PRODUCTmaserati */], function (state, _ref125) {
  var response = _ref125.response;

  state.lastEntriesmaserati = response.data;
  state.totalProductmaserati = response.total;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["t" /* LAST_PRODUCTmorellato */], function (state, _ref126) {
  var response = _ref126.response;

  state.lastEntriesmorellato = response.data;
  state.totalProductmorellato = response.total;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["A" /* LAST_PRODUCTtimberland */], function (state, _ref127) {
  var response = _ref127.response;

  state.lastEntriestimberland = response.data;
  state.totalProducttimberland = response.total;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["i" /* LAST_PRODUCTMichaelkors */], function (state, _ref128) {
  var response = _ref128.response;

  state.lastEntriesMichaelkors = response.data;
  state.totalProductMichaelkors = response.total;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["m" /* LAST_PRODUCTconnectee */], function (state, _ref129) {
  var response = _ref129.response;

  state.lastEntriesconnectee = response.data;
  state.totalProductconnectee = response.total;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["l" /* LAST_PRODUCTcerruti */], function (state, _ref130) {
  var response = _ref130.response;

  state.lastEntriescerruti = response.data;
  state.totalProductcerruti = response.total;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["r" /* LAST_PRODUCTlotus */], function (state, _ref131) {
  var response = _ref131.response;

  state.lastEntrieslotus = response.data;
  state.totalProductlotus = response.total;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["o" /* LAST_PRODUCTfestina */], function (state, _ref132) {
  var response = _ref132.response;

  state.lastEntriesfestina = response.data;
  state.totalProductfestina = response.total;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["j" /* LAST_PRODUCTTRUSSARDI */], function (state, _ref133) {
  var response = _ref133.response;

  state.lastEntriesTRUSSARDI = response.data;
  state.totalProductTRUSSARDI = response.total;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["B" /* LAST_PRODUCTversus */], function (state, _ref134) {
  var response = _ref134.response;

  state.lastEntriesversus = response.data;
  state.totalProductversus = response.total;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["o" /* LAST_PRODUCTfestina */], function (state, _ref135) {
  var response = _ref135.response;

  state.lastEntriesfestina = response.data;
  state.totalProductfestina = response.total;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["h" /* LAST_PRODUCTMONTIGNAC */], function (state, _ref136) {
  var response = _ref136.response;

  state.lastEntriesMONTIGNAC = response.data;
  state.totalProductMONTIGNAC = response.total;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["o" /* LAST_PRODUCTfestina */], function (state, _ref137) {
  var response = _ref137.response;

  state.lastEntriesfestina = response.data;
  state.totalProductfestina = response.total;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["p" /* LAST_PRODUCTfestinadepot */], function (state, _ref138) {
  var response = _ref138.response;

  state.lastEntriesfestinadepot = response.data;
  state.totalProductfestinadepot = response.total;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["x" /* LAST_PRODUCTref */], function (state, _ref139) {
  var response = _ref139.response;

  state.lastEntriesref = response.data;
  state.totalProductref = response.total;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["w" /* LAST_PRODUCTpromo */], function (state, _ref140) {
  var response = _ref140.response;

  state.lastEntriespromo = response.data;
  state.totalProductpromo = response.total;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["n" /* LAST_PRODUCTdiesel */], function (state, _ref141) {
  var response = _ref141.response;

  state.lastEntriesdiesel = response.data;
  state.totalProductdiesel = response.total;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["H" /* USER_INFO */], function (state, _ref142) {
  var response = _ref142.response;

  state.user = response.data;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["q" /* LAST_PRODUCTfossil */], function (state, _ref143) {
  var response = _ref143.response;

  state.lastEntriesfossil = response.data;
  state.totalProductfossil = response.total;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["H" /* USER_INFO */], function (state, _ref144) {
  var response = _ref144.response;

  state.user = response.data;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["E" /* LOGIN */], function (state, _ref145) {
  var isAuth = _ref145.isAuth;

  state.isAuthenticated = isAuth;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["F" /* REGISTER */], function (state, _ref146) {
  var isAuth = _ref146.isAuth;

  state.isAuthenticated = isAuth;
}), _mutations);

// one store for entire application
/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* default */].Store({
  state: state,
  //strict: debug,
  getters: getters,
  actions: actions,
  mutations: mutations
  /*plugins: [createPersistedState({
    //storage: window.sessionStorage //if change to localStorage replace evrey sessionStorage in this file
  })]*/
}));

/***/ }),
/* 89 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 90 */,
/* 91 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(24);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_98916dc8_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(165);
function injectStyle (ssrContext) {
  __webpack_require__(110)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_98916dc8_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 110 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 111 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_navbar_vue__ = __webpack_require__(25);
/* unused harmony reexport namespace */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_58bb1a6e_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_navbar_vue__ = __webpack_require__(113);
function injectStyle (ssrContext) {
  __webpack_require__(112)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-58bb1a6e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_navbar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_58bb1a6e_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_navbar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* unused harmony default export */ var _unused_webpack_default_export = (Component.exports);


/***/ }),
/* 112 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 113 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('header',{staticClass:"navbar navbar-sticky"},[_vm._m(0),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('div',{staticClass:"toolbar"},[_c('div',{staticClass:"inner"},[_vm._m(2),_vm._v(" "),_vm._m(3),_vm._v(" "),_vm._m(4),_vm._v(" "),_c('a',{staticClass:"toolbar-toggle",attrs:{"href":"#cart"}},[_c('i',[_c('span',{staticClass:"material-icons shopping_basket"}),_c('span',{staticClass:"count"},[_vm._v(_vm._s(_vm.itemsInCart))])])])]),_vm._v(" "),_c('div',{staticClass:"toolbar-dropdown"},[_vm._m(5),_vm._v(" "),_vm._m(6),_vm._v(" "),_vm._m(7),_vm._v(" "),_c('div',{staticClass:"toolbar-section",attrs:{"id":"cart"}},[_c('div',{staticClass:"table-responsive shopping-cart mb-0"},[_c('table',{staticClass:"table"},[_c('thead',[_c('tr',[_c('th',{attrs:{"colspan":"2"}},[_c('div',{staticClass:"d-flex justify-content-between align-items-center"},[_vm._v("Produits\n                      "),_c('router-link',{staticClass:"navi-link text-uppercase",attrs:{"to":"/cart"}},[_c('span',{staticClass:"text-xxs"},[_vm._v("Votre panier")]),_vm._v(" "),_c('i',{staticClass:"material-icons keyboard_arrow_right"})])],1)])])]),_vm._v(" "),_c('tbody',_vm._l((_vm.products),function(product){return _c('tr',{key:product.id},[_c('td',[_c('div',{staticClass:"product-item"},[_c('a',{staticClass:"product-thumb",attrs:{"href":"shop-single.html"}},[_c('img',{attrs:{"src":product.img,"alt":"Product"}})]),_vm._v(" "),_c('div',{staticClass:"product-info"},[_c('h4',{staticClass:"product-title"},[_c('a',{attrs:{"href":"shop-single.html"}},[_vm._v(_vm._s(product.name))])]),_c('span',[_c('em',[_vm._v("Prix:")]),_vm._v(" "+_vm._s(product.price))]),_c('span',[_c('em',[_vm._v("Quantité:")]),_vm._v(" "+_vm._s(product.quantity))])])])]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_c('a',{staticClass:"remove-from-cart",attrs:{"href":"#"},on:{"click":function($event){_vm.removeItem(product)}}},[_c('i',{staticClass:"material-icons icon_close"})])])])}))])]),_vm._v(" "),_c('hr',{staticClass:"mb-3"}),_vm._v(" "),_c('div',{staticClass:"d-flex flex-wrap justify-content-between align-items-center"},[_c('div',{staticClass:"pr-2 py-1 text-sm"},[_vm._v("Total: "),_c('span',{staticClass:"text-dark text-medium"},[_vm._v(_vm._s(_vm.total))])]),_vm._v(" "),_c('router-link',{staticClass:"btn btn-sm btn-success mb-0 mr-0",attrs:{"to":"/checkout"}},[_vm._v("Commander")])],1)])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"site-branding"},[_c('a',{staticClass:"site-logo hidden-xs-down",attrs:{"href":"index.html"}},[_c('img',{attrs:{"src":"static/img/logo/logo.png","alt":"luxuryShop"}})]),_c('a',{staticClass:"site-logo logo-sm hidden-sm-up",attrs:{"href":"index.html"}},[_c('img',{attrs:{"src":"static/img/logo/logo-sm.png","alt":"Unishop"}})]),_vm._v(" "),_c('div',{staticClass:"lang-currency-switcher"},[_c('div',{staticClass:"lang-currency-toggle"},[_c('img',{attrs:{"src":"static/img/flags/GB.png","alt":"English"}}),_c('span',[_vm._v("USD")]),_c('i',{staticClass:"material-icons arrow_drop_down"}),_vm._v(" "),_c('ul',{staticClass:"lang-currency-dropdown"},[_c('li',[_c('select',{staticClass:"form-control form-control-sm"},[_c('option',{attrs:{"value":"usd"}},[_vm._v("$ USD")]),_vm._v(" "),_c('option',{attrs:{"value":"usd"}},[_vm._v("€ EUR")]),_vm._v(" "),_c('option',{attrs:{"value":"usd"}},[_vm._v("£ UKP")]),_vm._v(" "),_c('option',{attrs:{"value":"usd"}},[_vm._v("¥ JPY")])])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#"}},[_c('img',{attrs:{"src":"static/img/flags/FR.png","alt":"Français"}}),_vm._v("Français")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#"}},[_c('img',{attrs:{"src":"static/img/flags/DE.png","alt":"Deutsch"}}),_vm._v("Deutsch")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#"}},[_c('img',{attrs:{"src":"static/img/flags/IT.png","alt":"Italiano"}}),_vm._v("Italiano")])])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',{staticClass:"site-menu"},[_c('ul',[_c('li',{staticClass:"active"},[_c('a',{attrs:{"href":"index.html"}},[_c('span',[_vm._v("Home")])]),_vm._v(" "),_c('ul',{staticClass:"sub-menu"},[_c('li',{staticClass:"active has-children"},[_c('a',{attrs:{"href":"index.html"}},[_c('span',[_vm._v("Hero Slider")])]),_vm._v(" "),_c('ul',{staticClass:"sub-menu w-400 p-0"},[_c('li',[_c('a',{staticClass:"p-0",attrs:{"href":"index.html"}},[_c('img',{attrs:{"src":"static/img/banners/home01.jpg","alt":"Hero Slider Home"}})])])])]),_vm._v(" "),_c('li',{staticClass:"has-children"},[_c('a',{attrs:{"href":"home-featured-categories.html"}},[_c('span',[_vm._v("Categories Grid")])]),_vm._v(" "),_c('ul',{staticClass:"sub-menu w-400 p-0"},[_c('li',[_c('a',{staticClass:"p-0",attrs:{"href":"home-featured-categories.html"}},[_c('img',{attrs:{"src":"static/img/banners/home02.jpg","alt":"Categories Grid Home"}})])])])])])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"shop-boxed-ls.html"}},[_c('span',[_vm._v("Shop")])]),_vm._v(" "),_c('ul',{staticClass:"sub-menu"},[_c('li',[_c('a',{attrs:{"href":"shop-categories.html"}},[_vm._v("Shop Categories")])]),_vm._v(" "),_c('li',{staticClass:"has-children"},[_c('a',{attrs:{"href":"shop-boxed-ls.html"}},[_c('span',[_vm._v("Shop Layout")])]),_vm._v(" "),_c('ul',{staticClass:"sub-menu"},[_c('li',[_c('a',{attrs:{"href":"shop-boxed-ls.html"}},[_vm._v("Boxed Left Sidebar")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"shop-boxed-rs.html"}},[_vm._v("Boxed Right Sidebar")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"shop-boxed-ft.html"}},[_vm._v("Boxed Filters Top")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"shop-full-ls.html"}},[_vm._v("Full Width Left Sidebar")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"shop-full-rs.html"}},[_vm._v("Full Width Right Sidebar")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"shop-full-ft.html"}},[_vm._v("Full Width Filters Top")])])])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"shop-single.html"}},[_vm._v("Single Product")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"cart.html"}},[_vm._v("Cart")])]),_vm._v(" "),_c('li',{staticClass:"has-children"},[_c('a',{attrs:{"href":"checkout-address.html"}},[_c('span',[_vm._v("Checkout")])]),_vm._v(" "),_c('ul',{staticClass:"sub-menu"},[_c('li',[_c('a',{attrs:{"href":"checkout-address.html"}},[_vm._v("Address")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"checkout-shipping.html"}},[_vm._v("Shipping")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"checkout-payment.html"}},[_vm._v("Payment")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"checkout-review.html"}},[_vm._v("Review")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"checkout-complete.html"}},[_vm._v("Complete")])])])])])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#"}},[_c('span',[_vm._v(" Mega Menu")])]),_vm._v(" "),_c('ul',{staticClass:"mega-menu"},[_c('li',[_c('span',{staticClass:"mega-menu-title text-uppercase"},[_vm._v("Furniture")]),_vm._v(" "),_c('ul',[_c('li',[_c('a',{attrs:{"href":"#"}},[_vm._v("Desk & Benching")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#"}},[_vm._v("Adjustable Desks")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#"}},[_vm._v("File Cabinets")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#"}},[_vm._v("Office Chairs")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#"}},[_vm._v("Tables")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#"}},[_vm._v("Storage Units")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#"}},[_vm._v("Accessories")])])])]),_vm._v(" "),_c('li',[_c('span',{staticClass:"mega-menu-title text-uppercase"},[_vm._v("Lighting")]),_vm._v(" "),_c('ul',[_c('li',[_c('a',{attrs:{"href":"#"}},[_vm._v("Ceiling Lights")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#"}},[_vm._v("Kitchen Lighting")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#"}},[_vm._v("Lamps")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#"}},[_vm._v("Wall Lights")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#"}},[_vm._v("Outdoor Lights")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#"}},[_vm._v("Dimmers & Controls")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#"}},[_vm._v("Light Bulbs")])])])]),_vm._v(" "),_c('li',[_c('span',{staticClass:"mega-menu-title text-uppercase"},[_vm._v("Shop by Color")]),_vm._v(" "),_c('div',{staticClass:"widget widget-colors"},[_c('ul',[_c('li',[_c('a',{attrs:{"href":"#"}},[_c('span',{staticClass:"color",staticStyle:{"background-color":"#fff","border":"1px solid #dcdcdc"}}),_vm._v("White")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#"}},[_c('span',{staticClass:"color",staticStyle:{"background-color":"#93c4ef"}}),_vm._v("Blue")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#"}},[_c('span',{staticClass:"color",staticStyle:{"background-color":"#a7c04d"}}),_vm._v("Green")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#"}},[_c('span',{staticClass:"color",staticStyle:{"background-color":"#ef0568"}}),_vm._v("Red")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#"}},[_c('span',{staticClass:"color",staticStyle:{"background-color":"#ffce2b"}}),_vm._v("Yellow")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#"}},[_c('span',{staticClass:"color",staticStyle:{"background-color":"#b5651d"}}),_vm._v("Brown")])])])])]),_vm._v(" "),_c('li',{staticClass:"banner-column"},[_c('a',{staticStyle:{"background-image":"url(static/img/banners/mega-menu.jpg)"},attrs:{"href":"#"}})])])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"account-orders.html"}},[_c('span',[_vm._v("Account")])]),_vm._v(" "),_c('ul',{staticClass:"sub-menu"},[_c('li',[_c('a',{attrs:{"href":"account-orders.html"}},[_vm._v("Orders List")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"account-wishlist.html"}},[_vm._v("Wishlist")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"account-profile.html"}},[_vm._v("Profile Page")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"account-address.html"}},[_vm._v("Contact / Shipping Address")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"account-tickets.html"}},[_vm._v("My Tickets")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"account-single-ticket.html"}},[_vm._v("Single Ticket")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"account-password-recovery.html"}},[_vm._v("Password Recovery")])])])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"blog.html"}},[_c('span',[_vm._v("Blog List")])]),_vm._v(" "),_c('ul',{staticClass:"sub-menu"},[_c('li',[_c('a',{attrs:{"href":"blog.html"}},[_vm._v("Blog List")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"blog-single.html"}},[_vm._v("Single Post")])])])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#"}},[_c('span',[_vm._v("Pages")])]),_vm._v(" "),_c('ul',{staticClass:"sub-menu"},[_c('li',[_c('a',{attrs:{"href":"about.html"}},[_vm._v("About Us")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"contacts.html"}},[_vm._v("Contacts")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"faq.html"}},[_vm._v("Help / FAQ")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"order-tracking.html"}},[_vm._v("Order Tracking")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"404.html"}},[_vm._v("404 Not Found")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"coming-soon.html"}},[_vm._v("Coming Soon")])]),_vm._v(" "),_c('li',[_c('a',{staticClass:"text-danger",attrs:{"href":"docs/dev-setup.html"}},[_vm._v("Documentation")])])])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"components/accordion.html"}},[_c('span',[_vm._v("Components")])]),_vm._v(" "),_c('ul',{staticClass:"mega-menu"},[_c('li',[_c('span',{staticClass:"mega-menu-title"},[_vm._v("A - F")]),_vm._v(" "),_c('ul',[_c('li',[_c('a',{attrs:{"href":"components/accordion.html"}},[_vm._v("Accordion")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"components/alerts.html"}},[_vm._v("Alerts")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"components/buttons.html"}},[_vm._v("Buttons")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"components/cards.html"}},[_vm._v("Cards")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"components/carousel.html"}},[_vm._v("Carousel")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"components/countdown.html"}},[_vm._v("Countdown")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"components/forms.html"}},[_vm._v("Forms")])])])]),_vm._v(" "),_c('li',[_c('span',{staticClass:"mega-menu-title"},[_vm._v("G - M")]),_vm._v(" "),_c('ul',[_c('li',[_c('a',{attrs:{"href":"components/gallery.html"}},[_vm._v("Gallery")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"components/google-maps.html"}},[_vm._v("Google Maps")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"components/images.html"}},[_vm._v("Images & Figures")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"components/list-group.html"}},[_vm._v("List Group")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"components/market-social-buttons.html"}},[_vm._v("Market & Social Buttons")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"components/media.html"}},[_vm._v("Media Object")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"components/modal.html"}},[_vm._v("Modal")])])])]),_vm._v(" "),_c('li',[_c('span',{staticClass:"mega-menu-title"},[_vm._v("P - T")]),_vm._v(" "),_c('ul',[_c('li',[_c('a',{attrs:{"href":"components/pagination.html"}},[_vm._v("Pagination")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"components/pills.html"}},[_vm._v("Pills")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"components/progress-bars.html"}},[_vm._v("Progress Bars")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"components/shop-items.html"}},[_vm._v("Shop Items")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"components/steps.html"}},[_vm._v("Steps")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"components/tables.html"}},[_vm._v("Tables")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"components/tabs.html"}},[_vm._v("Tabs")])])])]),_vm._v(" "),_c('li',[_c('span',{staticClass:"mega-menu-title"},[_vm._v("T - W")]),_vm._v(" "),_c('ul',[_c('li',[_c('a',{attrs:{"href":"components/team.html"}},[_vm._v("Team")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"components/toasts.html"}},[_vm._v("Toast Notifications")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"components/tooltips-popovers.html"}},[_vm._v("Tooltips & Popovers")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"components/typography.html"}},[_vm._v("Typography")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"components/video-player.html"}},[_vm._v("Video Player")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"components/widgets.html"}},[_vm._v("Widgets")])])])])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"toolbar-toggle mobile-menu-toggle",attrs:{"href":"#mobileMenu"}},[_c('i',{staticClass:"material-icons menu"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"toolbar-toggle search-toggle",attrs:{"href":"#search"}},[_c('i',{staticClass:"material-icons search"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"toolbar-toggle",attrs:{"href":"#account"}},[_c('i',{staticClass:"material-icons person"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"toolbar-section",attrs:{"id":"mobileMenu"}},[_c('div',{staticClass:"text-center mb-4"},[_c('div',{staticClass:"lang-currency-switcher"},[_c('div',{staticClass:"lang-currency-toggle"},[_c('img',{attrs:{"src":"static/img/flags/GB.png","alt":"English"}}),_c('span',[_vm._v("USD")]),_c('i',{staticClass:"material-icons arrow_drop_down"}),_vm._v(" "),_c('ul',{staticClass:"lang-currency-dropdown"},[_c('li',[_c('select',{staticClass:"form-control form-control-sm"},[_c('option',{attrs:{"value":"usd"}},[_vm._v("$ USD")]),_vm._v(" "),_c('option',{attrs:{"value":"usd"}},[_vm._v("€ EUR")]),_vm._v(" "),_c('option',{attrs:{"value":"usd"}},[_vm._v("£ UKP")]),_vm._v(" "),_c('option',{attrs:{"value":"usd"}},[_vm._v("¥ JPY")])])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#"}},[_c('img',{attrs:{"src":"static/img/flags/FR.png","alt":"Français"}}),_vm._v("Français")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#"}},[_c('img',{attrs:{"src":"static/img/flags/DE.png","alt":"Deutsch"}}),_vm._v("Deutsch")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#"}},[_c('img',{attrs:{"src":"static/img/flags/IT.png","alt":"Italiano"}}),_vm._v("Italiano")])])])])])]),_vm._v(" "),_c('form',{staticClass:"input-group form-group",attrs:{"method":"get"}},[_c('span',{staticClass:"input-group-btn"},[_c('button',{attrs:{"type":"submit"}},[_c('i',{staticClass:"material-icons search"})])]),_vm._v(" "),_c('input',{staticClass:"form-control",attrs:{"type":"search","placeholder":"Search website"}})]),_vm._v(" "),_c('nav',{staticClass:"slideable-menu mt-4"},[_c('ul',{staticClass:"menu"},[_c('li',{staticClass:"has-children active"},[_c('span',[_c('a',{attrs:{"href":"index.html"}},[_c('span',[_vm._v("Home")])]),_c('span',{staticClass:"sub-menu-toggle"})]),_vm._v(" "),_c('ul',{staticClass:"slideable-submenu"},[_c('li',{staticClass:"active"},[_c('a',{attrs:{"href":"index.html"}},[_vm._v("Hero Slider")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"home-featured-categories.html"}},[_vm._v("Categories Grid")])])])]),_vm._v(" "),_c('li',{staticClass:"has-children"},[_c('span',[_c('a',{attrs:{"href":"shop-boxed-ls.html"}},[_c('span',[_vm._v("Shop")])]),_c('span',{staticClass:"sub-menu-toggle"})]),_vm._v(" "),_c('ul',{staticClass:"slideable-submenu"},[_c('li',[_c('a',{attrs:{"href":"shop-categories.html"}},[_vm._v("Shop Categories")])]),_vm._v(" "),_c('li',{staticClass:"has-children"},[_c('span',[_c('a',{attrs:{"href":"shop-boxed-ls.html"}},[_c('span',[_vm._v("Shop Layout")])]),_c('span',{staticClass:"sub-menu-toggle"})]),_vm._v(" "),_c('ul',{staticClass:"slideable-submenu"},[_c('li',[_c('a',{attrs:{"href":"shop-boxed-ls.html"}},[_vm._v("Boxed Left Sidebar")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"shop-boxed-rs.html"}},[_vm._v("Boxed Right Sidebar")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"shop-boxed-ft.html"}},[_vm._v("Boxed Filters Top")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"shop-full-ls.html"}},[_vm._v("Full Width Left Sidebar")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"shop-full-rs.html"}},[_vm._v("Full Width Right Sidebar")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"shop-full-ft.html"}},[_vm._v("Full Width Filters Top")])])])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"shop-single.html"}},[_vm._v("Single Product")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"cart.html"}},[_vm._v("Cart")])]),_vm._v(" "),_c('li',{staticClass:"has-children"},[_c('span',[_c('a',{attrs:{"href":"checkout-address.html"}},[_c('span',[_vm._v("Checkout")])]),_c('span',{staticClass:"sub-menu-toggle"})]),_vm._v(" "),_c('ul',{staticClass:"slideable-submenu"},[_c('li',[_c('a',{attrs:{"href":"checkout-address.html"}},[_vm._v("Address")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"checkout-shipping.html"}},[_vm._v("Shipping")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"checkout-payment.html"}},[_vm._v("Payment")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"checkout-review.html"}},[_vm._v("Review")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"checkout-complete.html"}},[_vm._v("Complete")])])])])])]),_vm._v(" "),_c('li',{staticClass:"has-children"},[_c('span',[_c('a',{attrs:{"href":"#"}},[_vm._v("Categories")]),_c('span',{staticClass:"sub-menu-toggle"})]),_vm._v(" "),_c('ul',{staticClass:"slideable-submenu"},[_c('li',{staticClass:"has-children"},[_c('span',[_c('a',{attrs:{"href":"#"}},[_vm._v("Desks & Benching")]),_c('span',{staticClass:"sub-menu-toggle"})]),_vm._v(" "),_c('ul',{staticClass:"slideable-submenu"},[_c('li',[_c('a',{attrs:{"href":"#"}},[_vm._v("Executive Desks")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#"}},[_vm._v("Standing Desks")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#"}},[_vm._v("Benching Desks")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#"}},[_vm._v("Single Desks")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#"}},[_vm._v("View All")])])])]),_vm._v(" "),_c('li',{staticClass:"has-children"},[_c('span',[_c('a',{attrs:{"href":"#"}},[_vm._v("Office Furniture")]),_c('span',{staticClass:"sub-menu-toggle"})]),_vm._v(" "),_c('ul',{staticClass:"slideable-submenu"},[_c('li',[_c('a',{attrs:{"href":"#"}},[_vm._v("File Cabinets")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#"}},[_vm._v("Office Chairs")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#"}},[_vm._v("Adjustable Tables")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#"}},[_vm._v("Stools")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#"}},[_vm._v("View All")])])])]),_vm._v(" "),_c('li',{staticClass:"has-children"},[_c('span',[_c('a',{attrs:{"href":"#"}},[_vm._v("Lounge Seating")]),_c('span',{staticClass:"sub-menu-toggle"})]),_vm._v(" "),_c('ul',{staticClass:"slideable-submenu"},[_c('li',[_c('a',{attrs:{"href":"#"}},[_vm._v("Benches")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#"}},[_vm._v("Chairs")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#"}},[_vm._v("Pillows")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#"}},[_vm._v("Sofas")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#"}},[_vm._v("View All")])])])]),_vm._v(" "),_c('li',{staticClass:"has-children"},[_c('span',[_c('a',{attrs:{"href":"#"}},[_vm._v("Storage Units")]),_c('span',{staticClass:"sub-menu-toggle"})]),_vm._v(" "),_c('ul',{staticClass:"slideable-submenu"},[_c('li',[_c('a',{attrs:{"href":"#"}},[_vm._v("Bookcases")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#"}},[_vm._v("Box Seats & Benches")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#"}},[_vm._v("Credenza")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#"}},[_vm._v("View All")])])])]),_vm._v(" "),_c('li',{staticClass:"has-children"},[_c('span',[_c('a',{attrs:{"href":"#"}},[_vm._v("Lighting")]),_c('span',{staticClass:"sub-menu-toggle"})]),_vm._v(" "),_c('ul',{staticClass:"slideable-submenu"},[_c('li',[_c('a',{attrs:{"href":"#"}},[_vm._v("Ceiling Lights")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#"}},[_vm._v("Kitchen Lights")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#"}},[_vm._v("Wall Lights")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#"}},[_vm._v("Lamps")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#"}},[_vm._v("View All")])])])]),_vm._v(" "),_c('li',{staticClass:"has-children"},[_c('span',[_c('a',{attrs:{"href":"#"}},[_vm._v("Furniture Accessories")]),_c('span',{staticClass:"sub-menu-toggle"})]),_vm._v(" "),_c('ul',{staticClass:"slideable-submenu"},[_c('li',[_c('a',{attrs:{"href":"#"}},[_vm._v("Power Management")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#"}},[_vm._v("Desk Add Ons")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#"}},[_vm._v("Lamps")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#"}},[_vm._v("Monitor Arms")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#"}},[_vm._v("Desk Risers")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#"}},[_vm._v("View All")])])])])])]),_vm._v(" "),_c('li',{staticClass:"has-children"},[_c('span',[_c('a',{attrs:{"href":"account-orders.html"}},[_c('span',[_vm._v("Account")])]),_c('span',{staticClass:"sub-menu-toggle"})]),_vm._v(" "),_c('ul',{staticClass:"slideable-submenu"},[_c('li',[_c('a',{attrs:{"href":"account-orders.html"}},[_vm._v("Orders List")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"account-wishlist.html"}},[_vm._v("Wishlist")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"account-profile.html"}},[_vm._v("Profile Page")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"account-address.html"}},[_vm._v("Contact / Shipping Address")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"account-open-ticket.html"}},[_vm._v("Open Ticket")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"account-tickets.html"}},[_vm._v("My Tickets")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"account-single-ticket.html"}},[_vm._v("Single Ticket")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"account-password-recovery.html"}},[_vm._v("Password Recovery")])])])]),_vm._v(" "),_c('li',{staticClass:"has-children"},[_c('span',[_c('a',{attrs:{"href":"blog.html"}},[_c('span',[_vm._v("Blog List")])]),_c('span',{staticClass:"sub-menu-toggle"})]),_vm._v(" "),_c('ul',{staticClass:"slideable-submenu"},[_c('li',[_c('a',{attrs:{"href":"blog.html"}},[_vm._v("Blog List")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"blog-single.html"}},[_vm._v("Single Post")])])])]),_vm._v(" "),_c('li',{staticClass:"has-children"},[_c('span',[_c('a',{attrs:{"href":"#"}},[_vm._v("Pages")]),_c('span',{staticClass:"sub-menu-toggle"})]),_vm._v(" "),_c('ul',{staticClass:"slideable-submenu"},[_c('li',[_c('a',{attrs:{"href":"about.html"}},[_vm._v("About Us")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"contacts.html"}},[_vm._v("Contacts")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"faq.html"}},[_vm._v("Help / FAQ")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"order-tracking.html"}},[_vm._v("Order Tracking")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"404.html"}},[_vm._v("404 Not Found")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"coming-soon.html"}},[_vm._v("Coming Soon")])]),_vm._v(" "),_c('li',[_c('a',{staticClass:"text-danger",attrs:{"href":"docs/dev-setup.html"}},[_vm._v("Documentation")])])])]),_vm._v(" "),_c('li',{staticClass:"has-children"},[_c('span',[_c('a',{attrs:{"href":"components/accordion.html"}},[_c('span',[_vm._v("Components")])]),_c('span',{staticClass:"sub-menu-toggle"})]),_vm._v(" "),_c('ul',{staticClass:"slideable-submenu"},[_c('li',[_c('a',{attrs:{"href":"components/accordion.html"}},[_vm._v("Accordion")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"components/alerts.html"}},[_vm._v("Alerts")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"components/buttons.html"}},[_vm._v("Buttons")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"components/cards.html"}},[_vm._v("Cards")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"components/carousel.html"}},[_vm._v("Carousel")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"components/countdown.html"}},[_vm._v("Countdown")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"components/forms.html"}},[_vm._v("Forms")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"components/gallery.html"}},[_vm._v("Gallery")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"components/google-maps.html"}},[_vm._v("Google Maps")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"components/images.html"}},[_vm._v("Images & Figures")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"components/list-group.html"}},[_vm._v("List Group")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"components/market-social-buttons.html"}},[_vm._v("Market & Social Buttons")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"components/media.html"}},[_vm._v("Media Object")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"components/modal.html"}},[_vm._v("Modal")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"components/pagination.html"}},[_vm._v("Pagination")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"components/pills.html"}},[_vm._v("Pills")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"components/progress-bars.html"}},[_vm._v("Progress Bars")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"components/shop-items.html"}},[_vm._v("Shop Items")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"components/steps.html"}},[_vm._v("Steps")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"components/tables.html"}},[_vm._v("Tables")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"components/tabs.html"}},[_vm._v("Tabs")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"components/team.html"}},[_vm._v("Team")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"components/toasts.html"}},[_vm._v("Toast Notifications")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"components/tooltips-popovers.html"}},[_vm._v("Tooltips & Popovers")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"components/typography.html"}},[_vm._v("Typography")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"components/video-player.html"}},[_vm._v("Video Player")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"components/widgets.html"}},[_vm._v("Widgets")])])])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"toolbar-section",attrs:{"id":"search"}},[_c('form',{staticClass:"search-form mb-2",attrs:{"method":"get"}},[_c('input',{attrs:{"type":"search","placeholder":"Type search query"}}),_c('i',{staticClass:"material-icons search"})]),_vm._v(" "),_c('div',{staticClass:"widget widget-featured-products"},[_c('h3',{staticClass:"widget-title"},[_vm._v("Found in Products")]),_vm._v(" "),_c('div',{staticClass:"entry"},[_c('div',{staticClass:"entry-thumb"},[_c('a',{attrs:{"href":"shop-single.html"}},[_c('img',{attrs:{"src":"static/img/shop/widget/01.png","alt":"Product"}})])]),_vm._v(" "),_c('div',{staticClass:"entry-content"},[_c('h4',{staticClass:"entry-title"},[_c('a',{attrs:{"href":"shop-single.html"}},[_vm._v("Max "),_c('span',{staticClass:"text-highlighted"},[_vm._v("Task Chair")])])]),_c('span',{staticClass:"entry-meta"},[_vm._v("$299.00")])])]),_vm._v(" "),_c('div',{staticClass:"entry"},[_c('div',{staticClass:"entry-thumb"},[_c('a',{attrs:{"href":"shop-single.html"}},[_c('img',{attrs:{"src":"static/img/shop/widget/02.png","alt":"Product"}})])]),_vm._v(" "),_c('div',{staticClass:"entry-content"},[_c('h4',{staticClass:"entry-title"},[_c('a',{attrs:{"href":"shop-single.html"}},[_c('span',{staticClass:"text-highlighted"},[_vm._v("Drawer")]),_vm._v(" File Cabinet")])]),_c('span',{staticClass:"entry-meta"},[_vm._v("$265.00")])])]),_vm._v(" "),_c('div',{staticClass:"entry"},[_c('div',{staticClass:"entry-thumb"},[_c('a',{attrs:{"href":"shop-single.html"}},[_c('img',{attrs:{"src":"static/img/shop/widget/03.png","alt":"Product"}})])]),_vm._v(" "),_c('div',{staticClass:"entry-content"},[_c('h4',{staticClass:"entry-title"},[_c('a',{attrs:{"href":"shop-single.html"}},[_vm._v("Campfire "),_c('span',{staticClass:"text-highlighted"},[_vm._v("Paper")]),_vm._v(" Table")])]),_c('span',{staticClass:"entry-meta"},[_vm._v("$570.00")])])])]),_vm._v(" "),_c('div',{staticClass:"widget widget-featured-products"},[_c('h3',{staticClass:"widget-title"},[_vm._v("Found in Blog")]),_vm._v(" "),_c('div',{staticClass:"entry"},[_c('div',{staticClass:"entry-thumb"},[_c('a',{attrs:{"href":"blog-single.html"}},[_c('img',{attrs:{"src":"static/img/blog/widget/01.jpg","alt":"Post"}})])]),_vm._v(" "),_c('div',{staticClass:"entry-content"},[_c('h4',{staticClass:"entry-title"},[_c('a',{attrs:{"href":"blog-single.html"}},[_c('span',{staticClass:"text-highlighted"},[_vm._v("Modern")]),_vm._v(" Working Space")])]),_c('span',{staticClass:"entry-meta"},[_vm._v("May 09")])])]),_vm._v(" "),_c('div',{staticClass:"entry"},[_c('div',{staticClass:"entry-thumb"},[_c('a',{attrs:{"href":"blog-single.html"}},[_c('img',{attrs:{"src":"static/img/blog/widget/02.jpg","alt":"Post"}})])]),_vm._v(" "),_c('div',{staticClass:"entry-content"},[_c('h4',{staticClass:"entry-title"},[_c('a',{attrs:{"href":"blog-single.html"}},[_vm._v("Interior "),_c('span',{staticClass:"text-highlighted"},[_vm._v("Design")]),_vm._v(" Tricks")])]),_c('span',{staticClass:"entry-meta"},[_vm._v("April 18")])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"toolbar-section",attrs:{"id":"account"}},[_c('ul',{staticClass:"nav nav-tabs nav-justified",attrs:{"role":"tablist"}},[_c('li',{staticClass:"nav-item"},[_c('a',{staticClass:"nav-link active",attrs:{"href":"#login","data-toggle":"tab","role":"tab"}},[_vm._v("Log In")])]),_vm._v(" "),_c('li',{staticClass:"nav-item"},[_c('a',{staticClass:"nav-link",attrs:{"href":"#signup","data-toggle":"tab","role":"tab"}},[_vm._v("Sign Up")])])]),_vm._v(" "),_c('div',{staticClass:"tab-content"},[_c('div',{staticClass:"tab-pane fade show active",attrs:{"id":"login","role":"tabpanel"}},[_c('form',{attrs:{"autocomplete":"off","id":"login-form"}},[_c('div',{staticClass:"form-group input-group"},[_c('input',{staticClass:"form-control",attrs:{"type":"email","placeholder":"Email","required":""}}),_c('span',{staticClass:"input-group-addon"},[_c('i',{staticClass:"material-icons mail"})])]),_vm._v(" "),_c('div',{staticClass:"form-group input-group"},[_c('input',{staticClass:"form-control",attrs:{"type":"password","placeholder":"Password","required":""}}),_c('span',{staticClass:"input-group-addon"},[_c('i',{staticClass:"material-icons lock"})])]),_vm._v(" "),_c('div',{staticClass:"custom-control custom-checkbox form-group"},[_c('input',{staticClass:"custom-control-input",attrs:{"type":"checkbox","id":"logged","checked":""}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label",attrs:{"for":"logged"}},[_vm._v("Keep me logged in")])]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary btn-block",attrs:{"type":"submit"}},[_vm._v("Log In")])])]),_vm._v(" "),_c('div',{staticClass:"tab-pane fade",attrs:{"id":"signup","role":"tabpanel"}},[_c('form',{attrs:{"autocomplete":"off","id":"signup-form"}},[_c('div',{staticClass:"form-group"},[_c('input',{staticClass:"form-control",attrs:{"type":"text","placeholder":"Full Name","required":""}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('input',{staticClass:"form-control",attrs:{"type":"email","placeholder":"Email","required":""}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('input',{staticClass:"form-control",attrs:{"type":"password","placeholder":"Password","required":""}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('input',{staticClass:"form-control",attrs:{"type":"password","placeholder":"Confirm Password","required":""}})]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary btn-block",attrs:{"type":"submit"}},[_vm._v("Sign Up")]),_vm._v(" "),_c('p',{staticClass:"text-muted text-sm mt-4"},[_vm._v("OR sign up with your social account")]),_c('a',{staticClass:"media-btn media-facebook",attrs:{"href":"#"}},[_c('i',{staticClass:"socicon-facebook"}),_c('span',[_vm._v("Signup with Facebook")])]),_c('a',{staticClass:"media-btn media-google",attrs:{"href":"#"}},[_c('i',{staticClass:"socicon-googleplus"}),_c('span',[_vm._v("Signup with Google+")])]),_c('a',{staticClass:"media-btn media-twitter",attrs:{"href":"#"}},[_c('i',{staticClass:"socicon-twitter"}),_c('span',[_vm._v("Signup with Twitter")])])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 114 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_navigation_vue__ = __webpack_require__(26);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ca5e5d48_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_navigation_vue__ = __webpack_require__(160);
function injectStyle (ssrContext) {
  __webpack_require__(115)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-ca5e5d48"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_navigation_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ca5e5d48_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_navigation_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 115 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('header',{staticClass:"navbar navbar-sticky"},[_vm._m(0),_vm._v(" "),_c('nav',{staticClass:"site-menu"},[_c('ul',[_c('router-link',{attrs:{"tag":"li","to":"/"}},[_c('a',[_c('span',[_c('strong',[_vm._v("Accueil")])])])]),_vm._v(" "),_c('router-link',{attrs:{"tag":"li","to":"/all"}},[_c('a',[_c('span',[_c('strong',[_vm._v("Tous")])])])]),_vm._v(" "),_c('router-link',{attrs:{"tag":"li","to":"/men"}},[_c('a',[_c('span',[_c('strong',[_vm._v("Homme")])])])]),_vm._v(" "),_c('router-link',{attrs:{"tag":"li","to":"/women"}},[_c('a',[_c('span',[_c('strong',[_vm._v("Femme")])])])]),_vm._v(" "),_c('router-link',{attrs:{"tag":"li","to":"/nautica"}},[_c('a',[_c('span',[_c('strong',[_c('font',{attrs:{"color":"red"}},[_vm._v("Promotion")])],1)])])]),_vm._v(" "),_c('li',[_vm._m(1),_vm._v(" "),_c('ul',{staticClass:"sub-menu"},[_c('router-link',{attrs:{"tag":"li","to":"/festina"}},[_c('a',[_c('span',[_c('strong',[_vm._v("FESTINA")])])])]),_vm._v(" "),_c('router-link',{attrs:{"tag":"li","to":"/maserati"}},[_c('a',[_c('span',[_c('strong',[_vm._v("MASERATI")])])])]),_vm._v(" "),_c('router-link',{attrs:{"tag":"li","to":"/versus"}},[_c('a',[_c('span',[_c('strong',[_vm._v("VERSUS")])])])]),_vm._v(" "),_c('router-link',{attrs:{"tag":"li","to":"/trussardi"}},[_c('a',[_c('span',[_c('strong',[_vm._v("TRUSSARDI")])])])]),_vm._v(" "),_c('router-link',{attrs:{"tag":"li","to":"/morellato"}},[_c('a',[_c('span',[_c('strong',[_vm._v("MORELLATO")])])])]),_vm._v(" "),_c('router-link',{attrs:{"tag":"li","to":"/nautica"}},[_c('a',[_c('span',[_c('strong',[_vm._v("Promotion")])])])]),_vm._v(" "),_c('router-link',{attrs:{"tag":"li","to":"/timberland"}},[_c('a',[_c('span',[_c('strong',[_vm._v("TIMBERLAND")])])])]),_vm._v(" "),_c('router-link',{attrs:{"tag":"li","to":"/Michaelkors"}},[_c('a',[_c('span',[_c('strong',[_vm._v("MICHAEL KORS")])])])]),_vm._v(" "),_c('router-link',{attrs:{"tag":"li","to":"/armani"}},[_c('a',[_c('span',[_c('strong',[_vm._v("ARAMANI EXCHANGE ")])])])]),_vm._v(" "),_c('router-link',{attrs:{"tag":"li","to":"/fossil"}},[_c('a',[_c('span',[_c('strong',[_vm._v("FOSSIL")])])])]),_vm._v(" "),_c('router-link',{attrs:{"tag":"li","to":"/connectee"}},[_c('a',[_c('span',[_c('strong',[_vm._v("CONNECTEE")])])])])],1)]),_vm._v(" "),_c('router-link',{attrs:{"tag":"li","to":"/achat"}},[_c('a',[_c('span',[_c('strong',[_vm._v("COMMENT ACHETER ")])])])]),_vm._v(" "),_c('router-link',{attrs:{"tag":"li","to":"/contact"}},[_c('a',[_c('span',[_c('strong',[_vm._v("CONTACT")])])])])],1)]),_vm._v(" "),_c('div',{staticClass:"toolbar"},[_c('div',{staticClass:"inner"},[_c('a',{staticClass:"toolbar-toggle mobile-menu-toggle",class:{active:_vm.isActive},attrs:{"href":"#mobileMenu"},on:{"click":function($event){_vm.isActive=!_vm.isActive}}},[_c('i',{staticClass:"material-icons menu"})]),_vm._v(" "),_c('a',{staticClass:"toolbar-toggle",class:{active:_vm.isCart},attrs:{"href":"#cart"},on:{"click":function($event){_vm.isCart=!_vm.isCart}}},[_c('i',[_c('span',{staticClass:"material-icons shopping_basket"}),_c('span',{staticClass:"count"},[_vm._v(_vm._s(_vm.itemsInCart))])])])]),_vm._v(" "),_c('div',{staticClass:"toolbar-dropdown",class:{open:_vm.isActive}},[_c('div',{staticClass:"toolbar-section",attrs:{"id":"mobileMenu"}},[_c('nav',{staticClass:"slideable-menu mt-4"},[_c('ul',{staticClass:"menu"},[_c('router-link',{attrs:{"tag":"li","to":"/"},nativeOn:{"click":function($event){_vm.isActive=false}}},[_c('a',[_c('span',[_c('strong',[_vm._v("Accueil")])])])]),_vm._v(" "),_c('router-link',{attrs:{"tag":"li","to":"/all"},nativeOn:{"click":function($event){_vm.isActive=false}}},[_c('a',[_c('span',[_c('strong',[_vm._v("Tous")])])])]),_vm._v(" "),_c('router-link',{attrs:{"tag":"li","to":"/men"},nativeOn:{"click":function($event){_vm.isActive=false}}},[_c('a',[_c('span',[_c('strong',[_vm._v("Homme")])])])]),_vm._v(" "),_c('router-link',{attrs:{"tag":"li","to":"/women"},nativeOn:{"click":function($event){_vm.isActive=false}}},[_c('a',[_c('span',[_c('strong',[_vm._v("Femme")])])])]),_vm._v(" "),_c('router-link',{attrs:{"tag":"li","to":"/nautica"},nativeOn:{"click":function($event){_vm.isActive=false}}},[_c('a',[_c('span',[_c('strong',[_c('font',{attrs:{"color":"red"}},[_vm._v("PROMOTION")])],1)])])]),_vm._v(" "),_c('li',{staticClass:"has-children"},[_vm._m(2),_vm._v(" "),_c('ul',{staticClass:"slideable-submenu"},[_c('router-link',{attrs:{"tag":"li","to":"/festina"},nativeOn:{"click":function($event){_vm.isActive=false}}},[_c('a',[_c('span',[_c('strong',[_vm._v("Festina")])])])]),_vm._v(" "),_c('router-link',{attrs:{"tag":"li","to":"/maserati"},nativeOn:{"click":function($event){_vm.isActive=false}}},[_c('a',[_c('span',[_c('strong',[_vm._v("Maserati")])])])]),_vm._v(" "),_c('router-link',{attrs:{"tag":"li","to":"/versus"},nativeOn:{"click":function($event){_vm.isActive=false}}},[_c('a',[_c('span',[_c('strong',[_vm._v("Versus")])])])]),_vm._v(" "),_c('router-link',{attrs:{"tag":"li","to":"/trussardi"},nativeOn:{"click":function($event){_vm.isActive=false}}},[_c('a',[_c('span',[_c('strong',[_vm._v("TRUSSARDI")])])])]),_vm._v(" "),_c('router-link',{attrs:{"tag":"li","to":"/morellato"},nativeOn:{"click":function($event){_vm.isActive=false}}},[_c('a',[_c('span',[_c('strong',[_vm._v("Morellato")])])])]),_vm._v(" "),_c('router-link',{attrs:{"tag":"li","to":"/fossil"},nativeOn:{"click":function($event){_vm.isActive=false}}},[_c('a',[_c('span',[_c('strong',[_vm._v("Fossil")])])])]),_vm._v(" "),_c('router-link',{attrs:{"tag":"li","to":"/timberland"},nativeOn:{"click":function($event){_vm.isActive=false}}},[_c('a',[_c('span',[_c('strong',[_vm._v("Timberland")])])])]),_vm._v(" "),_c('router-link',{attrs:{"tag":"li","to":"/Michaelkors"},nativeOn:{"click":function($event){_vm.isActive=false}}},[_c('a',[_c('span',[_c('strong',[_vm._v("Michael kors")])])])]),_vm._v(" "),_c('router-link',{attrs:{"tag":"li","to":"/armani"},nativeOn:{"click":function($event){_vm.isActive=false}}},[_c('a',[_c('span',[_c('strong',[_vm._v("Armani exchange")])])])]),_vm._v(" "),_c('router-link',{attrs:{"tag":"li","to":"/diesel"},nativeOn:{"click":function($event){_vm.isActive=false}}},[_c('a',[_c('span',[_c('strong',[_vm._v("Diesel")])])])]),_vm._v(" "),_c('router-link',{attrs:{"tag":"li","to":"/nautica"},nativeOn:{"click":function($event){_vm.isActive=false}}},[_c('a',[_c('span',[_c('strong',[_vm._v("Nautica")])])])]),_vm._v(" "),_c('router-link',{attrs:{"tag":"li","to":"/lotus"},nativeOn:{"click":function($event){_vm.isActive=false}}},[_c('a',[_c('span',[_c('strong',[_vm._v("Lotus")])])])]),_vm._v(" "),_c('router-link',{attrs:{"tag":"li","to":"/connectee"},nativeOn:{"click":function($event){_vm.isActive=false}}},[_c('a',[_c('span',[_c('strong',[_vm._v("Connectee")])])])])],1)]),_vm._v(" "),_c('router-link',{attrs:{"tag":"li","to":"/achatmobile"},nativeOn:{"click":function($event){_vm.isActive=false}}},[_c('a',[_c('span',[_c('strong',[_vm._v("Comment acheter")])])])]),_vm._v(" "),_c('router-link',{attrs:{"tag":"li","to":"/contact"},nativeOn:{"click":function($event){_vm.isActive=false}}},[_c('a',[_c('span',[_c('strong',[_vm._v("Contact")])])])])],1)])]),_vm._v(" "),_vm._m(3),_vm._v(" "),_c('div',{staticClass:"toolbar-section",attrs:{"id":"account"}},[_vm._m(4),_vm._v(" "),_c('div',{staticClass:"tab-content"},[_c('div',{staticClass:"tab-pane fade show active",attrs:{"id":"login","role":"tabpanel"}},[(!_vm.isAuthenticated)?_c('form',{attrs:{"autocomplete":"off","id":"login-form"},on:{"submit":function($event){$event.preventDefault();return _vm.login($event)}}},[_c('div',{staticClass:"form-group input-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.email),expression:"email"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"E-mail","required":""},domProps:{"value":(_vm.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.email=$event.target.value}}}),_vm._v(" "),_vm._m(5)]),_vm._v(" "),_c('div',{staticClass:"form-group input-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.phonenumber),expression:"phonenumber"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"phone","required":""},domProps:{"value":(_vm.phonenumber)},on:{"input":function($event){if($event.target.composing){ return; }_vm.phonenumber=$event.target.value}}}),_vm._v(" "),_vm._m(6)]),_vm._v(" "),_c('div',{staticClass:"form-group input-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.password),expression:"password"}],staticClass:"form-control",attrs:{"type":"password","placeholder":"Mot de passe","required":""},domProps:{"value":(_vm.password)},on:{"input":function($event){if($event.target.composing){ return; }_vm.password=$event.target.value}}}),_vm._v(" "),_vm._m(7)]),_vm._v(" "),_vm._m(8),_vm._v(" "),_c('button',{staticClass:"btn btn-primary btn-block",attrs:{"type":"submit"}},[_vm._v("S'identifier")])]):_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.logout($event)}}},[_c('p',[_vm._v("Vous étes connecté !!!!")]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary btn-block",attrs:{"type":"submit"}},[_vm._v("Se déconnecter")])])]),_vm._v(" "),_c('div',{staticClass:"tab-pane fade",attrs:{"id":"register","role":"tabpanel"}},[(!_vm.isAuthenticated)?_c('form',{attrs:{"autocomplete":"off","id":"register-form"},on:{"submit":function($event){$event.preventDefault();return _vm.register($event)}}},[_c('div',{staticClass:"form-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.emailregister),expression:"emailregister"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Email","required":""},domProps:{"value":(_vm.emailregister)},on:{"input":function($event){if($event.target.composing){ return; }_vm.emailregister=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.passwordregister),expression:"passwordregister"}],staticClass:"form-control",attrs:{"type":"password","placeholder":"Mot de passe","required":""},domProps:{"value":(_vm.passwordregister)},on:{"input":function($event){if($event.target.composing){ return; }_vm.passwordregister=$event.target.value}}})]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary btn-block",attrs:{"type":"submit"}},[_vm._v("Inscrire")]),_vm._v(" "),_c('p',{staticClass:"text-muted text-sm mt-4"},[_vm._v("OU inscrivez-vous avec votre compte social")]),_vm._v(" "),_c('a',{staticClass:"media-btn media-facebook",attrs:{"href":"#"},on:{"click":_vm.openFbLoginDialog}},[_c('i',{staticClass:"socicon-facebook"}),_vm._v(" "),_c('span',[_vm._v("Inscrivez-vous avec Facebook")])])]):_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.logout($event)}}},[_c('p',[_vm._v("vous êtes authentifié!!!!")]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary btn-block",attrs:{"type":"submit"}},[_vm._v("Log Off")])])])])]),_vm._v(" "),_c('div',{staticClass:"toolbar-section",attrs:{"id":"cart"}},[_c('div',{staticClass:"table-responsive shopping-cart mb-0"},[_c('table',{staticClass:"table"},[_c('thead',[_c('tr',[_c('th',{attrs:{"colspan":"2"}},[_c('div',{staticClass:"d-flex justify-content-between align-items-center"},[_vm._v("Produits\n                      "),_c('router-link',{staticClass:"navi-link text-uppercase",attrs:{"to":"/cart"},nativeOn:{"click":function($event){return _vm.cancelCart($event)}}},[_c('span',{staticClass:"text-xxs"},[_vm._v("Votre Panier")]),_vm._v(" "),_c('i',{staticClass:"material-icons keyboard_arrow_right"})])],1)])])]),_vm._v(" "),_c('tbody',_vm._l((_vm.products),function(product){return _c('tr',{key:product.id},[_c('td',[_c('div',{staticClass:"product-item"},[_c('a',{staticClass:"product-thumb",attrs:{"href":"shop-single.html"}},[_c('img',{attrs:{"src":product.img,"alt":"Product"}})]),_vm._v(" "),_c('div',{staticClass:"product-info"},[_c('h4',{staticClass:"product-title"},[_c('a',{attrs:{"href":"shop-single.html"}},[_vm._v(_vm._s(product.name))])]),_c('span',[_c('em',[_vm._v("Prix:")]),_vm._v(" "+_vm._s(product.price))]),_c('span',[_c('em',[_vm._v("Quantité:")]),_vm._v(" "+_vm._s(product.quantity))])])])]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_c('a',{staticClass:"remove-from-cart",attrs:{"href":"#"},on:{"click":function($event){_vm.removeItem(product)}}},[_c('i',{staticClass:"material-icons icon_close"})])])])}))])]),_vm._v(" "),_c('hr',{staticClass:"mb-3"}),_vm._v(" "),_c('div',{staticClass:"d-flex flex-wrap justify-content-between align-items-center"},[_c('div',{staticClass:"pr-2 py-1 text-sm"},[_vm._v("TOTAL: "),_c('span',{staticClass:"text-dark text-medium"},[_vm._v(_vm._s(_vm.total))])]),_vm._v(" "),_c('router-link',{staticClass:"btn btn-sm btn-success mb-0 mr-0",attrs:{"to":"/checkout"},nativeOn:{"click":function($event){return _vm.cancelCart($event)}}},[_vm._v("Commander")])],1)])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"site-branding"},[_c('a',{staticClass:"site-logo hidden-xs-down",attrs:{"href":"https://luxuryshopdz.com/#/all"}},[_c('img',{attrs:{"src":"static/img/logo/logo.png","alt":"luxuryShop dz"}})]),_c('a',{staticClass:"site-logo logo-sm hidden-sm-up",attrs:{"to":"/"}},[_c('img',{attrs:{"src":"static/img/logo/logo-sm.png","alt":"luxuryshopdz"}})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{attrs:{"href":"#"}},[_c('span',[_c('strong',[_vm._v("Marque")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('a',{attrs:{"href":"#"}},[_c('span',[_c('strong',[_vm._v("Marque")])])]),_c('span',{staticClass:"sub-menu-toggle"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"toolbar-section",attrs:{"id":"search"}},[_c('div',{staticClass:"widget widget-featured-products"},[_c('h3',{staticClass:"widget-title"},[_vm._v("Found in Products")])]),_vm._v(" "),_c('div',{staticClass:"widget widget-featured-products"},[_c('h3',{staticClass:"widget-title"},[_vm._v("Found in Blog")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"nav nav-tabs nav-justified",attrs:{"role":"tablist"}},[_c('li',{staticClass:"nav-item"},[_c('a',{staticClass:"nav-link active",attrs:{"href":"#login","data-toggle":"tab","role":"tab"}},[_vm._v("Connecter")])]),_vm._v(" "),_c('li',{staticClass:"nav-item"},[_c('a',{staticClass:"nav-link",attrs:{"href":"#register","data-toggle":"tab","role":"tab"}},[_vm._v("Créer votre compte")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"input-group-addon"},[_c('i',{staticClass:"material-icons mail"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"input-group-addon"},[_c('i',{staticClass:"material-icons mail"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"input-group-addon"},[_c('i',{staticClass:"material-icons lock"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"custom-control custom-checkbox form-group"},[_c('input',{staticClass:"custom-control-input",attrs:{"type":"checkbox","id":"logged","checked":""}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label",attrs:{"for":"logged"}},[_vm._v("Rester connecté")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 161 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_mhdfooter_vue__ = __webpack_require__(40);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ec076f58_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_mhdfooter_vue__ = __webpack_require__(163);
function injectStyle (ssrContext) {
  __webpack_require__(162)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-ec076f58"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_mhdfooter_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ec076f58_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_mhdfooter_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 162 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 163 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('footer',{staticClass:"site-footer"},[_c('div',{staticClass:"column text-center"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:" text-center"},[_c('strong',[_c('li',[_c('a',{attrs:{"href":"https://luxuryshopdz.com/#/all"}},[_c('font',{attrs:{"color":"black"}},[_vm._v("TOUS")])],1)])])]),_vm._v(" "),_c('div',{staticClass:" text-center"},[_c('strong',[_c('li',[_c('a',{attrs:{"href":"https://luxuryshopdz.com/#/men"}},[_c('font',{attrs:{"color":"black"}},[_vm._v("HOMME")])],1)])])]),_vm._v(" "),_c('div',{staticClass:" text-center"},[_c('strong',[_c('li',[_c('a',{attrs:{"href":"https://luxuryshopdz.com/#/women"}},[_c('font',{attrs:{"color":"black"}},[_vm._v("FEMME")])],1)])])]),_vm._v(" "),_c('div',{staticClass:" text-center"},[_c('strong',[_c('li',[_c('a',{attrs:{"href":"https://luxuryshopdz.com/#/top"}},[_c('font',{attrs:{"color":"red"}},[_vm._v("TOP MODÉLES")])],1)])])]),_vm._v(" "),_c('div',{staticClass:" text-center"},[_c('strong',[_c('li',[_c('a',{attrs:{"href":"https://luxuryshopdz.com/#/festina"}},[_c('font',{attrs:{"color":"black"}},[_vm._v("FESTINA")])],1)])])]),_vm._v(" "),_c('div',{staticClass:" text-center"},[_c('strong',[_c('li',[_c('a',{attrs:{"href":"https://luxuryshopdz.com/#/Michaelkors"}},[_c('font',{attrs:{"color":"black"}},[_vm._v("MICHAEL KORS")])],1)])])]),_vm._v(" "),_c('div',{staticClass:" text-center"},[_c('strong',[_c('li',[_c('a',{attrs:{"href":"https://luxuryshopdz.com/#/armani"}},[_c('font',{attrs:{"color":"black"}},[_vm._v("ARMANI EXCHANGE")])],1)])])]),_vm._v(" "),_c('div',{staticClass:" text-center"},[_c('strong',[_c('li',[_c('a',{attrs:{"href":"https://luxuryshopdz.com/#/fossil"}},[_c('font',{attrs:{"color":"black"}},[_vm._v("FOSSIL")])],1)])])]),_vm._v(" "),_c('div',{staticClass:" text-center"},[_c('strong',[_c('li',[_c('a',{attrs:{"href":"https://luxuryshopdz.com/#/diesel"}},[_c('font',{attrs:{"color":"black"}},[_vm._v("DIESEL")])],1)])])]),_vm._v(" "),_c('div',{staticClass:" text-center"},[_c('strong',[_c('li',[_c('a',{attrs:{"href":"https://luxuryshopdz.com/#/connectee"}},[_c('font',{attrs:{"color":"black"}},[_vm._v("DIESEL")])],1)])])])]),_vm._v(" "),_c('div',{staticClass:"column text-center"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:" text-center"},[_c('strong',[_c('li',[_c('a',{attrs:{"href":"https://luxuryshopdz.com/#/contact"}},[_c('font',{attrs:{"color":"black"}},[_vm._v("CONTACT")])],1)])])]),_vm._v(" "),_c('div',{staticClass:" text-center"},[_c('strong',[_c('li',[_c('a',{attrs:{"href":"https://luxuryshopdz.com/#/"}},[_c('font',{attrs:{"color":"black"}},[_vm._v("ACCUEIL")])],1)])])])]),_vm._v(" "),_vm._m(2),_vm._v(" "),_c('div',{staticClass:"column"},[_c('h3',{staticClass:"widget-title text-center"},[_c('strong',[_vm._v(" Abonnement")]),_c('small',[_c('strong',[_c('font',{attrs:{"color":"black"}},[_vm._v("Pour recevoir les dernières offres et remises de la boutique.")])],1)])])]),_vm._v(" "),_c('div',{staticClass:"column"},[_c('h3',{staticClass:"widget-title text-center"},[_c('strong',[_vm._v(" MODES DE PAIEMENT ")]),_c('small',[_c('strong',[_c('font',{attrs:{"color":"black"}},[_vm._v("Vous payez à la livraison")])],1)])]),_vm._v(" "),_c('div')])]),_vm._v(" "),_vm._m(3),_vm._v(" "),_c('div',{staticClass:"site-backdrop"})])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h3',{staticClass:"widget-title text-center"},[_c('strong',[_vm._v(" MENU ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h3',{staticClass:"widget-title text-center"},[_c('strong')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"column text-center"},[_c('p',{staticClass:"text-sm mb-4"},[_c('strong',[_vm._v(" Besoin de soutien? appelez au ")]),_c('span',{staticClass:"text-primary"},[_vm._v("  "),_c('strong',[_vm._v("023 804 474 / 021 43 62 72")])])]),_c('a',{staticClass:"social-button sb-facebook",attrs:{"href":"https://www.facebook.com/LUXURYSHOPDZ/","data-toggle":"tooltip","data-placement":"top","title":"Facebook"}},[_c('i',{staticClass:"socicon-facebook"})]),_c('a',{staticClass:"social-button sb-instagram",attrs:{"href":"https://www.instagram.com/luxury.shop_dz_1/?hl=en","data-toggle":"tooltip","data-placement":"top","title":"Instagram"}},[_c('i',{staticClass:"socicon-instagram"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"scroll-to-top-btn",attrs:{"href":"#"}},[_c('i',{staticClass:"material-icons trending_flat"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 164 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 165 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('notifications',{attrs:{"group":"cart","position":"bottom right"}}),_vm._v(" "),_c('navigation'),_vm._v(" "),_c('transition',{attrs:{"enter-active-class":"animated fadeIn animation-delay-100","leave-active-class":"animated fadeOut animation-delay-100"}},[_c('router-view',{key:_vm.$route.fullPath})],1),_vm._v(" "),_c('mhdfooter')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 166 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_home__ = __webpack_require__(167);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_cart__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_product__ = __webpack_require__(176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_checkout_checkadress__ = __webpack_require__(179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_checkout_shipping__ = __webpack_require__(182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_checkout_payment__ = __webpack_require__(185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_checkout_review__ = __webpack_require__(188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_checkout_complete__ = __webpack_require__(191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_all__ = __webpack_require__(194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_vipclient__ = __webpack_require__(198);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_grid__ = __webpack_require__(201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_men__ = __webpack_require__(204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_festina__ = __webpack_require__(207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_festinadepot__ = __webpack_require__(210);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_bourdima__ = __webpack_require__(213);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_bourdimafossil__ = __webpack_require__(216);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_bourdimaarmani__ = __webpack_require__(219);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_bourdimadiesel__ = __webpack_require__(222);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_productref__ = __webpack_require__(225);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_bourdimaMichaelkors__ = __webpack_require__(228);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_bourdima2__ = __webpack_require__(231);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_royal__ = __webpack_require__(234);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_police__ = __webpack_require__(237);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_cerruti__ = __webpack_require__(240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__components_promo__ = __webpack_require__(243);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__components_lotus__ = __webpack_require__(246);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__components_versus__ = __webpack_require__(249);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__components_trussardi__ = __webpack_require__(252);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__components_MONTIGNAC__ = __webpack_require__(255);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__components_armani__ = __webpack_require__(258);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__components_nautica__ = __webpack_require__(261);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__components_maserati__ = __webpack_require__(264);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__components_morellato__ = __webpack_require__(267);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__components_timberland__ = __webpack_require__(270);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__components_michaelkors__ = __webpack_require__(273);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__components_connectee__ = __webpack_require__(276);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__components_diesel__ = __webpack_require__(279);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__components_top__ = __webpack_require__(282);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__components_fossil__ = __webpack_require__(285);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__components_women__ = __webpack_require__(288);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__components_achatmobile__ = __webpack_require__(291);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__components_about__ = __webpack_require__(294);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__components_achat__ = __webpack_require__(297);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__components_contact__ = __webpack_require__(300);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__components_userprofile__ = __webpack_require__(303);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46_vue_router__ = __webpack_require__(304);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47__store__ = __webpack_require__(88);




















































__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_46_vue_router__["a" /* default */]);

//used for lazy-loaded component used it for homepage only
//const HomePage = resolve => require(['../components/home.vue'], resolve);

var router = new __WEBPACK_IMPORTED_MODULE_46_vue_router__["a" /* default */]({
  // mode: 'history',
  routes: [{
    path: '/',
    name: 'default',
    component: __WEBPACK_IMPORTED_MODULE_1__components_home__["a" /* default */]
  }, {
    path: '/user',
    name: 'user',
    component: __WEBPACK_IMPORTED_MODULE_45__components_userprofile__["a" /* default */],
    meta: {
      requiresAuth: true
    }
  }, {
    path: '/about',
    name: 'about',
    component: __WEBPACK_IMPORTED_MODULE_42__components_about__["a" /* default */]
  }, {
    path: '/achat',
    name: 'achat',
    component: __WEBPACK_IMPORTED_MODULE_43__components_achat__["a" /* default */]
  }, {
    path: '/achatmobile',
    name: 'achatmobile',
    component: __WEBPACK_IMPORTED_MODULE_41__components_achatmobile__["a" /* default */]
  }, {
    path: '/contact',
    name: 'contact',
    component: __WEBPACK_IMPORTED_MODULE_44__components_contact__["a" /* default */]
  }, {
    path: '/checkout',
    name: 'checkout',
    component: __WEBPACK_IMPORTED_MODULE_4__components_checkout_checkadress__["a" /* default */]
  }, {
    path: '/shipping',
    name: 'shipping',
    component: __WEBPACK_IMPORTED_MODULE_5__components_checkout_shipping__["a" /* default */]
  }, {
    path: '/all',
    name: 'all',
    component: __WEBPACK_IMPORTED_MODULE_9__components_all__["a" /* default */]
  }, {
    path: '/vipclient',
    name: 'VIPCLIENT',
    component: __WEBPACK_IMPORTED_MODULE_10__components_vipclient__["a" /* default */]
  }, {
    path: '/product:ref',
    name: 'productref',
    component: __WEBPACK_IMPORTED_MODULE_19__components_productref__["a" /* default */]
  }, {
    path: '/festinadepot',
    name: 'festinadepot',
    component: __WEBPACK_IMPORTED_MODULE_14__components_festinadepot__["a" /* default */]
  }, {
    path: '/festina',
    name: 'festina',
    component: __WEBPACK_IMPORTED_MODULE_13__components_festina__["a" /* default */]
  }, {
    path: '/bourdima',
    name: 'bourdima',
    component: __WEBPACK_IMPORTED_MODULE_15__components_bourdima__["a" /* default */]
  }, {
    path: '/promo',
    name: 'promo',
    component: __WEBPACK_IMPORTED_MODULE_25__components_promo__["a" /* default */]
  }, {
    path: '/bourdima2',
    name: 'bourdima2',
    component: __WEBPACK_IMPORTED_MODULE_21__components_bourdima2__["a" /* default */]
  }, {
    path: '/bourdimafossil',
    name: 'bourdimafossil',
    component: __WEBPACK_IMPORTED_MODULE_16__components_bourdimafossil__["a" /* default */]
  }, {
    path: '/bourdimaMichaelkors',
    name: 'bourdimaMichaelkors',
    component: __WEBPACK_IMPORTED_MODULE_20__components_bourdimaMichaelkors__["a" /* default */]
  }, {
    path: '/bourdimaarmani',
    name: 'bourdimaarmani',
    component: __WEBPACK_IMPORTED_MODULE_17__components_bourdimaarmani__["a" /* default */]
  }, {
    path: '/bourdimadiesel',
    name: 'bourdimadiesel',
    component: __WEBPACK_IMPORTED_MODULE_18__components_bourdimadiesel__["a" /* default */]
  }, {
    path: '/armani',
    name: 'armani',
    component: __WEBPACK_IMPORTED_MODULE_30__components_armani__["a" /* default */]
  }, {
    path: '/maserati',
    name: 'maserati',
    component: __WEBPACK_IMPORTED_MODULE_32__components_maserati__["a" /* default */]
  }, {
    path: '/nautica',
    name: 'nautica',
    component: __WEBPACK_IMPORTED_MODULE_31__components_nautica__["a" /* default */]
  }, {
    path: '/morellato',
    name: 'morellato',
    component: __WEBPACK_IMPORTED_MODULE_33__components_morellato__["a" /* default */]
  }, {
    path: '/timberland',
    name: 'timberland',
    component: __WEBPACK_IMPORTED_MODULE_34__components_timberland__["a" /* default */]
  }, {
    path: '/productref/:ref',
    name: 'productrefd',
    component: __WEBPACK_IMPORTED_MODULE_19__components_productref__["a" /* default */]
  }, {
    path: '/royal',
    name: 'royal',
    component: __WEBPACK_IMPORTED_MODULE_22__components_royal__["a" /* default */]
  }, {
    path: '/diesel',
    name: 'diesel',
    component: __WEBPACK_IMPORTED_MODULE_37__components_diesel__["a" /* default */]
  }, {
    path: '/top',
    name: 'top',
    component: __WEBPACK_IMPORTED_MODULE_38__components_top__["a" /* default */]
  }, {
    path: '/cerruti',
    name: 'cerruti',
    component: __WEBPACK_IMPORTED_MODULE_24__components_cerruti__["a" /* default */]
  }, {
    path: '/lotus',
    name: 'lotus',
    component: __WEBPACK_IMPORTED_MODULE_26__components_lotus__["a" /* default */]
  }, {
    path: '/versus',
    name: 'versus',
    component: __WEBPACK_IMPORTED_MODULE_27__components_versus__["a" /* default */]
  }, {
    path: '/trussardi',
    name: 'trussardi',
    component: __WEBPACK_IMPORTED_MODULE_28__components_trussardi__["a" /* default */]
  }, {
    path: '/MONTIGNAC',
    name: 'MONTIGNAC',
    component: __WEBPACK_IMPORTED_MODULE_29__components_MONTIGNAC__["a" /* default */]
  }, {
    path: '/fossil',
    name: 'fossil',
    component: __WEBPACK_IMPORTED_MODULE_39__components_fossil__["a" /* default */]
  }, {
    path: '/michaelkors',
    name: 'michaelkors',
    component: __WEBPACK_IMPORTED_MODULE_35__components_michaelkors__["a" /* default */]
  }, {
    path: '/connectee',
    name: 'connectee',
    component: __WEBPACK_IMPORTED_MODULE_36__components_connectee__["a" /* default */]
  }, {
    path: '/men',
    name: 'men',
    component: __WEBPACK_IMPORTED_MODULE_12__components_men__["a" /* default */]
  }, {
    path: '/women',
    name: 'women',
    component: __WEBPACK_IMPORTED_MODULE_40__components_women__["a" /* default */]
  }, {
    path: '/payment',
    name: 'payment',
    component: __WEBPACK_IMPORTED_MODULE_6__components_checkout_payment__["a" /* default */]
  }, {
    path: '/review',
    name: 'review',
    component: __WEBPACK_IMPORTED_MODULE_7__components_checkout_review__["a" /* default */]
  }, {
    path: '/complete',
    name: 'complete',
    component: __WEBPACK_IMPORTED_MODULE_8__components_checkout_complete__["a" /* default */]
  }, {
    path: '/cart',
    name: 'cart',
    component: __WEBPACK_IMPORTED_MODULE_2__components_cart__["a" /* default */]
  }, {
    path: '/product',
    name: 'product',
    component: __WEBPACK_IMPORTED_MODULE_3__components_product__["a" /* default */]
  }, {
    path: '/grid',
    name: 'grid',
    component: __WEBPACK_IMPORTED_MODULE_11__components_grid__["a" /* default */]
  }],
  //linkActiveClass: "active",
  linkExactActiveClass: "active",
  scrollBehavior: function scrollBehavior(to, from, savedPosition) {
    return {
      x: 0,
      y: 0
    };
  }
});

router.beforeEach(function (to, from, next) {
  var requiresAuth = to.matched.some(function (record) {
    return record.meta.requiresAuth;
  });
  var userauth = JSON.parse(localStorage.getItem('auth'));
  console.log(userauth);
  if (requiresAuth && !userauth) {
    next('/');
  } else {
    next();
  }
});

/* harmony default export */ __webpack_exports__["a"] = (router);

/*export default new Router({
  mode: 'history',
  routes: [{
      path: '/',
      name: 'default',
      component: home
    },
    {
      path: '/user',
      name: 'user',
      component: userprofile,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/about',
      name: about,
      component: about
    },
    {
      path: '/contact',
      name: contact,
      component: contact
    },
    {
      path: '/checkout',
      name: 'checkout',
      component: checkadress
    },
    {
      path: '/shipping',
      name: 'shipping',
      component: shipping
    },
    {
      path: '/all',
      name: 'all',
      component: all
    },
    {
      path: '/men',
      name: 'men',
      component: men
    },
    {
      path: '/women',
      name: 'women',
      component: women
    },
    {
      path: '/payment',
      name: 'payment',
      component: payment
    },
    {
      path: '/review',
      name: 'review',
      component: review
    },
    {
      path: '/complete',
      name: 'complete',
      component: complete
    },
    {
      path: '/cart',
      name: 'cart',
      component: cart
    },
    {
      path: '/product',
      name: 'product',
      component: product
    },
    {
      path: '/grid',
      name: 'grid',
      component: grid
    }
  ],
  //linkActiveClass: "active",
  linkExactActiveClass: "active",
  scrollBehavior(to, from, savedPosition) {
    return {
      x: 0,
      y: 0
    }
  }*/

/***/ }),
/* 167 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_home_vue__ = __webpack_require__(41);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4b146c59_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_home_vue__ = __webpack_require__(172);
function injectStyle (ssrContext) {
  __webpack_require__(168)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4b146c59"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_home_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4b146c59_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_home_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 168 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._m(0),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('div',{staticClass:"wsite-section wsite-body-section wsite-background-1 wsite-custom-background"},[_c('div',{staticClass:"wsite-section-content"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"wsite-section-elements"},[_vm._m(2),_vm._v(" "),_c('div',[_c('div',{staticClass:"wsite-multicol"},[_c('div',{staticClass:"wsite-multicol-table-wrap",staticStyle:{"margin":"0 -5px"}},[_c('table',{staticClass:"wsite-multicol-table"},[_c('tbody',{staticClass:"wsite-multicol-tbody"},[_c('td',{staticClass:"wsite-multicol-col",staticStyle:{"width":"50%","padding":"0 5px"}},[_c('div',[_c('router-link',{staticClass:"wsite-image wsite-image-border-none ",staticStyle:{"padding-top":"10px","padding-bottom":"5px","margin-left":"0","margin-right":"0","text-align":"center"},attrs:{"to":"/women"}},[_c('a',[_c('img',{staticStyle:{"width":"auto","max-width":"100%"},attrs:{"src":"/womenmobile.jpg","alt":"Picture"}})]),_vm._v(" "),_c('div',{staticStyle:{"display":"block","font-size":"90%"}})])],1)]),_vm._v(" "),_c('td',{staticClass:"wsite-multicol-col",staticStyle:{"width":"50%","padding":"0 5px"}},[_c('div',[_c('router-link',{staticClass:"wsite-image wsite-image-border-none",staticStyle:{"padding-top":"10px","padding-bottom":"5px","margin-left":"0","margin-right":"0","text-align":"center"},attrs:{"to":"/men"}},[_c('a',[_c('img',{staticStyle:{"width":"auto","max-width":"100%"},attrs:{"src":"/luipc.jpg","alt":"Picture"}})]),_vm._v(" "),_c('div',{staticStyle:{"display":"block","font-size":"90%"}})])],1)])])])])])])])])])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('section',{staticClass:"container-fluid bg-bg-secondary padding-bottom-3x pb-5"},[_vm._m(3),_vm._v(" "),_c('div',{staticClass:"owl-carousel",attrs:{"id":"top-category"}},_vm._l((_vm.products),function(product){return _c('div',{key:product.id},[_c('div',{staticClass:"card"},[_c('router-link',{attrs:{"to":"/product"},nativeOn:{"click":function($event){_vm.ProductDetail(product)}}},[_c('img',{staticClass:"card-img-top",attrs:{"src":product.photo,"alt":"Card image"}})]),_vm._v(" "),_c('div',{staticClass:"card-body"},[_c('h3',{staticClass:"product-card-title"},[_c('b',[_c('strong',[_vm._v(_vm._s(product.description))])])]),_vm._v(" "),_c('span',{staticClass:"h6 d-block"},[_c('del',{staticClass:"text-muted text-normal"}),_vm._v(" "+_vm._s(product.price)+" DA")]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary btn-sm",on:{"click":function($event){_vm.addToCart(product)}}},[_c('strong',[_vm._v("Ajouter au panier")])])])],1)])}))]),_vm._v(" "),_c('section',{staticClass:"container-fluid bg-bg-secondary padding-bottom-3x pb-5"},[_vm._m(4),_vm._v(" "),_c('div',{staticClass:"owl-carousel",attrs:{"id":"top-categoryH"}},_vm._l((_vm.products2),function(product){return _c('div',{key:product.id},[_c('div',{staticClass:"card"},[_c('router-link',{attrs:{"to":"/product"},nativeOn:{"click":function($event){_vm.ProductDetail2(product)}}},[_c('img',{staticClass:"card-img-top",attrs:{"src":product.photo,"alt":"Card image"}})]),_vm._v(" "),_c('div',{staticClass:"card-body"},[_c('h3',{staticClass:"product-card-title"},[_c('b',[_c('strong',[_vm._v(_vm._s(product.description))])])]),_vm._v(" "),_c('span',{staticClass:"h6 d-block"},[_c('del',{staticClass:"text-muted text-normal"}),_vm._v(" "+_vm._s(product.price)+" DA")]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary btn-sm",on:{"click":function($event){_vm.addToCart(product)}}},[_c('strong',[_vm._v("Ajouter au panier")])])])],1)])}))]),_vm._v(" "),_vm._m(5)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"bg"},[_c('span',{staticClass:"overlay",staticStyle:{"background-color":"#000","opacity":".5"}}),_vm._v(" "),_c('div',{staticClass:"bg"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"container padding-top-0x padding-bottom-0x"},[_c('div',{staticClass:"owl-carousel",attrs:{"id":"mhdfeature"}},[_c('div',{staticClass:"text-center"},[_c('span',{staticClass:"d-block display-4 text-gray-light mb-4"},[_c('i',{staticClass:"material-icons flight"})]),_vm._v(" "),_c('h4',{staticClass:"h6 mb-2"},[_c('strong',[_vm._v("LIVRAISON EXPRESS ET GRATUITE ")])]),_vm._v(" "),_c('p',{staticClass:"text-sm text-muted mb-0"},[_vm._v(" lIVRAISON GRATUITE POUR LES 48 WILAYAS")])]),_vm._v(" "),_c('div',{staticClass:"text-center"},[_c('span',{staticClass:"d-block display-4 text-gray-light mb-4"},[_c('i',{staticClass:"material-icons autorenew"})]),_vm._v(" "),_c('h4',{staticClass:"h6 mb-2"},[_c('strong',[_vm._v(" GARANTIE DE DEUX ANS ")])]),_vm._v(" "),_c('p',{staticClass:"text-sm text-muted mb-0"},[_vm._v("Garantie de deux (02) ans sur tous nos produits ")])]),_vm._v(" "),_c('div',{staticClass:"text-center"},[_c('span',{staticClass:"d-block display-4 text-gray-light mb-4"},[_c('i',{staticClass:"material-icons headset_mic"})]),_vm._v(" "),_c('h4',{staticClass:"h6 mb-2"},[_c('strong',[_vm._v(" 24/7 Support en ligne ")])]),_vm._v(" "),_c('p',{staticClass:"text-sm text-muted mb-0"},[_vm._v("Assistance clientèle 24/7")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"wsite-multicol"},[_c('div',{staticClass:"wsite-multicol-table-wrap",staticStyle:{"margin":"0 -15px"}},[_c('table',{staticClass:"wsite-multicol-table"},[_c('tbody',{staticClass:"wsite-multicol-tbody"},[_c('td',{staticClass:"wsite-multicol-col",staticStyle:{"width":"25.151515151515%","padding":"0 15px"}},[_c('div',{staticClass:"wsite-spacer",staticStyle:{"height":"50px"}})]),_vm._v(" "),_c('td',{staticClass:"wsite-multicol-col",staticStyle:{"width":"50.20202020202%","padding":"0 15px"}}),_vm._v(" "),_c('td',{staticClass:"wsite-multicol-col",staticStyle:{"width":"24.646464646465%","padding":"0 15px"}},[_c('div',{staticClass:"wsite-spacer",staticStyle:{"height":"50px"}})])])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-center"},[_c('h6',{staticClass:"h6 mb-2"},[_c('strong',[_vm._v(" Nouveautés FEMME ")])]),_vm._v(" "),_c('h6',[_c('p',{staticClass:"text-sm text-muted mb-0"},[_c('strong',[_vm._v("Découvrez les nouveautés qui viennent d'arriver chez LUXURY SHOP DZ ! ")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-center"},[_c('h6',{staticClass:"h6 mb-2"},[_c('strong',[_vm._v(" Nouveautés HOMME")])]),_vm._v(" "),_c('h6',[_c('p',{staticClass:"text-sm text-muted mb-0"},[_c('strong',[_vm._v("Découvrez les nouveautés qui viennent d'arriver chez LUXURY SHOP DZ ! ")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"container-fluid bg-bg-secondary padding-bottom-3x pb-5"},[_c('div',{attrs:{"id":"top-category2"}},[_c('div',[_c('div',{staticClass:"card"},[_c('div',{staticClass:"d-flex justify-content-center",staticStyle:{"background-image":"url(static/img/main-bg.jpg)"}},[_c('div',{staticClass:"px-3 text-center"},[_c('img',{staticStyle:{"border":"solid 2px #000000"},attrs:{"src":"/mklogo.jpg","alt":"Category"}}),_vm._v(" "),_c('h2',{staticClass:"display-2 text-bold text-white text-shadow"}),_vm._v(" "),_c('div',{staticClass:"view-button"},[_c('a',{staticClass:"btn btn-primary",attrs:{"href":"/#/Michaelkors"}},[_vm._v("Voir la collection")])])])]),_vm._v(" "),_c('div',{staticClass:"d-flex justify-content-center",staticStyle:{"background-image":"url(static/img/main-bg.jpg)"}},[_c('div',{staticClass:"px-3 text-center"},[_c('img',{staticStyle:{"border":"solid 2px #000000"},attrs:{"src":"/festina-logo.jpg","alt":"Category"}}),_vm._v(" "),_c('h2',{staticClass:"display-2 text-bold text-white text-shadow"}),_vm._v(" "),_c('div',{staticClass:"view-button"},[_c('a',{staticClass:"btn btn-primary",attrs:{"href":"/#/festina"}},[_vm._v("Voir la collection")])])])]),_vm._v(" "),_c('div',{staticClass:"d-flex justify-content-center",staticStyle:{"background-image":"url(static/img/main-bg.jpg)"}},[_c('div',{staticClass:"px-3 text-center"},[_c('img',{staticStyle:{"border":"solid 2px #000000"},attrs:{"src":"/axlogo.jpg","alt":"Category"}}),_vm._v(" "),_c('h2',{staticClass:"display-2 text-bold text-white text-shadow"}),_vm._v(" "),_c('div',{staticClass:"view-button"},[_c('a',{staticClass:"btn btn-primary",attrs:{"href":"/#/armani"}},[_vm._v("Voir la collection")])])])]),_vm._v(" "),_c('div',{staticClass:"d-flex justify-content-center",staticStyle:{"background-image":"url(static/img/main-bg.jpg)"}},[_c('div',{staticClass:"px-3 text-center"},[_c('img',{staticStyle:{"border":"solid 2px #000000"},attrs:{"src":"/fossillogo.jpg","alt":"Category"}}),_vm._v(" "),_c('h2',{staticClass:"display-2 text-bold text-white text-shadow"}),_vm._v(" "),_c('div',{staticClass:"view-button"},[_c('a',{staticClass:"btn btn-primary",attrs:{"href":"/#/fossil"}},[_vm._v("Voir la collection")])])])])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 173 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_cart_vue__ = __webpack_require__(44);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1e12816a_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_cart_vue__ = __webpack_require__(175);
function injectStyle (ssrContext) {
  __webpack_require__(174)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1e12816a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_cart_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1e12816a_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_cart_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 174 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 175 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mr-top-30"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"container padding-bottom-3x mb-1"},[(true)?_c('div',{staticClass:"alert alert-info alert-dismissible fade show text-center",attrs:{"id":"alert"}},[_c('span',{staticClass:"alert-close",attrs:{"data-dismiss":"alert"}}),_c('i',{staticClass:"material-icons redeem lead"}),_vm._v("  "),_c('strong',[_vm._v("VOTRE PANIER")])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"table-responsive shopping-cart"},[_c('table',{staticClass:"table"},[_c('thead',[_c('tr',[_c('th',[_vm._v("Référence (s)")]),_vm._v(" "),_c('th',{staticClass:"text-center"},[_vm._v("Quantité")]),_vm._v(" "),_c('th',{staticClass:"text-center"},[_vm._v("Prix")]),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('th',{staticClass:"text-center"},[_vm._v("Total")]),_vm._v(" "),_c('th',{staticClass:"text-center"},[_c('a',{staticClass:"btn btn-sm btn-outline-danger",attrs:{"href":"#"},on:{"click":function($event){_vm.clearCart()}}},[_vm._v("Vider votre panier")])])])]),_vm._v(" "),_c('tbody',_vm._l((_vm.products),function(product){return _c('tr',{key:product.id},[_c('td',[_c('div',{staticClass:"product-item"},[_c('a',{staticClass:"product-thumb",attrs:{"href":"shop-single.html"}},[_c('img',{attrs:{"src":product.img,"alt":"Product"}})]),_vm._v(" "),_c('div',{staticClass:"product-info"},[_c('h4',{staticClass:"product-title"},[_c('a',{attrs:{"href":"shop-single.html"}},[_vm._v(_vm._s(product.id))])]),_c('span',[_c('em',[_vm._v("Marque:")]),_vm._v(" "+_vm._s(product.name))]),_c('span',[_c('em',[_vm._v("Description : ")]),_vm._v(_vm._s(product.description))])])])]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_c('div',{staticClass:"count-input"},[_c('div',[_vm._v("\n                  "+_vm._s(product.quantity)+"\n                ")])])]),_vm._v(" "),_c('td',{staticClass:"text-center text-lg text-medium"},[_vm._v(_vm._s(product.price))]),_vm._v(" "),_c('td',{staticClass:"text-center text-lg text-medium"},[_vm._v(_vm._s(product.price))]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_c('a',{staticClass:"remove-from-cart",attrs:{"href":"#","data-toggle":"tooltip","title":"Remove item"},on:{"click":function($event){_vm.removeItem(product)}}},[_c('i',{staticClass:"material-icons icon_close"})])])])}))])]),_vm._v(" "),_c('div',{staticClass:"shopping-cart-footer"},[_c('div',{staticClass:"column text-lg"},[_vm._v("Total à payer: "),_c('span',{staticClass:"text-medium text-dark"},[_vm._v(_vm._s(_vm.total)+" DA")])])]),_vm._v(" "),_c('div',{staticClass:"shopping-cart-footer"},[_c('div',{staticClass:"column"},[_c('router-link',{staticClass:"btn btn-outline-secondary",attrs:{"to":"/all"}},[_c('i',{staticClass:"icon-arrow-left"}),_vm._v(" Retour à l'accueil")])],1),_vm._v(" "),_c('div',{staticClass:"column"},[_c('router-link',{staticClass:"btn btn-success",attrs:{"to":"/checkout","disabled":!_vm.products.length}},[_vm._v("Commander")])],1)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-title"},[_c('div',{staticClass:"container"},[_c('h1',[_vm._v("Votre Panier")]),_vm._v(" "),_c('ul',{staticClass:"breadcrumbs"},[_c('li',[_c('a',{attrs:{"href":"index.html"}},[_vm._v("Accueil")])]),_vm._v(" "),_c('li',{staticClass:"separator"},[_vm._v(" / ")]),_vm._v(" "),_c('li',[_vm._v("Panier")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"view-button"},[_c('a',{staticClass:"btn btn-danger",attrs:{"href":"/#/promo"}},[_vm._v("Bénificier de la promo")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 176 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_product_vue__ = __webpack_require__(45);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ea56527c_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_product_vue__ = __webpack_require__(178);
function injectStyle (ssrContext) {
  __webpack_require__(177)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-ea56527c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_product_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ea56527c_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_product_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 177 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 178 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"bg-secondary pb-4 padding-top-3x mt-30"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6 mb-30"},[_c('div',{staticClass:"product-gallery"},[(_vm.product.sales)?_c('span',{staticClass:"product-badge text-danger"},[_vm._v("\n             "+_vm._s(_vm.product.discount))]):_vm._e(),_vm._v(" "),_c('v-zoom',{attrs:{"img":_vm.product.img,"width":555,"magnify":1}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-md-6 mb-30"},[_c('div',{staticClass:"card border-default bg-white pt-2 box-shadow"},[_c('div',{staticClass:"card-body"},[_c('h2',{staticClass:"mb-3"},[_c('strong',[_vm._v(_vm._s(_vm.product.name))])]),_vm._v(" "),_c('h3',{staticClass:"text-normal"},[_c('strong',[_vm._v(_vm._s(_vm.product.price)+" DA")])]),_vm._v(" "),_c('p',{staticClass:"text-sm text-muted"},[_c('strong',[_vm._v(_vm._s(_vm.product.description))])]),_vm._v(" "),_c('div',{staticClass:"row align-items-end mb-4"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"accordion",attrs:{"id":"accordion1","role":"tablist"}}),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('div',{staticClass:"pt-4 hidden-sm-up"}),_vm._v(" "),_c('button',{staticClass:"btn btn-primary btn-block my-0",on:{"click":function($event){_vm.addToCart(_vm.product)}}},[_vm._v("Ajouter au panier")])])]),_vm._v(" "),_c('ul',{staticClass:"list-unstyled text-sm mb-4"},[_c('li',[_c('span',{staticClass:"text-dark text-medium"},[_vm._v("Reférence:")]),_vm._v(" "+_vm._s(_vm.product.id))]),_vm._v(" "),_c('li',[_c('span',{staticClass:"text-dark text-medium"},[_vm._v("Categories:")]),_vm._v(" "),_c('a',{staticClass:"navi-link",attrs:{"href":"#"}},[_vm._v("Montre")]),_vm._v(" "),_c('a',{staticClass:"navi-link",attrs:{"href":"#"}},[_vm._v(_vm._s(_vm.product.name))])])]),_vm._v(" "),_vm._m(2)])])])])])]),_vm._v(" "),_c('div',{staticClass:"container padding-bottom-3x pt-5 mb-1"})])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form',{staticClass:"modal fade",attrs:{"method":"post","id":"leaveReview","tabindex":"-1"}},[_c('div',{staticClass:"modal-dialog modal-lg"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_c('h4',{staticClass:"modal-title"},[_vm._v("Leave a Review")]),_vm._v(" "),_c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"review-name"}},[_vm._v("Your Name")]),_vm._v(" "),_c('input',{staticClass:"form-control",attrs:{"type":"text","id":"review-name","required":""}})])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"review-email"}},[_vm._v("Your Email")]),_vm._v(" "),_c('input',{staticClass:"form-control",attrs:{"type":"email","id":"review-email","required":""}})])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"review-subject"}},[_vm._v("Subject")]),_vm._v(" "),_c('input',{staticClass:"form-control",attrs:{"type":"text","id":"review-subject","required":""}})])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"review-rating"}},[_vm._v("Rating")]),_vm._v(" "),_c('select',{staticClass:"form-control",attrs:{"id":"review-rating"}},[_c('option',[_vm._v("5 Stars")]),_vm._v(" "),_c('option',[_vm._v("4 Stars")]),_vm._v(" "),_c('option',[_vm._v("3 Stars")]),_vm._v(" "),_c('option',[_vm._v("2 Stars")]),_vm._v(" "),_c('option',[_vm._v("1 Star")])])])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"review-message"}},[_vm._v("Review")]),_vm._v(" "),_c('textarea',{staticClass:"form-control",attrs:{"id":"review-message","rows":"8","required":""}})])]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"submit"}},[_vm._v("Submit Review")])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-sd-4"},[_c('div',{staticClass:"form-group mb-0"},[_c('p',{staticClass:"text-normal"},[_c('strong',[_vm._v("      Garantie : 24 mois    ")])]),_vm._v(" "),_c('p',{staticClass:"text-normal"},[_c('strong',[_vm._v("      Service aprés vente    ")])]),_vm._v(" "),_c('p',{staticClass:"text-normal"},[_c('strong',[_vm._v("     Livraison gratuite     ")])]),_vm._v(" "),_c('br')])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex flex-wrap justify-content-between align-items-center"},[_c('div',{staticClass:"py-2"},[_c('a',{staticClass:"social-button shape-rounded sb-facebook",attrs:{"href":"#","data-toggle":"tooltip","data-placement":"top","title":"Facebook"}},[_c('i',{staticClass:"socicon-facebook"})]),_vm._v(" "),_c('a',{staticClass:"social-button shape-rounded sb-twitter",attrs:{"href":"#","data-toggle":"tooltip","data-placement":"top","title":"Twitter"}},[_c('i',{staticClass:"socicon-twitter"})]),_vm._v(" "),_c('a',{staticClass:"social-button shape-rounded sb-instagram",attrs:{"href":"#","data-toggle":"tooltip","data-placement":"top","title":"Instagram"}},[_c('i',{staticClass:"socicon-instagram"})]),_vm._v(" "),_c('a',{staticClass:"social-button shape-rounded sb-google-plus",attrs:{"href":"#","data-toggle":"tooltip","data-placement":"top","title":"Google +"}},[_c('i',{staticClass:"socicon-googleplus"})])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 179 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_checkadress_vue__ = __webpack_require__(47);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6f3f4ee6_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_checkadress_vue__ = __webpack_require__(181);
function injectStyle (ssrContext) {
  __webpack_require__(180)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6f3f4ee6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_checkadress_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6f3f4ee6_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_checkadress_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 180 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 181 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"page-title"},[_c('div',{staticClass:"container"},[_vm._m(0),_vm._v(" "),_c('ul',{staticClass:"breadcrumbs"},[_c('li',[_c('router-link',{attrs:{"to":"/"}},[_c('strong',[_vm._v(" Home ")])])],1),_vm._v(" "),_c('li',{staticClass:"separator"},[_vm._v(" / ")]),_vm._v(" "),_vm._m(1)])])]),_vm._v(" "),_c('div',{staticClass:"container padding-bottom-3x mb-2"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-9 col-lg-8"},[_vm._m(2),_vm._v(" "),_c('hr',{staticClass:"padding-bottom-1x"}),_vm._v(" "),_c('form',[_c('div',{staticClass:"row"},[(!_vm.isAuthenticated)?_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group"},[_vm._m(3),_vm._v(" "),_vm._m(4),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:({required:true, regex:/^[0]([5-6-7]{1}[0-9]{2}[0-9]{2}[0-9]{2}[0-9]{2})$/ }),expression:"{required:true, regex:/^[0]([5-6-7]{1}[0-9]{2}[0-9]{2}[0-9]{2}[0-9]{2})$/ }"},{name:"model",rawName:"v-model",value:(_vm.phoneNumber),expression:"phoneNumber"}],staticClass:"form-control",attrs:{"name":"phone","type":"number"},domProps:{"value":(_vm.phoneNumber)},on:{"input":function($event){if($event.target.composing){ return; }_vm.phoneNumber=$event.target.value}}}),_vm._v(" "),_c('span',{staticClass:"alert-box alert-danger"},[_vm._v(_vm._s(_vm.errors.first('phone')))])])]):_vm._e()])]),_vm._v(" "),_c('hr',{staticClass:"padding-bottom-1x"}),_vm._v(" "),_c('div',{staticClass:"d-flex justify-content-between"},[_c('router-link',{staticClass:"btn btn-outline-secondary m-0",attrs:{"to":"/cart"}},[_c('strong',[_vm._v(" Retour ")])]),_vm._v(" "),_c('router-link',{staticClass:"btn btn-primary m-0",attrs:{"to":"/payment","disabled":!_vm.isComplete},nativeOn:{"click":function($event){_vm.user_info(_vm.phoneNumber)}}},[_c('strong',[_vm._v(" Valider ")])])],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-4"},[_c('aside',{staticClass:"sidebar"},[_c('div',{staticClass:"padding-top-2x hidden-lg-up"}),_vm._v(" "),_c('section',{staticClass:"widget widget-order-summary bg-secondary border-0 p-4"},[_vm._m(5),_vm._v(" "),_c('table',{staticClass:"table text-sm mb-0"},[_c('tr',[_vm._m(6),_vm._v(" "),_c('td',{staticClass:"text-medium"},[_c('strong',[_vm._v(" "+_vm._s(_vm.total)+" DA ")])])]),_vm._v(" "),_vm._m(7),_vm._v(" "),_c('tr',[_c('td'),_vm._v(" "),_c('td',{staticClass:"text-lg text-medium"},[_c('strong',[_vm._v(" "+_vm._s(_vm.total)+" DA ")])])])])])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h1',[_c('strong',[_vm._v(" Paiement rapide ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',[_c('strong',[_vm._v(" Paiement rapide ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h4',[_c('strong',[_vm._v(" Remplissez votre numéro de téléphone ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{attrs:{"for":"phone"}},[_c('strong',[_vm._v("Téléphone portable: *")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{attrs:{"for":"phone"}},[_c('strong',[_vm._v("رقم الهاتف")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h3',{staticClass:"widget-title"},[_c('strong',[_vm._v(" Récapitulatif de la commande ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',[_c('strong',[_vm._v(" Total: ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('td',[_c('strong',[_vm._v(" frais de livraison: ")])]),_vm._v(" "),_c('td',{staticClass:"text-medium"},[_c('strong',[_vm._v(" 0.00 DA ")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 182 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_shipping_vue__ = __webpack_require__(48);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_07f82964_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_shipping_vue__ = __webpack_require__(184);
function injectStyle (ssrContext) {
  __webpack_require__(183)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-07f82964"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_shipping_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_07f82964_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_shipping_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 183 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 184 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"page-title"},[_c('div',{staticClass:"container"},[_c('h1',[_vm._v("Shipping")]),_vm._v(" "),_c('ul',{staticClass:"breadcrumbs"},[_c('li',[_c('router-link',{attrs:{"to":"/home"}},[_vm._v("Home")])],1),_vm._v(" "),_c('li',{staticClass:"separator"},[_vm._v(" / ")]),_vm._v(" "),_c('li',[_vm._v("Shipping")])])])]),_vm._v(" "),_c('div',{staticClass:"container padding-bottom-3x mb-2"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-9 col-lg-8"},[_c('div',{staticClass:"steps flex-sm-nowrap mb-5"},[_c('router-link',{staticClass:"step",attrs:{"to":"/checkout"}},[_c('h4',{staticClass:"step-title"},[_c('i',{staticClass:"material-icons check_circle"}),_vm._v("1. Address")])]),_vm._v(" "),_c('router-link',{staticClass:"step active",attrs:{"to":"/checkout"}},[_c('h4',{staticClass:"step-title"},[_vm._v("2. Shipping")])]),_c('router-link',{staticClass:"step",attrs:{"to":"/payment"}},[_c('h4',{staticClass:"step-title"},[_vm._v("3. Payment")])]),_c('router-link',{staticClass:"step",attrs:{"to":"/checkout"}},[_c('h4',{staticClass:"step-title"},[_vm._v("4. Review")])])],1),_vm._v(" "),_c('h4',[_vm._v("Choose Shipping Method")]),_vm._v(" "),_c('hr',{staticClass:"padding-bottom-1x"}),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('hr',{staticClass:"padding-bottom-1x"}),_vm._v(" "),_c('div',{staticClass:"d-flex justify-content-between"},[_c('router-link',{staticClass:"btn btn-outline-secondary m-0",attrs:{"to":"/checkout"}},[_vm._v("Back")]),_c('router-link',{staticClass:"btn btn-primary m-0",attrs:{"to":"/payment"}},[_vm._v("Continue")])],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-4"},[_c('aside',{staticClass:"sidebar"},[_c('div',{staticClass:"padding-top-2x hidden-lg-up"}),_vm._v(" "),_c('section',{staticClass:"widget widget-order-summary bg-secondary border-0 p-4"},[_c('h3',{staticClass:"widget-title"},[_vm._v("Order Summary")]),_vm._v(" "),_c('table',{staticClass:"table text-sm mb-0"},[_c('tr',[_c('td',[_vm._v("Cart Subtotal:")]),_vm._v(" "),_c('td',{staticClass:"text-medium"},[_vm._v("$"+_vm._s(_vm.total))])]),_vm._v(" "),_vm._m(1),_vm._v(" "),_vm._m(2)])]),_vm._v(" "),_vm._m(3)])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"table-responsive"},[_c('table',{staticClass:"table table-hover"},[_c('thead',{staticClass:"thead-default"},[_c('tr',[_c('th'),_vm._v(" "),_c('th',[_vm._v("Shipping method")]),_vm._v(" "),_c('th',[_vm._v("Delivery time")]),_vm._v(" "),_c('th',[_vm._v("Handling fee")])])]),_vm._v(" "),_c('tbody',[_c('tr',[_c('td',{staticClass:"align-middle"},[_c('div',{staticClass:"custom-control custom-radio mb-0"},[_c('input',{staticClass:"custom-control-input",attrs:{"type":"radio","id":"local","name":"shipping-method","checked":""}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label",attrs:{"for":"local"}})])]),_vm._v(" "),_c('td',{staticClass:"align-middle"},[_c('span',{staticClass:"text-medium"},[_vm._v("Local Shipping")]),_c('br'),_c('span',{staticClass:"text-muted text-sm"},[_vm._v("All Addresses(default zone), United States & Canada")])]),_vm._v(" "),_c('td',{staticClass:"align-middle"},[_vm._v("1 - 2 days ")]),_vm._v(" "),_c('td',{staticClass:"align-middle"},[_vm._v("$0.00")])]),_vm._v(" "),_c('tr',[_c('td',{staticClass:"align-middle"},[_c('div',{staticClass:"custom-control custom-radio mb-0"},[_c('input',{staticClass:"custom-control-input",attrs:{"type":"radio","id":"flat","name":"shipping-method"}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label",attrs:{"for":"flat"}})])]),_vm._v(" "),_c('td',{staticClass:"align-middle"},[_c('span',{staticClass:"text-medium"},[_vm._v("Fast mail")]),_c('br'),_c('span',{staticClass:"text-muted text-sm"},[_vm._v("All Addresses(default zone)")])]),_vm._v(" "),_c('td',{staticClass:"align-middle"},[_vm._v("1 - 2 days")]),_vm._v(" "),_c('td',{staticClass:"align-middle"},[_vm._v("$0.00")])]),_vm._v(" "),_c('tr',[_c('td',{staticClass:"align-middle"},[_c('div',{staticClass:"custom-control custom-radio mb-0"},[_c('input',{staticClass:"custom-control-input",attrs:{"type":"radio","id":"ups","name":"shipping-method"}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label",attrs:{"for":"ups"}})])]),_vm._v(" "),_c('td',{staticClass:"align-middle"},[_c('span',{staticClass:"text-medium"},[_vm._v("UPS Shipping")]),_c('br'),_c('span',{staticClass:"text-muted text-sm"},[_vm._v("All Addresses(default zone)")])]),_vm._v(" "),_c('td',{staticClass:"align-middle"},[_vm._v("1 - 2 days")]),_vm._v(" "),_c('td',{staticClass:"align-middle"},[_vm._v("$0.00")])]),_vm._v(" "),_c('tr',[_c('td',{staticClass:"align-middle"},[_c('div',{staticClass:"custom-control custom-radio mb-0"},[_c('input',{staticClass:"custom-control-input",attrs:{"type":"radio","id":"pickup","name":"shipping-method"}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label",attrs:{"for":"pickup"}})])]),_vm._v(" "),_c('td',{staticClass:"align-middle"},[_c('span',{staticClass:"text-medium"},[_vm._v("Local Pickup from store")]),_c('br'),_c('span',{staticClass:"text-muted text-sm"},[_vm._v("All Addresses(default zone)")])]),_vm._v(" "),_c('td',{staticClass:"align-middle"},[_vm._v("—")]),_vm._v(" "),_c('td',{staticClass:"align-middle"},[_vm._v("$0.00")])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('td',[_vm._v("Shipping:")]),_vm._v(" "),_c('td',{staticClass:"text-medium"},[_vm._v("$0.00")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('td'),_vm._v(" "),_c('td',{staticClass:"text-lg text-medium"},[_vm._v("$665.32")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fw-section mt-1 px-4 py-5 text-center",staticStyle:{"background-image":"url(static/img/banners/alert-bg.jpg)"}},[_c('h3',{staticClass:"text-white"},[_vm._v("Check our "),_c('br'),_c('span',{staticClass:"text-bold"},[_vm._v("Latest Offers.")]),_c('br'),_vm._v(" Save up to "),_c('span',{staticClass:"text-bold"},[_vm._v("50%")])]),_c('a',{staticClass:"btn btn-primary btn-sm",attrs:{"href":"#"}},[_vm._v("View Offers")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 185 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_payment_vue__ = __webpack_require__(49);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ff726226_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_payment_vue__ = __webpack_require__(187);
function injectStyle (ssrContext) {
  __webpack_require__(186)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-ff726226"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_payment_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ff726226_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_payment_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 186 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 187 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"page-title"},[_c('div',{staticClass:"container"},[_vm._m(0),_vm._v(" "),_c('ul',{staticClass:"breadcrumbs"},[_c('li',[_c('router-link',{attrs:{"to":"/"}},[_vm._v("Home")])],1),_vm._v(" "),_c('li',{staticClass:"separator"},[_vm._v(" / ")]),_vm._v(" "),_vm._m(1)])])]),_vm._v(" "),_c('div',{staticClass:"container padding-bottom-3x mb-2"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-9 col-lg-8"},[_vm._m(2),_vm._v(" "),_vm._m(3),_vm._v(" "),_c('hr',{staticClass:"padding-bottom-1x"}),_vm._v(" "),_c('form',[(!_vm.isAuthenticated)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group"},[_vm._m(4),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.user.firstName),expression:"user.firstName"}],staticClass:"form-control",attrs:{"name":"firstName","type":"text"},domProps:{"value":(_vm.user.firstName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.user, "firstName", $event.target.value)}}}),_vm._v(" "),_c('span',{staticClass:"alert-box alert-danger"},[_vm._v(_vm._s(_vm.errors.first('firstName')))])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group"},[_vm._m(5),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.user.lastName),expression:"user.lastName"}],staticClass:"form-control",attrs:{"name":"lastName","type":"text"},domProps:{"value":(_vm.user.lastName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.user, "lastName", $event.target.value)}}}),_vm._v(" "),_c('span',{staticClass:"alert-box alert-danger"},[_vm._v(_vm._s(_vm.errors.first('lastName')))])])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row"},[(!_vm.isAuthenticated)?_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group"},[_vm._m(6),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.user.email),expression:"user.email"}],staticClass:"form-control",attrs:{"name":"email","type":"email"},domProps:{"value":(_vm.user.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.user, "email", $event.target.value)}}}),_vm._v(" "),_c('span',{staticClass:"alert-box alert-danger"},[_vm._v(_vm._s(_vm.errors.first('email')))])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group"},[_vm._m(7),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.user.address),expression:"user.address"}],staticClass:"form-control",attrs:{"name":"address","type":"text"},domProps:{"value":(_vm.user.address)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.user, "address", $event.target.value)}}}),_vm._v(" "),_c('span',{staticClass:"alert-box alert-danger"},[_vm._v(_vm._s(_vm.errors.first('address')))])])]),_vm._v(" "),(!_vm.isAuthenticated)?_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group"},[_vm._m(8),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.user.phoneNumber),expression:"user.phoneNumber"}],staticClass:"form-control",attrs:{"name":"phoneNumber","type":"phoneNumber","disabled":""},domProps:{"value":(_vm.user.phoneNumber)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.user, "phoneNumber", $event.target.value)}}}),_vm._v(" "),_c('span',{staticClass:"alert-box alert-danger"},[_vm._v(_vm._s(_vm.errors.first('phoneNumber')))])])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group"},[_vm._m(9),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.deliveryWilaya),expression:"deliveryWilaya"}],staticClass:"delivery required form-control input-sm not_unifrom not_uniform ",attrs:{"id":"delivery_id_state","name":"delivery_id_state","data-field-name":"id_state","data-default-value":"","data-required":"1"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.deliveryWilaya=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":""}},[_vm._v("--")]),_c('option',{attrs:{"data-text":"01 - Adrar","data-iso-code":"DZ01","value":"Adrar"}},[_vm._v("01 - Adrar")]),_c('option',{attrs:{"data-text":"02 - Chlef","data-iso-code":"DZ02","value":"Chlef"}},[_vm._v("02 - Chlef")]),_c('option',{attrs:{"data-text":"03 - Laghouat","data-iso-code":"DZ03","value":"Laghouat"}},[_vm._v("03 - Laghouat")]),_c('option',{attrs:{"data-text":"04 - Oum El Bouaghi","data-iso-code":"DZ04","value":"Oum El Bouaghi"}},[_vm._v("04 - Oum El Bouaghi")]),_c('option',{attrs:{"data-text":"05 - Batna","data-iso-code":"DZ05","value":"Batna"}},[_vm._v("05 - Batna")]),_c('option',{attrs:{"data-text":"06 - Béjaïa","data-iso-code":"DZ06","value":"Béjaïa"}},[_vm._v("06 - Béjaïa")]),_c('option',{attrs:{"data-text":"07 - Biskra","data-iso-code":"Biskra","value":"Biskra"}},[_vm._v("07 - Biskra")]),_c('option',{attrs:{"data-text":"08 - Béchar","data-iso-code":"DZ08","value":"Béchar"}},[_vm._v("08 - Béchar")]),_c('option',{attrs:{"data-text":"09 - Blida","data-iso-code":"DZ09","value":"Blida"}},[_vm._v("09 - Blida")]),_c('option',{attrs:{"data-text":"10 - Bouira","data-iso-code":"DZ10","value":"Bouira"}},[_vm._v("10 - Bouira")]),_c('option',{attrs:{"data-text":"11 - Tamanrasset","data-iso-code":"DZ11","value":"Tamanrasset"}},[_vm._v("11 - Tamanrasset")]),_c('option',{attrs:{"data-text":"12 - Tébessa","data-iso-code":"DZ12","value":"349"}},[_vm._v("12 - Tébessa")]),_c('option',{attrs:{"data-text":"13 - Tlemcen","data-iso-code":"DZ13","value":"Tlemcen"}},[_vm._v("13 - Tlemcen")]),_c('option',{attrs:{"data-text":"14 - Tiaret","data-iso-code":"DZ14","value":"Tiaret"}},[_vm._v("14 - Tiaret")]),_c('option',{attrs:{"data-text":"15 - Tizi Ouzou","data-iso-code":"DZ15","value":"Tizi Ouzou"}},[_vm._v("15 - Tizi Ouzou")]),_c('option',{attrs:{"data-text":"16 - Alger","data-iso-code":"DZ16","value":"Alger"}},[_vm._v("16 - Alger")]),_c('option',{attrs:{"data-text":"17 - Djelfa","data-iso-code":"DZ17","value":"Djelfa"}},[_vm._v("17 - Djelfa")]),_c('option',{attrs:{"data-text":"18 - Jijel","data-iso-code":"DZ18","value":"355"}},[_vm._v("18 - Jijel")]),_c('option',{attrs:{"data-text":"19 - Sétif","data-iso-code":"DZ19","value":"Sétif"}},[_vm._v("19 - Sétif")]),_c('option',{attrs:{"data-text":"20 - Saïda","data-iso-code":"DZ20","value":"Saïda"}},[_vm._v("20 - Saïda")]),_c('option',{attrs:{"data-text":"21 - Skikda","data-iso-code":"DZ21","value":"Skikda"}},[_vm._v("21 - Skikda")]),_c('option',{attrs:{"data-text":"22 - Sidi Bel Abbès","data-iso-code":"DZ22","value":"Sidi Bel Abbès"}},[_vm._v("22 - Sidi Bel Abbès")]),_c('option',{attrs:{"data-text":"23 - Annaba","data-iso-code":"DZ23","value":"Annaba"}},[_vm._v("23 - Annaba")]),_c('option',{attrs:{"data-text":"24 - Guelma","data-iso-code":"DZ24","value":"Guelma"}},[_vm._v("24 - Guelma")]),_c('option',{attrs:{"data-text":"25 - Constantine","data-iso-code":"DZ25","value":"Constantine"}},[_vm._v("25 - Constantine")]),_c('option',{attrs:{"data-text":"26 - Médéa","data-iso-code":"Médéa","value":"363"}},[_vm._v("26 - Médéa")]),_c('option',{attrs:{"data-text":"27 - Mostaganem","data-iso-code":"DZ27","value":"364"}},[_vm._v("27 - Mostaganem")]),_c('option',{attrs:{"data-text":"28 - M&#039;Sila","data-iso-code":"DZ28","value":"M'Sila"}},[_vm._v("28 - M'Sila")]),_c('option',{attrs:{"data-text":"29 - Mascara","data-iso-code":"DZ29","value":"Mascara"}},[_vm._v("29 - Mascara")]),_c('option',{attrs:{"data-text":"30 - Ouargla","data-iso-code":"DZ30","value":"Ouargla"}},[_vm._v("30 - Ouargla")]),_c('option',{attrs:{"data-text":"31 - Oran","data-iso-code":"DZ31","value":"Oran"}},[_vm._v("31 - Oran")]),_c('option',{attrs:{"data-text":"32 - El Bayadh","data-iso-code":"DZ32","value":"El Bayadh"}},[_vm._v("32 - El Bayadh")]),_c('option',{attrs:{"data-text":"33 - Illizi","data-iso-code":"DZ33","value":"Illizi"}},[_vm._v("33 - Illizi")]),_c('option',{attrs:{"data-text":"34 - Bordj Bou Arreridj","data-iso-code":"DZ34","value":"Bordj Bou Arreridj"}},[_vm._v("34 - Bordj Bou Arreridj")]),_c('option',{attrs:{"data-text":"35 - Boumerdès","data-iso-code":"DZ35","value":"Boumerdès"}},[_vm._v("35 - Boumerdès")]),_c('option',{attrs:{"data-text":"36 - El Tarf","data-iso-code":"DZ36","value":"El Tarf"}},[_vm._v("36 - El Tarf")]),_c('option',{attrs:{"data-text":"37 - Tindouf","data-iso-code":"DZ37","value":"Tindouf"}},[_vm._v("37 - Tindouf")]),_c('option',{attrs:{"data-text":"38 - Tissemsilt","data-iso-code":"DZ38","value":"Tissemsilt"}},[_vm._v("38 - Tissemsilt")]),_c('option',{attrs:{"data-text":"39 - El Oued","data-iso-code":"DZ39","value":"El Oued"}},[_vm._v("39 - El Oued")]),_c('option',{attrs:{"data-text":"40 - Khenchela","data-iso-code":"DZ40","value":"Khenchela"}},[_vm._v("40 - Khenchela")]),_c('option',{attrs:{"data-text":"41 - Souk Ahras","data-iso-code":"DZ41","value":"Souk Ahras"}},[_vm._v("41 - Souk Ahras")]),_c('option',{attrs:{"data-text":"42 - Tipaza","data-iso-code":"DZ42","value":"Tipaza"}},[_vm._v("42 - Tipaza")]),_c('option',{attrs:{"data-text":"43 - Mila","data-iso-code":"DZ43","value":"Mila"}},[_vm._v("43 - Mila")]),_c('option',{attrs:{"data-text":"44 - Aïn Defla","data-iso-code":"DZ44","value":"Aïn Defla"}},[_vm._v("44 - Aïn Defla")]),_c('option',{attrs:{"data-text":"45 - Naâma","data-iso-code":"DZ45","value":"Naâma"}},[_vm._v("45 - Naâma")]),_c('option',{attrs:{"data-text":"46 - Aïn Témouchent","data-iso-code":"DZ46","value":"Aïn Témouchent"}},[_vm._v("46 - Aïn Témouchent")]),_c('option',{attrs:{"data-text":"47 - Ghardaïa","data-iso-code":"DZ47","value":"Ghardaïa"}},[_vm._v("47 - Ghardaïa")]),_c('option',{attrs:{"data-text":"48 - Relizane","data-iso-code":"DZ48","value":"Relizane"}},[_vm._v("48 - Relizane")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_vm._m(10),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.user.deliveryAddress),expression:"user.deliveryAddress"}],staticClass:"form-control",attrs:{"name":"deliveryAddress","type":"text"},domProps:{"value":(_vm.user.deliveryAddress)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.user, "deliveryAddress", $event.target.value)}}}),_vm._v(" "),_c('span',{staticClass:"alert-box alert-danger"},[_vm._v(_vm._s(_vm.errors.first('deliveryAddress')))])])])]),_vm._v(" "),_c('div',{staticClass:"accordion",attrs:{"id":"accordion1","role":"tablist"}},[_c('div',{staticClass:"card"},[_vm._m(11),_vm._v(" "),_c('div',{staticClass:"collapse",attrs:{"id":"collapseTwo","role":"tabpanel"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group"},[_vm._m(12),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.deliveryFirstName),expression:"deliveryFirstName"}],staticClass:"form-control",attrs:{"type":"text","name":"deliveryfn"},domProps:{"value":(_vm.deliveryFirstName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.deliveryFirstName=$event.target.value}}}),_vm._v(" "),_c('span',{staticClass:"alert-box alert-danger"},[_vm._v(_vm._s(_vm.errors.first('deliveryfn')))])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group"},[_vm._m(13),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.deliveryLastName),expression:"deliveryLastName"}],staticClass:"form-control",attrs:{"type":"text","name":"deliveryln"},domProps:{"value":(_vm.deliveryLastName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.deliveryLastName=$event.target.value}}}),_vm._v(" "),_c('span',{staticClass:"alert-box alert-danger"},[_vm._v(_vm._s(_vm.errors.first('deliveryln')))])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"form-group"},[_vm._m(14),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.deliveryPhoneNumber),expression:"deliveryPhoneNumber"}],staticClass:"form-control",attrs:{"type":"text","name":"deliveryph"},domProps:{"value":(_vm.deliveryPhoneNumber)},on:{"input":function($event){if($event.target.composing){ return; }_vm.deliveryPhoneNumber=$event.target.value}}}),_vm._v(" "),_c('span',{staticClass:"alert-box alert-danger"},[_vm._v(_vm._s(_vm.errors.first('deliveryph')))])])])])])])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('hr',{staticClass:"padding-bottom-1x"}),_vm._v(" "),_c('div',{staticClass:"d-flex justify-content-between"},[_c('router-link',{staticClass:"btn btn-outline-secondary m-0",attrs:{"to":"/cart"}},[_c('strong',[_vm._v(" Retour ")])]),_vm._v(" "),_c('router-link',{staticClass:"btn btn-primary m-0",attrs:{"to":"/review","disabled":!_vm.isComplete}},[_c('strong',[_vm._v(" Valider ")])])],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-4"},[_c('aside',{staticClass:"sidebar"},[_c('div',{staticClass:"padding-top-2x hidden-lg-up"}),_vm._v(" "),_c('section',{staticClass:"widget widget-order-summary bg-secondary border-0 p-4"},[_vm._m(15),_vm._v(" "),_c('table',{staticClass:"table text-sm mb-0"},[_c('tr',[_vm._m(16),_vm._v(" "),_c('td',{staticClass:"text-medium"},[_c('strong',[_vm._v(" "+_vm._s(_vm.total)+" DA ")])])]),_vm._v(" "),_vm._m(17),_vm._v(" "),_c('tr',[_c('td'),_vm._v(" "),_c('td',{staticClass:"text-lg text-medium"},[_c('strong',[_vm._v(" "+_vm._s(_vm.total)+" DA ")])])])])])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h1',[_c('strong',[_vm._v(" Paiement rapide ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',[_c('strong',[_vm._v(" Paiement rapide ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h4',[_c('strong',[_vm._v(" Remplissez les champs suivants pour confirmer votre commande ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h4',[_c('strong',[_vm._v(" املأ المعلومات التالية لتأكيد طلبك\n    ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{attrs:{"for":"firstName"}},[_c('strong',[_vm._v("Prénom   :* الاسم الأول")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{attrs:{"for":"lastName"}},[_c('strong',[_vm._v("Nom de famille :* اسم العائلة\n")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{attrs:{"for":"email"}},[_c('strong',[_vm._v("E-mail: البريد الإلكتروني\n ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{attrs:{"for":"address"}},[_c('strong',[_vm._v("Adresse personnelle  :* العنوان الشخصي")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{attrs:{"for":"phoneNumber"}},[_c('strong',[_vm._v("Téléphone de client: * رقم الهاتف")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{attrs:{"for":"checkout-city"}},[_c('strong',[_vm._v("Wilaya de livraison ولاية التسليم")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{attrs:{"for":"deliveryAddress"}},[_c('strong',[_vm._v("Adresse de la livraison  :* عنوان التسليم")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header",attrs:{"role":"tab"}},[_c('h6',[_c('a',{staticClass:"collapsed",attrs:{"href":"#collapseTwo","data-toggle":"collapse","data-parent":"#accordion1"}},[_c('strong',[_vm._v("à livrer pour : للتوصيل إلى")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{attrs:{"for":"deliveryfn"}},[_c('strong',[_vm._v("Prénom de réceptionneur de colis: الاسم الأول لمستقبِل الطرود")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{attrs:{"for":"deliveryln"}},[_c('strong',[_vm._v("Nom de famille de réceptionneur de colis : اسم العائلة لمستقبِل الطرود")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{attrs:{"for":"deliveryph"}},[_c('strong',[_vm._v("Téléphone de réceptionneur de colis: هاتف استقبال الطرود")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h3',{staticClass:"widget-title"},[_c('strong',[_vm._v(" Récapitulatif de la commande ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',[_c('strong',[_vm._v(" Total: ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('td',[_c('strong',[_vm._v(" frais de livraison: ")])]),_vm._v(" "),_c('td',{staticClass:"text-medium"},[_c('strong',[_vm._v(" 0.00 DA ")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 188 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_review_vue__ = __webpack_require__(50);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9eb4b750_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_review_vue__ = __webpack_require__(190);
function injectStyle (ssrContext) {
  __webpack_require__(189)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-9eb4b750"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_review_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9eb4b750_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_review_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 189 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 190 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"page-title"},[_c('div',{staticClass:"container"},[_c('h1',[_vm._v("Review")]),_vm._v(" "),_c('ul',{staticClass:"breadcrumbs"},[_c('li',[_c('router-link',{attrs:{"to":"/home"}},[_vm._v("Home")])],1),_vm._v(" "),_c('li',{staticClass:"separator"},[_vm._v(" / ")]),_vm._v(" "),_c('li',[_vm._v("Confirmation de la commande")])])])]),_vm._v(" "),_c('div',{staticClass:"container padding-bottom-3x mb-2"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-9 col-lg-8"},[_c('h4',[_vm._v("Vérifiez votre commande\n")]),_vm._v(" "),_c('hr',{staticClass:"padding-bottom-1x"}),_vm._v(" "),_c('div',{staticClass:"table-responsive shopping-cart mb-0"},[_c('table',{staticClass:"table"},[_vm._m(0),_vm._v(" "),_c('tbody',[_c('hr',{staticClass:"padding-bottom-1x"}),_vm._v(" "),_c('div',{staticClass:"d-flex justify-content-between"},[_c('router-link',{staticClass:"btn btn-outline-secondary m-0",attrs:{"to":"/payment"}},[_c('strong',[_vm._v("Retour")])]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary m-0",attrs:{"disabled":!_vm.commande||_vm.products.length===0},on:{"click":_vm.doCommande}},[_vm._v("Confirmation finale")])],1),_vm._v(" "),_vm._l((_vm.products),function(product){return _c('tr',{key:product.id},[_c('td',[_c('div',{staticClass:"product-item"},[_c('router-link',{staticClass:"product-thumb",attrs:{"to":"/product"},nativeOn:{"click":function($event){_vm.ProductDetail(product)}}},[_c('img',{attrs:{"src":product.img,"alt":"Product"}})]),_vm._v(" "),_c('div',{staticClass:"product-info"},[_c('h4',{staticClass:"product-title"},[_c('router-link',{attrs:{"to":"/product"},nativeOn:{"click":function($event){_vm.ProductDetail(product)}}},[_vm._v(_vm._s(product.id)),_c('small',[_vm._v(" x "+_vm._s(product.quantity))])])],1),_c('span',[_c('em',[_vm._v("Couleur:")]),_vm._v(" "+_vm._s(product.color))]),_c('span',[_c('em',[_vm._v("Description:")]),_vm._v(" "),_c('strong',[_vm._v(_vm._s(product.description))])])])],1)]),_vm._v(" "),_c('td',{staticClass:"text-center text-lg text-medium"},[_vm._v(_vm._s(product.price)+" DA")]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_c('router-link',{staticClass:"btn btn-outline-secondary btn-sm",attrs:{"to":"/cart"}},[_c('strong',[_vm._v("Modifier")])])],1)])})],2)])]),_vm._v(" "),_c('hr',{staticClass:"padding-bottom-1x"}),_vm._v(" "),_c('div',{staticClass:"text-right padding-bottom-1x"},[_vm._v("Total: "),_c('span',{staticClass:"text-medium text-dark"},[_vm._v(_vm._s(_vm.total))])]),_vm._v(" "),_c('div',{staticClass:"row padding-top-1x mt-3 mb-4"},[_c('div',{staticClass:"col-sm-6"},[_c('h5',[_vm._v("Expédition à:")]),_vm._v(" "),_c('ul',{staticClass:"list-unstyled text-sm"},[_c('li',[_vm._m(1),_vm._v(_vm._s(_vm.firstName)+" "+_vm._s(_vm.lastName))]),_vm._v(" "),_c('li',[_vm._m(2),_vm._v(" "+_vm._s(_vm.deliveryAddress))]),_vm._v(" "),_c('li',[_vm._m(3),_vm._v(_vm._s(_vm.phoneNumber))])])])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-4"},[_c('aside',{staticClass:"sidebar"},[_c('div',{staticClass:"padding-top-2x hidden-lg-up"}),_vm._v(" "),_c('section',{staticClass:"widget widget-order-summary bg-secondary border-0 p-4"},[_vm._m(4),_vm._v(" "),_c('table',{staticClass:"table text-sm mb-0"},[_c('tr',[_vm._m(5),_vm._v(" "),_c('td',{staticClass:"text-medium"},[_c('strong',[_vm._v(_vm._s(_vm.total)+" DA")])])]),_vm._v(" "),_vm._m(6),_vm._v(" "),_c('tr',[_c('td'),_vm._v(" "),_c('td',{staticClass:"text-lg text-medium"},[_c('strong',[_vm._v(_vm._s(_vm.total)+" DA")])])])])])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',[_vm._v("Référence (s)")]),_vm._v(" "),_c('th',{staticClass:"text-center"},[_vm._v("Total")]),_vm._v(" "),_c('th')])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"text-muted"},[_c('strong',[_vm._v("Client:")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"text-muted"},[_c('strong',[_vm._v("Adresse:")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"text-muted"},[_c('strong',[_vm._v("Numéro de téléphone:")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h3',{staticClass:"widget-title"},[_c('strong',[_vm._v(" ÉCAPITULATIF DE LA COMMANDE")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',[_c('strong',[_vm._v("Sous-total:")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('td',[_c('strong',[_vm._v("Livraison  :")])]),_vm._v(" "),_c('td',{staticClass:"text-medium"},[_c('strong',[_vm._v("0.00 DA")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 191 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_complete_vue__ = __webpack_require__(51);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_50dc97f2_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_complete_vue__ = __webpack_require__(193);
function injectStyle (ssrContext) {
  __webpack_require__(192)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-50dc97f2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_complete_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_50dc97f2_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_complete_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 192 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 193 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"page-title"},[_c('div',{staticClass:"container"},[_c('h1',[_vm._v("Complete")]),_vm._v(" "),_c('ul',{staticClass:"breadcrumbs"},[_c('li',[_c('router-link',{attrs:{"to":"/home"}},[_vm._v("Home")])],1),_vm._v(" "),_c('li',{staticClass:"separator"},[_vm._v(" / ")]),_vm._v(" "),_c('li',[_vm._v("Complete")])])])]),_vm._v(" "),_c('div',{staticClass:"container padding-bottom-3x mb-2"},[_c('div',{staticClass:"card text-center border-default"},[_c('div',{staticClass:"card-body padding-top-2x"},[_vm._m(0),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('p',{staticClass:"text-sm mb-2"},[_c('strong',[_vm._v("Assurez-vous de noter votre numéro de commande,soit")]),_vm._v(" "),_c('span',{staticClass:"text-medium"},[_vm._v(_vm._s(_vm.order))])]),_vm._v(" "),_vm._m(2),_vm._v(" "),_c('div',{staticClass:"padding-top-1x padding-bottom-1x"},[_c('router-link',{attrs:{"to":"/all"}},[_c('a',{staticClass:"btn btn-outline-secondary"},[_c('strong',[_vm._v("Accuiel")])])])],1)])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h3',{staticClass:"card-title mb-4"},[_c('strong',[_vm._v("Nous vous remercions de votre commande!")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"text-sm mb-2"},[_c('strong',[_vm._v("Votre commande a été passée et sera traitée dès que possible.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"text-sm mb-2"},[_c('strong',[_vm._v("Vous recevrez un email sous peu avec la confirmation de votre commande.")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 194 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_all_vue__ = __webpack_require__(52);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6a1f85d1_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_all_vue__ = __webpack_require__(197);
function injectStyle (ssrContext) {
  __webpack_require__(195)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6a1f85d1"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_all_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6a1f85d1_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_all_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 195 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 196 */,
/* 197 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mr-top-40"},[_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"container-fluid padding-bottom-3x mb-1"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-10 col-lg-9 col-md-8 order-md-2"},[_c('div',{staticClass:"d-flex flex-wrap-reverse flex-md-nowrap justify-content-center justify-content-sm-between align-items-center mb-30"},[_c('div',{staticClass:"pt-3 pb-1 pb-sm-3 text-sm text-center text-sm-left"},[_c('span',{staticClass:"text-muted mr-2"},[_vm._v("Affichage des produits")]),_vm._v("1- "+_vm._s(_vm.pageSize)+" Produits")]),_vm._v(" "),_c('form',{staticClass:"input-group shop-search-box",attrs:{"method":"get"}},[_vm._m(0),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filter),expression:"filter"}],staticClass:"form-control",staticStyle:{"border":"2px solid #000000"},attrs:{"type":"search","placeholder":"Recherche par Référence","disabled":_vm.brands.length>0},domProps:{"value":(_vm.filter)},on:{"keyup":_vm.search,"input":function($event){if($event.target.composing){ return; }_vm.filter=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"d-flex flex-wrap justify-content-center mb-2"},_vm._l((_vm.filterProduct),function(product){return _c('div',{key:product.id,staticClass:"col-xl-3 col-lg-4 col-sm-6"},[_c('div',{staticClass:"product-card mb-30"},[_c('div',{staticClass:"product-card-thumb"},[_c('router-link',{staticClass:"product-card-link",attrs:{"to":{ name: 'productref', params: { ref: product.id }}},nativeOn:{"click":function($event){_vm.ProductDetail(product)}}},[_c('div',{staticStyle:{"display":"flex"}})]),_c('img',{attrs:{"src":product.img,"alt":"Product"}}),_vm._v(" "),_c('div',{staticClass:"product-card-buttons"},[_c('button',{staticClass:"btn btn-primary btn-sm",on:{"click":function($event){_vm.addToCart(product)}}},[_vm._v("Ajouter au panier")])])],1),_vm._v(" "),_c('div',{staticClass:"product-card-details"},[_c('h3',{staticClass:"product-card-title"},[_c('b',{attrs:{"href":"shop-single.html"}},[_c('strong',[_vm._v(_vm._s(product.description))])])]),_vm._v(" "),_c('span',{staticClass:"h6 d-block"},[_c('del',{staticClass:"text-muted text-normal"},[_vm._v(_vm._s(product.price2)+" DA")]),_vm._v(" "+_vm._s(product.price)+" DA")])])])])})),_vm._v(" "),_c('pagination',{attrs:{"total":_vm.total,"page-size":_vm.pageSize,"callback":_vm.pageChanged,"options":_vm.paginationOptions,"nav-class":"pagination","ul-class":"column pages","li-class":"pt-2"}})],1),_vm._v(" "),_c('div',{staticClass:"col-xl-2 col-lg-3 col-md-4 order-md-1"},[_c('div',{staticClass:"sidebar-toggle position-left",class:{sidebaropen:_vm.sidebarOpen},on:{"click":function($event){_vm.sidebarOpen=!_vm.sidebarOpen}}},[_c('i',{staticClass:"material-icons filter_list"})])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"input-group-btn"},[_c('button',{attrs:{"type":"submit"}},[_c('i',{staticClass:"material-icons search"})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 198 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_vipclient_vue__ = __webpack_require__(53);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_72b74466_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_vipclient_vue__ = __webpack_require__(200);
function injectStyle (ssrContext) {
  __webpack_require__(199)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-72b74466"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_vipclient_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_72b74466_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_vipclient_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 199 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 200 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mr-top-40"},[_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"container-fluid padding-bottom-3x mb-1"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-10 col-lg-9 col-md-8 order-md-2"},[_c('div',{staticClass:"d-flex flex-wrap-reverse flex-md-nowrap justify-content-center justify-content-sm-between align-items-center mb-30"},[_c('div',{staticClass:"pt-3 pb-1 pb-sm-3 text-sm text-center text-sm-left"},[_c('span',{staticClass:"text-muted mr-2"},[_vm._v("Affichage des produits")]),_vm._v("1- "+_vm._s(_vm.pageSize)+" Produits")]),_vm._v(" "),_c('form',{staticClass:"input-group shop-search-box",attrs:{"method":"get"}},[_vm._m(0),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filter),expression:"filter"}],staticClass:"form-control",staticStyle:{"border":"2px solid #000000"},attrs:{"type":"search","placeholder":"Recherche par Référence","disabled":_vm.brands.length>0},domProps:{"value":(_vm.filter)},on:{"keyup":_vm.search,"input":function($event){if($event.target.composing){ return; }_vm.filter=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"d-flex flex-wrap justify-content-center mb-2"},_vm._l((_vm.filterProduct),function(product){return _c('div',{key:product.id,staticClass:"col-xl-3 col-lg-4 col-sm-6"},[_c('div',{staticClass:"product-card mb-30"},[_c('div',{staticClass:"product-card-thumb"},[_c('router-link',{staticClass:"product-card-link",attrs:{"to":{ name: 'productref', params: { ref: product.id }}},nativeOn:{"click":function($event){_vm.ProductDetail(product)}}},[_c('h6',{staticClass:"product-badge bgblack text-white "},[_c('b',[_vm._v("  OFFRE VIP ❤️ ")])])]),_c('img',{attrs:{"src":product.img,"alt":"Product"}}),_vm._v(" "),_c('div',{staticClass:"product-card-buttons"},[_c('button',{staticClass:"btn btn-primary btn-sm",on:{"click":function($event){_vm.addToCart(product)}}},[_vm._v("Ajouter au panier")])])],1),_vm._v(" "),_c('div',{staticClass:"product-card-details"},[_c('h3',{staticClass:"product-card-title"},[_c('b',{attrs:{"href":"shop-single.html"}},[_c('strong',[_vm._v(_vm._s(product.description))])])]),_vm._v(" "),_c('span',{staticClass:"h6 d-block"},[_c('del',{staticClass:"text-muted text-normal"},[_vm._v(_vm._s(product.price2)+" DA")]),_vm._v(" "+_vm._s(product.price)+" DA")])])])])})),_vm._v(" "),_c('pagination',{attrs:{"total":_vm.total,"page-size":_vm.pageSize,"callback":_vm.pageChanged,"options":_vm.paginationOptions,"nav-class":"pagination","ul-class":"column pages","li-class":"pt-2"}})],1),_vm._v(" "),_c('div',{staticClass:"col-xl-2 col-lg-3 col-md-4 order-md-1"},[_c('div',{staticClass:"sidebar-toggle position-left",class:{sidebaropen:_vm.sidebarOpen},on:{"click":function($event){_vm.sidebarOpen=!_vm.sidebarOpen}}},[_c('i',{staticClass:"material-icons filter_list"})]),_vm._v(" "),_c('aside',{staticClass:"sidebar sidebar-offcanvas position-left",class:{offcanvasopen:_vm.sidebarOpen}},[_c('span',{staticClass:"sidebar-close",on:{"click":function($event){_vm.sidebarOpen=!_vm.sidebarOpen}}},[_c('i',{staticClass:"material-icons icon_close"})]),_vm._v(" "),_c('section',{staticClass:"widget widget-icon-list"}),_vm._v(" "),_c('section',{staticClass:"widget widget-categories"}),_vm._v(" "),_c('section',{staticClass:"widget"})])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"input-group-btn"},[_c('button',{attrs:{"type":"submit"}},[_c('i',{staticClass:"material-icons search"})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 201 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_grid_vue__ = __webpack_require__(54);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_69028f65_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_grid_vue__ = __webpack_require__(203);
function injectStyle (ssrContext) {
  __webpack_require__(202)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-69028f65"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_grid_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_69028f65_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_grid_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 202 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 203 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"bg-secondary padding-top-3x padding-bottom-2x margin-top-3x"},[_c('div',{staticClass:"container"},[_c('h3',{staticClass:"text-center mb-30"},[_vm._v("Explore Watches")]),_vm._v(" "),_c('ul',{staticClass:"nav nav-pills justify-content-center pb-2"},[_c('li',{staticClass:"nav-item"},[_c('a',{staticClass:"nav-link active",attrs:{"href":"#","data-filter":"*"}},[_vm._v("All")])]),_vm._v(" "),_c('li',{staticClass:"nav-item"},[_c('a',{staticClass:"nav-link",attrs:{"href":"#","data-filter":".classic"}},[_vm._v("Classic")])]),_vm._v(" "),_c('li',{staticClass:"nav-item"},[_c('a',{staticClass:"nav-link",attrs:{"href":"#","data-filter":".digital"}},[_vm._v("Digital")])]),_vm._v(" "),_c('li',{staticClass:"nav-item"},[_c('a',{staticClass:"nav-link",attrs:{"href":"#","data-filter":".prestige"}},[_vm._v("Prestige")])]),_vm._v(" "),_c('li',{staticClass:"nav-item"},[_c('a',{staticClass:"nav-link",attrs:{"href":"#","data-filter":".sport"}},[_vm._v("Sport")])])]),_vm._v(" "),_c('div',{staticClass:"isotope-grid filter-grid cols-4 mt-4"},[_c('div',{staticClass:"gutter-sizer"}),_vm._v(" "),_c('div',{staticClass:"grid-sizer"}),_vm._v(" "),_c('div',{staticClass:"grid-item classic"},[_c('div',{staticClass:"product-card"},[_c('a',{staticClass:"product-thumb",attrs:{"href":"shop-single.html"}},[_c('img',{attrs:{"src":"static/img/shop/products/17.jpg","alt":"Product"}})]),_vm._v(" "),_c('h3',{staticClass:"product-title"},[_c('a',{attrs:{"href":"shop-single.html"}},[_vm._v("Gents BN0024 Classic")])]),_vm._v(" "),_c('h4',{staticClass:"product-price"},[_vm._v("€185.00")]),_vm._v(" "),_c('div',{staticClass:"product-buttons"},[_c('button',{staticClass:"btn btn-outline-secondary btn-sm btn-wishlist",attrs:{"data-toggle":"tooltip","title":"Whishlist"}},[_c('i',{staticClass:"icon-heart"})]),_vm._v(" "),_c('button',{staticClass:"btn btn-outline-primary btn-sm",attrs:{"data-toast":"","data-toast-type":"success","data-toast-position":"topRight","data-toast-icon":"icon-circle-check","data-toast-title":"Product","data-toast-message":"successfuly added to cart!"}},[_vm._v("Add to Cart")])])])]),_vm._v(" "),_c('div',{staticClass:"grid-item digital"},[_c('div',{staticClass:"product-card"},[_c('a',{staticClass:"product-thumb",attrs:{"href":"shop-single.html"}},[_c('img',{attrs:{"src":"static/img/shop/products/21.jpg","alt":"Product"}})]),_vm._v(" "),_c('h3',{staticClass:"product-title"},[_c('a',{attrs:{"href":"shop-single.html"}},[_vm._v("Gents BN0106 Digital ")])]),_vm._v(" "),_c('h4',{staticClass:"product-price"},[_vm._v("€655.00")]),_vm._v(" "),_c('div',{staticClass:"product-buttons"},[_c('button',{staticClass:"btn btn-outline-secondary btn-sm btn-wishlist",attrs:{"data-toggle":"tooltip","title":"Whishlist"}},[_c('i',{staticClass:"icon-heart"})]),_vm._v(" "),_c('button',{staticClass:"btn btn-outline-primary btn-sm",attrs:{"data-toast":"","data-toast-type":"success","data-toast-position":"topRight","data-toast-icon":"icon-circle-check","data-toast-title":"Product","data-toast-message":"successfuly added to cart!"}},[_vm._v("Add to Cart")])])])]),_vm._v(" "),_c('div',{staticClass:"grid-item prestige"},[_c('div',{staticClass:"product-card"},[_c('a',{staticClass:"product-thumb",attrs:{"href":"shop-single.html"}},[_c('img',{attrs:{"src":"static/img/shop/products/25.jpg","alt":"Product"}})]),_vm._v(" "),_c('h3',{staticClass:"product-title"},[_c('a',{attrs:{"href":"shop-single.html"}},[_vm._v("Gents BN0095 Prestige")])]),_vm._v(" "),_c('h4',{staticClass:"product-price"},[_vm._v("€725.00")]),_vm._v(" "),_c('div',{staticClass:"product-buttons"},[_c('button',{staticClass:"btn btn-outline-secondary btn-sm btn-wishlist",attrs:{"data-toggle":"tooltip","title":"Whishlist"}},[_c('i',{staticClass:"icon-heart"})]),_vm._v(" "),_c('button',{staticClass:"btn btn-outline-primary btn-sm",attrs:{"data-toast":"","data-toast-type":"success","data-toast-position":"topRight","data-toast-icon":"icon-circle-check","data-toast-title":"Product","data-toast-message":"successfuly added to cart!"}},[_vm._v("Add to Cart")])])])]),_vm._v(" "),_c('div',{staticClass:"grid-item classic"},[_c('div',{staticClass:"product-card"},[_c('a',{staticClass:"product-thumb",attrs:{"href":"shop-single.html"}},[_c('img',{attrs:{"src":"static/img/shop/products/19.jpg","alt":"Product"}})]),_vm._v(" "),_c('h3',{staticClass:"product-title"},[_c('a',{attrs:{"href":"shop-single.html"}},[_vm._v("Gents BN0211 Classic")])]),_vm._v(" "),_c('h4',{staticClass:"product-price"},[_vm._v("€350.00")]),_vm._v(" "),_c('div',{staticClass:"product-buttons"},[_c('button',{staticClass:"btn btn-outline-secondary btn-sm btn-wishlist",attrs:{"data-toggle":"tooltip","title":"Whishlist"}},[_c('i',{staticClass:"icon-heart"})]),_vm._v(" "),_c('button',{staticClass:"btn btn-outline-primary btn-sm",attrs:{"data-toast":"","data-toast-type":"success","data-toast-position":"topRight","data-toast-icon":"icon-circle-check","data-toast-title":"Product","data-toast-message":"successfuly added to cart!"}},[_vm._v("Add to Cart")])])])]),_vm._v(" "),_c('div',{staticClass:"grid-item digital"},[_c('div',{staticClass:"product-card"},[_c('a',{staticClass:"product-thumb",attrs:{"href":"shop-single.html"}},[_c('img',{attrs:{"src":"static/img/shop/products/22.jpg","alt":"Product"}})]),_vm._v(" "),_c('h3',{staticClass:"product-title"},[_c('a',{attrs:{"href":"shop-single.html"}},[_vm._v("Gents BN0076 Digital")])]),_vm._v(" "),_c('h4',{staticClass:"product-price"},[_vm._v("€225.00")]),_vm._v(" "),_c('div',{staticClass:"product-buttons"},[_c('button',{staticClass:"btn btn-outline-secondary btn-sm btn-wishlist",attrs:{"data-toggle":"tooltip","title":"Whishlist"}},[_c('i',{staticClass:"icon-heart"})]),_vm._v(" "),_c('button',{staticClass:"btn btn-outline-primary btn-sm",attrs:{"data-toast":"","data-toast-type":"success","data-toast-position":"topRight","data-toast-icon":"icon-circle-check","data-toast-title":"Product","data-toast-message":"successfuly added to cart!"}},[_vm._v("Add to Cart")])])])]),_vm._v(" "),_c('div',{staticClass:"grid-item sport"},[_c('div',{staticClass:"product-card"},[_c('a',{staticClass:"product-thumb",attrs:{"href":"shop-single.html"}},[_c('img',{attrs:{"src":"static/img/shop/products/26.jpg","alt":"Product"}})]),_vm._v(" "),_c('h3',{staticClass:"product-title"},[_c('a',{attrs:{"href":"shop-single.html"}},[_vm._v("Ladies BN0111 Sport")])]),_vm._v(" "),_c('h4',{staticClass:"product-price"},[_vm._v("€140.00")]),_vm._v(" "),_c('div',{staticClass:"product-buttons"},[_c('button',{staticClass:"btn btn-outline-secondary btn-sm btn-wishlist",attrs:{"data-toggle":"tooltip","title":"Whishlist"}},[_c('i',{staticClass:"icon-heart"})]),_vm._v(" "),_c('button',{staticClass:"btn btn-outline-primary btn-sm",attrs:{"data-toast":"","data-toast-type":"success","data-toast-position":"topRight","data-toast-icon":"icon-circle-check","data-toast-title":"Product","data-toast-message":"successfuly added to cart!"}},[_vm._v("Add to Cart")])])])]),_vm._v(" "),_c('div',{staticClass:"grid-item prestige"},[_c('div',{staticClass:"product-card"},[_c('a',{staticClass:"product-thumb",attrs:{"href":"shop-single.html"}},[_c('img',{attrs:{"src":"static/img/shop/products/28.jpg","alt":"Product"}})]),_vm._v(" "),_c('h3',{staticClass:"product-title"},[_c('a',{attrs:{"href":"shop-single.html"}},[_vm._v("Gents BN0221 Prestige")])]),_vm._v(" "),_c('h4',{staticClass:"product-price"},[_vm._v("€435.00")]),_vm._v(" "),_c('div',{staticClass:"product-buttons"},[_c('button',{staticClass:"btn btn-outline-secondary btn-sm btn-wishlist",attrs:{"data-toggle":"tooltip","title":"Whishlist"}},[_c('i',{staticClass:"icon-heart"})]),_vm._v(" "),_c('button',{staticClass:"btn btn-outline-primary btn-sm",attrs:{"data-toast":"","data-toast-type":"success","data-toast-position":"topRight","data-toast-icon":"icon-circle-check","data-toast-title":"Product","data-toast-message":"successfuly added to cart!"}},[_vm._v("Add to Cart")])])])]),_vm._v(" "),_c('div',{staticClass:"grid-item classic"},[_c('div',{staticClass:"product-card"},[_c('a',{staticClass:"product-thumb",attrs:{"href":"shop-single.html"}},[_c('img',{attrs:{"src":"static/img/shop/products/18.jpg","alt":"Product"}})]),_vm._v(" "),_c('h3',{staticClass:"product-title"},[_c('a',{attrs:{"href":"shop-single.html"}},[_vm._v("Gents BN0142 Classic")])]),_vm._v(" "),_c('h4',{staticClass:"product-price"},[_vm._v("€215.00")]),_vm._v(" "),_c('div',{staticClass:"product-buttons"},[_c('button',{staticClass:"btn btn-outline-secondary btn-sm btn-wishlist",attrs:{"data-toggle":"tooltip","title":"Whishlist"}},[_c('i',{staticClass:"icon-heart"})]),_vm._v(" "),_c('button',{staticClass:"btn btn-outline-primary btn-sm",attrs:{"data-toast":"","data-toast-type":"success","data-toast-position":"topRight","data-toast-icon":"icon-circle-check","data-toast-title":"Product","data-toast-message":"successfuly added to cart!"}},[_vm._v("Add to Cart")])])])]),_vm._v(" "),_c('div',{staticClass:"grid-item prestige"},[_c('div',{staticClass:"product-card"},[_c('a',{staticClass:"product-thumb",attrs:{"href":"shop-single.html"}},[_c('img',{attrs:{"src":"static/img/shop/products/24.jpg","alt":"Product"}})]),_vm._v(" "),_c('h3',{staticClass:"product-title"},[_c('a',{attrs:{"href":"shop-single.html"}},[_vm._v("Gents BN0095 Prestige")])]),_vm._v(" "),_c('h4',{staticClass:"product-price"},[_vm._v("€655.00")]),_vm._v(" "),_c('div',{staticClass:"product-buttons"},[_c('button',{staticClass:"btn btn-outline-secondary btn-sm btn-wishlist",attrs:{"data-toggle":"tooltip","title":"Whishlist"}},[_c('i',{staticClass:"icon-heart"})]),_vm._v(" "),_c('button',{staticClass:"btn btn-outline-primary btn-sm",attrs:{"data-toast":"","data-toast-type":"success","data-toast-position":"topRight","data-toast-icon":"icon-circle-check","data-toast-title":"Product","data-toast-message":"successfuly added to cart!"}},[_vm._v("Add to Cart")])])])]),_vm._v(" "),_c('div',{staticClass:"grid-item classic"},[_c('div',{staticClass:"product-card"},[_c('a',{staticClass:"product-thumb",attrs:{"href":"shop-single.html"}},[_c('img',{attrs:{"src":"static/img/shop/products/20.jpg","alt":"Product"}})]),_vm._v(" "),_c('h3',{staticClass:"product-title"},[_c('a',{attrs:{"href":"shop-single.html"}},[_vm._v("Gents BN0032 Classic")])]),_vm._v(" "),_c('h4',{staticClass:"product-price"},[_vm._v("€185.00")]),_vm._v(" "),_c('div',{staticClass:"product-buttons"},[_c('button',{staticClass:"btn btn-outline-secondary btn-sm btn-wishlist",attrs:{"data-toggle":"tooltip","title":"Whishlist"}},[_c('i',{staticClass:"icon-heart"})]),_vm._v(" "),_c('button',{staticClass:"btn btn-outline-primary btn-sm",attrs:{"data-toast":"","data-toast-type":"success","data-toast-position":"topRight","data-toast-icon":"icon-circle-check","data-toast-title":"Product","data-toast-message":"successfuly added to cart!"}},[_vm._v("Add to Cart")])])])]),_vm._v(" "),_c('div',{staticClass:"grid-item digital"},[_c('div',{staticClass:"product-card"},[_c('a',{staticClass:"product-thumb",attrs:{"href":"shop-single.html"}},[_c('img',{attrs:{"src":"static/img/shop/products/23.jpg","alt":"Product"}})]),_vm._v(" "),_c('h3',{staticClass:"product-title"},[_c('a',{attrs:{"href":"shop-single.html"}},[_vm._v("Gents BN0106 Digital")])]),_vm._v(" "),_c('h4',{staticClass:"product-price"},[_vm._v("€585.00")]),_vm._v(" "),_c('div',{staticClass:"product-buttons"},[_c('button',{staticClass:"btn btn-outline-secondary btn-sm btn-wishlist",attrs:{"data-toggle":"tooltip","title":"Whishlist"}},[_c('i',{staticClass:"icon-heart"})]),_vm._v(" "),_c('button',{staticClass:"btn btn-outline-primary btn-sm",attrs:{"data-toast":"","data-toast-type":"success","data-toast-position":"topRight","data-toast-icon":"icon-circle-check","data-toast-title":"Product","data-toast-message":"successfuly added to cart!"}},[_vm._v("Add to Cart")])])])]),_vm._v(" "),_c('div',{staticClass:"grid-item sport"},[_c('div',{staticClass:"product-card"},[_c('a',{staticClass:"product-thumb",attrs:{"href":"shop-single.html"}},[_c('img',{attrs:{"src":"static/img/shop/products/27.jpg","alt":"Product"}})]),_vm._v(" "),_c('h3',{staticClass:"product-title"},[_c('a',{attrs:{"href":"shop-single.html"}},[_vm._v("Ladies BN0111 Sport")])]),_vm._v(" "),_c('h4',{staticClass:"product-price"},[_vm._v("€140.00")]),_vm._v(" "),_c('div',{staticClass:"product-buttons"},[_c('button',{staticClass:"btn btn-outline-secondary btn-sm btn-wishlist",attrs:{"data-toggle":"tooltip","title":"Whishlist"}},[_c('i',{staticClass:"icon-heart"})]),_vm._v(" "),_c('button',{staticClass:"btn btn-outline-primary btn-sm",attrs:{"data-toast":"","data-toast-type":"success","data-toast-position":"topRight","data-toast-icon":"icon-circle-check","data-toast-title":"Product","data-toast-message":"successfuly added to cart!"}},[_vm._v("Add to Cart")])])])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 204 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_men_vue__ = __webpack_require__(55);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9544e368_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_men_vue__ = __webpack_require__(206);
function injectStyle (ssrContext) {
  __webpack_require__(205)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-9544e368"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_men_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9544e368_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_men_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 205 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 206 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mr-top-40"},[_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"container-fluid padding-bottom-3x mb-1"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-10 col-lg-9 col-md-8 order-md-2"},[_c('div',{staticClass:"d-flex flex-wrap-reverse flex-md-nowrap justify-content-center justify-content-sm-between align-items-center mb-30"},[_c('div',{staticClass:"pt-3 pb-1 pb-sm-3 text-sm text-center text-sm-left"},[_c('span',{staticClass:"text-muted mr-2"},[_vm._v("Affichage des produits")]),_vm._v("1- "+_vm._s(_vm.pageSize)+" Produits")]),_vm._v(" "),_c('form',{staticClass:"input-group shop-search-box",attrs:{"method":"get"}},[_vm._m(0),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filter),expression:"filter"}],staticClass:"form-control",staticStyle:{"border":"2px solid #000000"},attrs:{"type":"search","placeholder":"Recherche par Référence","disabled":_vm.brands.length>0},domProps:{"value":(_vm.filter)},on:{"keyup":_vm.search,"input":function($event){if($event.target.composing){ return; }_vm.filter=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"d-flex flex-wrap justify-content-center mb-2"},_vm._l((_vm.filterProduct),function(product){return _c('div',{key:product.id,staticClass:"col-xl-3 col-lg-4 col-sm-6"},[_c('div',{staticClass:"product-card mb-30"},[_c('div',{staticClass:"product-card-thumb"},[_c('router-link',{staticClass:"product-card-link",attrs:{"to":{ name: 'productref', params: { ref: product.id }}},nativeOn:{"click":function($event){_vm.ProductDetail(product)}}},[_c('div',{staticStyle:{"display":"flex"}})]),_c('img',{attrs:{"src":product.img,"alt":"Product"}}),_vm._v(" "),_c('div',{staticClass:"product-card-buttons"},[_c('button',{staticClass:"btn btn-primary btn-sm",on:{"click":function($event){_vm.addToCart(product)}}},[_vm._v("Ajouter au panier")])])],1),_vm._v(" "),_c('div',{staticClass:"product-card-details"},[_c('h3',{staticClass:"product-card-title"},[_c('b',{attrs:{"href":"shop-single.html"}},[_c('strong',[_vm._v(_vm._s(product.description))])])]),_vm._v(" "),_c('span',{staticClass:"h6 d-block"},[_c('del',{staticClass:"text-muted text-normal"},[_vm._v(_vm._s(product.price2)+" DA")]),_vm._v(" "+_vm._s(product.price)+" DA")])])])])})),_vm._v(" "),_c('pagination',{attrs:{"total":_vm.total,"page-size":_vm.pageSize,"callback":_vm.pageChanged,"options":_vm.paginationOptions,"nav-class":"pagination","ul-class":"column pages","li-class":"pt-2"}})],1),_vm._v(" "),_c('div',{staticClass:"col-xl-2 col-lg-3 col-md-4 order-md-1"},[_c('div',{staticClass:"sidebar-toggle position-left",class:{sidebaropen:_vm.sidebarOpen},on:{"click":function($event){_vm.sidebarOpen=!_vm.sidebarOpen}}},[_c('i',{staticClass:"material-icons filter_list"})]),_vm._v(" "),_c('aside',{staticClass:"sidebar sidebar-offcanvas position-left",class:{offcanvasopen:_vm.sidebarOpen}},[_c('span',{staticClass:"sidebar-close",on:{"click":function($event){_vm.sidebarOpen=!_vm.sidebarOpen}}},[_c('i',{staticClass:"material-icons icon_close"})]),_vm._v(" "),_c('section',{staticClass:"widget widget-icon-list"},[_vm._m(1),_vm._v(" "),_c('ul',[_c('li',[_c('a',{attrs:{"href":"#"},on:{"click":function($event){_vm.ordreby('quantite')}}},[_c('i',{staticClass:"material-icons favorite_border"}),_vm._v("Popularité")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#"},on:{"click":function($event){_vm.ordreby('annee')}}},[_c('i',{staticClass:"material-icons vertical_align_top"}),_vm._v("Dernière collection")])])])]),_vm._v(" "),_c('section',{staticClass:"widget widget-categories"},[_vm._m(2),_vm._v(" "),_c('el-slider',{attrs:{"range":"","step":10000,"show-stops":"","max":80000},model:{value:(_vm.priceValue),callback:function ($$v) {_vm.priceValue=$$v},expression:"priceValue"}}),_vm._v(" "),_c('form',{staticClass:"price-range-slider",on:{"submit":function($event){$event.preventDefault();return _vm.submit($event)}}},[_c('div',{staticClass:"ui-range-slider-footer"},[_c('div',{staticClass:"column"},[_c('button',{staticClass:"btn btn-outline-primary btn-sm",attrs:{"type":"submit","disabled":_vm.brands.length>0}},[_vm._v("Filtrer")])]),_vm._v(" "),_c('div',{staticClass:"column"},[_c('span',[_vm._v(_vm._s(_vm.priceValue[0])+"DA-"+_vm._s(_vm.priceValue[1])+"DA")])])])])],1),_vm._v(" "),_c('section',{staticClass:"widget"},[_vm._m(3),_vm._v(" "),_c('div',{staticClass:"custom-control custom-checkbox"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.brands),expression:"brands"}],staticClass:"custom-control-input",attrs:{"type":"checkbox","id":"festina","value":"festina"},domProps:{"checked":Array.isArray(_vm.brands)?_vm._i(_vm.brands,"festina")>-1:(_vm.brands)},on:{"change":[function($event){var $$a=_vm.brands,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="festina",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.brands=$$a.concat([$$v]))}else{$$i>-1&&(_vm.brands=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.brands=$$c}},_vm.brandChecked]}}),_vm._v(" "),_vm._m(4)]),_vm._v(" "),_c('div',{staticClass:"custom-control custom-checkbox"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.brands),expression:"brands"}],staticClass:"custom-control-input",attrs:{"type":"checkbox","id":"morellato","value":"morellato"},domProps:{"checked":Array.isArray(_vm.brands)?_vm._i(_vm.brands,"morellato")>-1:(_vm.brands)},on:{"change":[function($event){var $$a=_vm.brands,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="morellato",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.brands=$$a.concat([$$v]))}else{$$i>-1&&(_vm.brands=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.brands=$$c}},_vm.brandChecked]}}),_vm._v(" "),_vm._m(5)]),_vm._v(" "),_c('div',{staticClass:"custom-control custom-checkbox"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.brands),expression:"brands"}],staticClass:"custom-control-input",attrs:{"type":"checkbox","id":"maserati","value":"maserati"},domProps:{"checked":Array.isArray(_vm.brands)?_vm._i(_vm.brands,"maserati")>-1:(_vm.brands)},on:{"change":[function($event){var $$a=_vm.brands,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="maserati",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.brands=$$a.concat([$$v]))}else{$$i>-1&&(_vm.brands=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.brands=$$c}},_vm.brandChecked]}}),_vm._v(" "),_vm._m(6)]),_vm._v(" "),_c('div',{staticClass:"custom-control custom-checkbox"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.brands),expression:"brands"}],staticClass:"custom-control-input",attrs:{"type":"checkbox","id":"MONTIGNAC","value":"MONTIGNAC"},domProps:{"checked":Array.isArray(_vm.brands)?_vm._i(_vm.brands,"MONTIGNAC")>-1:(_vm.brands)},on:{"change":[function($event){var $$a=_vm.brands,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="MONTIGNAC",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.brands=$$a.concat([$$v]))}else{$$i>-1&&(_vm.brands=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.brands=$$c}},_vm.brandChecked]}}),_vm._v(" "),_vm._m(7)]),_vm._v(" "),_c('div',{staticClass:"custom-control custom-checkbox"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.brands),expression:"brands"}],staticClass:"custom-control-input",attrs:{"type":"checkbox","id":"nautica","value":"nautica"},domProps:{"checked":Array.isArray(_vm.brands)?_vm._i(_vm.brands,"nautica")>-1:(_vm.brands)},on:{"change":[function($event){var $$a=_vm.brands,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="nautica",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.brands=$$a.concat([$$v]))}else{$$i>-1&&(_vm.brands=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.brands=$$c}},_vm.brandChecked]}}),_vm._v(" "),_vm._m(8)]),_vm._v(" "),_c('div',{staticClass:"custom-control custom-checkbox"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.brands),expression:"brands"}],staticClass:"custom-control-input",attrs:{"type":"checkbox","id":"timberland","value":"timberland"},domProps:{"checked":Array.isArray(_vm.brands)?_vm._i(_vm.brands,"timberland")>-1:(_vm.brands)},on:{"change":[function($event){var $$a=_vm.brands,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="timberland",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.brands=$$a.concat([$$v]))}else{$$i>-1&&(_vm.brands=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.brands=$$c}},_vm.brandChecked]}}),_vm._v(" "),_vm._m(9)]),_vm._v(" "),_c('div',{staticClass:"custom-control custom-checkbox"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.brands),expression:"brands"}],staticClass:"custom-control-input",attrs:{"type":"checkbox","id":"mk","value":"michael kors"},domProps:{"checked":Array.isArray(_vm.brands)?_vm._i(_vm.brands,"michael kors")>-1:(_vm.brands)},on:{"change":[function($event){var $$a=_vm.brands,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="michael kors",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.brands=$$a.concat([$$v]))}else{$$i>-1&&(_vm.brands=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.brands=$$c}},_vm.brandChecked]}}),_vm._v(" "),_vm._m(10)]),_vm._v(" "),_c('div',{staticClass:"custom-control custom-checkbox"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.brands),expression:"brands"}],staticClass:"custom-control-input",attrs:{"type":"checkbox","id":"armani exchange","value":"armani exchange"},domProps:{"checked":Array.isArray(_vm.brands)?_vm._i(_vm.brands,"armani exchange")>-1:(_vm.brands)},on:{"change":[function($event){var $$a=_vm.brands,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="armani exchange",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.brands=$$a.concat([$$v]))}else{$$i>-1&&(_vm.brands=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.brands=$$c}},_vm.brandChecked]}}),_vm._v(" "),_vm._m(11)]),_vm._v(" "),_c('div',{staticClass:"custom-control custom-checkbox"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.brands),expression:"brands"}],staticClass:"custom-control-input",attrs:{"type":"checkbox","id":"diesel","value":"diesel"},domProps:{"checked":Array.isArray(_vm.brands)?_vm._i(_vm.brands,"diesel")>-1:(_vm.brands)},on:{"change":[function($event){var $$a=_vm.brands,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="diesel",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.brands=$$a.concat([$$v]))}else{$$i>-1&&(_vm.brands=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.brands=$$c}},_vm.brandChecked]}}),_vm._v(" "),_vm._m(12)]),_vm._v(" "),_c('div',{staticClass:"custom-control custom-checkbox"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.brands),expression:"brands"}],staticClass:"custom-control-input",attrs:{"type":"checkbox","id":"fossil","value":"fossil"},domProps:{"checked":Array.isArray(_vm.brands)?_vm._i(_vm.brands,"fossil")>-1:(_vm.brands)},on:{"change":[function($event){var $$a=_vm.brands,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="fossil",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.brands=$$a.concat([$$v]))}else{$$i>-1&&(_vm.brands=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.brands=$$c}},_vm.brandChecked]}}),_vm._v(" "),_vm._m(13)]),_vm._v(" "),_c('div',{staticClass:"custom-control custom-checkbox"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.brands),expression:"brands"}],staticClass:"custom-control-input",attrs:{"type":"checkbox","id":"lotus","value":"lotus"},domProps:{"checked":Array.isArray(_vm.brands)?_vm._i(_vm.brands,"lotus")>-1:(_vm.brands)},on:{"change":[function($event){var $$a=_vm.brands,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="lotus",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.brands=$$a.concat([$$v]))}else{$$i>-1&&(_vm.brands=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.brands=$$c}},_vm.brandChecked]}}),_vm._v(" "),_vm._m(14)])])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"input-group-btn"},[_c('button',{attrs:{"type":"submit"}},[_c('i',{staticClass:"material-icons search"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h3',{staticClass:"widget-title"},[_c('strong',[_vm._v("  Filtrer par ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h3',{staticClass:"widget-title"},[_c('strong',[_vm._v(" PRIX ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h3',{staticClass:"widget-title"},[_c('strong',[_vm._v("MARQUE")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"custom-control-label",attrs:{"for":"festina"}},[_c('strong',[_vm._v("Festina")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"custom-control-label",attrs:{"for":"morellato"}},[_c('strong',[_vm._v("Morellato")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"custom-control-label",attrs:{"for":"maserati"}},[_c('strong',[_vm._v("Maserati")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"custom-control-label",attrs:{"for":"MONTIGNAC"}},[_c('strong',[_vm._v("MONTIGNAC")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"custom-control-label",attrs:{"for":"nautica"}},[_c('strong',[_vm._v("Nautica")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"custom-control-label",attrs:{"for":"timberland"}},[_c('strong',[_vm._v("Timberland")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"custom-control-label",attrs:{"for":"mk"}},[_c('strong',[_vm._v("Michael Kors")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"custom-control-label",attrs:{"for":"armani exchange"}},[_c('strong',[_vm._v(" Armani exchange ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"custom-control-label",attrs:{"for":"diesel"}},[_c('strong',[_vm._v("Diesel")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"custom-control-label",attrs:{"for":"fossil"}},[_c('strong',[_vm._v("Fossil")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"custom-control-label",attrs:{"for":"lotus"}},[_c('strong',[_vm._v("Lotus")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 207 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_festina_vue__ = __webpack_require__(56);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_21dc0876_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_festina_vue__ = __webpack_require__(209);
function injectStyle (ssrContext) {
  __webpack_require__(208)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-21dc0876"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_festina_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_21dc0876_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_festina_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 208 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 209 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mr-top-40"},[_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"container-fluid padding-bottom-3x mb-1"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-10 col-lg-9 col-md-8 order-md-2"},[_c('div',{staticClass:"d-flex flex-wrap-reverse flex-md-nowrap justify-content-center justify-content-sm-between align-items-center mb-30"},[_c('div',{staticClass:"pt-3 pb-1 pb-sm-3 text-sm text-center text-sm-left"},[_c('span',{staticClass:"text-muted mr-2"},[_vm._v("Affichage des produits")]),_vm._v("1- "+_vm._s(_vm.pageSize)+" Produits")]),_vm._v(" "),_c('form',{staticClass:"input-group shop-search-box",attrs:{"method":"get"}},[_vm._m(0),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filter),expression:"filter"}],staticClass:"form-control",staticStyle:{"border":"2px solid #000000"},attrs:{"type":"search","placeholder":"Recherche par Référence","disabled":_vm.brands.length>0},domProps:{"value":(_vm.filter)},on:{"keyup":_vm.search,"input":function($event){if($event.target.composing){ return; }_vm.filter=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"d-flex flex-wrap justify-content-center mb-2"},_vm._l((_vm.filterProduct),function(product){return _c('div',{key:product.id,staticClass:"col-xl-3 col-lg-4 col-sm-6"},[_c('div',{staticClass:"product-card mb-30"},[_c('div',{staticClass:"product-card-thumb"},[_c('router-link',{staticClass:"product-card-link",attrs:{"to":{ name: 'productref', params: { ref: product.id }}},nativeOn:{"click":function($event){_vm.ProductDetail(product)}}}),_c('img',{attrs:{"src":product.img,"alt":"Product"}}),_vm._v(" "),_c('div',{staticClass:"product-card-buttons"},[_c('button',{staticClass:"btn btn-primary btn-sm",on:{"click":function($event){_vm.addToCart(product)}}},[_vm._v("Ajouter au panier")])])],1),_vm._v(" "),_c('div',{staticClass:"product-card-details"},[_c('h3',{staticClass:"product-card-title"},[_c('b',{attrs:{"href":"shop-single.html"}},[_c('strong',[_vm._v(_vm._s(product.description))])])]),_vm._v(" "),_c('span',{staticClass:"h6 d-block"},[_c('del',{staticClass:"text-muted text-normal"},[_vm._v(_vm._s(product.price2)+" DA")]),_vm._v(" "+_vm._s(product.price)+" DA")])])])])})),_vm._v(" "),_c('pagination',{attrs:{"total":_vm.total,"page-size":_vm.pageSize,"callback":_vm.pageChanged,"options":_vm.paginationOptions,"nav-class":"pagination","ul-class":"column pages","li-class":"pt-2"}})],1),_vm._v(" "),_c('div',{staticClass:"col-xl-2 col-lg-3 col-md-4 order-md-1"},[_c('div',{staticClass:"sidebar-toggle position-left",class:{sidebaropen:_vm.sidebarOpen},on:{"click":function($event){_vm.sidebarOpen=!_vm.sidebarOpen}}},[_c('i',{staticClass:"material-icons filter_list"})]),_vm._v(" "),_c('aside',{staticClass:"sidebar sidebar-offcanvas position-left",class:{offcanvasopen:_vm.sidebarOpen}},[_c('span',{staticClass:"sidebar-close",on:{"click":function($event){_vm.sidebarOpen=!_vm.sidebarOpen}}},[_c('i',{staticClass:"material-icons icon_close"})]),_vm._v(" "),_c('section',{staticClass:"widget widget-icon-list"})])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"input-group-btn"},[_c('button',{attrs:{"type":"submit"}},[_c('i',{staticClass:"material-icons search"})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 210 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_festinadepot_vue__ = __webpack_require__(57);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0b27d5c2_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_festinadepot_vue__ = __webpack_require__(212);
function injectStyle (ssrContext) {
  __webpack_require__(211)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0b27d5c2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_festinadepot_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0b27d5c2_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_festinadepot_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 211 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 212 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mr-top-40"},[_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"container-fluid padding-bottom-3x mb-1"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-10 col-lg-9 col-md-8 order-md-2"},[_c('div',{staticClass:"d-flex flex-wrap-reverse flex-md-nowrap justify-content-center justify-content-sm-between align-items-center mb-30"},[_c('div',{staticClass:"pt-3 pb-1 pb-sm-3 text-sm text-center text-sm-left"},[_c('span',{staticClass:"text-muted mr-2"},[_vm._v("Affichage des produits")]),_vm._v("1- "+_vm._s(_vm.pageSize)+" Produits")]),_vm._v(" "),_c('form',{staticClass:"input-group shop-search-box",attrs:{"method":"get"}},[_vm._m(0),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filter),expression:"filter"}],staticClass:"form-control",staticStyle:{"border":"2px solid #000000"},attrs:{"type":"search","placeholder":"Recherche par Référence","disabled":_vm.brands.length>0},domProps:{"value":(_vm.filter)},on:{"keyup":_vm.search,"input":function($event){if($event.target.composing){ return; }_vm.filter=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"d-flex flex-wrap justify-content-center mb-2"},_vm._l((_vm.filterProduct),function(product){return _c('div',{key:product.id,staticClass:"col-xl-3 col-lg-4 col-sm-6"},[_c('div',{staticClass:"product-card mb-30"},[_c('div',{staticClass:"product-card-thumb"},[_c('router-link',{staticClass:"product-card-link",attrs:{"to":{ name: 'productref', params: { ref: product.id }}},nativeOn:{"click":function($event){_vm.ProductDetail(product)}}},[(product.annee=='2020')?_c('h6',{staticClass:"product-badge text-danger"},[_c('b',[_vm._v("NOUVEAU "),_c('i',{staticClass:"material-icons favorite_border"}),_c('i',{staticClass:"material-icons favorite_border"}),_c('i',{staticClass:"material-icons favorite_border"})])]):_vm._e(),_vm._v(" "),(product.annee>'2021')?_c('h6',{staticClass:"product-badge text-danger"},[_c('b',[_vm._v(" EXCLUSIVITE ")])]):_vm._e(),_vm._v(" "),(product.quantite>='3' && product.annee!='2020'&& product.annee!='2022'&& product.annee!='2023'&& product.annee!='2024')?_c('h6',{staticClass:"product-badge text-danger"},[_c('b',[_vm._v("TOP "),_c('i',{staticClass:"material-icons favorite_border"}),_c('i',{staticClass:"material-icons favorite_border"}),_c('i',{staticClass:"material-icons favorite_border"}),_c('i',{staticClass:"material-icons favorite_border"}),_c('i',{staticClass:"material-icons favorite_border"})])]):_vm._e()]),_c('img',{attrs:{"src":product.img,"alt":"Product"}}),_vm._v(" "),_c('div',{staticClass:"product-card-buttons"},[_c('button',{staticClass:"btn btn-primary btn-sm",on:{"click":function($event){_vm.addToCart(product)}}},[_vm._v("Ajouter au panier")])])],1),_vm._v(" "),_c('div',{staticClass:"product-card-details"},[_c('h3',{staticClass:"product-card-title"},[_c('b',{attrs:{"href":"shop-single.html"}},[_c('strong',[_vm._v("QU :"+_vm._s(product.quantite))])])]),_vm._v(" "),_c('h3',{staticClass:"product-card-title"},[_c('b',{attrs:{"href":"shop-single.html"}},[_c('strong',[_vm._v("SY :"+_vm._s(product.annee))])])]),_vm._v(" "),_c('h3',{staticClass:"product-card-title"},[_c('b',{attrs:{"href":"shop-single.html"}},[_c('strong',[_vm._v("OR :"+_vm._s(product.typeBracelet))])])]),_vm._v(" "),_c('h3',{staticClass:"product-card-title"},[_c('b',{attrs:{"href":"shop-single.html"}},[_c('strong',[_vm._v("ML :"+_vm._s(product.description))])])]),_vm._v(" "),_c('h3',{staticClass:"product-card-title"},[_c('b',{attrs:{"href":"shop-single.html"}},[_c('strong',[_vm._v("kh :"+_vm._s(product.price2))])])]),_vm._v(" "),_c('h3',{staticClass:"product-card-title"},[_c('b',{attrs:{"href":"shop-single.html"}},[_c('strong',[_vm._v("DP :"+_vm._s(product.waterResiste))])])]),_vm._v(" "),_c('span',{staticClass:"h6 d-block"},[_c('del',{staticClass:"text-muted text-normal"}),_vm._v(" "+_vm._s(product.price)+" DA")])])])])})),_vm._v(" "),_c('pagination',{attrs:{"total":_vm.total,"page-size":_vm.pageSize,"callback":_vm.pageChanged,"options":_vm.paginationOptions,"nav-class":"pagination","ul-class":"column pages","li-class":"pt-2"}})],1),_vm._v(" "),_c('div',{staticClass:"col-xl-2 col-lg-3 col-md-4 order-md-1"},[_c('div',{staticClass:"sidebar-toggle position-left",class:{sidebaropen:_vm.sidebarOpen},on:{"click":function($event){_vm.sidebarOpen=!_vm.sidebarOpen}}},[_c('i',{staticClass:"material-icons filter_list"})]),_vm._v(" "),_c('aside',{staticClass:"sidebar sidebar-offcanvas position-left",class:{offcanvasopen:_vm.sidebarOpen}},[_c('span',{staticClass:"sidebar-close",on:{"click":function($event){_vm.sidebarOpen=!_vm.sidebarOpen}}},[_c('i',{staticClass:"material-icons icon_close"})]),_vm._v(" "),_c('section',{staticClass:"widget widget-icon-list"},[_vm._m(1),_vm._v(" "),_c('ul',[_c('li',[_c('a',{attrs:{"href":"#"},on:{"click":function($event){_vm.ordreby('quantite')}}},[_c('i',{staticClass:"material-icons favorite_border"}),_vm._v("oran")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#"},on:{"click":function($event){_vm.ordreby('annee')}}},[_c('i',{staticClass:"material-icons vertical_align_top"}),_vm._v("sidi yahia")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#"},on:{"click":function($event){_vm.ordreby('annee2')}}},[_c('i',{staticClass:"material-icons vertical_align_top"}),_vm._v("mall")])])])]),_vm._v(" "),_c('section',{staticClass:"widget widget-categories"},[_c('h3',{staticClass:"widget-title"},[_vm._v("PRIX")]),_vm._v(" "),_c('el-slider',{attrs:{"range":"","step":10000,"show-stops":"","max":80000},model:{value:(_vm.priceValue),callback:function ($$v) {_vm.priceValue=$$v},expression:"priceValue"}}),_vm._v(" "),_c('form',{staticClass:"price-range-slider",on:{"submit":function($event){$event.preventDefault();return _vm.submit($event)}}},[_c('div',{staticClass:"ui-range-slider-footer"},[_vm._m(2),_vm._v(" "),_c('div',{staticClass:"column"},[_c('span',[_vm._v(_vm._s(_vm.priceValue[0])+"DA-"+_vm._s(_vm.priceValue[1])+"DA")])])])])],1),_vm._v(" "),_c('section',{staticClass:"widget"},[_vm._m(3),_vm._v(" "),_c('div',{staticClass:"custom-control custom-checkbox"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.brands),expression:"brands"}],staticClass:"custom-control-input",attrs:{"type":"checkbox","id":"Homme","value":"H"},domProps:{"checked":Array.isArray(_vm.brands)?_vm._i(_vm.brands,"H")>-1:(_vm.brands)},on:{"change":[function($event){var $$a=_vm.brands,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="H",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.brands=$$a.concat([$$v]))}else{$$i>-1&&(_vm.brands=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.brands=$$c}},_vm.brandChecked]}}),_vm._v(" "),_vm._m(4)]),_vm._v(" "),_c('div',{staticClass:"custom-control custom-checkbox"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.brands),expression:"brands"}],staticClass:"custom-control-input",attrs:{"type":"checkbox","id":"femme","value":"F"},domProps:{"checked":Array.isArray(_vm.brands)?_vm._i(_vm.brands,"F")>-1:(_vm.brands)},on:{"change":[function($event){var $$a=_vm.brands,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="F",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.brands=$$a.concat([$$v]))}else{$$i>-1&&(_vm.brands=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.brands=$$c}},_vm.brandChecked]}}),_vm._v(" "),_vm._m(5)])])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"input-group-btn"},[_c('button',{attrs:{"type":"submit"}},[_c('i',{staticClass:"material-icons search"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h3',{staticClass:"widget-title"},[_c('strong',[_vm._v("  Filter par ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"column"},[_c('button',{staticClass:"btn btn-outline-primary btn-sm",attrs:{"type":"submit"}},[_vm._v("Filter")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h3',{staticClass:"widget-title"},[_c('strong',[_vm._v("Homme /")]),_vm._v(" "),_c('strong',[_vm._v(" FEMME ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"custom-control-label",attrs:{"for":"Homme"}},[_c('strong',[_vm._v("HOMME ")]),_vm._v(" "),_c('span',{staticClass:"text-muted"},[_vm._v("(25)")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"custom-control-label",attrs:{"for":"femme"}},[_c('strong',[_vm._v("FEMME ")]),_vm._v(" "),_c('span',{staticClass:"text-muted"},[_vm._v("(25)")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 213 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_bourdima_vue__ = __webpack_require__(58);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fa2cd9ae_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_bourdima_vue__ = __webpack_require__(215);
function injectStyle (ssrContext) {
  __webpack_require__(214)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-fa2cd9ae"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_bourdima_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fa2cd9ae_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_bourdima_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 214 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 215 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mr-top-40"},[_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"container-fluid padding-bottom-3x mb-1"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-10 col-lg-9 col-md-8 order-md-2"},[_c('div',{staticClass:"d-flex flex-wrap-reverse flex-md-nowrap justify-content-center justify-content-sm-between align-items-center mb-30"},[_c('div',{staticClass:"pt-3 pb-1 pb-sm-3 text-sm text-center text-sm-left"},[_c('span',{staticClass:"text-muted mr-2"},[_vm._v("Affichage des produits")]),_vm._v("1- "+_vm._s(_vm.pageSize)+" Produits")]),_vm._v(" "),_c('form',{staticClass:"input-group shop-search-box",attrs:{"method":"get"}},[_vm._m(0),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filter),expression:"filter"}],staticClass:"form-control",staticStyle:{"border":"2px solid #000000"},attrs:{"type":"search","placeholder":"Recherche par Référence","disabled":_vm.brands.length>0},domProps:{"value":(_vm.filter)},on:{"keyup":_vm.search,"input":function($event){if($event.target.composing){ return; }_vm.filter=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"d-flex flex-wrap justify-content-center mb-2"},_vm._l((_vm.filterProduct),function(product){return _c('div',{key:product.id,staticClass:"col-xl-3 col-lg-4 col-sm-6"},[_c('div',{staticClass:"product-card mb-30"},[_c('div',{staticClass:"product-card-thumb"},[_c('router-link',{staticClass:"product-card-link",attrs:{"to":"/product"},nativeOn:{"click":function($event){_vm.ProductDetail(product)}}}),_c('img',{attrs:{"src":product.img,"alt":"Product"}}),_vm._v(" "),_c('div',{staticClass:"product-card-buttons"},[_c('button',{staticClass:"btn btn-primary btn-sm",on:{"click":function($event){_vm.addToCart(product)}}},[_vm._v("Ajouter au panier")])])],1),_vm._v(" "),_c('div',{staticClass:"product-card-details"},[_c('h3',{staticClass:"product-card-title"},[_c('b',{attrs:{"href":"shop-single.html"}},[_c('strong',[_vm._v(_vm._s(product.id)+" /stock:=> "+_vm._s(product.quantite))])])]),_vm._v(" "),_c('h4',{staticClass:"product-card-price"},[_c('strong',[_vm._v(_vm._s(product.price)+" DA ")])])])])])})),_vm._v(" "),_c('pagination',{attrs:{"total":_vm.total,"page-size":_vm.pageSize,"callback":_vm.pageChanged,"options":_vm.paginationOptions,"nav-class":"pagination","ul-class":"column pages","li-class":"pt-2"}})],1),_vm._v(" "),_c('div',{staticClass:"col-xl-2 col-lg-3 col-md-4 order-md-1"},[_c('div',{staticClass:"sidebar-toggle position-left",class:{sidebaropen:_vm.sidebarOpen},on:{"click":function($event){_vm.sidebarOpen=!_vm.sidebarOpen}}},[_c('i',{staticClass:"material-icons filter_list"})]),_vm._v(" "),_c('aside',{staticClass:"sidebar sidebar-offcanvas position-left",class:{offcanvasopen:_vm.sidebarOpen}},[_c('span',{staticClass:"sidebar-close",on:{"click":function($event){_vm.sidebarOpen=!_vm.sidebarOpen}}},[_c('i',{staticClass:"material-icons icon_close"})]),_vm._v(" "),_c('section',{staticClass:"widget widget-icon-list"},[_vm._m(1),_vm._v(" "),_c('ul',[_c('li',[_c('a',{attrs:{"href":"#"},on:{"click":function($event){_vm.ordreby('quantite')}}},[_c('i',{staticClass:"material-icons favorite_border"}),_vm._v("Popularité")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#"},on:{"click":function($event){_vm.ordreby('annee')}}},[_c('i',{staticClass:"material-icons vertical_align_top"}),_vm._v("Dernière collection")])])])]),_vm._v(" "),_c('section',{staticClass:"widget widget-categories"},[_c('h3',{staticClass:"widget-title"},[_vm._v("PRIX")]),_vm._v(" "),_c('el-slider',{attrs:{"range":"","step":10000,"show-stops":"","max":80000},model:{value:(_vm.priceValue),callback:function ($$v) {_vm.priceValue=$$v},expression:"priceValue"}}),_vm._v(" "),_c('form',{staticClass:"price-range-slider",on:{"submit":function($event){$event.preventDefault();return _vm.submit($event)}}},[_c('div',{staticClass:"ui-range-slider-footer"},[_vm._m(2),_vm._v(" "),_c('div',{staticClass:"column"},[_c('span',[_vm._v(_vm._s(_vm.priceValue[0])+"DA-"+_vm._s(_vm.priceValue[1])+"DA")])])])])],1),_vm._v(" "),_c('section',{staticClass:"widget"},[_vm._m(3),_vm._v(" "),_c('div',{staticClass:"custom-control custom-checkbox"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.brands),expression:"brands"}],staticClass:"custom-control-input",attrs:{"type":"checkbox","id":"Homme","value":"H"},domProps:{"checked":Array.isArray(_vm.brands)?_vm._i(_vm.brands,"H")>-1:(_vm.brands)},on:{"change":[function($event){var $$a=_vm.brands,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="H",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.brands=$$a.concat([$$v]))}else{$$i>-1&&(_vm.brands=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.brands=$$c}},_vm.brandChecked]}}),_vm._v(" "),_vm._m(4)]),_vm._v(" "),_c('div',{staticClass:"custom-control custom-checkbox"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.brands),expression:"brands"}],staticClass:"custom-control-input",attrs:{"type":"checkbox","id":"femme","value":"F"},domProps:{"checked":Array.isArray(_vm.brands)?_vm._i(_vm.brands,"F")>-1:(_vm.brands)},on:{"change":[function($event){var $$a=_vm.brands,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="F",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.brands=$$a.concat([$$v]))}else{$$i>-1&&(_vm.brands=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.brands=$$c}},_vm.brandChecked]}}),_vm._v(" "),_vm._m(5)])])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"input-group-btn"},[_c('button',{attrs:{"type":"submit"}},[_c('i',{staticClass:"material-icons search"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h3',{staticClass:"widget-title"},[_c('strong',[_vm._v("  Filter par ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"column"},[_c('button',{staticClass:"btn btn-outline-primary btn-sm",attrs:{"type":"submit"}},[_vm._v("Filter")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h3',{staticClass:"widget-title"},[_c('strong',[_vm._v("Homme /")]),_vm._v(" "),_c('strong',[_vm._v(" FEMME ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"custom-control-label",attrs:{"for":"Homme"}},[_c('strong',[_vm._v("HOMME ")]),_vm._v(" "),_c('span',{staticClass:"text-muted"},[_vm._v("(25)")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"custom-control-label",attrs:{"for":"femme"}},[_c('strong',[_vm._v("FEMME ")]),_vm._v(" "),_c('span',{staticClass:"text-muted"},[_vm._v("(25)")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 216 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_bourdimafossil_vue__ = __webpack_require__(59);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_14593ab5_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_bourdimafossil_vue__ = __webpack_require__(218);
function injectStyle (ssrContext) {
  __webpack_require__(217)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-14593ab5"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_bourdimafossil_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_14593ab5_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_bourdimafossil_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 217 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 218 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mr-top-40"},[_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"container-fluid padding-bottom-3x mb-1"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-10 col-lg-9 col-md-8 order-md-2"},[_c('div',{staticClass:"d-flex flex-wrap-reverse flex-md-nowrap justify-content-center justify-content-sm-between align-items-center mb-30"},[_c('div',{staticClass:"pt-3 pb-1 pb-sm-3 text-sm text-center text-sm-left"},[_c('span',{staticClass:"text-muted mr-2"},[_vm._v("Affichage des produits")]),_vm._v("1- "+_vm._s(_vm.pageSize)+" Produits")]),_vm._v(" "),_c('form',{staticClass:"input-group shop-search-box",attrs:{"method":"get"}},[_vm._m(0),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filter),expression:"filter"}],staticClass:"form-control",staticStyle:{"border":"2px solid #000000"},attrs:{"type":"search","placeholder":"Recherche par Référence","disabled":_vm.brands.length>0},domProps:{"value":(_vm.filter)},on:{"keyup":_vm.search,"input":function($event){if($event.target.composing){ return; }_vm.filter=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"d-flex flex-wrap justify-content-center mb-2"},_vm._l((_vm.filterProduct),function(product){return _c('div',{key:product.id,staticClass:"col-xl-3 col-lg-4 col-sm-6"},[_c('div',{staticClass:"product-card mb-30"},[_c('div',{staticClass:"product-card-thumb"},[_c('router-link',{staticClass:"product-card-link",attrs:{"to":"/product"},nativeOn:{"click":function($event){_vm.ProductDetail(product)}}}),_c('img',{attrs:{"src":product.img,"alt":"Product"}}),_vm._v(" "),_c('div',{staticClass:"product-card-buttons"},[_c('button',{staticClass:"btn btn-primary btn-sm",on:{"click":function($event){_vm.addToCart(product)}}},[_vm._v("Ajouter au panier")])])],1),_vm._v(" "),_c('div',{staticClass:"product-card-details"},[_c('h3',{staticClass:"product-card-title"},[_c('b',{attrs:{"href":"shop-single.html"}},[_c('strong',[_vm._v(_vm._s(product.id)+" /stock:=> "+_vm._s(product.quantite))])])]),_vm._v(" "),_c('h4',{staticClass:"product-card-price"},[_c('strong',[_vm._v(_vm._s(product.price)+" DA ")])])])])])})),_vm._v(" "),_c('pagination',{attrs:{"total":_vm.total,"page-size":_vm.pageSize,"callback":_vm.pageChanged,"options":_vm.paginationOptions,"nav-class":"pagination","ul-class":"column pages","li-class":"pt-2"}})],1),_vm._v(" "),_c('div',{staticClass:"col-xl-2 col-lg-3 col-md-4 order-md-1"},[_c('div',{staticClass:"sidebar-toggle position-left",class:{sidebaropen:_vm.sidebarOpen},on:{"click":function($event){_vm.sidebarOpen=!_vm.sidebarOpen}}},[_c('i',{staticClass:"material-icons filter_list"})]),_vm._v(" "),_c('aside',{staticClass:"sidebar sidebar-offcanvas position-left",class:{offcanvasopen:_vm.sidebarOpen}},[_c('span',{staticClass:"sidebar-close",on:{"click":function($event){_vm.sidebarOpen=!_vm.sidebarOpen}}},[_c('i',{staticClass:"material-icons icon_close"})]),_vm._v(" "),_c('section',{staticClass:"widget widget-icon-list"},[_vm._m(1),_vm._v(" "),_c('ul',[_c('li',[_c('a',{attrs:{"href":"#"},on:{"click":function($event){_vm.ordreby('quantite')}}},[_c('i',{staticClass:"material-icons favorite_border"}),_vm._v("Popularité")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#"},on:{"click":function($event){_vm.ordreby('annee')}}},[_c('i',{staticClass:"material-icons vertical_align_top"}),_vm._v("Dernière collection")])])])]),_vm._v(" "),_c('section',{staticClass:"widget widget-categories"},[_c('h3',{staticClass:"widget-title"},[_vm._v("PRIX")]),_vm._v(" "),_c('el-slider',{attrs:{"range":"","step":10000,"show-stops":"","max":80000},model:{value:(_vm.priceValue),callback:function ($$v) {_vm.priceValue=$$v},expression:"priceValue"}}),_vm._v(" "),_c('form',{staticClass:"price-range-slider",on:{"submit":function($event){$event.preventDefault();return _vm.submit($event)}}},[_c('div',{staticClass:"ui-range-slider-footer"},[_vm._m(2),_vm._v(" "),_c('div',{staticClass:"column"},[_c('span',[_c('strong',[_vm._v(_vm._s(_vm.priceValue[0])+"DA-"+_vm._s(_vm.priceValue[1])+"DA ")])])])])])],1),_vm._v(" "),_c('section',{staticClass:"widget"},[_vm._m(3),_vm._v(" "),_c('div',{staticClass:"custom-control custom-checkbox"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.brands),expression:"brands"}],staticClass:"custom-control-input",attrs:{"type":"checkbox","id":"Homme","value":"H"},domProps:{"checked":Array.isArray(_vm.brands)?_vm._i(_vm.brands,"H")>-1:(_vm.brands)},on:{"change":[function($event){var $$a=_vm.brands,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="H",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.brands=$$a.concat([$$v]))}else{$$i>-1&&(_vm.brands=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.brands=$$c}},_vm.brandChecked]}}),_vm._v(" "),_vm._m(4)]),_vm._v(" "),_c('div',{staticClass:"custom-control custom-checkbox"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.brands),expression:"brands"}],staticClass:"custom-control-input",attrs:{"type":"checkbox","id":"femme","value":"F"},domProps:{"checked":Array.isArray(_vm.brands)?_vm._i(_vm.brands,"F")>-1:(_vm.brands)},on:{"change":[function($event){var $$a=_vm.brands,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="F",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.brands=$$a.concat([$$v]))}else{$$i>-1&&(_vm.brands=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.brands=$$c}},_vm.brandChecked]}}),_vm._v(" "),_vm._m(5)])])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"input-group-btn"},[_c('button',{attrs:{"type":"submit"}},[_c('i',{staticClass:"material-icons search"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h3',{staticClass:"widget-title"},[_c('strong',[_vm._v("  Filter par ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"column"},[_c('button',{staticClass:"btn btn-outline-primary btn-sm",attrs:{"type":"submit"}},[_vm._v("Filter")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h3',{staticClass:"widget-title"},[_c('strong',[_vm._v("Homme /")]),_vm._v(" "),_c('strong',[_vm._v(" FEMME ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"custom-control-label",attrs:{"for":"Homme"}},[_c('strong',[_vm._v("HOMME ")]),_vm._v(" "),_c('span',{staticClass:"text-muted"},[_vm._v("(25)")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"custom-control-label",attrs:{"for":"femme"}},[_c('strong',[_vm._v("FEMME ")]),_vm._v(" "),_c('span',{staticClass:"text-muted"},[_vm._v("(25)")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 219 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_bourdimaarmani_vue__ = __webpack_require__(60);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_72c67ac4_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_bourdimaarmani_vue__ = __webpack_require__(221);
function injectStyle (ssrContext) {
  __webpack_require__(220)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-72c67ac4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_bourdimaarmani_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_72c67ac4_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_bourdimaarmani_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 220 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 221 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mr-top-40"},[_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"container-fluid padding-bottom-3x mb-1"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-10 col-lg-9 col-md-8 order-md-2"},[_c('div',{staticClass:"d-flex flex-wrap-reverse flex-md-nowrap justify-content-center justify-content-sm-between align-items-center mb-30"},[_c('div',{staticClass:"pt-3 pb-1 pb-sm-3 text-sm text-center text-sm-left"},[_c('span',{staticClass:"text-muted mr-2"},[_vm._v("Affichage des produits")]),_vm._v("1- "+_vm._s(_vm.pageSize)+" Produits")]),_vm._v(" "),_c('form',{staticClass:"input-group shop-search-box",attrs:{"method":"get"}},[_vm._m(0),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filter),expression:"filter"}],staticClass:"form-control",staticStyle:{"border":"2px solid #000000"},attrs:{"type":"search","placeholder":"Recherche par Référence","disabled":_vm.brands.length>0},domProps:{"value":(_vm.filter)},on:{"keyup":_vm.search,"input":function($event){if($event.target.composing){ return; }_vm.filter=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"d-flex flex-wrap justify-content-center mb-2"},[_c('div',{staticClass:"d-flex flex-wrap justify-content-center mb-2"},_vm._l((_vm.filterProduct),function(product){return _c('div',{key:product.id,staticClass:"col-xl-3 col-lg-4 col-sm-6"},[_c('div',{staticClass:"product-card mb-30"},[_c('div',{staticClass:"product-card-thumb"},[_c('router-link',{staticClass:"product-card-link",attrs:{"to":"/product"},nativeOn:{"click":function($event){_vm.ProductDetail(product)}}}),_c('img',{attrs:{"src":product.img,"alt":"Product"}}),_vm._v(" "),_c('div',{staticClass:"product-card-buttons"},[_c('button',{staticClass:"btn btn-primary btn-sm",on:{"click":function($event){_vm.addToCart(product)}}},[_vm._v("Ajouter au panier")])])],1),_vm._v(" "),_c('div',{staticClass:"product-card-details"},[_c('h3',{staticClass:"product-card-title"},[_c('b',{attrs:{"href":"shop-single.html"}},[_c('strong',[_vm._v(_vm._s(product.id)+" /stock:=> "+_vm._s(product.quantite))])])]),_vm._v(" "),_c('h4',{staticClass:"product-card-price"},[_c('strong',[_vm._v(_vm._s(product.price)+" DA ")])])])])])}))]),_vm._v(" "),_c('pagination',{attrs:{"total":_vm.total,"page-size":_vm.pageSize,"callback":_vm.pageChanged,"options":_vm.paginationOptions,"nav-class":"pagination","ul-class":"column pages","li-class":"pt-2"}})],1),_vm._v(" "),_c('div',{staticClass:"col-xl-2 col-lg-3 col-md-4 order-md-1"},[_c('div',{staticClass:"sidebar-toggle position-left",class:{sidebaropen:_vm.sidebarOpen},on:{"click":function($event){_vm.sidebarOpen=!_vm.sidebarOpen}}},[_c('i',{staticClass:"material-icons filter_list"})]),_vm._v(" "),_c('aside',{staticClass:"sidebar sidebar-offcanvas position-left",class:{offcanvasopen:_vm.sidebarOpen}},[_c('span',{staticClass:"sidebar-close",on:{"click":function($event){_vm.sidebarOpen=!_vm.sidebarOpen}}},[_c('i',{staticClass:"material-icons icon_close"})]),_vm._v(" "),_c('section',{staticClass:"widget widget-icon-list"},[_vm._m(1),_vm._v(" "),_c('ul',[_c('li',[_c('a',{attrs:{"href":"#"},on:{"click":function($event){_vm.ordreby('quantite')}}},[_c('i',{staticClass:"material-icons favorite_border"}),_vm._v("Popularité")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#"},on:{"click":function($event){_vm.ordreby('annee')}}},[_c('i',{staticClass:"material-icons vertical_align_top"}),_vm._v("Dernière collection")])])])]),_vm._v(" "),_c('section',{staticClass:"widget widget-categories"},[_c('h3',{staticClass:"widget-title"},[_vm._v("PRIX")]),_vm._v(" "),_c('el-slider',{attrs:{"range":"","step":10000,"show-stops":"","max":80000},model:{value:(_vm.priceValue),callback:function ($$v) {_vm.priceValue=$$v},expression:"priceValue"}}),_vm._v(" "),_c('form',{staticClass:"price-range-slider",on:{"submit":function($event){$event.preventDefault();return _vm.submit($event)}}},[_c('div',{staticClass:"ui-range-slider-footer"},[_vm._m(2),_vm._v(" "),_c('div',{staticClass:"column"},[_c('span',[_vm._v(_vm._s(_vm.priceValue[0])+"DA-"+_vm._s(_vm.priceValue[1])+"DA")])])])])],1),_vm._v(" "),_c('section',{staticClass:"widget"},[_vm._m(3),_vm._v(" "),_c('div',{staticClass:"custom-control custom-checkbox"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.brands),expression:"brands"}],staticClass:"custom-control-input",attrs:{"type":"checkbox","id":"Homme","value":"H"},domProps:{"checked":Array.isArray(_vm.brands)?_vm._i(_vm.brands,"H")>-1:(_vm.brands)},on:{"change":[function($event){var $$a=_vm.brands,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="H",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.brands=$$a.concat([$$v]))}else{$$i>-1&&(_vm.brands=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.brands=$$c}},_vm.brandChecked]}}),_vm._v(" "),_vm._m(4)]),_vm._v(" "),_c('div',{staticClass:"custom-control custom-checkbox"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.brands),expression:"brands"}],staticClass:"custom-control-input",attrs:{"type":"checkbox","id":"femme","value":"F"},domProps:{"checked":Array.isArray(_vm.brands)?_vm._i(_vm.brands,"F")>-1:(_vm.brands)},on:{"change":[function($event){var $$a=_vm.brands,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="F",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.brands=$$a.concat([$$v]))}else{$$i>-1&&(_vm.brands=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.brands=$$c}},_vm.brandChecked]}}),_vm._v(" "),_vm._m(5)])])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"input-group-btn"},[_c('button',{attrs:{"type":"submit"}},[_c('i',{staticClass:"material-icons search"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h3',{staticClass:"widget-title"},[_c('strong',[_vm._v("  Filter par ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"column"},[_c('button',{staticClass:"btn btn-outline-primary btn-sm",attrs:{"type":"submit"}},[_vm._v("Filter")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h3',{staticClass:"widget-title"},[_c('strong',[_vm._v("Homme /")]),_vm._v(" "),_c('strong',[_vm._v(" FEMME ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"custom-control-label",attrs:{"for":"Homme"}},[_c('strong',[_vm._v("HOMME ")]),_vm._v(" "),_c('span',{staticClass:"text-muted"},[_vm._v("(25)")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"custom-control-label",attrs:{"for":"femme"}},[_c('strong',[_vm._v("FEMME ")]),_vm._v(" "),_c('span',{staticClass:"text-muted"},[_vm._v("(25)")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 222 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_bourdimadiesel_vue__ = __webpack_require__(61);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a8584988_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_bourdimadiesel_vue__ = __webpack_require__(224);
function injectStyle (ssrContext) {
  __webpack_require__(223)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-a8584988"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_bourdimadiesel_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a8584988_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_bourdimadiesel_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 223 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 224 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mr-top-40"},[_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"container-fluid padding-bottom-3x mb-1"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-10 col-lg-9 col-md-8 order-md-2"},[_c('div',{staticClass:"d-flex flex-wrap-reverse flex-md-nowrap justify-content-center justify-content-sm-between align-items-center mb-30"},[_c('div',{staticClass:"pt-3 pb-1 pb-sm-3 text-sm text-center text-sm-left"},[_c('span',{staticClass:"text-muted mr-2"},[_vm._v("Affichage des produits")]),_vm._v("1- "+_vm._s(_vm.pageSize)+" Produits")]),_vm._v(" "),_c('form',{staticClass:"input-group shop-search-box",attrs:{"method":"get"}},[_vm._m(0),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filter),expression:"filter"}],staticClass:"form-control",staticStyle:{"border":"2px solid #000000"},attrs:{"type":"search","placeholder":"Recherche par Référence","disabled":_vm.brands.length>0},domProps:{"value":(_vm.filter)},on:{"keyup":_vm.search,"input":function($event){if($event.target.composing){ return; }_vm.filter=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"d-flex flex-wrap justify-content-center mb-2"},_vm._l((_vm.filterProduct),function(product){return _c('div',{key:product.id,staticClass:"col-xl-3 col-lg-4 col-sm-6"},[_c('div',{staticClass:"product-card mb-30"},[_c('div',{staticClass:"product-card-thumb"},[_c('router-link',{staticClass:"product-card-link",attrs:{"to":"/product"},nativeOn:{"click":function($event){_vm.ProductDetail(product)}}}),_c('img',{attrs:{"src":product.img,"alt":"Product"}}),_vm._v(" "),_c('div',{staticClass:"product-card-buttons"},[_c('button',{staticClass:"btn btn-primary btn-sm",on:{"click":function($event){_vm.addToCart(product)}}},[_vm._v("Ajouter au panier")])])],1),_vm._v(" "),_c('div',{staticClass:"product-card-details"},[_c('h3',{staticClass:"product-card-title"},[_c('b',{attrs:{"href":"shop-single.html"}},[_c('strong',[_vm._v(_vm._s(product.id)+" /stock:=> "+_vm._s(product.quantite))])])]),_vm._v(" "),_c('h4',{staticClass:"product-card-price"},[_c('strong',[_vm._v(_vm._s(product.price)+" DA ")])])])])])})),_vm._v(" "),_c('pagination',{attrs:{"total":_vm.total,"page-size":_vm.pageSize,"callback":_vm.pageChanged,"options":_vm.paginationOptions,"nav-class":"pagination","ul-class":"column pages","li-class":"pt-2"}})],1),_vm._v(" "),_c('div',{staticClass:"col-xl-2 col-lg-3 col-md-4 order-md-1"},[_c('div',{staticClass:"sidebar-toggle position-left",class:{sidebaropen:_vm.sidebarOpen},on:{"click":function($event){_vm.sidebarOpen=!_vm.sidebarOpen}}},[_c('i',{staticClass:"material-icons filter_list"})]),_vm._v(" "),_c('aside',{staticClass:"sidebar sidebar-offcanvas position-left",class:{offcanvasopen:_vm.sidebarOpen}},[_c('span',{staticClass:"sidebar-close",on:{"click":function($event){_vm.sidebarOpen=!_vm.sidebarOpen}}},[_c('i',{staticClass:"material-icons icon_close"})]),_vm._v(" "),_c('section',{staticClass:"widget widget-icon-list"},[_vm._m(1),_vm._v(" "),_c('ul',[_c('li',[_c('a',{attrs:{"href":"#"},on:{"click":function($event){_vm.ordreby('quantite')}}},[_c('i',{staticClass:"material-icons favorite_border"}),_vm._v("Popularité")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#"},on:{"click":function($event){_vm.ordreby('annee')}}},[_c('i',{staticClass:"material-icons vertical_align_top"}),_vm._v("Dernière collection")])])])]),_vm._v(" "),_c('section',{staticClass:"widget widget-categories"},[_c('h3',{staticClass:"widget-title"},[_vm._v("PRIX")]),_vm._v(" "),_c('el-slider',{attrs:{"range":"","step":10000,"show-stops":"","max":80000},model:{value:(_vm.priceValue),callback:function ($$v) {_vm.priceValue=$$v},expression:"priceValue"}}),_vm._v(" "),_c('form',{staticClass:"price-range-slider",on:{"submit":function($event){$event.preventDefault();return _vm.submit($event)}}},[_c('div',{staticClass:"ui-range-slider-footer"},[_vm._m(2),_vm._v(" "),_c('div',{staticClass:"column"},[_c('span',[_vm._v(_vm._s(_vm.priceValue[0])+"DA-"+_vm._s(_vm.priceValue[1])+"DA")])])])])],1),_vm._v(" "),_c('section',{staticClass:"widget"},[_vm._m(3),_vm._v(" "),_c('div',{staticClass:"custom-control custom-checkbox"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.brands),expression:"brands"}],staticClass:"custom-control-input",attrs:{"type":"checkbox","id":"Homme","value":"H"},domProps:{"checked":Array.isArray(_vm.brands)?_vm._i(_vm.brands,"H")>-1:(_vm.brands)},on:{"change":[function($event){var $$a=_vm.brands,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="H",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.brands=$$a.concat([$$v]))}else{$$i>-1&&(_vm.brands=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.brands=$$c}},_vm.brandChecked]}}),_vm._v(" "),_vm._m(4)]),_vm._v(" "),_c('div',{staticClass:"custom-control custom-checkbox"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.brands),expression:"brands"}],staticClass:"custom-control-input",attrs:{"type":"checkbox","id":"femme","value":"F"},domProps:{"checked":Array.isArray(_vm.brands)?_vm._i(_vm.brands,"F")>-1:(_vm.brands)},on:{"change":[function($event){var $$a=_vm.brands,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="F",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.brands=$$a.concat([$$v]))}else{$$i>-1&&(_vm.brands=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.brands=$$c}},_vm.brandChecked]}}),_vm._v(" "),_vm._m(5)])])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"input-group-btn"},[_c('button',{attrs:{"type":"submit"}},[_c('i',{staticClass:"material-icons search"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h3',{staticClass:"widget-title"},[_c('strong',[_vm._v("  Filter par ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"column"},[_c('button',{staticClass:"btn btn-outline-primary btn-sm",attrs:{"type":"submit"}},[_vm._v("Filter")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h3',{staticClass:"widget-title"},[_c('strong',[_vm._v("Homme /")]),_vm._v(" "),_c('strong',[_vm._v(" FEMME ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"custom-control-label",attrs:{"for":"Homme"}},[_c('strong',[_vm._v("HOMME ")]),_vm._v(" "),_c('span',{staticClass:"text-muted"},[_vm._v("(25)")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"custom-control-label",attrs:{"for":"femme"}},[_c('strong',[_vm._v("FEMME ")]),_vm._v(" "),_c('span',{staticClass:"text-muted"},[_vm._v("(25)")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 225 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_productref_vue__ = __webpack_require__(62);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0d31cd7a_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_productref_vue__ = __webpack_require__(227);
function injectStyle (ssrContext) {
  __webpack_require__(226)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0d31cd7a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_productref_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0d31cd7a_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_productref_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 226 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 227 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"bg-secondary pb-4 padding-top-3x mt-30"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6 mb-30"},[_c('div',{staticClass:"product-gallery"},[(_vm.product.sales)?_c('span',{staticClass:"product-badge text-danger"},[_vm._v("\n             "+_vm._s(_vm.product.discount))]):_vm._e(),_vm._v(" "),_c('v-zoom',{attrs:{"img":_vm.product.img,"width":555,"magnify":1}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-md-6 mb-30"},[_c('div',{staticClass:"card border-default bg-white pt-2 box-shadow"},[_c('div',{staticClass:"card-body"},[_c('h2',{staticClass:"mb-3"},[_c('strong',[_vm._v(_vm._s(_vm.product.name)+"/"+_vm._s(_vm.product.id))])]),_vm._v(" "),_c('span',{staticClass:"h6 d-block"},[_c('del',{staticClass:"text-muted text-normal"},[_vm._v(_vm._s(_vm.product.price2)+" DA")]),_vm._v(" "+_vm._s(_vm.product.price)+" DA")]),_vm._v(" "),_c('p',{staticClass:"text-sm text-muted"},[_c('strong',[_vm._v(_vm._s(_vm.product.description))])]),_vm._v(" "),_c('div',{staticClass:"row align-items-end mb-4"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"accordion",attrs:{"id":"accordion1","role":"tablist"}}),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('div',{staticClass:"pt-4 hidden-sm-up"}),_vm._v(" "),_c('button',{staticClass:"btn btn-primary btn-block my-0",on:{"click":function($event){_vm.addToCart(_vm.product)}}},[_vm._v("Ajouter au panier")])])]),_vm._v(" "),_c('ul',{staticClass:"list-unstyled text-sm mb-4"},[_c('li',[_c('span',{staticClass:"text-dark text-medium"},[_vm._v("Reférence:")]),_vm._v(" "+_vm._s(_vm.product.id))]),_vm._v(" "),_c('li',[_c('span',{staticClass:"text-dark text-medium"},[_vm._v("Categories:")]),_vm._v(" "),_c('a',{staticClass:"navi-link",attrs:{"href":"#"}},[_vm._v("Montre")]),_vm._v(" "),_c('a',{staticClass:"navi-link",attrs:{"href":"#"}},[_vm._v(_vm._s(_vm.product.name))])])]),_vm._v(" "),_vm._m(2)])])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form',{staticClass:"modal fade",attrs:{"method":"post","id":"leaveReview","tabindex":"-1"}},[_c('div',{staticClass:"modal-dialog modal-lg"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_c('h4',{staticClass:"modal-title"},[_vm._v("Leave a Review")]),_vm._v(" "),_c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"review-name"}},[_vm._v("Your Name")]),_vm._v(" "),_c('input',{staticClass:"form-control",attrs:{"type":"text","id":"review-name","required":""}})])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"review-email"}},[_vm._v("Your Email")]),_vm._v(" "),_c('input',{staticClass:"form-control",attrs:{"type":"email","id":"review-email","required":""}})])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"review-subject"}},[_vm._v("Subject")]),_vm._v(" "),_c('input',{staticClass:"form-control",attrs:{"type":"text","id":"review-subject","required":""}})])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"review-rating"}},[_vm._v("Rating")]),_vm._v(" "),_c('select',{staticClass:"form-control",attrs:{"id":"review-rating"}},[_c('option',[_vm._v("5 Stars")]),_vm._v(" "),_c('option',[_vm._v("4 Stars")]),_vm._v(" "),_c('option',[_vm._v("3 Stars")]),_vm._v(" "),_c('option',[_vm._v("2 Stars")]),_vm._v(" "),_c('option',[_vm._v("1 Star")])])])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"review-message"}},[_vm._v("Review")]),_vm._v(" "),_c('textarea',{staticClass:"form-control",attrs:{"id":"review-message","rows":"8","required":""}})])]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"submit"}},[_vm._v("Submit Review")])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-sd-4"},[_c('div',{staticClass:"form-group mb-0"},[_c('p',{staticClass:"text-normal"},[_c('strong',[_vm._v("      Garantie : 24 mois    ")])]),_vm._v(" "),_c('p',{staticClass:"text-normal"},[_c('strong',[_vm._v("      Service aprés vente    ")])]),_vm._v(" "),_c('p',{staticClass:"text-normal"},[_c('strong',[_vm._v("     Livraison gratuite     ")])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('br')])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex flex-wrap justify-content-between align-items-center"},[_c('div',{staticClass:"py-2"},[_c('a',{staticClass:"social-button shape-rounded sb-facebook",attrs:{"href":"#","data-toggle":"tooltip","data-placement":"top","title":"Facebook"}},[_c('i',{staticClass:"socicon-facebook"})]),_vm._v(" "),_c('a',{staticClass:"social-button shape-rounded sb-twitter",attrs:{"href":"#","data-toggle":"tooltip","data-placement":"top","title":"Twitter"}},[_c('i',{staticClass:"socicon-twitter"})]),_vm._v(" "),_c('a',{staticClass:"social-button shape-rounded sb-instagram",attrs:{"href":"#","data-toggle":"tooltip","data-placement":"top","title":"Instagram"}},[_c('i',{staticClass:"socicon-instagram"})]),_vm._v(" "),_c('a',{staticClass:"social-button shape-rounded sb-google-plus",attrs:{"href":"#","data-toggle":"tooltip","data-placement":"top","title":"Google +"}},[_c('i',{staticClass:"socicon-googleplus"})])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 228 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_bourdimaMichaelkors_vue__ = __webpack_require__(63);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7e7fffce_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_bourdimaMichaelkors_vue__ = __webpack_require__(230);
function injectStyle (ssrContext) {
  __webpack_require__(229)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7e7fffce"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_bourdimaMichaelkors_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7e7fffce_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_bourdimaMichaelkors_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 229 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 230 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mr-top-40"},[_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"container-fluid padding-bottom-3x mb-1"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-10 col-lg-9 col-md-8 order-md-2"},[_c('div',{staticClass:"d-flex flex-wrap-reverse flex-md-nowrap justify-content-center justify-content-sm-between align-items-center mb-30"},[_c('div',{staticClass:"pt-3 pb-1 pb-sm-3 text-sm text-center text-sm-left"},[_c('span',{staticClass:"text-muted mr-2"},[_vm._v("Affichage des produits")]),_vm._v("1- "+_vm._s(_vm.pageSize)+" Produits")]),_vm._v(" "),_c('form',{staticClass:"input-group shop-search-box",attrs:{"method":"get"}},[_vm._m(0),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filter),expression:"filter"}],staticClass:"form-control",staticStyle:{"border":"2px solid #000000"},attrs:{"type":"search","placeholder":"Recherche par Référence","disabled":_vm.brands.length>0},domProps:{"value":(_vm.filter)},on:{"keyup":_vm.search,"input":function($event){if($event.target.composing){ return; }_vm.filter=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"d-flex flex-wrap justify-content-center mb-2"},_vm._l((_vm.filterProduct),function(product){return _c('div',{key:product.id,staticClass:"col-xl-3 col-lg-4 col-sm-6"},[_c('div',{staticClass:"product-card mb-30"},[_c('div',{staticClass:"product-card-thumb"},[_c('router-link',{staticClass:"product-card-link",attrs:{"to":"/product"},nativeOn:{"click":function($event){_vm.ProductDetail(product)}}}),_c('img',{attrs:{"src":product.img,"alt":"Product"}}),_vm._v(" "),_c('div',{staticClass:"product-card-buttons"},[_c('button',{staticClass:"btn btn-primary btn-sm",on:{"click":function($event){_vm.addToCart(product)}}},[_vm._v("Ajouter au panier")])])],1),_vm._v(" "),_c('div',{staticClass:"product-card-details"},[_c('h3',{staticClass:"product-card-title"},[_c('b',{attrs:{"href":"shop-single.html"}},[_c('strong',[_vm._v(_vm._s(product.id)+" /stock:=> "+_vm._s(product.quantite))])])]),_vm._v(" "),_c('h4',{staticClass:"product-card-price"},[_c('strong',[_vm._v(_vm._s(product.price)+" DA ")])])])])])})),_vm._v(" "),_c('pagination',{attrs:{"total":_vm.total,"page-size":_vm.pageSize,"callback":_vm.pageChanged,"options":_vm.paginationOptions,"nav-class":"pagination","ul-class":"column pages","li-class":"pt-2"}})],1),_vm._v(" "),_c('div',{staticClass:"col-xl-2 col-lg-3 col-md-4 order-md-1"},[_c('div',{staticClass:"sidebar-toggle position-left",class:{sidebaropen:_vm.sidebarOpen},on:{"click":function($event){_vm.sidebarOpen=!_vm.sidebarOpen}}},[_c('i',{staticClass:"material-icons filter_list"})]),_vm._v(" "),_c('aside',{staticClass:"sidebar sidebar-offcanvas position-left",class:{offcanvasopen:_vm.sidebarOpen}},[_c('span',{staticClass:"sidebar-close",on:{"click":function($event){_vm.sidebarOpen=!_vm.sidebarOpen}}},[_c('i',{staticClass:"material-icons icon_close"})]),_vm._v(" "),_c('section',{staticClass:"widget widget-icon-list"},[_vm._m(1),_vm._v(" "),_c('ul',[_c('li',[_c('a',{attrs:{"href":"#"},on:{"click":function($event){_vm.ordreby('quantite')}}},[_c('i',{staticClass:"material-icons favorite_border"}),_vm._v("Popularité")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#"},on:{"click":function($event){_vm.ordreby('annee')}}},[_c('i',{staticClass:"material-icons vertical_align_top"}),_vm._v("Dernière collection")])])])]),_vm._v(" "),_c('section',{staticClass:"widget widget-categories"},[_c('h3',{staticClass:"widget-title"},[_vm._v("PRIX")]),_vm._v(" "),_c('el-slider',{attrs:{"range":"","step":10000,"show-stops":"","max":80000},model:{value:(_vm.priceValue),callback:function ($$v) {_vm.priceValue=$$v},expression:"priceValue"}}),_vm._v(" "),_c('form',{staticClass:"price-range-slider",on:{"submit":function($event){$event.preventDefault();return _vm.submit($event)}}},[_c('div',{staticClass:"ui-range-slider-footer"},[_vm._m(2),_vm._v(" "),_c('div',{staticClass:"column"},[_c('span',[_c('strong',[_vm._v(_vm._s(_vm.priceValue[0])+"DA-"+_vm._s(_vm.priceValue[1])+"DA ")])])])])])],1),_vm._v(" "),_c('section',{staticClass:"widget"},[_vm._m(3),_vm._v(" "),_c('div',{staticClass:"custom-control custom-checkbox"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.brands),expression:"brands"}],staticClass:"custom-control-input",attrs:{"type":"checkbox","id":"Homme","value":"H"},domProps:{"checked":Array.isArray(_vm.brands)?_vm._i(_vm.brands,"H")>-1:(_vm.brands)},on:{"change":[function($event){var $$a=_vm.brands,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="H",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.brands=$$a.concat([$$v]))}else{$$i>-1&&(_vm.brands=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.brands=$$c}},_vm.brandChecked]}}),_vm._v(" "),_vm._m(4)]),_vm._v(" "),_c('div',{staticClass:"custom-control custom-checkbox"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.brands),expression:"brands"}],staticClass:"custom-control-input",attrs:{"type":"checkbox","id":"femme","value":"F"},domProps:{"checked":Array.isArray(_vm.brands)?_vm._i(_vm.brands,"F")>-1:(_vm.brands)},on:{"change":[function($event){var $$a=_vm.brands,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="F",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.brands=$$a.concat([$$v]))}else{$$i>-1&&(_vm.brands=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.brands=$$c}},_vm.brandChecked]}}),_vm._v(" "),_vm._m(5)])])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"input-group-btn"},[_c('button',{attrs:{"type":"submit"}},[_c('i',{staticClass:"material-icons search"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h3',{staticClass:"widget-title"},[_c('strong',[_vm._v("  Filter par ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"column"},[_c('button',{staticClass:"btn btn-outline-primary btn-sm",attrs:{"type":"submit"}},[_vm._v("Filter")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h3',{staticClass:"widget-title"},[_c('strong',[_vm._v("Homme /")]),_vm._v(" "),_c('strong',[_vm._v(" FEMME ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"custom-control-label",attrs:{"for":"Homme"}},[_c('strong',[_vm._v("HOMME ")]),_vm._v(" "),_c('span',{staticClass:"text-muted"},[_vm._v("(25)")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"custom-control-label",attrs:{"for":"femme"}},[_c('strong',[_vm._v("FEMME ")]),_vm._v(" "),_c('span',{staticClass:"text-muted"},[_vm._v("(25)")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 231 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_bourdima2_vue__ = __webpack_require__(64);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cc870f88_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_bourdima2_vue__ = __webpack_require__(233);
function injectStyle (ssrContext) {
  __webpack_require__(232)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-cc870f88"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_bourdima2_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cc870f88_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_bourdima2_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 232 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 233 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mr-top-40"},[_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"container-fluid padding-bottom-3x mb-1"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-10 col-lg-9 col-md-8 order-md-2"},[_c('div',{staticClass:"d-flex flex-wrap-reverse flex-md-nowrap justify-content-center justify-content-sm-between align-items-center mb-30"},[_c('div',{staticClass:"pt-3 pb-1 pb-sm-3 text-sm text-center text-sm-left"},[_c('span',{staticClass:"text-muted mr-2"},[_vm._v("Affichage des produits")]),_vm._v("1- "+_vm._s(_vm.pageSize)+" Produits")]),_vm._v(" "),_c('form',{staticClass:"input-group shop-search-box",attrs:{"method":"get"}},[_vm._m(0),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filter),expression:"filter"}],staticClass:"form-control",staticStyle:{"border":"2px solid #000000"},attrs:{"type":"search","placeholder":"Recherche par Référence","disabled":_vm.brands.length>0},domProps:{"value":(_vm.filter)},on:{"keyup":_vm.search,"input":function($event){if($event.target.composing){ return; }_vm.filter=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"d-flex flex-wrap justify-content-center mb-2"},_vm._l((_vm.filterProduct),function(product){return _c('div',{key:product.id,staticClass:"col-xl-3 col-lg-4 col-sm-6"},[_c('div',{staticClass:"product-card mb-30"},[_c('div',{staticClass:"product-card-thumb"},[_c('router-link',{staticClass:"product-card-link",attrs:{"to":"/product"},nativeOn:{"click":function($event){_vm.ProductDetail(product)}}}),_c('img',{attrs:{"src":product.img,"alt":"Product"}}),_vm._v(" "),_c('div',{staticClass:"product-card-buttons"},[_c('button',{staticClass:"btn btn-primary btn-sm",on:{"click":function($event){_vm.addToCart(product)}}},[_vm._v("Ajouter au panier")])])],1),_vm._v(" "),_c('div',{staticClass:"product-card-details"},[_c('h3',{staticClass:"product-card-title"},[_c('b',{attrs:{"href":"shop-single.html"}},[_c('strong',[_vm._v(_vm._s(product.id)+" /stock:=> "+_vm._s(product.quantite))])])]),_vm._v(" "),_c('h4',{staticClass:"product-card-price"},[_c('strong',[_vm._v(_vm._s(product.price)+" DA ")])])])])])})),_vm._v(" "),_c('pagination',{attrs:{"total":_vm.total,"page-size":_vm.pageSize,"callback":_vm.pageChanged,"options":_vm.paginationOptions,"nav-class":"pagination","ul-class":"column pages","li-class":"pt-2"}})],1),_vm._v(" "),_c('div',{staticClass:"col-xl-2 col-lg-3 col-md-4 order-md-1"},[_c('div',{staticClass:"sidebar-toggle position-left",class:{sidebaropen:_vm.sidebarOpen},on:{"click":function($event){_vm.sidebarOpen=!_vm.sidebarOpen}}},[_c('i',{staticClass:"material-icons filter_list"})]),_vm._v(" "),_c('aside',{staticClass:"sidebar sidebar-offcanvas position-left",class:{offcanvasopen:_vm.sidebarOpen}},[_c('span',{staticClass:"sidebar-close",on:{"click":function($event){_vm.sidebarOpen=!_vm.sidebarOpen}}},[_c('i',{staticClass:"material-icons icon_close"})]),_vm._v(" "),_c('section',{staticClass:"widget widget-icon-list"},[_vm._m(1),_vm._v(" "),_c('ul',[_c('li',[_c('a',{attrs:{"href":"#"},on:{"click":function($event){_vm.ordreby('quantite')}}},[_c('i',{staticClass:"material-icons favorite_border"}),_vm._v("Popularité")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#"},on:{"click":function($event){_vm.ordreby('annee')}}},[_c('i',{staticClass:"material-icons vertical_align_top"}),_vm._v("Dernière collection")])])])]),_vm._v(" "),_c('section',{staticClass:"widget widget-categories"},[_vm._m(2),_vm._v(" "),_c('el-slider',{attrs:{"range":"","step":10000,"show-stops":"","max":80000},model:{value:(_vm.priceValue),callback:function ($$v) {_vm.priceValue=$$v},expression:"priceValue"}}),_vm._v(" "),_c('form',{staticClass:"price-range-slider",on:{"submit":function($event){$event.preventDefault();return _vm.submit($event)}}},[_c('div',{staticClass:"ui-range-slider-footer"},[_c('div',{staticClass:"column"},[_c('button',{staticClass:"btn btn-outline-primary btn-sm",attrs:{"type":"submit","disabled":_vm.brands.length>0}},[_vm._v("Filtrer")])]),_vm._v(" "),_c('div',{staticClass:"column"},[_c('span',[_vm._v(_vm._s(_vm.priceValue[0])+"DA-"+_vm._s(_vm.priceValue[1])+"DA")])])])])],1),_vm._v(" "),_c('section',{staticClass:"widget"},[_vm._m(3),_vm._v(" "),_c('div',{staticClass:"custom-control custom-checkbox"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.brands),expression:"brands"}],staticClass:"custom-control-input",attrs:{"type":"checkbox","id":"festina","value":"festina"},domProps:{"checked":Array.isArray(_vm.brands)?_vm._i(_vm.brands,"festina")>-1:(_vm.brands)},on:{"change":[function($event){var $$a=_vm.brands,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="festina",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.brands=$$a.concat([$$v]))}else{$$i>-1&&(_vm.brands=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.brands=$$c}},_vm.brandChecked]}}),_vm._v(" "),_vm._m(4)]),_vm._v(" "),_c('div',{staticClass:"custom-control custom-checkbox"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.brands),expression:"brands"}],staticClass:"custom-control-input",attrs:{"type":"checkbox","id":"mk","value":"michael kors"},domProps:{"checked":Array.isArray(_vm.brands)?_vm._i(_vm.brands,"michael kors")>-1:(_vm.brands)},on:{"change":[function($event){var $$a=_vm.brands,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="michael kors",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.brands=$$a.concat([$$v]))}else{$$i>-1&&(_vm.brands=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.brands=$$c}},_vm.brandChecked]}}),_vm._v(" "),_vm._m(5)]),_vm._v(" "),_c('div',{staticClass:"custom-control custom-checkbox"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.brands),expression:"brands"}],staticClass:"custom-control-input",attrs:{"type":"checkbox","id":"armani exchange","value":"armani exchange"},domProps:{"checked":Array.isArray(_vm.brands)?_vm._i(_vm.brands,"armani exchange")>-1:(_vm.brands)},on:{"change":[function($event){var $$a=_vm.brands,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="armani exchange",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.brands=$$a.concat([$$v]))}else{$$i>-1&&(_vm.brands=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.brands=$$c}},_vm.brandChecked]}}),_vm._v(" "),_vm._m(6)]),_vm._v(" "),_c('div',{staticClass:"custom-control custom-checkbox"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.brands),expression:"brands"}],staticClass:"custom-control-input",attrs:{"type":"checkbox","id":"diesel","value":"diesel"},domProps:{"checked":Array.isArray(_vm.brands)?_vm._i(_vm.brands,"diesel")>-1:(_vm.brands)},on:{"change":[function($event){var $$a=_vm.brands,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="diesel",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.brands=$$a.concat([$$v]))}else{$$i>-1&&(_vm.brands=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.brands=$$c}},_vm.brandChecked]}}),_vm._v(" "),_vm._m(7)]),_vm._v(" "),_c('div',{staticClass:"custom-control custom-checkbox"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.brands),expression:"brands"}],staticClass:"custom-control-input",attrs:{"type":"checkbox","id":"fossil","value":"fossil"},domProps:{"checked":Array.isArray(_vm.brands)?_vm._i(_vm.brands,"fossil")>-1:(_vm.brands)},on:{"change":[function($event){var $$a=_vm.brands,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="fossil",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.brands=$$a.concat([$$v]))}else{$$i>-1&&(_vm.brands=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.brands=$$c}},_vm.brandChecked]}}),_vm._v(" "),_vm._m(8)]),_vm._v(" "),_c('div',{staticClass:"custom-control custom-checkbox"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.brands),expression:"brands"}],staticClass:"custom-control-input",attrs:{"type":"checkbox","id":"CERRUTI","value":"CERRUTI"},domProps:{"checked":Array.isArray(_vm.brands)?_vm._i(_vm.brands,"CERRUTI")>-1:(_vm.brands)},on:{"change":[function($event){var $$a=_vm.brands,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="CERRUTI",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.brands=$$a.concat([$$v]))}else{$$i>-1&&(_vm.brands=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.brands=$$c}},_vm.brandChecked]}}),_vm._v(" "),_vm._m(9)]),_vm._v(" "),_c('div',{staticClass:"custom-control custom-checkbox"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.brands),expression:"brands"}],staticClass:"custom-control-input",attrs:{"type":"checkbox","id":"rl","value":"royal london"},domProps:{"checked":Array.isArray(_vm.brands)?_vm._i(_vm.brands,"royal london")>-1:(_vm.brands)},on:{"change":[function($event){var $$a=_vm.brands,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="royal london",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.brands=$$a.concat([$$v]))}else{$$i>-1&&(_vm.brands=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.brands=$$c}},_vm.brandChecked]}}),_vm._v(" "),_vm._m(10)])])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"input-group-btn"},[_c('button',{attrs:{"type":"submit"}},[_c('i',{staticClass:"material-icons search"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h3',{staticClass:"widget-title"},[_c('strong',[_vm._v("  Filtrer par ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h3',{staticClass:"widget-title"},[_c('strong',[_vm._v(" PRIX ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h3',{staticClass:"widget-title"},[_c('strong',[_vm._v("MARQUE")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"custom-control-label",attrs:{"for":"festina"}},[_c('strong',[_vm._v("Festina")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"custom-control-label",attrs:{"for":"mk"}},[_c('strong',[_vm._v("Michael Kors")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"custom-control-label",attrs:{"for":"armani exchange"}},[_c('strong',[_vm._v(" Armani exchange ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"custom-control-label",attrs:{"for":"diesel"}},[_c('strong',[_vm._v("Diesel")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"custom-control-label",attrs:{"for":"fossil"}},[_c('strong',[_vm._v("Fossil")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"custom-control-label",attrs:{"for":"CERRUTI"}},[_c('strong',[_vm._v("CERRUTI")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"custom-control-label",attrs:{"for":"rl"}},[_c('strong',[_vm._v("Royal london")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 234 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_royal_vue__ = __webpack_require__(65);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1d35e49a_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_royal_vue__ = __webpack_require__(236);
function injectStyle (ssrContext) {
  __webpack_require__(235)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1d35e49a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_royal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1d35e49a_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_royal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 235 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 236 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mr-top-40"},[_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"container-fluid padding-bottom-3x mb-1"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-10 col-lg-9 col-md-8 order-md-2"},[_c('div',{staticClass:"d-flex flex-wrap-reverse flex-md-nowrap justify-content-center justify-content-sm-between align-items-center mb-30"},[_c('div',{staticClass:"pt-3 pb-1 pb-sm-3 text-sm text-center text-sm-left"},[_c('span',{staticClass:"text-muted mr-2"},[_vm._v("Affichage des produits")]),_vm._v("1- "+_vm._s(_vm.pageSize)+" Produits")]),_vm._v(" "),_c('form',{staticClass:"input-group shop-search-box",attrs:{"method":"get"}},[_vm._m(0),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filter),expression:"filter"}],staticClass:"form-control",staticStyle:{"border":"2px solid #000000"},attrs:{"type":"search","placeholder":"Recherche par Référence","disabled":_vm.brands.length>0},domProps:{"value":(_vm.filter)},on:{"keyup":_vm.search,"input":function($event){if($event.target.composing){ return; }_vm.filter=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"d-flex flex-wrap justify-content-center mb-2"},_vm._l((_vm.filterProduct),function(product){return _c('div',{key:product.id,staticClass:"col-xl-3 col-lg-4 col-sm-6"},[_c('div',{staticClass:"product-card mb-30"},[_c('div',{staticClass:"product-card-thumb"},[_c('router-link',{staticClass:"product-card-link",attrs:{"to":"/product"},nativeOn:{"click":function($event){_vm.ProductDetail(product)}}}),_c('img',{attrs:{"src":product.img,"alt":"Product"}}),_vm._v(" "),_c('div',{staticClass:"product-card-buttons"},[_c('button',{staticClass:"btn btn-primary btn-sm",on:{"click":function($event){_vm.addToCart(product)}}},[_vm._v("Ajouter au panier")])])],1),_vm._v(" "),_c('div',{staticClass:"product-card-details"},[_c('h3',{staticClass:"product-card-title"},[_c('b',{attrs:{"href":"shop-single.html"}},[_c('strong',[_vm._v(_vm._s(product.description))])])]),_vm._v(" "),_c('span',{staticClass:"h6 d-block"},[_c('del',{staticClass:"text-muted text-normal"},[_vm._v(_vm._s(product.price2)+" DA")]),_vm._v(" "+_vm._s(product.price)+" DA")])])])])})),_vm._v(" "),_c('pagination',{attrs:{"total":_vm.total,"page-size":_vm.pageSize,"callback":_vm.pageChanged,"options":_vm.paginationOptions,"nav-class":"pagination","ul-class":"column pages","li-class":"pt-2"}})],1),_vm._v(" "),_c('div',{staticClass:"col-xl-2 col-lg-3 col-md-4 order-md-1"},[_c('div',{staticClass:"sidebar-toggle position-left",class:{sidebaropen:_vm.sidebarOpen},on:{"click":function($event){_vm.sidebarOpen=!_vm.sidebarOpen}}},[_c('i',{staticClass:"material-icons filter_list"})]),_vm._v(" "),_c('aside',{staticClass:"sidebar sidebar-offcanvas position-left",class:{offcanvasopen:_vm.sidebarOpen}},[_c('span',{staticClass:"sidebar-close",on:{"click":function($event){_vm.sidebarOpen=!_vm.sidebarOpen}}},[_c('i',{staticClass:"material-icons icon_close"})]),_vm._v(" "),_c('section',{staticClass:"widget widget-icon-list"},[_vm._m(1),_vm._v(" "),_c('ul',[_c('li',[_c('a',{attrs:{"href":"#"},on:{"click":function($event){_vm.ordreby('quantite')}}},[_c('i',{staticClass:"material-icons favorite_border"}),_vm._v("Popularité")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#"},on:{"click":function($event){_vm.ordreby('annee')}}},[_c('i',{staticClass:"material-icons vertical_align_top"}),_vm._v("Dernière collection")])])])]),_vm._v(" "),_c('section',{staticClass:"widget widget-categories"},[_c('h3',{staticClass:"widget-title"},[_vm._v("PRIX")]),_vm._v(" "),_c('el-slider',{attrs:{"range":"","step":10000,"show-stops":"","max":80000},model:{value:(_vm.priceValue),callback:function ($$v) {_vm.priceValue=$$v},expression:"priceValue"}}),_vm._v(" "),_c('form',{staticClass:"price-range-slider",on:{"submit":function($event){$event.preventDefault();return _vm.submit($event)}}},[_c('div',{staticClass:"ui-range-slider-footer"},[_vm._m(2),_vm._v(" "),_c('div',{staticClass:"column"},[_c('span',[_vm._v(_vm._s(_vm.priceValue[0])+"DA-"+_vm._s(_vm.priceValue[1])+"DA")])])])])],1),_vm._v(" "),_c('section',{staticClass:"widget"},[_vm._m(3),_vm._v(" "),_c('div',{staticClass:"custom-control custom-checkbox"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.brands),expression:"brands"}],staticClass:"custom-control-input",attrs:{"type":"checkbox","id":"Homme","value":"H"},domProps:{"checked":Array.isArray(_vm.brands)?_vm._i(_vm.brands,"H")>-1:(_vm.brands)},on:{"change":[function($event){var $$a=_vm.brands,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="H",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.brands=$$a.concat([$$v]))}else{$$i>-1&&(_vm.brands=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.brands=$$c}},_vm.brandChecked]}}),_vm._v(" "),_vm._m(4)]),_vm._v(" "),_c('div',{staticClass:"custom-control custom-checkbox"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.brands),expression:"brands"}],staticClass:"custom-control-input",attrs:{"type":"checkbox","id":"femme","value":"F"},domProps:{"checked":Array.isArray(_vm.brands)?_vm._i(_vm.brands,"F")>-1:(_vm.brands)},on:{"change":[function($event){var $$a=_vm.brands,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="F",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.brands=$$a.concat([$$v]))}else{$$i>-1&&(_vm.brands=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.brands=$$c}},_vm.brandChecked]}}),_vm._v(" "),_vm._m(5)])])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"input-group-btn"},[_c('button',{attrs:{"type":"submit"}},[_c('i',{staticClass:"material-icons search"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h3',{staticClass:"widget-title"},[_c('strong',[_vm._v("  Filter par ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"column"},[_c('button',{staticClass:"btn btn-outline-primary btn-sm",attrs:{"type":"submit"}},[_vm._v("Filter")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h3',{staticClass:"widget-title"},[_c('strong',[_vm._v("Homme /")]),_vm._v(" "),_c('strong',[_vm._v(" FEMME ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"custom-control-label",attrs:{"for":"Homme"}},[_c('strong',[_vm._v("HOMME ")]),_vm._v(" "),_c('span',{staticClass:"text-muted"},[_vm._v("(25)")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"custom-control-label",attrs:{"for":"femme"}},[_c('strong',[_vm._v("FEMME ")]),_vm._v(" "),_c('span',{staticClass:"text-muted"},[_vm._v("(25)")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 237 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_police_vue__ = __webpack_require__(66);
/* unused harmony reexport namespace */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_476d2962_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_police_vue__ = __webpack_require__(239);
function injectStyle (ssrContext) {
  __webpack_require__(238)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-476d2962"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_police_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_476d2962_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_police_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* unused harmony default export */ var _unused_webpack_default_export = (Component.exports);


/***/ }),
/* 238 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 239 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mr-top-40"},[_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"container-fluid padding-bottom-3x mb-1"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-10 col-lg-9 col-md-8 order-md-2"},[_c('div',{staticClass:"d-flex flex-wrap-reverse flex-md-nowrap justify-content-center justify-content-sm-between align-items-center mb-30"},[_c('div',{staticClass:"pt-3 pb-1 pb-sm-3 text-sm text-center text-sm-left"},[_c('span',{staticClass:"text-muted mr-2"},[_vm._v("Affichage des produits")]),_vm._v("1- "+_vm._s(_vm.pageSize)+" Produits")]),_vm._v(" "),_c('form',{staticClass:"input-group shop-search-box",attrs:{"method":"get"}},[_vm._m(0),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filter),expression:"filter"}],staticClass:"form-control",attrs:{"type":"search","placeholder":"Recherche par réference","disabled":_vm.brands.length>0},domProps:{"value":(_vm.filter)},on:{"keyup":_vm.search,"input":function($event){if($event.target.composing){ return; }_vm.filter=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"d-flex flex-wrap justify-content-center mb-2"},_vm._l((_vm.filterProduct),function(product){return _c('div',{key:product.id,staticClass:"col-xl-3 col-lg-4 col-sm-6"},[_c('div',{staticClass:"product-card mb-30"},[_c('div',{staticClass:"product-card-thumb"},[_c('router-link',{staticClass:"product-card-link",attrs:{"to":"/product"},nativeOn:{"click":function($event){_vm.ProductDetail(product)}}}),_c('img',{attrs:{"src":product.img,"alt":"Product"}}),_vm._v(" "),_c('div',{staticClass:"product-card-buttons"},[_c('button',{staticClass:"btn btn-primary btn-sm",on:{"click":function($event){_vm.addToCart(product)}}},[_vm._v("Ajouter au panier")])])],1),_vm._v(" "),_c('div',{staticClass:"product-card-details"},[_c('h3',{staticClass:"product-card-title"},[_c('b',{attrs:{"href":"shop-single.html"}},[_c('strong',[_vm._v(_vm._s(product.description))])])]),_vm._v(" "),_c('span',{staticClass:"h6 d-block"},[_c('del',{staticClass:"text-muted text-normal"},[_vm._v(_vm._s(product.price2)+" DA")]),_vm._v(" "+_vm._s(product.price)+" DA")])])])])})),_vm._v(" "),_c('pagination',{attrs:{"total":_vm.total,"page-size":_vm.pageSize,"callback":_vm.pageChanged,"options":_vm.paginationOptions,"nav-class":"pagination","ul-class":"column pages","li-class":"pt-2"}})],1),_vm._v(" "),_c('div',{staticClass:"col-xl-2 col-lg-3 col-md-4 order-md-1"},[_c('div',{staticClass:"sidebar-toggle position-left",class:{sidebaropen:_vm.sidebarOpen},on:{"click":function($event){_vm.sidebarOpen=!_vm.sidebarOpen}}},[_c('i',{staticClass:"material-icons filter_list"})]),_vm._v(" "),_c('aside',{staticClass:"sidebar sidebar-offcanvas position-left",class:{offcanvasopen:_vm.sidebarOpen}},[_c('span',{staticClass:"sidebar-close",on:{"click":function($event){_vm.sidebarOpen=!_vm.sidebarOpen}}},[_c('i',{staticClass:"material-icons icon_close"})]),_vm._v(" "),_c('section',{staticClass:"widget widget-icon-list"},[_vm._m(1),_vm._v(" "),_c('ul',[_c('li',[_c('a',{attrs:{"href":"#"},on:{"click":function($event){_vm.ordreby('quantite')}}},[_c('i',{staticClass:"material-icons favorite_border"}),_vm._v("Popularité")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#"},on:{"click":function($event){_vm.ordreby('annee')}}},[_c('i',{staticClass:"material-icons vertical_align_top"}),_vm._v("Dernière collection")])])])]),_vm._v(" "),_c('section',{staticClass:"widget widget-categories"},[_c('h3',{staticClass:"widget-title"},[_vm._v("PRIX")]),_vm._v(" "),_c('el-slider',{attrs:{"range":"","step":10000,"show-stops":"","max":80000},model:{value:(_vm.priceValue),callback:function ($$v) {_vm.priceValue=$$v},expression:"priceValue"}}),_vm._v(" "),_c('form',{staticClass:"price-range-slider",on:{"submit":function($event){$event.preventDefault();return _vm.submit($event)}}},[_c('div',{staticClass:"ui-range-slider-footer"},[_vm._m(2),_vm._v(" "),_c('div',{staticClass:"column"},[_c('span',[_vm._v(_vm._s(_vm.priceValue[0])+"DA-"+_vm._s(_vm.priceValue[1])+"DA")])])])])],1)])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"input-group-btn"},[_c('button',{attrs:{"type":"submit"}},[_c('i',{staticClass:"material-icons search"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h3',{staticClass:"widget-title"},[_c('strong',[_vm._v("  Filter par ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"column"},[_c('button',{staticClass:"btn btn-outline-primary btn-sm",attrs:{"type":"submit"}},[_vm._v("Filter")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 240 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_cerruti_vue__ = __webpack_require__(67);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e731af98_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_cerruti_vue__ = __webpack_require__(242);
function injectStyle (ssrContext) {
  __webpack_require__(241)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-e731af98"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_cerruti_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e731af98_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_cerruti_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 241 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 242 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mr-top-40"},[_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"container-fluid padding-bottom-3x mb-1"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-10 col-lg-9 col-md-8 order-md-2"},[_c('div',{staticClass:"d-flex flex-wrap-reverse flex-md-nowrap justify-content-center justify-content-sm-between align-items-center mb-30"},[_c('div',{staticClass:"pt-3 pb-1 pb-sm-3 text-sm text-center text-sm-left"},[_c('span',{staticClass:"text-muted mr-2"},[_vm._v("Affichage des produits")]),_vm._v("1- "+_vm._s(_vm.pageSize)+" Produits")]),_vm._v(" "),_c('form',{staticClass:"input-group shop-search-box",attrs:{"method":"get"}},[_vm._m(0),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filter),expression:"filter"}],staticClass:"form-control",staticStyle:{"border":"2px solid #000000"},attrs:{"type":"search","placeholder":"Recherche par Référence","disabled":_vm.brands.length>0},domProps:{"value":(_vm.filter)},on:{"keyup":_vm.search,"input":function($event){if($event.target.composing){ return; }_vm.filter=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"d-flex flex-wrap justify-content-center mb-2"},_vm._l((_vm.filterProduct),function(product){return _c('div',{key:product.id,staticClass:"col-xl-3 col-lg-4 col-sm-6"},[_c('div',{staticClass:"product-card mb-30"},[_c('div',{staticClass:"product-card-thumb"},[_c('router-link',{staticClass:"product-card-link",attrs:{"to":{ name: 'productref', params: { ref: product.id }}},nativeOn:{"click":function($event){_vm.ProductDetail(product)}}},[_c('div',{staticStyle:{"display":"flex"}},[_c('H6',{staticClass:"product-badge bgblack text-white ",staticStyle:{}},[_c('b',[_vm._v("   رمضان كريم    ")])])],1)]),_c('img',{attrs:{"src":product.img,"alt":"Product"}}),_vm._v(" "),_c('div',{staticClass:"product-card-buttons"},[_c('button',{staticClass:"btn btn-primary btn-sm",on:{"click":function($event){_vm.addToCart(product)}}},[_vm._v("Ajouter au panier")])])],1),_vm._v(" "),_c('div',{staticClass:"product-card-details"},[_c('h3',{staticClass:"product-card-title"},[_c('b',{attrs:{"href":"shop-single.html"}},[_c('strong',[_vm._v(_vm._s(product.description))])])]),_vm._v(" "),_c('span',{staticClass:"h6 d-block"},[_c('del',{staticClass:"text-muted text-normal"},[_vm._v(_vm._s(product.price2)+" DA")]),_vm._v(" "+_vm._s(product.price)+" DA")])])])])})),_vm._v(" "),_c('pagination',{attrs:{"total":_vm.total,"page-size":_vm.pageSize,"callback":_vm.pageChanged,"options":_vm.paginationOptions,"nav-class":"pagination","ul-class":"column pages","li-class":"pt-2"}})],1),_vm._v(" "),_c('div',{staticClass:"col-xl-2 col-lg-3 col-md-4 order-md-1"},[_c('div',{staticClass:"sidebar-toggle position-left",class:{sidebaropen:_vm.sidebarOpen},on:{"click":function($event){_vm.sidebarOpen=!_vm.sidebarOpen}}},[_c('i',{staticClass:"material-icons filter_list"})]),_vm._v(" "),_c('aside',{staticClass:"sidebar sidebar-offcanvas position-left",class:{offcanvasopen:_vm.sidebarOpen}},[_c('span',{staticClass:"sidebar-close",on:{"click":function($event){_vm.sidebarOpen=!_vm.sidebarOpen}}},[_c('i',{staticClass:"material-icons icon_close"})]),_vm._v(" "),_c('section',{staticClass:"widget widget-icon-list"},[_vm._m(1),_vm._v(" "),_c('ul',[_c('li',[_c('a',{attrs:{"href":"#"},on:{"click":function($event){_vm.ordreby('quantite')}}},[_c('i',{staticClass:"material-icons favorite_border"}),_vm._v("Popularité")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#"},on:{"click":function($event){_vm.ordreby('annee')}}},[_c('i',{staticClass:"material-icons vertical_align_top"}),_vm._v("Dernière collection")])])])]),_vm._v(" "),_c('section',{staticClass:"widget widget-categories"},[_c('h3',{staticClass:"widget-title"},[_vm._v("PRIX")]),_vm._v(" "),_c('el-slider',{attrs:{"range":"","step":10000,"show-stops":"","max":80000},model:{value:(_vm.priceValue),callback:function ($$v) {_vm.priceValue=$$v},expression:"priceValue"}}),_vm._v(" "),_c('form',{staticClass:"price-range-slider",on:{"submit":function($event){$event.preventDefault();return _vm.submit($event)}}},[_c('div',{staticClass:"ui-range-slider-footer"},[_vm._m(2),_vm._v(" "),_c('div',{staticClass:"column"},[_c('span',[_vm._v(_vm._s(_vm.priceValue[0])+"DA-"+_vm._s(_vm.priceValue[1])+"DA")])])])])],1)])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"input-group-btn"},[_c('button',{attrs:{"type":"submit"}},[_c('i',{staticClass:"material-icons search"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h3',{staticClass:"widget-title"},[_c('strong',[_vm._v("  Filter par ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"column"},[_c('button',{staticClass:"btn btn-outline-primary btn-sm",attrs:{"type":"submit"}},[_vm._v("Filter")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 243 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_promo_vue__ = __webpack_require__(68);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2eaef6bc_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_promo_vue__ = __webpack_require__(245);
function injectStyle (ssrContext) {
  __webpack_require__(244)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2eaef6bc"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_promo_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2eaef6bc_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_promo_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 244 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 245 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mr-top-40"},[_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"container-fluid padding-bottom-3x mb-1"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-10 col-lg-9 col-md-8 order-md-2"},[_c('div',{staticClass:"d-flex flex-wrap-reverse flex-md-nowrap justify-content-center justify-content-sm-between align-items-center mb-30"},[_c('div',{staticClass:"pt-3 pb-1 pb-sm-3 text-sm text-center text-sm-left"},[_c('span',{staticClass:"text-muted mr-2"},[_vm._v("Affichage des produits")]),_vm._v("1- "+_vm._s(_vm.pageSize)+" Produits")]),_vm._v(" "),_c('form',{staticClass:"input-group shop-search-box",attrs:{"method":"get"}},[_vm._m(0),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filter),expression:"filter"}],staticClass:"form-control",staticStyle:{"border":"2px solid #000000"},attrs:{"type":"search","placeholder":"Recherche par Référence","disabled":_vm.brands.length>0},domProps:{"value":(_vm.filter)},on:{"keyup":_vm.search,"input":function($event){if($event.target.composing){ return; }_vm.filter=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"d-flex flex-wrap justify-content-center mb-2"},_vm._l((_vm.filterProduct),function(product){return _c('div',{key:product.id,staticClass:"col-xl-3 col-lg-4 col-sm-6"},[_c('div',{staticClass:"product-card mb-30"},[_c('div',{staticClass:"product-card-thumb"},[_c('router-link',{staticClass:"product-card-link",attrs:{"to":{ name: 'productref', params: { ref: product.id }}},nativeOn:{"click":function($event){_vm.ProductDetail(product)}}}),_c('img',{attrs:{"src":product.img,"alt":"Product"}}),_vm._v(" "),_c('div',{staticClass:"product-card-buttons"},[_c('button',{staticClass:"btn btn-primary btn-sm",on:{"click":function($event){_vm.addToCart(product)}}},[_vm._v("Ajouter au panier")])])],1),_vm._v(" "),_c('div',{staticClass:"product-card-details"},[_c('h3',{staticClass:"product-card-title"},[_c('b',{attrs:{"href":"shop-single.html"}},[_c('strong',[_vm._v(_vm._s(product.description))])])]),_vm._v(" "),_c('span',{staticClass:"h6 d-block"},[_c('del',{staticClass:"text-muted text-normal"},[_vm._v(_vm._s(product.price2)+" DA")]),_vm._v(" "+_vm._s(product.price)+" DA")])])])])})),_vm._v(" "),_c('pagination',{attrs:{"total":_vm.total,"page-size":_vm.pageSize,"callback":_vm.pageChanged,"options":_vm.paginationOptions,"nav-class":"pagination","ul-class":"column pages","li-class":"pt-2"}})],1),_vm._v(" "),_c('div',{staticClass:"col-xl-2 col-lg-3 col-md-4 order-md-1"},[_c('div',{staticClass:"sidebar-toggle position-left",class:{sidebaropen:_vm.sidebarOpen},on:{"click":function($event){_vm.sidebarOpen=!_vm.sidebarOpen}}},[_c('i',{staticClass:"material-icons filter_list"})]),_vm._v(" "),_c('aside',{staticClass:"sidebar sidebar-offcanvas position-left",class:{offcanvasopen:_vm.sidebarOpen}},[_c('span',{staticClass:"sidebar-close",on:{"click":function($event){_vm.sidebarOpen=!_vm.sidebarOpen}}},[_c('i',{staticClass:"material-icons icon_close"})]),_vm._v(" "),_c('section',{staticClass:"widget widget-icon-list"})])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"input-group-btn"},[_c('button',{attrs:{"type":"submit"}},[_c('i',{staticClass:"material-icons search"})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 246 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_lotus_vue__ = __webpack_require__(69);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6c9a2390_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_lotus_vue__ = __webpack_require__(248);
function injectStyle (ssrContext) {
  __webpack_require__(247)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6c9a2390"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_lotus_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6c9a2390_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_lotus_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 247 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 248 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mr-top-40"},[_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"container-fluid padding-bottom-3x mb-1"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-10 col-lg-9 col-md-8 order-md-2"},[_c('div',{staticClass:"d-flex flex-wrap-reverse flex-md-nowrap justify-content-center justify-content-sm-between align-items-center mb-30"},[_c('div',{staticClass:"pt-3 pb-1 pb-sm-3 text-sm text-center text-sm-left"},[_c('span',{staticClass:"text-muted mr-2"},[_vm._v("Affichage des produits")]),_vm._v("1- "+_vm._s(_vm.pageSize)+" Produits")]),_vm._v(" "),_c('form',{staticClass:"input-group shop-search-box",attrs:{"method":"get"}},[_vm._m(0),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filter),expression:"filter"}],staticClass:"form-control",staticStyle:{"border":"2px solid #000000"},attrs:{"type":"search","placeholder":"Recherche par Référence","disabled":_vm.brands.length>0},domProps:{"value":(_vm.filter)},on:{"keyup":_vm.search,"input":function($event){if($event.target.composing){ return; }_vm.filter=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"d-flex flex-wrap justify-content-center mb-2"},_vm._l((_vm.filterProduct),function(product){return _c('div',{key:product.id,staticClass:"col-xl-3 col-lg-4 col-sm-6"},[_c('div',{staticClass:"product-card mb-30"},[_c('div',{staticClass:"product-card-thumb"},[_c('router-link',{staticClass:"product-card-link",attrs:{"to":{ name: 'productref', params: { ref: product.id }}},nativeOn:{"click":function($event){_vm.ProductDetail(product)}}},[_c('div',{staticStyle:{"display":"flex"}},[_c('H6',{staticClass:"product-badge bgblack text-white ",staticStyle:{}},[_c('b',[_vm._v("   رمضان كريم    ")])])],1)]),_c('img',{attrs:{"src":product.img,"alt":"Product"}}),_vm._v(" "),_c('div',{staticClass:"product-card-buttons"},[_c('button',{staticClass:"btn btn-primary btn-sm",on:{"click":function($event){_vm.addToCart(product)}}},[_vm._v("Ajouter au panier")])])],1),_vm._v(" "),_c('div',{staticClass:"product-card-details"},[_c('h3',{staticClass:"product-card-title"},[_c('b',{attrs:{"href":"shop-single.html"}},[_c('strong',[_vm._v(_vm._s(product.description))])])]),_vm._v(" "),_c('span',{staticClass:"h6 d-block"},[_c('del',{staticClass:"text-muted text-normal"},[_vm._v(_vm._s(product.price2)+" DA")]),_vm._v(" "+_vm._s(product.price)+" DA")])])])])})),_vm._v(" "),_c('pagination',{attrs:{"total":_vm.total,"page-size":_vm.pageSize,"callback":_vm.pageChanged,"options":_vm.paginationOptions,"nav-class":"pagination","ul-class":"column pages","li-class":"pt-2"}})],1),_vm._v(" "),_c('div',{staticClass:"col-xl-2 col-lg-3 col-md-4 order-md-1"},[_c('div',{staticClass:"sidebar-toggle position-left",class:{sidebaropen:_vm.sidebarOpen},on:{"click":function($event){_vm.sidebarOpen=!_vm.sidebarOpen}}},[_c('i',{staticClass:"material-icons filter_list"})]),_vm._v(" "),_c('aside',{staticClass:"sidebar sidebar-offcanvas position-left",class:{offcanvasopen:_vm.sidebarOpen}},[_c('span',{staticClass:"sidebar-close",on:{"click":function($event){_vm.sidebarOpen=!_vm.sidebarOpen}}},[_c('i',{staticClass:"material-icons icon_close"})]),_vm._v(" "),_c('section',{staticClass:"widget widget-icon-list"},[_vm._m(1),_vm._v(" "),_c('ul',[_c('li',[_c('a',{attrs:{"href":"#"},on:{"click":function($event){_vm.ordreby('quantite')}}},[_c('i',{staticClass:"material-icons favorite_border"}),_vm._v("Popularité")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#"},on:{"click":function($event){_vm.ordreby('annee')}}},[_c('i',{staticClass:"material-icons vertical_align_top"}),_vm._v("Dernière collection")])])])]),_vm._v(" "),_c('section',{staticClass:"widget widget-categories"},[_c('h3',{staticClass:"widget-title"},[_vm._v("PRIX")]),_vm._v(" "),_c('el-slider',{attrs:{"range":"","step":10000,"show-stops":"","max":80000},model:{value:(_vm.priceValue),callback:function ($$v) {_vm.priceValue=$$v},expression:"priceValue"}}),_vm._v(" "),_c('form',{staticClass:"price-range-slider",on:{"submit":function($event){$event.preventDefault();return _vm.submit($event)}}},[_c('div',{staticClass:"ui-range-slider-footer"},[_vm._m(2),_vm._v(" "),_c('div',{staticClass:"column"},[_c('span',[_vm._v(_vm._s(_vm.priceValue[0])+"DA-"+_vm._s(_vm.priceValue[1])+"DA")])])])])],1)])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"input-group-btn"},[_c('button',{attrs:{"type":"submit"}},[_c('i',{staticClass:"material-icons search"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h3',{staticClass:"widget-title"},[_c('strong',[_vm._v("  Filter par ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"column"},[_c('button',{staticClass:"btn btn-outline-primary btn-sm",attrs:{"type":"submit"}},[_vm._v("Filter")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 249 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_versus_vue__ = __webpack_require__(70);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fcb0e5f0_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_versus_vue__ = __webpack_require__(251);
function injectStyle (ssrContext) {
  __webpack_require__(250)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-fcb0e5f0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_versus_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fcb0e5f0_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_versus_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 250 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 251 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mr-top-40"},[_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"container-fluid padding-bottom-3x mb-1"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-10 col-lg-9 col-md-8 order-md-2"},[_c('div',{staticClass:"d-flex flex-wrap-reverse flex-md-nowrap justify-content-center justify-content-sm-between align-items-center mb-30"},[_c('div',{staticClass:"pt-3 pb-1 pb-sm-3 text-sm text-center text-sm-left"},[_c('span',{staticClass:"text-muted mr-2"},[_vm._v("Affichage des produits")]),_vm._v("1- "+_vm._s(_vm.pageSize)+" Produits")]),_vm._v(" "),_c('form',{staticClass:"input-group shop-search-box",attrs:{"method":"get"}},[_vm._m(0),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filter),expression:"filter"}],staticClass:"form-control",staticStyle:{"border":"2px solid #000000"},attrs:{"type":"search","placeholder":"Recherche par Référence","disabled":_vm.brands.length>0},domProps:{"value":(_vm.filter)},on:{"keyup":_vm.search,"input":function($event){if($event.target.composing){ return; }_vm.filter=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"d-flex flex-wrap justify-content-center mb-2"},_vm._l((_vm.filterProduct),function(product){return _c('div',{key:product.id,staticClass:"col-xl-3 col-lg-4 col-sm-6"},[_c('div',{staticClass:"product-card mb-30"},[_c('div',{staticClass:"product-card-thumb"},[_c('router-link',{staticClass:"product-card-link",attrs:{"to":{ name: 'productref', params: { ref: product.id }}},nativeOn:{"click":function($event){_vm.ProductDetail(product)}}},[_c('div',{staticStyle:{"display":"flex"}})]),_c('img',{attrs:{"src":product.img,"alt":"Product"}}),_vm._v(" "),_c('div',{staticClass:"product-card-buttons"},[_c('button',{staticClass:"btn btn-primary btn-sm",on:{"click":function($event){_vm.addToCart(product)}}},[_vm._v("Ajouter au panier")])])],1),_vm._v(" "),_c('div',{staticClass:"product-card-details"},[_c('h3',{staticClass:"product-card-title"},[_c('b',{attrs:{"href":"shop-single.html"}},[_c('strong',[_vm._v(_vm._s(product.description))])])]),_vm._v(" "),_c('span',{staticClass:"h6 d-block"},[_c('del',{staticClass:"text-muted text-normal"},[_vm._v(_vm._s(product.price2)+" DA")]),_vm._v(" "+_vm._s(product.price)+" DA")])])])])})),_vm._v(" "),_c('pagination',{attrs:{"total":_vm.total,"page-size":_vm.pageSize,"callback":_vm.pageChanged,"options":_vm.paginationOptions,"nav-class":"pagination","ul-class":"column pages","li-class":"pt-2"}})],1),_vm._v(" "),_c('div',{staticClass:"col-xl-2 col-lg-3 col-md-4 order-md-1"},[_c('div',{staticClass:"sidebar-toggle position-left",class:{sidebaropen:_vm.sidebarOpen},on:{"click":function($event){_vm.sidebarOpen=!_vm.sidebarOpen}}},[_c('i',{staticClass:"material-icons filter_list"})]),_vm._v(" "),_c('aside',{staticClass:"sidebar sidebar-offcanvas position-left",class:{offcanvasopen:_vm.sidebarOpen}},[_c('span',{staticClass:"sidebar-close",on:{"click":function($event){_vm.sidebarOpen=!_vm.sidebarOpen}}},[_c('i',{staticClass:"material-icons icon_close"})]),_vm._v(" "),_c('section',{staticClass:"widget widget-icon-list"})])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"input-group-btn"},[_c('button',{attrs:{"type":"submit"}},[_c('i',{staticClass:"material-icons search"})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 252 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_trussardi_vue__ = __webpack_require__(71);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_20a0a952_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_trussardi_vue__ = __webpack_require__(254);
function injectStyle (ssrContext) {
  __webpack_require__(253)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-20a0a952"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_trussardi_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_20a0a952_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_trussardi_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 253 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 254 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mr-top-40"},[_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"container-fluid padding-bottom-3x mb-1"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-10 col-lg-9 col-md-8 order-md-2"},[_c('div',{staticClass:"d-flex flex-wrap-reverse flex-md-nowrap justify-content-center justify-content-sm-between align-items-center mb-30"},[_c('div',{staticClass:"pt-3 pb-1 pb-sm-3 text-sm text-center text-sm-left"},[_c('span',{staticClass:"text-muted mr-2"},[_vm._v("Affichage des produits")]),_vm._v("1- "+_vm._s(_vm.pageSize)+" Produits")]),_vm._v(" "),_c('form',{staticClass:"input-group shop-search-box",attrs:{"method":"get"}},[_vm._m(0),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filter),expression:"filter"}],staticClass:"form-control",staticStyle:{"border":"2px solid #000000"},attrs:{"type":"search","placeholder":"Recherche par Référence","disabled":_vm.brands.length>0},domProps:{"value":(_vm.filter)},on:{"keyup":_vm.search,"input":function($event){if($event.target.composing){ return; }_vm.filter=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"d-flex flex-wrap justify-content-center mb-2"},_vm._l((_vm.filterProduct),function(product){return _c('div',{key:product.id,staticClass:"col-xl-3 col-lg-4 col-sm-6"},[_c('div',{staticClass:"product-card mb-30"},[_c('div',{staticClass:"product-card-thumb"},[_c('router-link',{staticClass:"product-card-link",attrs:{"to":{ name: 'productref', params: { ref: product.id }}},nativeOn:{"click":function($event){_vm.ProductDetail(product)}}},[_c('div',{staticStyle:{"display":"flex"}})]),_c('img',{attrs:{"src":product.img,"alt":"Product"}}),_vm._v(" "),_c('div',{staticClass:"product-card-buttons"},[_c('button',{staticClass:"btn btn-primary btn-sm",on:{"click":function($event){_vm.addToCart(product)}}},[_vm._v("Ajouter au panier")])])],1),_vm._v(" "),_c('div',{staticClass:"product-card-details"},[_c('h3',{staticClass:"product-card-title"},[_c('b',{attrs:{"href":"shop-single.html"}},[_c('strong',[_vm._v(_vm._s(product.description))])])]),_vm._v(" "),_c('span',{staticClass:"h6 d-block"},[_c('del',{staticClass:"text-muted text-normal"},[_vm._v(_vm._s(product.price2)+" DA")]),_vm._v(" "+_vm._s(product.price)+" DA")])])])])})),_vm._v(" "),_c('pagination',{attrs:{"total":_vm.total,"page-size":_vm.pageSize,"callback":_vm.pageChanged,"options":_vm.paginationOptions,"nav-class":"pagination","ul-class":"column pages","li-class":"pt-2"}})],1),_vm._v(" "),_c('div',{staticClass:"col-xl-2 col-lg-3 col-md-4 order-md-1"},[_c('div',{staticClass:"sidebar-toggle position-left",class:{sidebaropen:_vm.sidebarOpen},on:{"click":function($event){_vm.sidebarOpen=!_vm.sidebarOpen}}},[_c('i',{staticClass:"material-icons filter_list"})]),_vm._v(" "),_c('aside',{staticClass:"sidebar sidebar-offcanvas position-left",class:{offcanvasopen:_vm.sidebarOpen}},[_c('span',{staticClass:"sidebar-close",on:{"click":function($event){_vm.sidebarOpen=!_vm.sidebarOpen}}},[_c('i',{staticClass:"material-icons icon_close"})]),_vm._v(" "),_c('section',{staticClass:"widget widget-icon-list"})])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"input-group-btn"},[_c('button',{attrs:{"type":"submit"}},[_c('i',{staticClass:"material-icons search"})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 255 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MONTIGNAC_vue__ = __webpack_require__(72);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_02293ebf_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MONTIGNAC_vue__ = __webpack_require__(257);
function injectStyle (ssrContext) {
  __webpack_require__(256)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-02293ebf"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MONTIGNAC_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_02293ebf_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MONTIGNAC_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 256 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 257 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mr-top-40"},[_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"container-fluid padding-bottom-3x mb-1"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-10 col-lg-9 col-md-8 order-md-2"},[_c('div',{staticClass:"d-flex flex-wrap-reverse flex-md-nowrap justify-content-center justify-content-sm-between align-items-center mb-30"},[_c('div',{staticClass:"pt-3 pb-1 pb-sm-3 text-sm text-center text-sm-left"},[_c('span',{staticClass:"text-muted mr-2"},[_vm._v("Affichage des produits")]),_vm._v("1- "+_vm._s(_vm.pageSize)+" Produits")]),_vm._v(" "),_c('form',{staticClass:"input-group shop-search-box",attrs:{"method":"get"}},[_vm._m(0),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filter),expression:"filter"}],staticClass:"form-control",staticStyle:{"border":"2px solid #000000"},attrs:{"type":"search","placeholder":"Recherche par Référence","disabled":_vm.brands.length>0},domProps:{"value":(_vm.filter)},on:{"keyup":_vm.search,"input":function($event){if($event.target.composing){ return; }_vm.filter=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"d-flex flex-wrap justify-content-center mb-2"},_vm._l((_vm.filterProduct),function(product){return _c('div',{key:product.id,staticClass:"col-xl-3 col-lg-4 col-sm-6"},[_c('div',{staticClass:"product-card mb-30"},[_c('div',{staticClass:"product-card-thumb"},[_c('router-link',{staticClass:"product-card-link",attrs:{"to":{ name: 'productref', params: { ref: product.id }}},nativeOn:{"click":function($event){_vm.ProductDetail(product)}}},[_c('div',{staticStyle:{"display":"flex"}},[_c('H6',{staticClass:"product-badge bgblack text-white ",staticStyle:{}},[_c('b',[_vm._v("   رمضان كريم    ")])])],1)]),_c('img',{attrs:{"src":product.img,"alt":"Product"}}),_vm._v(" "),_c('div',{staticClass:"product-card-buttons"},[_c('button',{staticClass:"btn btn-primary btn-sm",on:{"click":function($event){_vm.addToCart(product)}}},[_vm._v("Ajouter au panier")])])],1),_vm._v(" "),_c('div',{staticClass:"product-card-details"},[_c('h3',{staticClass:"product-card-title"},[_c('b',{attrs:{"href":"shop-single.html"}},[_c('strong',[_vm._v(_vm._s(product.description))])])]),_vm._v(" "),_c('span',{staticClass:"h6 d-block"},[_c('del',{staticClass:"text-muted text-normal"},[_vm._v(_vm._s(product.price2)+" DA")]),_vm._v(" "+_vm._s(product.price)+" DA")])])])])})),_vm._v(" "),_c('pagination',{attrs:{"total":_vm.total,"page-size":_vm.pageSize,"callback":_vm.pageChanged,"options":_vm.paginationOptions,"nav-class":"pagination","ul-class":"column pages","li-class":"pt-2"}})],1),_vm._v(" "),_c('div',{staticClass:"col-xl-2 col-lg-3 col-md-4 order-md-1"},[_c('div',{staticClass:"sidebar-toggle position-left",class:{sidebaropen:_vm.sidebarOpen},on:{"click":function($event){_vm.sidebarOpen=!_vm.sidebarOpen}}},[_c('i',{staticClass:"material-icons filter_list"})]),_vm._v(" "),_c('aside',{staticClass:"sidebar sidebar-offcanvas position-left",class:{offcanvasopen:_vm.sidebarOpen}},[_c('span',{staticClass:"sidebar-close",on:{"click":function($event){_vm.sidebarOpen=!_vm.sidebarOpen}}},[_c('i',{staticClass:"material-icons icon_close"})]),_vm._v(" "),_c('section',{staticClass:"widget widget-icon-list"})])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"input-group-btn"},[_c('button',{attrs:{"type":"submit"}},[_c('i',{staticClass:"material-icons search"})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 258 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_armani_vue__ = __webpack_require__(73);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_127fbb2a_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_armani_vue__ = __webpack_require__(260);
function injectStyle (ssrContext) {
  __webpack_require__(259)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-127fbb2a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_armani_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_127fbb2a_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_armani_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 259 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 260 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mr-top-40"},[_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"container-fluid padding-bottom-3x mb-1"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-10 col-lg-9 col-md-8 order-md-2"},[_c('div',{staticClass:"d-flex flex-wrap-reverse flex-md-nowrap justify-content-center justify-content-sm-between align-items-center mb-30"},[_c('div',{staticClass:"pt-3 pb-1 pb-sm-3 text-sm text-center text-sm-left"},[_c('span',{staticClass:"text-muted mr-2"},[_vm._v("Affichage des produits")]),_vm._v("1- "+_vm._s(_vm.pageSize)+" Produits")]),_vm._v(" "),_c('form',{staticClass:"input-group shop-search-box",attrs:{"method":"get"}},[_vm._m(0),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filter),expression:"filter"}],staticClass:"form-control",staticStyle:{"border":"2px solid #000000"},attrs:{"type":"search","placeholder":"Recherche par Référence","disabled":_vm.brands.length>0},domProps:{"value":(_vm.filter)},on:{"keyup":_vm.search,"input":function($event){if($event.target.composing){ return; }_vm.filter=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"d-flex flex-wrap justify-content-center mb-2"},_vm._l((_vm.filterProduct),function(product){return _c('div',{key:product.id,staticClass:"col-xl-3 col-lg-4 col-sm-6"},[_c('div',{staticClass:"product-card mb-30"},[_c('div',{staticClass:"product-card-thumb"},[_c('router-link',{staticClass:"product-card-link",attrs:{"to":{ name: 'productref', params: { ref: product.id }}},nativeOn:{"click":function($event){_vm.ProductDetail(product)}}},[_c('div',{staticStyle:{"display":"flex"}})]),_c('img',{attrs:{"src":product.img,"alt":"Product"}}),_vm._v(" "),_c('div',{staticClass:"product-card-buttons"},[_c('button',{staticClass:"btn btn-primary btn-sm",on:{"click":function($event){_vm.addToCart(product)}}},[_vm._v("Ajouter au panier")])])],1),_vm._v(" "),_c('div',{staticClass:"product-card-details"},[_c('h3',{staticClass:"product-card-title"},[_c('b',{attrs:{"href":"shop-single.html"}},[_c('strong',[_vm._v(_vm._s(product.description))])])]),_vm._v(" "),_c('span',{staticClass:"h6 d-block"},[_c('del',{staticClass:"text-muted text-normal"},[_vm._v(_vm._s(product.price2)+" DA")]),_vm._v(" "+_vm._s(product.price)+" DA")])])])])})),_vm._v(" "),_c('pagination',{attrs:{"total":_vm.total,"page-size":_vm.pageSize,"callback":_vm.pageChanged,"options":_vm.paginationOptions,"nav-class":"pagination","ul-class":"column pages","li-class":"pt-2"}})],1),_vm._v(" "),_c('div',{staticClass:"col-xl-2 col-lg-3 col-md-4 order-md-1"},[_c('div',{staticClass:"sidebar-toggle position-left",class:{sidebaropen:_vm.sidebarOpen},on:{"click":function($event){_vm.sidebarOpen=!_vm.sidebarOpen}}},[_c('i',{staticClass:"material-icons filter_list"})]),_vm._v(" "),_c('aside',{staticClass:"sidebar sidebar-offcanvas position-left",class:{offcanvasopen:_vm.sidebarOpen}},[_c('span',{staticClass:"sidebar-close",on:{"click":function($event){_vm.sidebarOpen=!_vm.sidebarOpen}}},[_c('i',{staticClass:"material-icons icon_close"})]),_vm._v(" "),_c('section',{staticClass:"widget widget-icon-list"})])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"input-group-btn"},[_c('button',{attrs:{"type":"submit"}},[_c('i',{staticClass:"material-icons search"})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 261 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_nautica_vue__ = __webpack_require__(74);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3829656a_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_nautica_vue__ = __webpack_require__(263);
function injectStyle (ssrContext) {
  __webpack_require__(262)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3829656a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_nautica_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3829656a_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_nautica_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 262 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 263 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mr-top-40"},[_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"container-fluid padding-bottom-3x mb-1"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-10 col-lg-9 col-md-8 order-md-2"},[_c('div',{staticClass:"d-flex flex-wrap-reverse flex-md-nowrap justify-content-center justify-content-sm-between align-items-center mb-30"},[_c('div',{staticClass:"pt-3 pb-1 pb-sm-3 text-sm text-center text-sm-left"},[_c('span',{staticClass:"text-muted mr-2"},[_vm._v("Affichage des produits")]),_vm._v("1- "+_vm._s(_vm.pageSize)+" Produits")]),_vm._v(" "),_c('form',{staticClass:"input-group shop-search-box",attrs:{"method":"get"}},[_vm._m(0),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filter),expression:"filter"}],staticClass:"form-control",staticStyle:{"border":"2px solid #000000"},attrs:{"type":"search","placeholder":"Recherche par Référence","disabled":_vm.brands.length>0},domProps:{"value":(_vm.filter)},on:{"keyup":_vm.search,"input":function($event){if($event.target.composing){ return; }_vm.filter=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"d-flex flex-wrap justify-content-center mb-2"},_vm._l((_vm.filterProduct),function(product){return _c('div',{key:product.id,staticClass:"col-xl-3 col-lg-4 col-sm-6"},[_c('div',{staticClass:"product-card mb-30"},[_c('div',{staticClass:"product-card-thumb"},[_c('router-link',{staticClass:"product-card-link",attrs:{"to":{ name: 'productref', params: { ref: product.id }}},nativeOn:{"click":function($event){_vm.ProductDetail(product)}}},[_c('div',{staticStyle:{"display":"flex"}},[_c('H6',{staticClass:"product-badge bgblack text-white ",staticStyle:{}},[_c('b',[_vm._v("   Promotion    ")])])],1)]),_c('img',{attrs:{"src":product.img,"alt":"Product"}}),_vm._v(" "),_c('div',{staticClass:"product-card-buttons"},[_c('button',{staticClass:"btn btn-primary btn-sm",on:{"click":function($event){_vm.addToCart(product)}}},[_vm._v("Ajouter au panier")])])],1),_vm._v(" "),_c('div',{staticClass:"product-card-details"},[_c('h3',{staticClass:"product-card-title"},[_c('b',{attrs:{"href":"shop-single.html"}},[_c('strong',[_vm._v(_vm._s(product.description))])])]),_vm._v(" "),_c('span',{staticClass:"h6 d-block"},[_c('del',{staticClass:"text-muted text-normal"},[_vm._v(_vm._s(product.price2)+" DA")]),_vm._v(" "+_vm._s(product.price)+" DA")])])])])})),_vm._v(" "),_c('pagination',{attrs:{"total":_vm.total,"page-size":_vm.pageSize,"callback":_vm.pageChanged,"options":_vm.paginationOptions,"nav-class":"pagination","ul-class":"column pages","li-class":"pt-2"}})],1),_vm._v(" "),_c('div',{staticClass:"col-xl-2 col-lg-3 col-md-4 order-md-1"},[_c('div',{staticClass:"sidebar-toggle position-left",class:{sidebaropen:_vm.sidebarOpen},on:{"click":function($event){_vm.sidebarOpen=!_vm.sidebarOpen}}},[_c('i',{staticClass:"material-icons filter_list"})]),_vm._v(" "),_c('aside',{staticClass:"sidebar sidebar-offcanvas position-left",class:{offcanvasopen:_vm.sidebarOpen}},[_c('span',{staticClass:"sidebar-close",on:{"click":function($event){_vm.sidebarOpen=!_vm.sidebarOpen}}},[_c('i',{staticClass:"material-icons icon_close"})]),_vm._v(" "),_c('section',{staticClass:"widget widget-icon-list"})])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"input-group-btn"},[_c('button',{attrs:{"type":"submit"}},[_c('i',{staticClass:"material-icons search"})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 264 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_maserati_vue__ = __webpack_require__(75);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_16d14805_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_maserati_vue__ = __webpack_require__(266);
function injectStyle (ssrContext) {
  __webpack_require__(265)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-16d14805"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_maserati_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_16d14805_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_maserati_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 265 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 266 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mr-top-40"},[_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"container-fluid padding-bottom-3x mb-1"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-10 col-lg-9 col-md-8 order-md-2"},[_c('div',{staticClass:"d-flex flex-wrap-reverse flex-md-nowrap justify-content-center justify-content-sm-between align-items-center mb-30"},[_c('div',{staticClass:"pt-3 pb-1 pb-sm-3 text-sm text-center text-sm-left"},[_c('span',{staticClass:"text-muted mr-2"},[_vm._v("Affichage des produits")]),_vm._v("1- "+_vm._s(_vm.pageSize)+" Produits")]),_vm._v(" "),_c('form',{staticClass:"input-group shop-search-box",attrs:{"method":"get"}},[_vm._m(0),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filter),expression:"filter"}],staticClass:"form-control",staticStyle:{"border":"2px solid #000000"},attrs:{"type":"search","placeholder":"Recherche par Référence","disabled":_vm.brands.length>0},domProps:{"value":(_vm.filter)},on:{"keyup":_vm.search,"input":function($event){if($event.target.composing){ return; }_vm.filter=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"d-flex flex-wrap justify-content-center mb-2"},_vm._l((_vm.filterProduct),function(product){return _c('div',{key:product.id,staticClass:"col-xl-3 col-lg-4 col-sm-6"},[_c('div',{staticClass:"product-card mb-30"},[_c('div',{staticClass:"product-card-thumb"},[_c('router-link',{staticClass:"product-card-link",attrs:{"to":{ name: 'productref', params: { ref: product.id }}},nativeOn:{"click":function($event){_vm.ProductDetail(product)}}}),_c('img',{attrs:{"src":product.img,"alt":"Product"}}),_vm._v(" "),_c('div',{staticClass:"product-card-buttons"},[_c('button',{staticClass:"btn btn-primary btn-sm",on:{"click":function($event){_vm.addToCart(product)}}},[_vm._v("Ajouter au panier")])])],1),_vm._v(" "),_c('div',{staticClass:"product-card-details"},[_c('h3',{staticClass:"product-card-title"},[_c('b',{attrs:{"href":"shop-single.html"}},[_c('strong',[_vm._v(_vm._s(product.description))])])]),_vm._v(" "),_c('span',{staticClass:"h6 d-block"},[_c('del',{staticClass:"text-muted text-normal"},[_vm._v(_vm._s(product.price2)+" DA")]),_vm._v(" "+_vm._s(product.price)+" DA")])])])])})),_vm._v(" "),_c('pagination',{attrs:{"total":_vm.total,"page-size":_vm.pageSize,"callback":_vm.pageChanged,"options":_vm.paginationOptions,"nav-class":"pagination","ul-class":"column pages","li-class":"pt-2"}})],1),_vm._v(" "),_c('div',{staticClass:"col-xl-2 col-lg-3 col-md-4 order-md-1"},[_c('div',{staticClass:"sidebar-toggle position-left",class:{sidebaropen:_vm.sidebarOpen},on:{"click":function($event){_vm.sidebarOpen=!_vm.sidebarOpen}}},[_c('i',{staticClass:"material-icons filter_list"})]),_vm._v(" "),_c('aside',{staticClass:"sidebar sidebar-offcanvas position-left",class:{offcanvasopen:_vm.sidebarOpen}},[_c('span',{staticClass:"sidebar-close",on:{"click":function($event){_vm.sidebarOpen=!_vm.sidebarOpen}}},[_c('i',{staticClass:"material-icons icon_close"})]),_vm._v(" "),_c('section',{staticClass:"widget widget-icon-list"})])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"input-group-btn"},[_c('button',{attrs:{"type":"submit"}},[_c('i',{staticClass:"material-icons search"})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 267 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_morellato_vue__ = __webpack_require__(76);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3c2c0772_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_morellato_vue__ = __webpack_require__(269);
function injectStyle (ssrContext) {
  __webpack_require__(268)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3c2c0772"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_morellato_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3c2c0772_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_morellato_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 268 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 269 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mr-top-40"},[_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"container-fluid padding-bottom-3x mb-1"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-10 col-lg-9 col-md-8 order-md-2"},[_c('div',{staticClass:"d-flex flex-wrap-reverse flex-md-nowrap justify-content-center justify-content-sm-between align-items-center mb-30"},[_c('div',{staticClass:"pt-3 pb-1 pb-sm-3 text-sm text-center text-sm-left"},[_c('span',{staticClass:"text-muted mr-2"},[_vm._v("Affichage des produits")]),_vm._v("1- "+_vm._s(_vm.pageSize)+" Produits")]),_vm._v(" "),_c('form',{staticClass:"input-group shop-search-box",attrs:{"method":"get"}},[_vm._m(0),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filter),expression:"filter"}],staticClass:"form-control",staticStyle:{"border":"2px solid #000000"},attrs:{"type":"search","placeholder":"Recherche par Référence","disabled":_vm.brands.length>0},domProps:{"value":(_vm.filter)},on:{"keyup":_vm.search,"input":function($event){if($event.target.composing){ return; }_vm.filter=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"d-flex flex-wrap justify-content-center mb-2"},_vm._l((_vm.filterProduct),function(product){return _c('div',{key:product.id,staticClass:"col-xl-3 col-lg-4 col-sm-6"},[_c('div',{staticClass:"product-card mb-30"},[_c('div',{staticClass:"product-card-thumb"},[_c('router-link',{staticClass:"product-card-link",attrs:{"to":{ name: 'productref', params: { ref: product.id }}},nativeOn:{"click":function($event){_vm.ProductDetail(product)}}},[_c('div',{staticStyle:{"display":"flex"}})]),_c('img',{attrs:{"src":product.img,"alt":"Product"}}),_vm._v(" "),_c('div',{staticClass:"product-card-buttons"},[_c('button',{staticClass:"btn btn-primary btn-sm",on:{"click":function($event){_vm.addToCart(product)}}},[_vm._v("Ajouter au panier")])])],1),_vm._v(" "),_c('div',{staticClass:"product-card-details"},[_c('h3',{staticClass:"product-card-title"},[_c('b',{attrs:{"href":"shop-single.html"}},[_c('strong',[_vm._v(_vm._s(product.description))])])]),_vm._v(" "),_c('span',{staticClass:"h6 d-block"},[_c('del',{staticClass:"text-muted text-normal"},[_vm._v(_vm._s(product.price2)+" DA")]),_vm._v(" "+_vm._s(product.price)+" DA")])])])])})),_vm._v(" "),_c('pagination',{attrs:{"total":_vm.total,"page-size":_vm.pageSize,"callback":_vm.pageChanged,"options":_vm.paginationOptions,"nav-class":"pagination","ul-class":"column pages","li-class":"pt-2"}})],1),_vm._v(" "),_c('div',{staticClass:"col-xl-2 col-lg-3 col-md-4 order-md-1"},[_c('div',{staticClass:"sidebar-toggle position-left",class:{sidebaropen:_vm.sidebarOpen},on:{"click":function($event){_vm.sidebarOpen=!_vm.sidebarOpen}}},[_c('i',{staticClass:"material-icons filter_list"})]),_vm._v(" "),_c('aside',{staticClass:"sidebar sidebar-offcanvas position-left",class:{offcanvasopen:_vm.sidebarOpen}},[_c('span',{staticClass:"sidebar-close",on:{"click":function($event){_vm.sidebarOpen=!_vm.sidebarOpen}}},[_c('i',{staticClass:"material-icons icon_close"})]),_vm._v(" "),_c('section',{staticClass:"widget widget-icon-list"})])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"input-group-btn"},[_c('button',{attrs:{"type":"submit"}},[_c('i',{staticClass:"material-icons search"})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 270 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_timberland_vue__ = __webpack_require__(77);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0c0d6081_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_timberland_vue__ = __webpack_require__(272);
function injectStyle (ssrContext) {
  __webpack_require__(271)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0c0d6081"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_timberland_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0c0d6081_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_timberland_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 271 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 272 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mr-top-40"},[_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"container-fluid padding-bottom-3x mb-1"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-10 col-lg-9 col-md-8 order-md-2"},[_c('div',{staticClass:"d-flex flex-wrap-reverse flex-md-nowrap justify-content-center justify-content-sm-between align-items-center mb-30"},[_c('div',{staticClass:"pt-3 pb-1 pb-sm-3 text-sm text-center text-sm-left"},[_c('span',{staticClass:"text-muted mr-2"},[_vm._v("Affichage des produits")]),_vm._v("1- "+_vm._s(_vm.pageSize)+" Produits")]),_vm._v(" "),_c('form',{staticClass:"input-group shop-search-box",attrs:{"method":"get"}},[_vm._m(0),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filter),expression:"filter"}],staticClass:"form-control",staticStyle:{"border":"2px solid #000000"},attrs:{"type":"search","placeholder":"Recherche par Référence","disabled":_vm.brands.length>0},domProps:{"value":(_vm.filter)},on:{"keyup":_vm.search,"input":function($event){if($event.target.composing){ return; }_vm.filter=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"d-flex flex-wrap justify-content-center mb-2"},_vm._l((_vm.filterProduct),function(product){return _c('div',{key:product.id,staticClass:"col-xl-3 col-lg-4 col-sm-6"},[_c('div',{staticClass:"product-card mb-30"},[_c('div',{staticClass:"product-card-thumb"},[_c('router-link',{staticClass:"product-card-link",attrs:{"to":{ name: 'productref', params: { ref: product.id }}},nativeOn:{"click":function($event){_vm.ProductDetail(product)}}}),_c('img',{attrs:{"src":product.img,"alt":"Product"}}),_vm._v(" "),_c('div',{staticClass:"product-card-buttons"},[_c('button',{staticClass:"btn btn-primary btn-sm",on:{"click":function($event){_vm.addToCart(product)}}},[_vm._v("Ajouter au panier")])])],1),_vm._v(" "),_c('div',{staticClass:"product-card-details"},[_c('h3',{staticClass:"product-card-title"},[_c('b',{attrs:{"href":"shop-single.html"}},[_c('strong',[_vm._v(_vm._s(product.description))])])]),_vm._v(" "),_c('span',{staticClass:"h6 d-block"},[_c('del',{staticClass:"text-muted text-normal"},[_vm._v(_vm._s(product.price2)+" DA")]),_vm._v(" "+_vm._s(product.price2)+" DA")])])])])})),_vm._v(" "),_c('pagination',{attrs:{"total":_vm.total,"page-size":_vm.pageSize,"callback":_vm.pageChanged,"options":_vm.paginationOptions,"nav-class":"pagination","ul-class":"column pages","li-class":"pt-2"}})],1),_vm._v(" "),_c('div',{staticClass:"col-xl-2 col-lg-3 col-md-4 order-md-1"},[_c('div',{staticClass:"sidebar-toggle position-left",class:{sidebaropen:_vm.sidebarOpen},on:{"click":function($event){_vm.sidebarOpen=!_vm.sidebarOpen}}},[_c('i',{staticClass:"material-icons filter_list"})]),_vm._v(" "),_c('aside',{staticClass:"sidebar sidebar-offcanvas position-left",class:{offcanvasopen:_vm.sidebarOpen}},[_c('span',{staticClass:"sidebar-close",on:{"click":function($event){_vm.sidebarOpen=!_vm.sidebarOpen}}},[_c('i',{staticClass:"material-icons icon_close"})]),_vm._v(" "),_c('section',{staticClass:"widget widget-icon-list"})])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"input-group-btn"},[_c('button',{attrs:{"type":"submit"}},[_c('i',{staticClass:"material-icons search"})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 273 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_michaelkors_vue__ = __webpack_require__(78);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8e8239f0_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_michaelkors_vue__ = __webpack_require__(275);
function injectStyle (ssrContext) {
  __webpack_require__(274)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-8e8239f0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_michaelkors_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8e8239f0_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_michaelkors_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 274 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 275 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mr-top-40"},[_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"container-fluid padding-bottom-3x mb-1"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-10 col-lg-9 col-md-8 order-md-2"},[_c('div',{staticClass:"d-flex flex-wrap-reverse flex-md-nowrap justify-content-center justify-content-sm-between align-items-center mb-30"},[_c('div',{staticClass:"pt-3 pb-1 pb-sm-3 text-sm text-center text-sm-left"},[_c('span',{staticClass:"text-muted mr-2"},[_vm._v("Affichage des produits")]),_vm._v("1- "+_vm._s(_vm.pageSize)+" Produits")]),_vm._v(" "),_c('form',{staticClass:"input-group shop-search-box",attrs:{"method":"get"}},[_vm._m(0),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filter),expression:"filter"}],staticClass:"form-control",staticStyle:{"border":"2px solid #000000"},attrs:{"type":"search","placeholder":"Recherche par Référence","disabled":_vm.brands.length>0},domProps:{"value":(_vm.filter)},on:{"keyup":_vm.search,"input":function($event){if($event.target.composing){ return; }_vm.filter=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"d-flex flex-wrap justify-content-center mb-2"},_vm._l((_vm.filterProduct),function(product){return _c('div',{key:product.id,staticClass:"col-xl-3 col-lg-4 col-sm-6"},[_c('div',{staticClass:"product-card mb-30"},[_c('div',{staticClass:"product-card-thumb"},[_c('router-link',{staticClass:"product-card-link",attrs:{"to":{ name: 'productref', params: { ref: product.id }}},nativeOn:{"click":function($event){_vm.ProductDetail(product)}}},[_c('div',{staticStyle:{"display":"flex"}})]),_c('img',{attrs:{"src":product.img,"alt":"Product"}}),_vm._v(" "),_c('div',{staticClass:"product-card-buttons"},[_c('button',{staticClass:"btn btn-primary btn-sm",on:{"click":function($event){_vm.addToCart(product)}}},[_vm._v("Ajouter au panier")])])],1),_vm._v(" "),_c('div',{staticClass:"product-card-details"},[_c('h3',{staticClass:"product-card-title"},[_c('b',{attrs:{"href":"shop-single.html"}},[_c('strong',[_vm._v(_vm._s(product.description))])])]),_vm._v(" "),_c('span',{staticClass:"h6 d-block"},[_c('del',{staticClass:"text-muted text-normal"},[_vm._v(_vm._s(product.price2)+" DA")]),_vm._v(" "+_vm._s(product.price)+" DA")])])])])})),_vm._v(" "),_c('pagination',{attrs:{"total":_vm.total,"page-size":_vm.pageSize,"callback":_vm.pageChanged,"options":_vm.paginationOptions,"nav-class":"pagination","ul-class":"column pages","li-class":"pt-2"}})],1),_vm._v(" "),_c('div',{staticClass:"col-xl-2 col-lg-3 col-md-4 order-md-1"},[_c('div',{staticClass:"sidebar-toggle position-left",class:{sidebaropen:_vm.sidebarOpen},on:{"click":function($event){_vm.sidebarOpen=!_vm.sidebarOpen}}},[_c('i',{staticClass:"material-icons filter_list"})]),_vm._v(" "),_c('aside',{staticClass:"sidebar sidebar-offcanvas position-left",class:{offcanvasopen:_vm.sidebarOpen}},[_c('span',{staticClass:"sidebar-close",on:{"click":function($event){_vm.sidebarOpen=!_vm.sidebarOpen}}},[_c('i',{staticClass:"material-icons icon_close"})]),_vm._v(" "),_c('section',{staticClass:"widget widget-icon-list"})])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"input-group-btn"},[_c('button',{attrs:{"type":"submit"}},[_c('i',{staticClass:"material-icons search"})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 276 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_connectee_vue__ = __webpack_require__(79);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_076d4fed_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_connectee_vue__ = __webpack_require__(278);
function injectStyle (ssrContext) {
  __webpack_require__(277)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-076d4fed"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_connectee_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_076d4fed_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_connectee_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 277 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 278 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mr-top-40"},[_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"container-fluid padding-bottom-3x mb-1"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-10 col-lg-9 col-md-8 order-md-2"},[_c('div',{staticClass:"d-flex flex-wrap-reverse flex-md-nowrap justify-content-center justify-content-sm-between align-items-center mb-30"},[_c('div',{staticClass:"pt-3 pb-1 pb-sm-3 text-sm text-center text-sm-left"},[_c('span',{staticClass:"text-muted mr-2"},[_vm._v("Affichage des produits")]),_vm._v("1- "+_vm._s(_vm.pageSize)+" Produits")]),_vm._v(" "),_c('form',{staticClass:"input-group shop-search-box",attrs:{"method":"get"}},[_vm._m(0),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filter),expression:"filter"}],staticClass:"form-control",staticStyle:{"border":"2px solid #000000"},attrs:{"type":"search","placeholder":"Recherche par Référence","disabled":_vm.brands.length>0},domProps:{"value":(_vm.filter)},on:{"keyup":_vm.search,"input":function($event){if($event.target.composing){ return; }_vm.filter=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"d-flex flex-wrap justify-content-center mb-2"},_vm._l((_vm.filterProduct),function(product){return _c('div',{key:product.id,staticClass:"col-xl-3 col-lg-4 col-sm-6"},[_c('div',{staticClass:"product-card mb-30"},[_c('div',{staticClass:"product-card-thumb"},[_c('router-link',{staticClass:"product-card-link",attrs:{"to":{ name: 'productref', params: { ref: product.id }}},nativeOn:{"click":function($event){_vm.ProductDetail(product)}}},[_c('div',{staticStyle:{"display":"flex"}},[_c('H6',{staticClass:"product-badge bgblack text-white ",staticStyle:{}},[_c('b',[_vm._v("   رمضان كريم    ")])])],1)]),_c('img',{attrs:{"src":product.img,"alt":"Product"}}),_vm._v(" "),_c('div',{staticClass:"product-card-buttons"},[_c('button',{staticClass:"btn btn-primary btn-sm",on:{"click":function($event){_vm.addToCart(product)}}},[_vm._v("Ajouter au panier")])])],1),_vm._v(" "),_c('div',{staticClass:"product-card-details"},[_c('h3',{staticClass:"product-card-title"},[_c('b',{attrs:{"href":"shop-single.html"}},[_c('strong',[_vm._v(_vm._s(product.description))])])]),_vm._v(" "),_c('span',{staticClass:"h6 d-block"},[_c('del',{staticClass:"text-muted text-normal"},[_vm._v(_vm._s(product.price2)+" DA")]),_vm._v(" "+_vm._s(product.price)+" DA")])])])])})),_vm._v(" "),_c('pagination',{attrs:{"total":_vm.total,"page-size":_vm.pageSize,"callback":_vm.pageChanged,"options":_vm.paginationOptions,"nav-class":"pagination","ul-class":"column pages","li-class":"pt-2"}})],1),_vm._v(" "),_c('div',{staticClass:"col-xl-2 col-lg-3 col-md-4 order-md-1"},[_c('div',{staticClass:"sidebar-toggle position-left",class:{sidebaropen:_vm.sidebarOpen},on:{"click":function($event){_vm.sidebarOpen=!_vm.sidebarOpen}}},[_c('i',{staticClass:"material-icons filter_list"})]),_vm._v(" "),_c('aside',{staticClass:"sidebar sidebar-offcanvas position-left",class:{offcanvasopen:_vm.sidebarOpen}},[_c('span',{staticClass:"sidebar-close",on:{"click":function($event){_vm.sidebarOpen=!_vm.sidebarOpen}}},[_c('i',{staticClass:"material-icons icon_close"})]),_vm._v(" "),_c('section',{staticClass:"widget widget-icon-list"},[_vm._m(1),_vm._v(" "),_c('ul',[_c('li',[_c('a',{attrs:{"href":"#"},on:{"click":function($event){_vm.ordreby('quantite')}}},[_c('i',{staticClass:"material-icons favorite_border"}),_vm._v("Popularité")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#"},on:{"click":function($event){_vm.ordreby('annee')}}},[_c('i',{staticClass:"material-icons vertical_align_top"}),_vm._v("Dernière collection")])])])]),_vm._v(" "),_c('section',{staticClass:"widget widget-categories"},[_c('h3',{staticClass:"widget-title"},[_vm._v("PRIX")]),_vm._v(" "),_c('el-slider',{attrs:{"range":"","step":10000,"show-stops":"","max":80000},model:{value:(_vm.priceValue),callback:function ($$v) {_vm.priceValue=$$v},expression:"priceValue"}}),_vm._v(" "),_c('form',{staticClass:"price-range-slider",on:{"submit":function($event){$event.preventDefault();return _vm.submit($event)}}},[_c('div',{staticClass:"ui-range-slider-footer"},[_vm._m(2),_vm._v(" "),_c('div',{staticClass:"column"},[_c('span',[_vm._v(_vm._s(_vm.priceValue[0])+"DA-"+_vm._s(_vm.priceValue[1])+"DA")])])])])],1)])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"input-group-btn"},[_c('button',{attrs:{"type":"submit"}},[_c('i',{staticClass:"material-icons search"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h3',{staticClass:"widget-title"},[_c('strong',[_vm._v("  Filter par ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"column"},[_c('button',{staticClass:"btn btn-outline-primary btn-sm",attrs:{"type":"submit"}},[_vm._v("Filter")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 279 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_diesel_vue__ = __webpack_require__(80);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_098b982b_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_diesel_vue__ = __webpack_require__(281);
function injectStyle (ssrContext) {
  __webpack_require__(280)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-098b982b"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_diesel_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_098b982b_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_diesel_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 280 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 281 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mr-top-40"},[_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"container-fluid padding-bottom-3x mb-1"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-10 col-lg-9 col-md-8 order-md-2"},[_c('div',{staticClass:"d-flex flex-wrap-reverse flex-md-nowrap justify-content-center justify-content-sm-between align-items-center mb-30"},[_c('div',{staticClass:"pt-3 pb-1 pb-sm-3 text-sm text-center text-sm-left"},[_c('span',{staticClass:"text-muted mr-2"},[_vm._v("Affichage des produits")]),_vm._v("1- "+_vm._s(_vm.pageSize)+" Produits")]),_vm._v(" "),_c('form',{staticClass:"input-group shop-search-box",attrs:{"method":"get"}},[_vm._m(0),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filter),expression:"filter"}],staticClass:"form-control",staticStyle:{"border":"2px solid #000000"},attrs:{"type":"search","placeholder":"Recherche par Référence","disabled":_vm.brands.length>0},domProps:{"value":(_vm.filter)},on:{"keyup":_vm.search,"input":function($event){if($event.target.composing){ return; }_vm.filter=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"d-flex flex-wrap justify-content-center mb-2"},_vm._l((_vm.filterProduct),function(product){return _c('div',{key:product.id,staticClass:"col-xl-3 col-lg-4 col-sm-6"},[_c('div',{staticClass:"product-card mb-30"},[_c('div',{staticClass:"product-card-thumb"},[_c('router-link',{staticClass:"product-card-link",attrs:{"to":{ name: 'productref', params: { ref: product.id }}},nativeOn:{"click":function($event){_vm.ProductDetail(product)}}},[_c('div',{staticStyle:{"display":"flex"}},[_c('H6',{staticClass:"product-badge bgblack text-white ",staticStyle:{}},[_c('b',[_vm._v("   رمضان كريم    ")])])],1)]),_c('img',{attrs:{"src":product.img,"alt":"Product"}}),_vm._v(" "),_c('div',{staticClass:"product-card-buttons"},[_c('button',{staticClass:"btn btn-primary btn-sm",on:{"click":function($event){_vm.addToCart(product)}}},[_vm._v("Ajouter au panier")])])],1),_vm._v(" "),_c('div',{staticClass:"product-card-details"},[_c('h3',{staticClass:"product-card-title"},[_c('b',{attrs:{"href":"shop-single.html"}},[_c('strong',[_vm._v(_vm._s(product.description))])])]),_vm._v(" "),_c('span',{staticClass:"h6 d-block"},[_c('del',{staticClass:"text-muted text-normal"},[_vm._v(_vm._s(product.price2)+" DA")]),_vm._v(" "+_vm._s(product.price)+" DA")])])])])})),_vm._v(" "),_c('pagination',{attrs:{"total":_vm.total,"page-size":_vm.pageSize,"callback":_vm.pageChanged,"options":_vm.paginationOptions,"nav-class":"pagination","ul-class":"column pages","li-class":"pt-2"}})],1),_vm._v(" "),_c('div',{staticClass:"col-xl-2 col-lg-3 col-md-4 order-md-1"},[_c('div',{staticClass:"sidebar-toggle position-left",class:{sidebaropen:_vm.sidebarOpen},on:{"click":function($event){_vm.sidebarOpen=!_vm.sidebarOpen}}},[_c('i',{staticClass:"material-icons filter_list"})]),_vm._v(" "),_c('aside',{staticClass:"sidebar sidebar-offcanvas position-left",class:{offcanvasopen:_vm.sidebarOpen}},[_c('span',{staticClass:"sidebar-close",on:{"click":function($event){_vm.sidebarOpen=!_vm.sidebarOpen}}},[_c('i',{staticClass:"material-icons icon_close"})]),_vm._v(" "),_c('section',{staticClass:"widget widget-icon-list"})])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"input-group-btn"},[_c('button',{attrs:{"type":"submit"}},[_c('i',{staticClass:"material-icons search"})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 282 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_top_vue__ = __webpack_require__(81);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b438a2e0_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_top_vue__ = __webpack_require__(284);
function injectStyle (ssrContext) {
  __webpack_require__(283)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-b438a2e0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_top_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b438a2e0_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_top_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 283 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 284 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mr-top-40"},[_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"container-fluid padding-bottom-3x mb-1"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-10 col-lg-9 col-md-8 order-md-2"},[_c('div',{staticClass:"d-flex flex-wrap-reverse flex-md-nowrap justify-content-center justify-content-sm-between align-items-center mb-30"},[_c('div',{staticClass:"pt-3 pb-1 pb-sm-3 text-sm text-center text-sm-left"},[_c('span',{staticClass:"text-muted mr-2"},[_vm._v("Affichage des produits")]),_vm._v("1- "+_vm._s(_vm.pageSize)+" Produits")]),_vm._v(" "),_c('form',{staticClass:"input-group shop-search-box",attrs:{"method":"get"}},[_vm._m(0),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filter),expression:"filter"}],staticClass:"form-control",staticStyle:{"border":"2px solid #000000"},attrs:{"type":"search","placeholder":"Recherche par Référence","disabled":_vm.brands.length>0},domProps:{"value":(_vm.filter)},on:{"keyup":_vm.search,"input":function($event){if($event.target.composing){ return; }_vm.filter=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"d-flex flex-wrap justify-content-center mb-2"},_vm._l((_vm.filterProduct),function(product){return _c('div',{key:product.id,staticClass:"col-xl-3 col-lg-4 col-sm-6"},[_c('div',{staticClass:"product-card mb-30"},[_c('div',{staticClass:"product-card-thumb"},[_c('router-link',{staticClass:"product-card-link",attrs:{"to":{ name: 'productref', params: { ref: product.id }}},nativeOn:{"click":function($event){_vm.ProductDetail(product)}}},[_c('div',{staticStyle:{"display":"flex"}})]),_c('img',{attrs:{"src":product.img,"alt":"Product"}}),_vm._v(" "),_c('div',{staticClass:"product-card-buttons"},[_c('button',{staticClass:"btn btn-primary btn-sm",on:{"click":function($event){_vm.addToCart(product)}}},[_vm._v("Ajouter au panier")])])],1),_vm._v(" "),_c('div',{staticClass:"product-card-details"},[_c('h3',{staticClass:"product-card-title"},[_c('b',{attrs:{"href":"shop-single.html"}},[_c('strong',[_vm._v(_vm._s(product.description))])])]),_vm._v(" "),_c('span',{staticClass:"h6 d-block"},[_c('del',{staticClass:"text-muted text-normal"},[_vm._v(_vm._s(product.price2)+" DA")]),_vm._v(" "+_vm._s(product.price)+" DA")])])])])})),_vm._v(" "),_c('pagination',{attrs:{"total":_vm.total,"page-size":_vm.pageSize,"callback":_vm.pageChanged,"options":_vm.paginationOptions,"nav-class":"pagination","ul-class":"column pages","li-class":"pt-2"}})],1),_vm._v(" "),_c('div',{staticClass:"col-xl-2 col-lg-3 col-md-4 order-md-1"},[_c('div',{staticClass:"sidebar-toggle position-left",class:{sidebaropen:_vm.sidebarOpen},on:{"click":function($event){_vm.sidebarOpen=!_vm.sidebarOpen}}},[_c('i',{staticClass:"material-icons filter_list"})]),_vm._v(" "),_c('aside',{staticClass:"sidebar sidebar-offcanvas position-left",class:{offcanvasopen:_vm.sidebarOpen}},[_c('span',{staticClass:"sidebar-close",on:{"click":function($event){_vm.sidebarOpen=!_vm.sidebarOpen}}},[_c('i',{staticClass:"material-icons icon_close"})]),_vm._v(" "),_c('section',{staticClass:"widget widget-icon-list"}),_vm._v(" "),_c('section',{staticClass:"widget widget-categories"})])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"input-group-btn"},[_c('button',{attrs:{"type":"submit"}},[_c('i',{staticClass:"material-icons search"})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 285 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_fossil_vue__ = __webpack_require__(82);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7c618f0c_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_fossil_vue__ = __webpack_require__(287);
function injectStyle (ssrContext) {
  __webpack_require__(286)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7c618f0c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_fossil_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7c618f0c_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_fossil_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 286 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 287 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mr-top-40"},[_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"container-fluid padding-bottom-3x mb-1"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-10 col-lg-9 col-md-8 order-md-2"},[_c('div',{staticClass:"d-flex flex-wrap-reverse flex-md-nowrap justify-content-center justify-content-sm-between align-items-center mb-30"},[_c('div',{staticClass:"pt-3 pb-1 pb-sm-3 text-sm text-center text-sm-left"},[_c('span',{staticClass:"text-muted mr-2"},[_vm._v("Affichage des produits")]),_vm._v("1- "+_vm._s(_vm.pageSize)+" Produits")]),_vm._v(" "),_c('form',{staticClass:"input-group shop-search-box",attrs:{"method":"get"}},[_vm._m(0),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filter),expression:"filter"}],staticClass:"form-control",staticStyle:{"border":"2px solid #000000"},attrs:{"type":"search","placeholder":"Recherche par Référence","disabled":_vm.brands.length>0},domProps:{"value":(_vm.filter)},on:{"keyup":_vm.search,"input":function($event){if($event.target.composing){ return; }_vm.filter=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"d-flex flex-wrap justify-content-center mb-2"},_vm._l((_vm.filterProduct),function(product){return _c('div',{key:product.id,staticClass:"col-xl-3 col-lg-4 col-sm-6"},[_c('div',{staticClass:"product-card mb-30"},[_c('div',{staticClass:"product-card-thumb"},[_c('router-link',{staticClass:"product-card-link",attrs:{"to":{ name: 'productref', params: { ref: product.id }}},nativeOn:{"click":function($event){_vm.ProductDetail(product)}}}),_c('img',{attrs:{"src":product.img,"alt":"Product"}}),_vm._v(" "),_c('div',{staticClass:"product-card-buttons"},[_c('button',{staticClass:"btn btn-primary btn-sm",on:{"click":function($event){_vm.addToCart(product)}}},[_vm._v("Ajouter au panier")])])],1),_vm._v(" "),_c('div',{staticClass:"product-card-details"},[_c('h3',{staticClass:"product-card-title"},[_c('b',{attrs:{"href":"shop-single.html"}},[_c('strong',[_vm._v(_vm._s(product.description))])])]),_vm._v(" "),_c('span',{staticClass:"h6 d-block"},[_c('del',{staticClass:"text-muted text-normal"},[_vm._v(_vm._s(product.price2)+" DA")]),_vm._v(" "+_vm._s(product.price)+" DA")])])])])})),_vm._v(" "),_c('pagination',{attrs:{"total":_vm.total,"page-size":_vm.pageSize,"callback":_vm.pageChanged,"options":_vm.paginationOptions,"nav-class":"pagination","ul-class":"column pages","li-class":"pt-2"}})],1),_vm._v(" "),_c('div',{staticClass:"col-xl-2 col-lg-3 col-md-4 order-md-1"},[_c('div',{staticClass:"sidebar-toggle position-left",class:{sidebaropen:_vm.sidebarOpen},on:{"click":function($event){_vm.sidebarOpen=!_vm.sidebarOpen}}},[_c('i',{staticClass:"material-icons filter_list"})]),_vm._v(" "),_c('aside',{staticClass:"sidebar sidebar-offcanvas position-left",class:{offcanvasopen:_vm.sidebarOpen}},[_c('span',{staticClass:"sidebar-close",on:{"click":function($event){_vm.sidebarOpen=!_vm.sidebarOpen}}},[_c('i',{staticClass:"material-icons icon_close"})]),_vm._v(" "),_c('section',{staticClass:"widget widget-icon-list"})])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"input-group-btn"},[_c('button',{attrs:{"type":"submit"}},[_c('i',{staticClass:"material-icons search"})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 288 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_women_vue__ = __webpack_require__(83);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3628610e_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_women_vue__ = __webpack_require__(290);
function injectStyle (ssrContext) {
  __webpack_require__(289)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3628610e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_women_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3628610e_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_women_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)


/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 289 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 290 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mr-top-40"},[_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"container-fluid padding-bottom-3x mb-1"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-10 col-lg-9 col-md-8 order-md-2"},[_c('div',{staticClass:"d-flex flex-wrap-reverse flex-md-nowrap justify-content-center justify-content-sm-between align-items-center mb-30"},[_c('div',{staticClass:"pt-3 pb-1 pb-sm-3 text-sm text-center text-sm-left"},[_c('span',{staticClass:"text-muted mr-2"},[_vm._v("Affichage des produits")]),_vm._v("1- "+_vm._s(_vm.pageSize)+" Produits")]),_vm._v(" "),_c('form',{staticClass:"input-group shop-search-box",attrs:{"method":"get"}},[_vm._m(0),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filter),expression:"filter"}],staticClass:"form-control",staticStyle:{"border":"2px solid #000000"},attrs:{"type":"search","placeholder":"Recherche par Référence","disabled":_vm.brands.length>0},domProps:{"value":(_vm.filter)},on:{"keyup":_vm.search,"input":function($event){if($event.target.composing){ return; }_vm.filter=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"d-flex flex-wrap justify-content-center mb-2"},_vm._l((_vm.filterProduct),function(product){return _c('div',{key:product.id,staticClass:"col-xl-3 col-lg-4 col-sm-6"},[_c('div',{staticClass:"product-card mb-30"},[_c('div',{staticClass:"product-card-thumb"},[_c('router-link',{staticClass:"product-card-link",attrs:{"to":{ name: 'productref', params: { ref: product.id }}},nativeOn:{"click":function($event){_vm.ProductDetail(product)}}},[_c('div',{staticStyle:{"display":"flex"}},[_c('H6',{staticClass:"product-badge bgblack text-white ",staticStyle:{}},[_c('b',[_vm._v("   رمضان كريم    ")])])],1)]),_c('img',{attrs:{"src":product.img,"alt":"Product"}}),_vm._v(" "),_c('div',{staticClass:"product-card-buttons"},[_c('button',{staticClass:"btn btn-primary btn-sm",on:{"click":function($event){_vm.addToCart(product)}}},[_vm._v("Ajouter au panier")])])],1),_vm._v(" "),_c('div',{staticClass:"product-card-details"},[_c('h3',{staticClass:"product-card-title"},[_c('b',{attrs:{"href":"shop-single.html"}},[_c('strong',[_vm._v(_vm._s(product.description))])])]),_vm._v(" "),_c('span',{staticClass:"h6 d-block"},[_c('del',{staticClass:"text-muted text-normal"},[_vm._v(_vm._s(product.price2)+" DA")]),_vm._v(" "+_vm._s(product.price)+" DA")])])])])})),_vm._v(" "),_c('pagination',{attrs:{"total":_vm.total,"page-size":_vm.pageSize,"callback":_vm.pageChanged,"options":_vm.paginationOptions,"nav-class":"pagination","ul-class":"column pages","li-class":"pt-2"}})],1),_vm._v(" "),_c('div',{staticClass:"col-xl-2 col-lg-3 col-md-4 order-md-1"},[_c('div',{staticClass:"sidebar-toggle position-left",class:{sidebaropen:_vm.sidebarOpen},on:{"click":function($event){_vm.sidebarOpen=!_vm.sidebarOpen}}},[_c('i',{staticClass:"material-icons filter_list"})]),_vm._v(" "),_c('aside',{staticClass:"sidebar sidebar-offcanvas position-left",class:{offcanvasopen:_vm.sidebarOpen}},[_c('span',{staticClass:"sidebar-close",on:{"click":function($event){_vm.sidebarOpen=!_vm.sidebarOpen}}},[_c('i',{staticClass:"material-icons icon_close"})]),_vm._v(" "),_c('section',{staticClass:"widget widget-icon-list"},[_vm._m(1),_vm._v(" "),_c('ul',[_c('li',[_c('a',{attrs:{"href":"#"},on:{"click":function($event){_vm.ordreby('quantite')}}},[_c('i',{staticClass:"material-icons favorite_border"}),_vm._v("Popularité")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#"},on:{"click":function($event){_vm.ordreby('annee')}}},[_c('i',{staticClass:"material-icons vertical_align_top"}),_vm._v("Dernière collection")])])])]),_vm._v(" "),_c('section',{staticClass:"widget widget-categories"},[_vm._m(2),_vm._v(" "),_c('el-slider',{attrs:{"range":"","step":10000,"show-stops":"","max":80000},model:{value:(_vm.priceValue),callback:function ($$v) {_vm.priceValue=$$v},expression:"priceValue"}}),_vm._v(" "),_c('form',{staticClass:"price-range-slider",on:{"submit":function($event){$event.preventDefault();return _vm.submit($event)}}},[_c('div',{staticClass:"ui-range-slider-footer"},[_c('div',{staticClass:"column"},[_c('button',{staticClass:"btn btn-outline-primary btn-sm",attrs:{"type":"submit","disabled":_vm.brands.length>0}},[_vm._v("Filtrer")])]),_vm._v(" "),_c('div',{staticClass:"column"},[_c('span',[_vm._v(_vm._s(_vm.priceValue[0])+"DA-"+_vm._s(_vm.priceValue[1])+"DA")])])])])],1),_vm._v(" "),_c('section',{staticClass:"widget"},[_vm._m(3),_vm._v(" "),_c('div',{staticClass:"custom-control custom-checkbox"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.brands),expression:"brands"}],staticClass:"custom-control-input",attrs:{"type":"checkbox","id":"festina","value":"festina"},domProps:{"checked":Array.isArray(_vm.brands)?_vm._i(_vm.brands,"festina")>-1:(_vm.brands)},on:{"change":[function($event){var $$a=_vm.brands,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="festina",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.brands=$$a.concat([$$v]))}else{$$i>-1&&(_vm.brands=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.brands=$$c}},_vm.brandChecked]}}),_vm._v(" "),_vm._m(4)]),_vm._v(" "),_c('div',{staticClass:"custom-control custom-checkbox"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.brands),expression:"brands"}],staticClass:"custom-control-input",attrs:{"type":"checkbox","id":"morellato","value":"morellato"},domProps:{"checked":Array.isArray(_vm.brands)?_vm._i(_vm.brands,"morellato")>-1:(_vm.brands)},on:{"change":[function($event){var $$a=_vm.brands,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="morellato",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.brands=$$a.concat([$$v]))}else{$$i>-1&&(_vm.brands=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.brands=$$c}},_vm.brandChecked]}}),_vm._v(" "),_vm._m(5)]),_vm._v(" "),_c('div',{staticClass:"custom-control custom-checkbox"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.brands),expression:"brands"}],staticClass:"custom-control-input",attrs:{"type":"checkbox","id":"maserati","value":"maserati"},domProps:{"checked":Array.isArray(_vm.brands)?_vm._i(_vm.brands,"maserati")>-1:(_vm.brands)},on:{"change":[function($event){var $$a=_vm.brands,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="maserati",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.brands=$$a.concat([$$v]))}else{$$i>-1&&(_vm.brands=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.brands=$$c}},_vm.brandChecked]}}),_vm._v(" "),_vm._m(6)]),_vm._v(" "),_c('div',{staticClass:"custom-control custom-checkbox"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.brands),expression:"brands"}],staticClass:"custom-control-input",attrs:{"type":"checkbox","id":"timberland","value":"timberland"},domProps:{"checked":Array.isArray(_vm.brands)?_vm._i(_vm.brands,"timberland")>-1:(_vm.brands)},on:{"change":[function($event){var $$a=_vm.brands,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="timberland",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.brands=$$a.concat([$$v]))}else{$$i>-1&&(_vm.brands=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.brands=$$c}},_vm.brandChecked]}}),_vm._v(" "),_vm._m(7)]),_vm._v(" "),_c('div',{staticClass:"custom-control custom-checkbox"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.brands),expression:"brands"}],staticClass:"custom-control-input",attrs:{"type":"checkbox","id":"mk","value":"michael kors"},domProps:{"checked":Array.isArray(_vm.brands)?_vm._i(_vm.brands,"michael kors")>-1:(_vm.brands)},on:{"change":[function($event){var $$a=_vm.brands,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="michael kors",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.brands=$$a.concat([$$v]))}else{$$i>-1&&(_vm.brands=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.brands=$$c}},_vm.brandChecked]}}),_vm._v(" "),_vm._m(8)]),_vm._v(" "),_c('div',{staticClass:"custom-control custom-checkbox"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.brands),expression:"brands"}],staticClass:"custom-control-input",attrs:{"type":"checkbox","id":"armani exchange","value":"armani exchange"},domProps:{"checked":Array.isArray(_vm.brands)?_vm._i(_vm.brands,"armani exchange")>-1:(_vm.brands)},on:{"change":[function($event){var $$a=_vm.brands,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="armani exchange",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.brands=$$a.concat([$$v]))}else{$$i>-1&&(_vm.brands=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.brands=$$c}},_vm.brandChecked]}}),_vm._v(" "),_vm._m(9)]),_vm._v(" "),_c('div',{staticClass:"custom-control custom-checkbox"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.brands),expression:"brands"}],staticClass:"custom-control-input",attrs:{"type":"checkbox","id":"diesel","value":"diesel"},domProps:{"checked":Array.isArray(_vm.brands)?_vm._i(_vm.brands,"diesel")>-1:(_vm.brands)},on:{"change":[function($event){var $$a=_vm.brands,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="diesel",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.brands=$$a.concat([$$v]))}else{$$i>-1&&(_vm.brands=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.brands=$$c}},_vm.brandChecked]}}),_vm._v(" "),_vm._m(10)]),_vm._v(" "),_c('div',{staticClass:"custom-control custom-checkbox"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.brands),expression:"brands"}],staticClass:"custom-control-input",attrs:{"type":"checkbox","id":"fossil","value":"fossil"},domProps:{"checked":Array.isArray(_vm.brands)?_vm._i(_vm.brands,"fossil")>-1:(_vm.brands)},on:{"change":[function($event){var $$a=_vm.brands,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="fossil",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.brands=$$a.concat([$$v]))}else{$$i>-1&&(_vm.brands=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.brands=$$c}},_vm.brandChecked]}}),_vm._v(" "),_vm._m(11)]),_vm._v(" "),_c('div',{staticClass:"custom-control custom-checkbox"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.brands),expression:"brands"}],staticClass:"custom-control-input",attrs:{"type":"checkbox","id":"lotus","value":"lotus"},domProps:{"checked":Array.isArray(_vm.brands)?_vm._i(_vm.brands,"lotus")>-1:(_vm.brands)},on:{"change":[function($event){var $$a=_vm.brands,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="lotus",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.brands=$$a.concat([$$v]))}else{$$i>-1&&(_vm.brands=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.brands=$$c}},_vm.brandChecked]}}),_vm._v(" "),_vm._m(12)])])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"input-group-btn"},[_c('button',{attrs:{"type":"submit"}},[_c('i',{staticClass:"material-icons search"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h3',{staticClass:"widget-title"},[_c('strong',[_vm._v("  Filtrer par ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h3',{staticClass:"widget-title"},[_c('strong',[_vm._v(" PRIX ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h3',{staticClass:"widget-title"},[_c('strong',[_vm._v("MARQUE")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"custom-control-label",attrs:{"for":"festina"}},[_c('strong',[_vm._v("Festina")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"custom-control-label",attrs:{"for":"morellato"}},[_c('strong',[_vm._v("Morellato")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"custom-control-label",attrs:{"for":"maserati"}},[_c('strong',[_vm._v("Maserati")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"custom-control-label",attrs:{"for":"timberland"}},[_c('strong',[_vm._v("Timberland")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"custom-control-label",attrs:{"for":"mk"}},[_c('strong',[_vm._v("Michael Kors")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"custom-control-label",attrs:{"for":"armani exchange"}},[_c('strong',[_vm._v(" Armani exchange ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"custom-control-label",attrs:{"for":"diesel"}},[_c('strong',[_vm._v("Diesel")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"custom-control-label",attrs:{"for":"fossil"}},[_c('strong',[_vm._v("Fossil")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"custom-control-label",attrs:{"for":"lotus"}},[_c('strong',[_vm._v("Lotus")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 291 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_achatmobile_vue__ = __webpack_require__(84);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_33ba7827_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_achatmobile_vue__ = __webpack_require__(293);
function injectStyle (ssrContext) {
  __webpack_require__(292)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-33ba7827"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_achatmobile_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_33ba7827_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_achatmobile_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 292 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 293 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"page-title"},[_c('div',{staticClass:"container"},[_c('h1',[_vm._v("Comment acheter ")]),_vm._v(" "),_c('ul',{staticClass:"breadcrumbs"},[_c('h2',[_c('strong',[_vm._v("  luxuryshopdz est aujourd'hui le numéro 1 en Algerie des ventes de montres origianles  ")])])])])]),_vm._v(" "),_c('div',[_c('h2',{staticStyle:{"text-align":"center"}},[_c('span',{staticStyle:{"color":"#FFA500"}},[_c('strong',[_vm._v("Etape N°1 :")])]),_vm._v(" "),_c('span',{staticStyle:{"color":"#4a4a4a"}},[_c('strong',[_vm._v(" Accédez au site www.luxuryshopdz.com ")])])]),_vm._v(" "),_c('h2',{staticStyle:{"text-align":"center"}},[_c('img',{attrs:{"src":"static/img/shop/categories/homemob.png","width":"90%","alt":"Etape_01 Ombre (1).png"}})])]),_vm._v("\n↓↓\n"),_c('div',[_c('h2',{staticStyle:{"text-align":"center"}},[_c('span',{staticStyle:{"color":"#FFA500"}},[_c('strong',[_vm._v("Etape N°2 :")])]),_vm._v(" "),_c('span',{staticStyle:{"color":"#4a4a4a"}},[_c('strong',[_vm._v(" Cliquez sur le produit qui vous intéresse. ")])])]),_vm._v(" "),_c('h2',{staticStyle:{"text-align":"center"}},[_c('img',{attrs:{"src":"static/img/shop/categories/commandemob.png","width":"70%","alt":"Etape_01 Ombre (1).png"}})])]),_vm._v("\n↓↓\n"),_c('div',[_c('h2',{staticStyle:{"text-align":"center"}},[_c('span',{staticStyle:{"color":"#FFA500"}},[_c('strong',[_vm._v("Etape N°3 :")])]),_vm._v(" "),_c('span',{staticStyle:{"color":"#4a4a4a"}},[_c('strong',[_vm._v(" Cliquez sur \"Ajouter au panier\"  ")])])]),_vm._v(" "),_c('h2',{staticStyle:{"text-align":"center"}},[_c('img',{attrs:{"src":"static/img/shop/categories/produitmob.png","width":"70%","alt":"Etape_01 Ombre (1).png"}})])]),_vm._v("\n↓↓\n"),_c('div',[_c('h2',{staticStyle:{"text-align":"center"}},[_c('span',{staticStyle:{"color":"#FFA500"}},[_c('strong',[_vm._v("Etape N°4 :")])]),_vm._v(" "),_c('span',{staticStyle:{"color":"#4a4a4a"}},[_c('strong',[_vm._v(" cliquez sur \"Commander\".  ")])])]),_vm._v(" "),_c('h2',{staticStyle:{"text-align":"center"}},[_c('img',{attrs:{"src":"static/img/shop/categories/commande2mob.png","width":"70%","alt":"Etape_01 Ombre (1).png"}})])]),_vm._v("\n↓↓\n"),_c('div',[_c('h2',{staticStyle:{"text-align":"center"}},[_c('span',{staticStyle:{"color":"#FFA500"}},[_c('strong',[_vm._v("Etape N°5 :")])]),_vm._v(" "),_c('span',{staticStyle:{"color":"#4a4a4a"}},[_c('strong',[_vm._v(" Remplissez votre numéro de téléphone et cliquez sur \"Valider\". ")])])]),_vm._v(" "),_c('h2',{staticStyle:{"text-align":"center"}},[_c('img',{attrs:{"src":"static/img/shop/categories/telephonemob.png","width":"70%","alt":"Etape_01 Ombre (1).png"}})])]),_vm._v("\n↓↓\n"),_c('div',[_c('h2',{staticStyle:{"text-align":"center"}},[_c('span',{staticStyle:{"color":"#FFA500"}},[_c('strong',[_vm._v("Etape N°6 :")])]),_vm._v(" "),_c('span',{staticStyle:{"color":"#4a4a4a"}},[_c('strong',[_vm._v(" Confirmez votre commande en cliquons  sur \"Valider\". ")])])]),_vm._v(" "),_c('h2',{staticStyle:{"text-align":"center"}},[_c('img',{attrs:{"src":"static/img/shop/categories/fourmmob.png","width":"70%","alt":"Etape_01 Ombre (1).png"}})])]),_vm._v("\n↓↓\n"),_c('div',[_c('h2',{staticStyle:{"text-align":"center"}},[_c('span',{staticStyle:{"color":"#FFA500"}},[_c('strong',[_vm._v("Etape N°8 :")])]),_vm._v(" "),_c('span',{staticStyle:{"color":"#4a4a4a"}},[_c('strong',[_vm._v(" Etape N°7 : L'équipe de luxuryshopdz, vous joindra par téléphone pour finaliser votre commande. ")])])]),_vm._v(" "),_c('h2',{staticStyle:{"text-align":"center"}},[_c('img',{attrs:{"src":"static/img/shop/categories/fourmfinalmob.png","width":"70%","alt":"Etape_01 Ombre (1).png"}})])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 294 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_about_vue__ = __webpack_require__(85);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f9f47d24_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_about_vue__ = __webpack_require__(296);
function injectStyle (ssrContext) {
  __webpack_require__(295)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-f9f47d24"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_about_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f9f47d24_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_about_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 295 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 296 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"bg"}),_vm._v(" "),_c('div',{staticClass:"page-title"},[_c('div',{staticClass:"container"},[_c('h1',[_vm._v("About Us")]),_vm._v(" "),_c('ul',{staticClass:"breadcrumbs"},[_c('li',[_c('router-link',{attrs:{"to":"/"}},[_vm._v("Home")])],1),_vm._v(" "),_c('li',{staticClass:"separator"},[_vm._v(" / ")]),_vm._v(" "),_c('li',[_vm._v("About Us")])])])]),_vm._v(" "),_vm._m(0),_vm._v(" "),_vm._m(1),_vm._v(" "),_vm._m(2)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('section',{staticClass:"row align-items-center padding-bottom-2x"},[_c('div',{staticClass:"col-md-5"},[_c('img',{staticClass:"d-block w-270 m-auto",attrs:{"src":"static/img/features/01.jpg","alt":"Online Shopping"}})]),_vm._v(" "),_c('div',{staticClass:"col-md-7 text-md-left text-center"},[_c('div',{staticClass:"mt-30 hidden-md-up"}),_vm._v(" "),_c('h2',[_vm._v("Search, Select, Buy Online.")]),_vm._v(" "),_c('p',{staticClass:"text-sm"},[_vm._v("Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aliquam id purus at risus pellentesque faucibus a quis eros. In eu fermentum leo. Integer ut eros lacus. Proin ut accumsan leo. Morbi vitae est eget dolor consequat aliquam eget quis dolor. Mauris rutrum fermentum erat, at euismod lorem pharetra nec. Duis erat lectus, ultrices euismod sagittis at, pharetra eu nisl. Phasellus id ante at velit tincidunt hendrerit.")]),_c('a',{staticClass:"text-decoration-none",attrs:{"href":"shop-grid-ls.html"}},[_vm._v("View Products "),_c('i',{staticClass:"material-icons keyboard_arrow_right lead"})])])]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('section',{staticClass:"row align-items-center padding-top-2x padding-bottom-2x"},[_c('div',{staticClass:"col-md-5 order-md-2"},[_c('img',{staticClass:"d-block w-270 m-auto",attrs:{"src":"static/img/features/02.jpg","alt":"Delivery"}})]),_vm._v(" "),_c('div',{staticClass:"col-md-7 order-md-1 text-md-left text-center"},[_c('div',{staticClass:"mt-30 hidden-md-up"}),_vm._v(" "),_c('h2',[_vm._v("Fast Delivery Worldwide.")]),_vm._v(" "),_c('p',{staticClass:"text-sm"},[_vm._v("Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aliquam id purus at risus pellentesque faucibus a quis eros. In eu fermentum leo. Integer ut eros lacus. Proin ut accumsan leo. Morbi vitae est eget dolor consequat aliquam eget quis dolor. Mauris rutrum fermentum erat, at euismod lorem pharetra nec. Duis erat lectus, ultrices euismod sagittis at, pharetra eu nisl. Phasellus id ante at velit tincidunt hendrerit.")]),_c('a',{staticClass:"text-decoration-none",attrs:{"href":"#"}},[_vm._v("Shipping Details "),_c('i',{staticClass:"material-icons keyboard_arrow_right lead"})])])]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('section',{staticClass:"row align-items-center padding-top-2x padding-bottom-2x"},[_c('div',{staticClass:"col-md-5"},[_c('img',{staticClass:"d-block w-270 m-auto",attrs:{"src":"static/img/features/03.jpg","alt":"Mobile App"}})]),_vm._v(" "),_c('div',{staticClass:"col-md-7 text-md-left text-center"},[_c('div',{staticClass:"mt-30 hidden-md-up"}),_vm._v(" "),_c('h2',[_vm._v("Great Mobile App. Shop On The Go.")]),_vm._v(" "),_c('p',{staticClass:"text-sm mb-4"},[_vm._v("Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aliquam id purus at risus pellentesque faucibus a quis eros. In eu fermentum leo. Integer ut eros lacus. Proin ut accumsan leo. Morbi vitae est eget dolor consequat aliquam.")]),_c('a',{staticClass:"market-button apple-button",attrs:{"href":"#"}},[_c('span',{staticClass:"mb-subtitle"},[_vm._v("Download on the")]),_c('span',{staticClass:"mb-title"},[_vm._v("App Store")])]),_c('a',{staticClass:"market-button google-button",attrs:{"href":"#"}},[_c('span',{staticClass:"mb-subtitle"},[_vm._v("Download on the")]),_c('span',{staticClass:"mb-title"},[_vm._v("Google Play")])]),_c('a',{staticClass:"market-button windows-button",attrs:{"href":"#"}},[_c('span',{staticClass:"mb-subtitle"},[_vm._v("Download on the")]),_c('span',{staticClass:"mb-title"},[_vm._v("Windows Store")])])])]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('section',{staticClass:"row align-items-center padding-top-2x padding-bottom-3x"},[_c('div',{staticClass:"col-md-5 order-md-2"},[_c('img',{staticClass:"d-block w-270 m-auto",attrs:{"src":"static/img/features/04.jpg","alt":"Delivery"}})]),_vm._v(" "),_c('div',{staticClass:"col-md-7 order-md-1 text-md-left text-center"},[_c('div',{staticClass:"mt-30 hidden-md-up"}),_vm._v(" "),_c('h2',[_vm._v("Shop Offline. Cozy Outlet Stores.")]),_vm._v(" "),_c('p',{staticClass:"text-sm"},[_vm._v("Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aliquam id purus at risus pellentesque faucibus a quis eros. In eu fermentum leo. Integer ut eros lacus. Proin ut accumsan leo. Morbi vitae est eget dolor consequat aliquam eget quis dolor. Mauris rutrum fermentum erat, at euismod lorem pharetra nec. Duis erat lectus, ultrices euismod sagittis at, pharetra eu nisl. Phasellus id ante at velit tincidunt hendrerit.")]),_c('a',{staticClass:"text-decoration-none",attrs:{"href":"contacts.html"}},[_vm._v("See Outlet Stores "),_c('i',{staticClass:"material-icons keyboard_arrow_right lead"})])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"fw-section padding-top-9x padding-bottom-9x",staticStyle:{"background-image":"url(static/img/backgrounds/video_popup.jpg)"}},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"gallery-wrapper text-center"},[_c('div',{staticClass:"gallery-item video-btn text-center"},[_c('a',{attrs:{"href":"#","data-type":"video","data-video":"<div class=\"wrapper\"><div class=\"video-wrapper\"><iframe class=\"pswp__video\" width=\"960\" height=\"640\" src=_https_/player.vimeo.com/video/670011569a09.html?color=dc9814&title=0&byline=0&portrait=0%22 frameborder=\"0\" allowfullscreen></iframe></div></div>"}}),_c('span',{staticClass:"caption text-center"},[_vm._v("Unishop - your reliable partner")])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"container padding-bottom-2x mb-2"},[_c('div',{staticClass:"text-center padding-top-3x mb-30"},[_c('h2',{staticClass:"mb-3"},[_vm._v("Our Core Team")]),_vm._v(" "),_c('p',{staticClass:"text-muted mb-5"},[_vm._v("People behind your awesome shopping experience.")])]),_vm._v(" "),_c('section',{staticClass:"row"},[_c('div',{staticClass:"col-md-3 col-sm-6 mb-30 text-center"},[_c('img',{staticClass:"d-block w-150 mx-auto img-thumbnail rounded mb-2",attrs:{"src":"static/img/team/01.jpg","alt":"Team"}}),_vm._v(" "),_c('h6',[_vm._v("Grace Wright")]),_vm._v(" "),_c('p',{staticClass:"text-muted mb-2"},[_vm._v("Founder, CEO")]),_vm._v(" "),_c('div',{staticClass:"social-bar"},[_c('a',{staticClass:"social-button shape-rounded sb-facebook",attrs:{"href":"#","data-toggle":"tooltip","data-placement":"top","title":"Facebook"}},[_c('i',{staticClass:"socicon-facebook"})]),_c('a',{staticClass:"social-button shape-rounded sb-twitter",attrs:{"href":"#","data-toggle":"tooltip","data-placement":"top","title":"Twitter"}},[_c('i',{staticClass:"socicon-twitter"})]),_c('a',{staticClass:"social-button shape-rounded sb-google-plus",attrs:{"href":"#","data-toggle":"tooltip","data-placement":"top","title":"Google +"}},[_c('i',{staticClass:"socicon-googleplus"})])])]),_vm._v(" "),_c('div',{staticClass:"col-md-3 col-sm-6 mb-30 text-center"},[_c('img',{staticClass:"d-block w-150 mx-auto img-thumbnail rounded mb-2",attrs:{"src":"static/img/team/02.jpg","alt":"Team"}}),_vm._v(" "),_c('h6',[_vm._v("Taylor Jackson")]),_vm._v(" "),_c('p',{staticClass:"text-muted mb-2"},[_vm._v("Financial Director")]),_vm._v(" "),_c('div',{staticClass:"social-bar"},[_c('a',{staticClass:"social-button shape-rounded sb-skype",attrs:{"href":"#","data-toggle":"tooltip","data-placement":"top","title":"Skype"}},[_c('i',{staticClass:"socicon-skype"})]),_c('a',{staticClass:"social-button shape-rounded sb-facebook",attrs:{"href":"#","data-toggle":"tooltip","data-placement":"top","title":"Facebook"}},[_c('i',{staticClass:"socicon-facebook"})]),_c('a',{staticClass:"social-button shape-rounded sb-paypal",attrs:{"href":"#","data-toggle":"tooltip","data-placement":"top","title":"PayPal"}},[_c('i',{staticClass:"socicon-paypal"})])])]),_vm._v(" "),_c('div',{staticClass:"col-md-3 col-sm-6 mb-30 text-center"},[_c('img',{staticClass:"d-block w-150 mx-auto img-thumbnail rounded mb-2",attrs:{"src":"static/img/team/03.jpg","alt":"Team"}}),_vm._v(" "),_c('h6',[_vm._v("Quinton Cross")]),_vm._v(" "),_c('p',{staticClass:"text-muted mb-2"},[_vm._v("Marketing Director")]),_vm._v(" "),_c('div',{staticClass:"social-bar"},[_c('a',{staticClass:"social-button shape-rounded sb-twitter",attrs:{"href":"#","data-toggle":"tooltip","data-placement":"top","title":"Twitter"}},[_c('i',{staticClass:"socicon-twitter"})]),_c('a',{staticClass:"social-button shape-rounded sb-google-plus",attrs:{"href":"#","data-toggle":"tooltip","data-placement":"top","title":"Google +"}},[_c('i',{staticClass:"socicon-googleplus"})]),_c('a',{staticClass:"social-button shape-rounded sb-email",attrs:{"href":"#","data-toggle":"tooltip","data-placement":"top","title":"Email"}},[_c('i',{staticClass:"socicon-mail"})])])]),_vm._v(" "),_c('div',{staticClass:"col-md-3 col-sm-6 mb-30 text-center"},[_c('img',{staticClass:"d-block w-150 mx-auto img-thumbnail rounded mb-2",attrs:{"src":"static/img/team/04.jpg","alt":"Team"}}),_vm._v(" "),_c('h6',[_vm._v("Liana Mullen")]),_vm._v(" "),_c('p',{staticClass:"text-muted mb-2"},[_vm._v("Lead Designer")]),_vm._v(" "),_c('div',{staticClass:"social-bar"},[_c('a',{staticClass:"social-button shape-rounded sb-behance",attrs:{"href":"#","data-toggle":"tooltip","data-placement":"top","title":"Behance"}},[_c('i',{staticClass:"socicon-behance"})]),_c('a',{staticClass:"social-button shape-rounded sb-dribbble",attrs:{"href":"#","data-toggle":"tooltip","data-placement":"top","title":"Dribbble"}},[_c('i',{staticClass:"socicon-dribbble"})]),_c('a',{staticClass:"social-button shape-rounded sb-instagram",attrs:{"href":"#","data-toggle":"tooltip","data-placement":"top","title":"Instagram"}},[_c('i',{staticClass:"socicon-instagram"})])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 297 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_achat_vue__ = __webpack_require__(86);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_101558f4_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_achat_vue__ = __webpack_require__(299);
function injectStyle (ssrContext) {
  __webpack_require__(298)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-101558f4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_achat_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_101558f4_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_achat_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 298 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 299 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"page-title"},[_c('div',{staticClass:"container"},[_c('h1',[_vm._v("Comment acheter ")]),_vm._v(" "),_c('ul',{staticClass:"breadcrumbs"},[_c('h2',[_c('strong',[_vm._v("  luxuryshopdz est aujourd'hui le numéro 1 en Algerie des ventes de montres origianles  ")])])])])]),_vm._v(" "),_c('h2',{staticStyle:{"text-align":"center"}},[_c('span',{staticStyle:{"color":"#FFA500"}},[_c('strong',[_vm._v("Etape N°1 :")])]),_vm._v(" "),_c('span',{staticStyle:{"color":"#4a4a4a"}},[_c('strong',[_vm._v(" Accédez au site www.luxuryshopdz.com ")])])]),_vm._v(" "),_c('h2',{staticStyle:{"text-align":"center"}},[_c('img',{attrs:{"src":"static/img/shop/categories/home.png","width":"70%","alt":"Etape_01 Ombre (1).png"}})]),_vm._v("\n↓↓\n"),_c('h2',{staticStyle:{"text-align":"center"}},[_c('span',{staticStyle:{"color":"#FFA500"}},[_c('strong',[_vm._v("Etape N°2 :")])]),_vm._v(" "),_c('span',{staticStyle:{"color":"#4a4a4a"}},[_c('strong',[_vm._v(" Cliquez sur le produit qui vous intéresse. ")])])]),_vm._v(" "),_c('h2',{staticStyle:{"text-align":"center"}},[_c('img',{attrs:{"src":"static/img/shop/categories/tous.png","width":"70%","alt":"Etape_01 Ombre (1).png"}})]),_vm._v("\n↓↓\n"),_c('h2',{staticStyle:{"text-align":"center"}},[_c('span',{staticStyle:{"color":"#FFA500"}},[_c('strong',[_vm._v("Etape N°3 :")])]),_vm._v(" "),_c('span',{staticStyle:{"color":"#4a4a4a"}},[_c('strong',[_vm._v(" Cliquez sur \"Ajouter au panier\"  ")])])]),_vm._v(" "),_c('h2',{staticStyle:{"text-align":"center"}},[_c('img',{attrs:{"src":"static/img/shop/categories/produit.png","width":"70%","alt":"Etape_01 Ombre (1).png"}})]),_vm._v("\n↓↓\n\n"),_c('h2',{staticStyle:{"text-align":"center"}},[_c('span',{staticStyle:{"color":"#FFA500"}},[_c('strong',[_vm._v("Etape N°4 :")])]),_vm._v(" "),_c('span',{staticStyle:{"color":"#4a4a4a"}},[_c('strong',[_vm._v(" cliquez sur \"Commander\".  ")])])]),_vm._v(" "),_c('h2',{staticStyle:{"text-align":"center"}},[_c('img',{attrs:{"src":"static/img/shop/categories/commande.png","width":"70%","alt":"Etape_01 Ombre (1).png"}})]),_vm._v("\n↓↓\n"),_c('h2',{staticStyle:{"text-align":"center"}},[_c('span',{staticStyle:{"color":"#FFA500"}},[_c('strong',[_vm._v("Etape N°5 :")])]),_vm._v(" "),_c('span',{staticStyle:{"color":"#4a4a4a"}},[_c('strong',[_vm._v(" Remplissez votre numéro de téléphone et cliquez sur \"Valider\". ")])])]),_vm._v(" "),_c('h2',{staticStyle:{"text-align":"center"}},[_c('img',{attrs:{"src":"static/img/shop/categories/telephone.png","width":"70%","alt":"Etape_01 Ombre (1).png"}})]),_vm._v("\n↓↓\n"),_c('h2',{staticStyle:{"text-align":"center"}},[_c('span',{staticStyle:{"color":"#FFA500"}},[_c('strong',[_vm._v("Etape N°6 :")])]),_vm._v(" "),_c('span',{staticStyle:{"color":"#4a4a4a"}},[_c('strong',[_vm._v(" Confirmez votre commande en cliquons  sur \"Valider\". ")])])]),_vm._v(" "),_c('h2',{staticStyle:{"text-align":"center"}},[_c('img',{attrs:{"src":"static/img/shop/categories/fourm.png","width":"70%","alt":"Etape_01 Ombre (1).png"}})]),_vm._v("\n↓↓\n"),_c('h2',{staticStyle:{"text-align":"center"}},[_c('span',{staticStyle:{"color":"#FFA500"}},[_c('strong',[_vm._v("Etape N°7 :")])]),_vm._v(" "),_c('span',{staticStyle:{"color":"#4a4a4a"}},[_c('strong',[_vm._v("  L'équipe de luxuryshopdz, vous joindra par téléphone pour finaliser votre commande. ")])])]),_vm._v(" "),_c('h2',{staticStyle:{"text-align":"center"}},[_c('img',{attrs:{"src":"static/img/shop/categories/fourmfinal.png","width":"70%","alt":"Etape_01 Ombre (1).png"}})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 300 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_contact_vue__ = __webpack_require__(87);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2beffb46_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_contact_vue__ = __webpack_require__(302);
function injectStyle (ssrContext) {
  __webpack_require__(301)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2beffb46"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_contact_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2beffb46_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_contact_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 301 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 302 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"page-title"},[_c('div',{staticClass:"container"},[_c('h1',[_vm._v("Contacts")]),_vm._v(" "),_c('ul',{staticClass:"breadcrumbs"},[_c('li',[_c('a',{attrs:{"href":"index.html"}},[_vm._v("Home")])]),_vm._v(" "),_c('li',{staticClass:"separator"},[_vm._v(" / ")]),_vm._v(" "),_c('li',[_vm._v("Contacts")])])])]),_vm._v(" "),_c('div',{staticClass:"container padding-bottom-2x mb-2"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-7"},[_c('div',{staticClass:"display-3 text-muted opacity-75 mb-30"},[_c('strong',[_vm._v(" Service Clients ")])])]),_vm._v(" "),_c('div',{staticClass:"col-md-5"},[_c('ul',{staticClass:"list-icon"},[_c('li',[_c('i',{staticClass:"material-icons mail_outline text-muted"}),_c('a',{staticClass:"navi-link",attrs:{"href":"mailto:customer.service@unishop.com"}},[_vm._v("contact@luxuryshopdz.com")])]),_vm._v(" "),_c('li',[_c('i',{staticClass:"material-icons phone text-muted"}),_vm._v(" 023 804 474 / 021 436 272")]),_vm._v(" "),_c('li',[_c('i',{staticClass:"material-icons access_time text-muted"}),_vm._v("1 - 2 jours ouvrables")])])])]),_vm._v(" "),_c('hr',{staticClass:"margin-top-2x"}),_vm._v(" "),_c('div',{staticClass:"row margin-top-2x"},[_c('div',{staticClass:"col-md-7"},[_c('div',{staticClass:"display-3 text-muted opacity-75 mb-30"},[_c('strong',[_vm._v(" Support technique ")])])]),_vm._v(" "),_c('div',{staticClass:"col-md-5"},[_c('ul',{staticClass:"list-icon"},[_c('li',[_c('i',{staticClass:"material-icons mail_outline text-muted"}),_c('a',{staticClass:"navi-link",attrs:{"href":"mailto:support@unishop.com"}},[_vm._v("support@luxuryshopdz.com")])]),_vm._v(" "),_c('li',[_c('i',{staticClass:"material-icons phone text-muted"}),_vm._v(" 023 804 474 / 021 436 272")]),_vm._v(" "),_c('li',[_c('i',{staticClass:"material-icons access_time text-muted"}),_vm._v("1 - 2 jours ouvrables")])])])]),_vm._v(" "),_c('h2',{staticClass:"margin-top-3x text-center mb-30"},[_vm._v("Siège socials")]),_vm._v(" "),_c('div',{staticClass:"d-flex justify-content-center"},[_c('div',{staticClass:"card border-default mb-30"},[_c('div',{staticClass:"card-body bg-dark"},[_c('ul',{staticClass:"list-icon text-sm text-white"},[_c('li',[_c('i',{staticClass:"material-icons place text-muted"}),_vm._v(" Magasin '1': Centre commercial mohammadia mall , les bannaniers alger (sous sol ) magasin numéro 869")]),_vm._v(" "),_c('li',[_c('i',{staticClass:"material-icons phone text-muted"}),_vm._v("023 804 474")]),_vm._v(" "),_c('li',[_c('i',{staticClass:"material-icons mail_outline text-muted"}),_c('a',{staticClass:"navi-link-light",attrs:{"href":"mailto:orlando.store@unishop.com"}},[_vm._v("support@luxuryshopdz.com")])])])])]),_vm._v(" "),_c('div',{staticClass:"card border-default mb-30"},[_c('div',{staticClass:"card-body bg-dark"},[_c('ul',{staticClass:"list-icon text-sm text-white"},[_c('li',[_c('i',{staticClass:"material-icons place text-muted"}),_vm._v(" Magasin '2' : 07 rue hamdani lahcen,sidi yahia sur la montée vers paradou (à coté de mobilis)")]),_vm._v(" "),_c('li',[_c('i',{staticClass:"material-icons phone text-muted"}),_vm._v(" 021 436 272")]),_vm._v(" "),_c('li',[_c('i',{staticClass:"material-icons mail_outline text-muted"}),_c('a',{staticClass:"navi-link-light",attrs:{"href":"mailto:chicago.store@unishop.comm"}},[_vm._v("support@luxuryshopdz.com")])])])])]),_vm._v(" "),_c('div',{staticClass:"card border-default mb-30"},[_c('div',{staticClass:"card-body bg-dark"},[_c('ul',{staticClass:"list-icon text-sm text-white"},[_c('li',[_c('i',{staticClass:"material-icons place text-muted"}),_vm._v("Magasin '3': Cité Point du jour Coop.Ibn Sina N132 .ORAN ")]),_vm._v(" "),_c('li',[_c('i',{staticClass:"material-icons phone text-muted"}),_vm._v(" 021 436 272")]),_vm._v(" "),_c('li',[_c('i',{staticClass:"material-icons mail_outline text-muted"}),_c('a',{staticClass:"navi-link-light",attrs:{"href":"mailto:chicago.store@unishop.comm"}},[_vm._v("support@luxuryshopdz.com")])])])])]),_vm._v(" "),_c('div',{staticClass:"card border-default mb-30"},[_c('div',{staticClass:"card-body bg-dark"},[_c('ul',{staticClass:"list-icon text-sm text-white"},[_c('li',[_c('i',{staticClass:"material-icons place text-muted"}),_vm._v("Magasin '4': elkhroub en face EX daira de lekhroub , constantine")]),_vm._v(" "),_c('li',[_c('i',{staticClass:"material-icons phone text-muted"}),_vm._v(" 021 436 272")]),_vm._v(" "),_c('li',[_c('i',{staticClass:"material-icons mail_outline text-muted"}),_c('a',{staticClass:"navi-link-light",attrs:{"href":"mailto:chicago.store@unishop.comm"}},[_vm._v("support@luxuryshopdz.com")])])])])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 303 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ADD_TO_CART; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return FETCH_DATA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return DETAIL_PRODUCT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CLEAR_CART; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return REMOVE_FROM_CART; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return DO_COMMANDE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return LAST_PRODUCT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return LAST_PRODUCT2; });
/* unused harmony export LAST_PRODUCTH */
/* unused harmony export lastEntriesfestina */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return LAST_PRODUCTfestina; });
/* unused harmony export lastEntriesfestinadepot */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return LAST_PRODUCTfestinadepot; });
/* unused harmony export lastEntriespromo */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return LAST_PRODUCTpromo; });
/* unused harmony export lastProductpromo */
/* unused harmony export lastEntriesvideo */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return LAST_PRODUCTvideo; });
/* unused harmony export lastEntriesroyal */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return LAST_PRODUCTroyal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return LAST_PRODUCTpolice; });
/* unused harmony export lastEntriesarmani */
/* unused harmony export lastEntriesnautica */
/* unused harmony export lastEntriesmaserati */
/* unused harmony export lastEntriesmorellato */
/* unused harmony export lastEntriestimberland */
/* unused harmony export lastEntriesMichaelkors */
/* unused harmony export lastEntriesconnectee */
/* unused harmony export lastEntriesdiesel */
/* unused harmony export lastEntriespolice */
/* unused harmony export lastEntriesfossil */
/* unused harmony export lastEntrieslotus */
/* unused harmony export lastEntriesversus */
/* unused harmony export lastEntriesTRUSSARDI */
/* unused harmony export lastEntriesMONTIGNAC */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return LAST_PRODUCTarmani; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return LAST_PRODUCTnautica; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return LAST_PRODUCTmaserati; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return LAST_PRODUCTmorellato; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return LAST_PRODUCTtimberland; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return LAST_PRODUCTMichaelkors; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return LAST_PRODUCTconnectee; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return LAST_PRODUCTdiesel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return LAST_PRODUCTfossil; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return LAST_PRODUCTcerruti; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return LAST_PRODUCTlotus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return LAST_PRODUCTversus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return LAST_PRODUCTTRUSSARDI; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return LAST_PRODUCTMONTIGNAC; });
/* unused harmony export lastEntriesref */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return LAST_PRODUCTref; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return LAST_PRODUCTreference; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return USER_INFO; });
/* unused harmony export user */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return LOGIN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return REGISTER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return LOAD_CART; });
var ADD_TO_CART = 'ADD_TO_CART';
var FETCH_DATA = 'FETCH_DATA';
var DETAIL_PRODUCT = 'DETAIL_PRODUCT';
var CLEAR_CART = 'CLEAR_CART';
var REMOVE_FROM_CART = 'REMOVE_FROM_CART';
var DO_COMMANDE = 'DO_COMMANDE';
var LAST_PRODUCT = 'LAST_PRODUCT';
var LAST_PRODUCT2 = 'LAST_PRODUCT2';
var LAST_PRODUCTH = 'LAST_PRODUCTH';
var lastEntriesfestina = 'lastEntriesfestina';
var LAST_PRODUCTfestina = 'LAST_PRODUCTfestina';
var lastEntriesfestinadepot = 'lastEntriesfestinadepot';
var LAST_PRODUCTfestinadepot = 'LAST_PRODUCTfestinadepot';
var lastEntriespromo = 'lastEntriespromo';
var LAST_PRODUCTpromo = 'LAST_PRODUCTpromo';
var lastProductpromo = 'LAST_PRODUCTpromo';

var lastEntriesvideo = 'lastEntriesvideo';
var LAST_PRODUCTvideo = 'LAST_PRODUCTvideo';
var lastEntriesroyal = 'lastEntriesroyal';
var LAST_PRODUCTroyal = 'LAST_PRODUCTroyal';
var LAST_PRODUCTpolice = 'LAST_PRODUCTpolice';
var lastEntriesarmani = 'lastEntriesarmani';
var lastEntriesnautica = 'lastEntriesnautica';
var lastEntriesmaserati = 'lastEntriesmaserati';
var lastEntriesmorellato = 'lastEntriesmorellato';
var lastEntriestimberland = 'lastEntriestimberland';
var lastEntriesMichaelkors = 'lastEntriesMichaelkors';
var lastEntriesconnectee = 'lastEntriesconnectee';
var lastEntriesdiesel = 'lastEntriesdiesel';
var lastEntriespolice = 'lastEntriespolice';
var lastEntriesfossil = 'lastEntriesfossil';
var lastEntrieslotus = 'lastEntrieslotus';
var lastEntriesversus = 'lastEntriesversus';
var lastEntriesTRUSSARDI = 'lastEntriesTRUSSARDI';
var lastEntriesMONTIGNAC = 'lastEntriesMONTIGNAC';
var LAST_PRODUCTarmani = 'LAST_PRODUCTarmani';
var LAST_PRODUCTnautica = 'LAST_PRODUCTnautica';
var LAST_PRODUCTmaserati = 'LAST_PRODUCTmaserati';
var LAST_PRODUCTmorellato = 'LAST_PRODUCTmorellato';
var LAST_PRODUCTtimberland = 'LAST_PRODUCTtimberland';
var LAST_PRODUCTMichaelkors = 'LAST_PRODUCTMichaelkors';
var LAST_PRODUCTconnectee = 'LAST_PRODUCTconnectee';
var LAST_PRODUCTdiesel = 'LAST_PRODUCTdiesel';
var LAST_PRODUCTfossil = 'LAST_PRODUCTfossil';
var LAST_PRODUCTcerruti = 'LAST_PRODUCTcerruti';
var LAST_PRODUCTlotus = 'LAST_PRODUCTlotus';
var LAST_PRODUCTversus = 'LAST_PRODUCTversus';
var LAST_PRODUCTTRUSSARDI = 'LAST_PRODUCTTRUSSARDI';
var LAST_PRODUCTMONTIGNAC = 'LAST_PRODUCTMONTIGNAC';
var lastEntriesref = 'lastEntriesref';
var LAST_PRODUCTref = 'LAST_PRODUCTref';
var LAST_PRODUCTreference = 'LAST_PRODUCTreference';

var USER_INFO = 'USER_INFO';
var user = 'user';
var LOGIN = 'LOGIN';
var REGISTER = 'REGISTER';
var LOAD_CART = 'LOAD_CART';

/***/ })
],[15]);


// WEBPACK FOOTER //
// static/js/app.3bd85498df9b26ae38eb.js